(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 62663:
/***/ (function(module) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),

/***/ 44286:
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ 49029:
/***/ (function(module) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),

/***/ 18674:
/***/ (function(module) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),

/***/ 40180:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(14259);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ 98805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castSlice = __webpack_require__(40180),
    hasUnicode = __webpack_require__(62689),
    stringToArray = __webpack_require__(83140),
    toString = __webpack_require__(79833);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),

/***/ 35393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayReduce = __webpack_require__(62663),
    deburr = __webpack_require__(53816),
    words = __webpack_require__(58748);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),

/***/ 69389:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(18674);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),

/***/ 62689:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 93157:
/***/ (function(module) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),

/***/ 83140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(44286),
    hasUnicode = __webpack_require__(62689),
    unicodeToArray = __webpack_require__(676);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ 676:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ 94192:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),

/***/ 53816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var deburrLetter = __webpack_require__(69389),
    toString = __webpack_require__(79833);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),

/***/ 18029:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCompounder = __webpack_require__(35393),
    upperFirst = __webpack_require__(11700);

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;


/***/ }),

/***/ 11700:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(98805);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),

/***/ 58748:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiWords = __webpack_require__(49029),
    hasUnicodeWord = __webpack_require__(93157),
    toString = __webpack_require__(79833),
    unicodeWords = __webpack_require__(94192);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(12989);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ COUNTRY_CONFIG; }
/* harmony export */ });
var COUNTRY_CONFIG = {
    VN: "Vietnam",
    TH: "Thailand",
    PH: "Philippines",
    MY: "Malaysia",
    SG: "Singapore",
    ID: "Indonesia",
    OTHER: "Other"
};


/***/ }),

/***/ 12989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ src_pages; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/index.js + 251 modules
var es = __webpack_require__(27175);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var es_useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./src/features/share/configs/pages.ts
var pages = __webpack_require__(40229);
// EXTERNAL MODULE: ./src/features/share/configs/const.ts
var configs_const = __webpack_require__(55016);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(65457);
// EXTERNAL MODULE: ./src/features/share/components/layouts/Logged.tsx
var Logged = __webpack_require__(19747);
// EXTERNAL MODULE: ./src/features/share/components/layouts/mobile-layout/style.module.scss
var style_module = __webpack_require__(57488);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/features/share/components/layouts/mobile-layout/index.tsx






function MobileLayout(props) {
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var isOpenFloatingPanel = dynamicConfig && dynamicConfig.isOpenFloatingPanel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Logged/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("".concat((style_module_default()).mobileContainer, " mobile-layout"), isOpenFloatingPanel ? "overflow-hidden" : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "myBackgroundViewPortal"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("layout-content ".concat((style_module_default()).mobileContent), !isOpenFloatingPanel && "pb-[84px]"),
                    id: "passio-layout-content",
                    children: [
                        props.children,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "myFloatingPanelPortal"
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/features/share/icons/index.tsx
var icons = __webpack_require__(64035);
// EXTERNAL MODULE: ./src/features/block/block.conf.ts + 92 modules
var block_conf = __webpack_require__(61086);
// EXTERNAL MODULE: ./src/features/share/HOC/portal.tsx
var portal = __webpack_require__(62944);
// EXTERNAL MODULE: ./src/features/share/thunk/index.tsx
var thunk = __webpack_require__(60580);
;// CONCATENATED MODULE: ./node_modules/antd-mobile-icons/es/ExclamationCircleFill.js

function ExclamationCircleFill(props) {
    return /*#__PURE__*/ react.createElement("svg", Object.assign({
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, props, {
        style: Object.assign({
            verticalAlign: "-0.125em"
        }, props.style),
        className: [
            "antd-mobile-icon",
            props.className
        ].filter(Boolean).join(" ")
    }), /*#__PURE__*/ react.createElement("g", {
        id: "ExclamationCircleFill-ExclamationCircleFill",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("g", null, /*#__PURE__*/ react.createElement("rect", {
        id: "ExclamationCircleFill-\u77E9\u5F62",
        fill: "#D76060",
        opacity: 0,
        x: 0,
        y: 0,
        width: 48,
        height: 48
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M24,2 C36.1502645,2 46,11.8497355 46,24 C46,36.1502645 36.1502645,46 24,46 C11.8497355,46 2,36.1502645 2,24 C2,11.8497355 11.8497355,2 24,2 Z M25.1,31 L22.9,31 C22.6790861,31 22.5,31.1790861 22.5,31.4 L22.5,31.4 L22.5,33.6 C22.5,33.8209139 22.6790861,34 22.9,34 L22.9,34 L25.1,34 C25.3209139,34 25.5,33.8209139 25.5,33.6 L25.5,33.6 L25.5,31.4 C25.5,31.1790861 25.3209139,31 25.1,31 L25.1,31 Z M25.1,14 L22.9,14 C22.6790861,14 22.5,14.1790861 22.5,14.4 L22.5,14.4 L22.5,27.6 C22.5,27.8209139 22.6790861,28 22.9,28 L22.9,28 L25.1,28 C25.3209139,28 25.5,27.8209139 25.5,27.6 L25.5,27.6 L25.5,14.4 C25.5,14.1790861 25.3209139,14 25.1,14 L25.1,14 Z",
        id: "ExclamationCircleFill-\u5F62\u72B6\u7ED3\u5408",
        fill: "currentColor",
        fillRule: "nonzero"
    }))));
}
/* harmony default export */ var es_ExclamationCircleFill = (ExclamationCircleFill);

// EXTERNAL MODULE: ./src/features/block/components/BlockSelectionV2/index.tsx + 2 modules
var BlockSelectionV2 = __webpack_require__(99872);
// EXTERNAL MODULE: ./src/features/block/config/interface.ts
var config_interface = __webpack_require__(93807);
// EXTERNAL MODULE: ./src/features/main/store/dynamicSlice.ts
var dynamicSlice = __webpack_require__(24865);
// EXTERNAL MODULE: ./src/features/main/store/interface.ts
var store_interface = __webpack_require__(30053);
// EXTERNAL MODULE: ./src/features/main/store/positionsSlice.ts + 2 modules
var positionsSlice = __webpack_require__(99265);
// EXTERNAL MODULE: ./src/features/main/store/siteSettingSlice.ts
var siteSettingSlice = __webpack_require__(24882);
// EXTERNAL MODULE: ./src/features/share/api/index.tsx
var api = __webpack_require__(85861);
// EXTERNAL MODULE: ./src/features/share/components/full-screen-popup/index.tsx
var full_screen_popup = __webpack_require__(40015);
// EXTERNAL MODULE: ./src/features/share/components/PopupComponent/index.tsx
var PopupComponent = __webpack_require__(21043);
// EXTERNAL MODULE: ./node_modules/antd-mobile/es/utils/sleep.js
var sleep = __webpack_require__(24547);
// EXTERNAL MODULE: ./src/features/share/configs/system.ts
var system = __webpack_require__(935);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./src/features/share/lib/ga-events.ts
var ga_events = __webpack_require__(2991);
// EXTERNAL MODULE: ./node_modules/simplebar/src/simplebar.css
var simplebar = __webpack_require__(23021);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(5678);
// EXTERNAL MODULE: ./src/features/design/components/AddNewBlock/AddNewBlock.tsx + 2 modules
var AddNewBlock = __webpack_require__(36629);
// EXTERNAL MODULE: ./src/features/setting/components/Icons/index.tsx
var Icons = __webpack_require__(76143);
;// CONCATENATED MODULE: ./src/features/design/components/Preview/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var Preview = function(props) {
    var user = props.user, onCancelPreview = props.onCancelPreview, siteSettings = props.siteSettings;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var previewUrl = (0,react.useMemo)(function() {
        var ref;
        var domain = user === null || user === void 0 ? void 0 : (ref = user.kol) === null || ref === void 0 ? void 0 : ref.domain;
        var siteSettingId = siteSettings.id;
        return "https://".concat(domain, "/preview?id=").concat(siteSettingId, "&isDisableLink=true");
    }, [
        user,
        siteSettings
    ]);
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var handleClickToLink = function() {
        var ref;
        var castWindow = window;
        var domain = user === null || user === void 0 ? void 0 : (ref = user.kol) === null || ref === void 0 ? void 0 : ref.domain;
        var siteSettingId = siteSettings.id;
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.PREVIEW_SITE */.Bt.PREVIEW_SITE, "PreviewSiteInBrowser", domain, ga_events/* ACTION_CONFIG.PREVIEW_SITE_IN_BROWSER */.AN.PREVIEW_SITE_IN_BROWSER);
        if (castWindow.flutter_inappwebview !== undefined) {
            var _flutter_inappwebview;
            var args = [
                {
                    url: "https://".concat(domain, "/preview?id=").concat(siteSettingId)
                }
            ];
            (_flutter_inappwebview = castWindow.flutter_inappwebview).callHandler.apply(_flutter_inappwebview, [
                "openInBrowser"
            ].concat(_toConsumableArray(args)));
        } else {
            window.open("https://".concat(domain, "/preview?id=").concat(siteSettingId), "_blank");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white",
                style: {
                    borderBottom: "1px solid rgb(238, 238, 238)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-width-content-class m-auto text-lg font-normal flex text-center items-center gap-1 p-3 relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            onClick: function() {
                                return onCancelPreview();
                            },
                            className: "cursor-pointer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* BackArrow */.D1, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "flex-1 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "flex items-center justify-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PreviewThemeIcon */.gc, {
                                        className: "w-5 h-5"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[18px] leading-6",
                                        children: t("ss_builder_theme_template_preview_mode_title")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "absolute right-2 top-2 cursor-pointer p-1",
                            onClick: function() {
                                return handleClickToLink();
                            },
                            title: t("ss_builder_browser_opening_label"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* GlobalIcon */.ww, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                style: {
                    height: "calc(100% - 50px)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    id: "theme-preview-iframe",
                    src: previewUrl,
                    className: "h-full w-full"
                })
            })
        ]
    });
};
/* harmony default export */ var components_Preview = (Preview);

// EXTERNAL MODULE: ./src/features/share/icons/product-tour-icon.tsx
var product_tour_icon = __webpack_require__(16525);
// EXTERNAL MODULE: ./src/features/design/components/ProductTour/product-tour-config.ts
var product_tour_config = __webpack_require__(35445);
// EXTERNAL MODULE: ./src/features/share/components/ProductTourComponent/index.tsx
var ProductTourComponent = __webpack_require__(17347);
// EXTERNAL MODULE: ./src/features/main/store/creatorProfileSlice.ts
var creatorProfileSlice = __webpack_require__(72976);
;// CONCATENATED MODULE: ./src/features/design/components/ProductTour/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



















var ProductTour = function(props) {
    var ref5, ref1;
    var handleOpenProductTour = props.handleOpenProductTour, isProductTourManual = props.isProductTourManual;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var productTourRef = (0,react.useRef)(null);
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var user = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.user;
    });
    var domain = user === null || user === void 0 ? void 0 : (ref5 = user.kol) === null || ref5 === void 0 ? void 0 : ref5.domain;
    var userId = user === null || user === void 0 ? void 0 : (ref1 = user.kol) === null || ref1 === void 0 ? void 0 : ref1._id;
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var isEnableHeaderDynamic = dynamicConfig === null || dynamicConfig === void 0 ? void 0 : dynamicConfig.isEnableHeaderDynamic;
    var ref2 = (0,react.useState)(0), prevStepIndex = ref2[0], setPrevStepIndex = ref2[1];
    var ref3 = (0,react.useState)(true), check = ref3[0], setCheck = ref3[1];
    var ref4 = (0,react.useState)(true), checkComplete = ref4[0], setCheckComplete = ref4[1];
    var classHiddenCloseTooltip = isProductTourManual ? "" : "hidden-close-tooltip";
    var hiddenCloseTooltipSteps = [];
    var stepsDefault = product_tour_config/* steps.map */.S6.map(function(ele, idx) {
        return {
            title: '<div class="wrapper-image">' + product_tour_icon/* placeHolderImageIcon */.GT + '\n          <img class="img-product-tour" src='.concat(ele.image_header, ' /> </div>\n          <div class="title">').concat(t(ele.title_key), "<div/>"),
            element: ele.using_selector ? document.querySelector(".".concat(ele.element_class)) : ".".concat(ele.element_class),
            intro: "<div> ".concat(t(ele.intro_key), "<div/>"),
            tooltipClass: classnames_default()("tooltip-product-tour", !isProductTourManual && idx === product_tour_config/* STEP_INDEX.STEP_16 */.om.STEP_16 ? ele.tooltip_class.replace("show-label-text", "") : ele.tooltip_class, (hiddenCloseTooltipSteps === null || hiddenCloseTooltipSteps === void 0 ? void 0 : hiddenCloseTooltipSteps.includes(idx)) && classHiddenCloseTooltip),
            position: ele.position || "auto"
        };
    });
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var setRef = function(ref) {
        productTourRef.current = ref;
    };
    var onExit = function() {};
    var onBeforeExit = function(stepIndex) {
        if (check) {
            // tách GA step 17 để tracking riêng do step cuối bị duplicate
            if (isProductTourManual && prevStepIndex !== product_tour_config/* STEP_INDEX.STEP_16 */.om.STEP_16) {
                ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.PRODUCT_TOUR */.Bt.PRODUCT_TOUR, "ProductTour_Step".concat(stepIndex + 1), domain, "Step ".concat(stepIndex + 1));
            }
            if (!isProductTourManual && prevStepIndex !== product_tour_config/* STEP_INDEX.STEP_17 */.om.STEP_17) {
                ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.PRODUCT_TOUR_AUTO */.Bt.PRODUCT_TOUR_AUTO, "ProductTourAuto_Step".concat(stepIndex + 1), domain, "Step ".concat(stepIndex + 1));
            }
            setCheck(false);
            var castWindow = window;
            castWindow.triggerVisiblePopoverBlock(false);
            castWindow.triggerVisiblePopoverHeader(false);
            onCompleteProductTour();
        }
    };
    var handleEnableHeader = function() {
        var enableValue = configs_const/* DISABLE_POSITION */.MC;
        dispatch((0,positionsSlice/* disableEnablePosition */.uX)({
            enableValue: enableValue,
            positionSlug: configs_const/* POSITION_MAIN_LAYOUT.HEADER */.Kw.HEADER
        }));
    };
    var onChangeProductTour = function(nextStepIndex, nextElement) {
        var castWindow = window;
        //VisiblePopoverBlock
        if (nextStepIndex === product_tour_config/* STEP_INDEX.STEP_2 */.om.STEP_2 && prevStepIndex < nextStepIndex) {
            castWindow.triggerVisiblePopoverBlock(true);
        }
        if (nextStepIndex === product_tour_config/* STEP_INDEX.STEP_3 */.om.STEP_3) {
            productTourRef.current.updateStepElement(product_tour_config/* STEP_INDEX.STEP_3 */.om.STEP_3);
        }
        if (nextStepIndex === product_tour_config/* STEP_INDEX.STEP_5 */.om.STEP_5 && prevStepIndex < nextStepIndex || nextStepIndex === product_tour_config/* STEP_INDEX.STEP_1 */.om.STEP_1 && prevStepIndex > nextStepIndex) {
            castWindow.triggerVisiblePopoverBlock(false);
        }
        if (nextStepIndex === product_tour_config/* STEP_INDEX.STEP_4 */.om.STEP_4 && prevStepIndex > nextStepIndex) {
            castWindow.triggerVisiblePopoverBlock(true);
        }
        //VisiblePopoverHeader
        if (nextStepIndex === product_tour_config/* STEP_INDEX.STEP_8 */.om.STEP_8 && prevStepIndex < nextStepIndex) {
            castWindow.triggerVisiblePopoverHeader(true);
        }
        if (nextStepIndex === product_tour_config/* STEP_INDEX.STEP_9 */.om.STEP_9) {
            productTourRef.current.updateStepElement(product_tour_config/* STEP_INDEX.STEP_9 */.om.STEP_9);
        }
        if (nextStepIndex === product_tour_config/* STEP_INDEX.STEP_10 */.om.STEP_10) {
            productTourRef.current.updateStepElement(product_tour_config/* STEP_INDEX.STEP_10 */.om.STEP_10);
        }
        if (nextStepIndex === product_tour_config/* STEP_INDEX.STEP_12 */.om.STEP_12 && prevStepIndex < nextStepIndex || nextStepIndex === product_tour_config/* STEP_INDEX.STEP_7 */.om.STEP_7 && prevStepIndex > nextStepIndex) {
            castWindow.triggerVisiblePopoverHeader(false);
        }
        if (nextStepIndex === product_tour_config/* STEP_INDEX.STEP_11 */.om.STEP_11 && prevStepIndex > nextStepIndex) {
            castWindow.triggerVisiblePopoverHeader(true);
        }
        setPrevStepIndex(nextStepIndex);
    };
    (0,react.useEffect)(function() {
        if (prevStepIndex === product_tour_config/* STEP_INDEX.STEP_9 */.om.STEP_9) {
            document.querySelector(".".concat(product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_9 */.uN.STEP_9)).classList.add("step-9");
            if (document.querySelector(".".concat(product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_10 */.uN.STEP_10)).classList.contains("step-10")) {
                document.querySelector(".".concat(product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_10 */.uN.STEP_10)).classList.remove("step-10");
            }
        }
        if (prevStepIndex === product_tour_config/* STEP_INDEX.STEP_10 */.om.STEP_10) {
            document.querySelector(".".concat(product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_10 */.uN.STEP_10)).classList.add("step-10");
            if (document.querySelector(".".concat(product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_9 */.uN.STEP_9)).classList.contains("step-9")) {
                document.querySelector(".".concat(product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_9 */.uN.STEP_9)).classList.remove("step-9");
            }
        }
    }, [
        prevStepIndex
    ]);
    var onCompleteProductTour = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!checkComplete) {
                            _ctx.next = 19;
                            break;
                        }
                        setCheckComplete(false);
                        handleOpenProductTour();
                        if (isProductTourManual) {
                            _ctx.next = 15;
                            break;
                        }
                        res = null;
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return (0,api/* updateCreator */.Kz)({
                            finish_product_tour: store_interface/* FINISH_PRODUCT_TOUR_ENUM.TRUE */.Gx.TRUE
                        });
                    case 8:
                        res = _ctx.sent;
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](5);
                        console.log(_ctx.t0);
                    case 14:
                        dispatch((0,creatorProfileSlice/* setCreatorProfile */.I4)({
                            data: {
                                finish_product_tour: store_interface/* FINISH_PRODUCT_TOUR_ENUM.TRUE */.Gx.TRUE
                            }
                        }));
                    case 15:
                        if (isEnableHeaderDynamic) {
                            handleEnableHeader();
                        }
                        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
                            data: {
                                isOpenProductTourDynamic: false
                            }
                        }));
                        if (isProductTourManual && prevStepIndex === product_tour_config/* STEP_INDEX.STEP_16 */.om.STEP_16) {
                            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.PRODUCT_TOUR */.Bt.PRODUCT_TOUR, "ProductTour_Step16", domain, "Step 16");
                        }
                        if (!isProductTourManual && prevStepIndex === product_tour_config/* STEP_INDEX.STEP_17 */.om.STEP_17) {
                            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.PRODUCT_TOUR_AUTO */.Bt.PRODUCT_TOUR_AUTO, "ProductTourAuto_Step17", domain, "Step 17");
                        }
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    11
                ]
            ]);
        }));
        return function onCompleteProductTour() {
            return _ref.apply(this, arguments);
        };
    }();
    var stepsMemo1 = (0,react.useMemo)(function() {
        var stepsMemo = stepsDefault;
        if (isProductTourManual) {
            stepsMemo = stepsMemo.filter(function(ele, idx) {
                return idx !== product_tour_config/* STEP_INDEX.STEP_17 */.om.STEP_17;
            });
        }
        return stepsMemo;
    }, [
        isProductTourManual,
        stepsDefault
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTourComponent/* default */.Z, {
                steps: stepsMemo1,
                onExit: onExit,
                onBeforeExit: onBeforeExit,
                onChange: onChangeProductTour,
                onComplete: onCompleteProductTour,
                setRef: setRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(portal/* default */.Z, {
                elementId: "product-tour-skip-button-id",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "fixed top-4 left-4 z-[100000000] bg-[#ee3244ff] py-1 px-2 rounded-full text-base text-white shadow-lg flex flex-row gap-1 items-center",
                    onClick: onBeforeExit,
                    children: [
                        t("ss_builder_popover_manual_button_close"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                            width: 14,
                            height: 14,
                            onClick: function() {},
                            fillColor: "#FFFFFF"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_ProductTour = (ProductTour);

// EXTERNAL MODULE: ./src/features/design/components/ThemeTemplateHandler/ThemeTemplateLists/index.tsx
var ThemeTemplateLists = __webpack_require__(46073);
// EXTERNAL MODULE: ./src/features/share/lib/index.ts + 1 modules
var lib = __webpack_require__(11116);
// EXTERNAL MODULE: ./src/features/design/components/ThemeTemplateHandler/ThemeTemplatePreviewByImage/index.tsx
var ThemeTemplatePreviewByImage = __webpack_require__(46393);
// EXTERNAL MODULE: ./node_modules/react-select/creatable/dist/react-select-creatable.esm.js + 52 modules
var react_select_creatable_esm = __webpack_require__(68451);
// EXTERNAL MODULE: ./src/features/design/components/ThemeTemplateHandler/ThemeTemplateSaving/style.module.scss
var ThemeTemplateSaving_style_module = __webpack_require__(52889);
var ThemeTemplateSaving_style_module_default = /*#__PURE__*/__webpack_require__.n(ThemeTemplateSaving_style_module);
;// CONCATENATED MODULE: ./src/features/design/components/ThemeTemplateHandler/ThemeTemplateSaving/index.tsx
function ThemeTemplateSaving_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ThemeTemplateSaving_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ThemeTemplateSaving_arrayLikeToArray(arr);
}
function ThemeTemplateSaving_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ThemeTemplateSaving_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ThemeTemplateSaving_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ThemeTemplateSaving_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ThemeTemplateSaving_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ThemeTemplateSaving_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || ThemeTemplateSaving_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function ThemeTemplateSaving_toConsumableArray(arr) {
    return ThemeTemplateSaving_arrayWithoutHoles(arr) || ThemeTemplateSaving_iterableToArray(arr) || ThemeTemplateSaving_unsupportedIterableToArray(arr) || ThemeTemplateSaving_nonIterableSpread();
}
function ThemeTemplateSaving_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ThemeTemplateSaving_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ThemeTemplateSaving_arrayLikeToArray(o, minLen);
}















var createOption = function(label) {
    return {
        label: label,
        value: label
    };
};
var THEME_NAME_MAXIMUM = 25;
var KEY_ENTER = "Enter";
var KEY_COMMA = ",";
var ThemeTemplateSaving = function(props) {
    var ref17;
    var handleCancelThemeSaving = props.handleCancelThemeSaving, KEY = props.KEY, themeTemplateData = props.themeTemplateData, handleConfirmThemeSaving = props.handleConfirmThemeSaving;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var themeImageDefault = themeTemplateData === null || themeTemplateData === void 0 ? void 0 : themeTemplateData.image;
    var themeTitleDefault = themeTemplateData === null || themeTemplateData === void 0 ? void 0 : themeTemplateData.title;
    var user = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.user;
    });
    var userId = user === null || user === void 0 ? void 0 : (ref17 = user.kol) === null || ref17 === void 0 ? void 0 : ref17._id;
    var tagsDefault = themeTemplateData === null || themeTemplateData === void 0 ? void 0 : themeTemplateData.tags;
    var tags = tagsDefault === null || tagsDefault === void 0 ? void 0 : tagsDefault.map(function(ele) {
        return {
            label: ele,
            value: ele
        };
    });
    var regexPattern = /\s+/g;
    var ref1 = (0,react.useState)(themeTitleDefault), themeNameValue = ref1[0], setThemeNameValue = ref1[1];
    var ref2 = (0,react.useState)(themeImageDefault), valueUrlImage = ref2[0], setValueUrlImage = ref2[1];
    var ref3 = (0,react.useState)(""), valueNameImage = ref3[0], setValueNameImage = ref3[1];
    var ref4 = (0,react.useState)(null), valueImageBase64 = ref4[0], setValueImageBase64 = ref4[1];
    var ref5 = (0,react.useState)([]), uploadedImageArr = ref5[0], setUploadedImageArr = ref5[1];
    var ref6 = (0,react.useState)(false), isValidFileFormat = ref6[0], setIsValidFileFormat = ref6[1];
    var ref7 = (0,react.useState)(false), isValidFileSize = ref7[0], setIsValidFileSize = ref7[1];
    var ref8 = (0,react.useState)(false), isOpenThemeTemplatePreview = ref8[0], setIsOpenThemeTemplatePreview = ref8[1];
    var ref9 = (0,react.useState)([]), themeTemplateArr = ref9[0], setThemeTemplateArr = ref9[1];
    var ref10 = (0,react.useState)([]), suggestions = ref10[0], setSuggestions = ref10[1];
    var ref11 = (0,react.useState)(""), inputValueTag = ref11[0], setInputValueTag = ref11[1];
    var ref12 = _slicedToArray(react.useState(tags !== null && tags !== void 0 ? tags : []), 2), valueTag = ref12[0], setValueTag = ref12[1];
    var ref13 = (0,react.useState)(tagsDefault), tagThemeTemplate = ref13[0], setTagThemeTemplate = ref13[1];
    var ref14 = (0,react.useState)(false), isOpenMenu = ref14[0], setIsOpenMenu = ref14[1];
    var requestTagList = function() {
        var _ref = ThemeTemplateSaving_asyncToGenerator(runtime_default().mark(function _callee() {
            var keyword, listTagResponse, dataRequest, options, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        keyword = _args.length > 0 && _args[0] !== void 0 ? _args[0] : "";
                        listTagResponse = null;
                        dataRequest = {
                            per_page: 12,
                            keyword: keyword ? keyword.trim().replaceAll(regexPattern, " ").replaceAll(KEY_COMMA, "") : ""
                        };
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return (0,api/* requestSearchTag */.sV)(dataRequest);
                    case 6:
                        listTagResponse = _ctx.sent;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](3);
                        console.log(_ctx.t0);
                    case 12:
                        options = listTagResponse === null || listTagResponse === void 0 ? void 0 : listTagResponse.data.map(function(ele) {
                            return {
                                value: ele.title,
                                label: ele.title
                            };
                        });
                        setSuggestions(options !== null && options !== void 0 ? options : []);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    9
                ]
            ]);
        }));
        return function requestTagList() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var requestThemeTemplateList = function() {
            var _ref = ThemeTemplateSaving_asyncToGenerator(runtime_default().mark(function _callee() {
                var listThemeResponse, dataRequest, listThemeArr;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            listThemeResponse = null;
                            dataRequest = {
                                per_page: 100,
                                keyword: ""
                            };
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return (0,api/* requestSearchThemeTemplate */.IU)(dataRequest);
                        case 5:
                            listThemeResponse = _ctx.sent;
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](2);
                            console.log(_ctx.t0);
                        case 11:
                            listThemeArr = listThemeResponse === null || listThemeResponse === void 0 ? void 0 : listThemeResponse.data;
                            if (listThemeArr) setThemeTemplateArr(listThemeArr);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        8
                    ]
                ]);
            }));
            return function requestThemeTemplateList() {
                return _ref.apply(this, arguments);
            };
        }();
        requestThemeTemplateList();
    }, []);
    var checkDuplicateNameTheme = (0,react.useMemo)(function() {
        var themeDuplicatedName = null;
        if (KEY === configs_const/* THEME_TEMPLATE_KEY.SAVE_NEW */.vF.SAVE_NEW) {
            themeDuplicatedName = themeTemplateArr === null || themeTemplateArr === void 0 ? void 0 : themeTemplateArr.find(function(x) {
                var ref, ref15, ref16;
                return ((ref15 = x === null || x === void 0 ? void 0 : (ref = x.title) === null || ref === void 0 ? void 0 : ref.trim()) === null || ref15 === void 0 ? void 0 : ref15.toLowerCase()) === ((ref16 = themeNameValue === null || themeNameValue === void 0 ? void 0 : themeNameValue.trim()) === null || ref16 === void 0 ? void 0 : ref16.toLowerCase());
            });
        } else if (KEY === configs_const/* THEME_TEMPLATE_KEY.EDIT */.vF.EDIT || KEY === configs_const/* THEME_TEMPLATE_KEY.OVERWRITE */.vF.OVERWRITE) {
            var ref18;
            themeDuplicatedName = (ref18 = themeTemplateArr === null || themeTemplateArr === void 0 ? void 0 : themeTemplateArr.filter(function(a) {
                return a.id !== (themeTemplateData === null || themeTemplateData === void 0 ? void 0 : themeTemplateData.id);
            })) === null || ref18 === void 0 ? void 0 : ref18.find(function(x) {
                var ref, ref19, ref20;
                return ((ref19 = x === null || x === void 0 ? void 0 : (ref = x.title) === null || ref === void 0 ? void 0 : ref.trim()) === null || ref19 === void 0 ? void 0 : ref19.toLowerCase()) === ((ref20 = themeNameValue === null || themeNameValue === void 0 ? void 0 : themeNameValue.trim()) === null || ref20 === void 0 ? void 0 : ref20.toLowerCase());
            });
        }
        if (themeDuplicatedName) {
            return true;
        } else return false;
    }, [
        themeTemplateArr,
        themeNameValue
    ]);
    var handleImageUrl = function(value) {
        var imgFileItems = value && value[value.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
        } else {
            setUploadedImageArr(value);
            setValueImageBase64(imgFileItems.dataBase64);
            setValueUrlImage(imgFileItems.url);
            setValueNameImage(imgFileItems.fileName);
            setIsValidFileFormat(false);
            setIsValidFileSize(false);
        }
    };
    var handleChangeThemeTemplateName = function(val) {
        if (val.length <= THEME_NAME_MAXIMUM) {
            setThemeNameValue(val);
        }
    };
    var titlePageRender = (0,react.useMemo)(function() {
        var titleValue = "";
        switch(KEY){
            case configs_const/* THEME_TEMPLATE_KEY.SAVE_NEW */.vF.SAVE_NEW:
                titleValue = t("ss_builder_save_new_theme_template_title");
                break;
            case configs_const/* THEME_TEMPLATE_KEY.OVERWRITE */.vF.OVERWRITE:
                titleValue = t("ss_builder_overwrite_theme_template_title");
                break;
            case configs_const/* THEME_TEMPLATE_KEY.EDIT */.vF.EDIT:
                titleValue = t("ss_builder_edit_theme_template_title");
                break;
        }
        return titleValue;
    }, [
        KEY
    ]);
    var buttonSaveLabelRender = (0,react.useMemo)(function() {
        var btnLabel = "";
        switch(KEY){
            case configs_const/* THEME_TEMPLATE_KEY.SAVE_NEW */.vF.SAVE_NEW:
                btnLabel = t("ss_builder_add_new_theme_btn_label");
                break;
            case configs_const/* THEME_TEMPLATE_KEY.OVERWRITE */.vF.OVERWRITE:
                btnLabel = t("ss_builder_overwrite_theme_btn_label");
                break;
            case configs_const/* THEME_TEMPLATE_KEY.EDIT */.vF.EDIT:
                btnLabel = t("ss_builder_edit_theme_btn_label");
                break;
        }
        return btnLabel;
    }, [
        KEY
    ]);
    var handleOpenThemeTemplatePreview = function() {
        setIsOpenThemeTemplatePreview(true);
    };
    var isDisableSaveBtn = (0,react.useMemo)(function() {
        if (valueUrlImage && themeNameValue && !checkDuplicateNameTheme || KEY === configs_const/* THEME_TEMPLATE_KEY.EDIT */.vF.EDIT && !checkDuplicateNameTheme && (valueUrlImage && valueUrlImage !== themeImageDefault || themeNameValue && themeNameValue !== themeTitleDefault) || tagThemeTemplate !== tagsDefault) {
            return false;
        } else return true;
    }, [
        valueUrlImage,
        themeNameValue,
        themeImageDefault,
        themeTitleDefault,
        KEY,
        checkDuplicateNameTheme, 
    ]);
    var handleSaveTheme = function() {
        handleConfirmThemeSaving({
            image: (valueUrlImage === null || valueUrlImage === void 0 ? void 0 : valueUrlImage.startsWith("http")) ? valueUrlImage : valueImageBase64,
            image_name: valueNameImage,
            title: themeNameValue,
            id: themeTemplateData === null || themeTemplateData === void 0 ? void 0 : themeTemplateData.id,
            tags: tagThemeTemplate !== null && tagThemeTemplate !== void 0 ? tagThemeTemplate : []
        });
        createManyTag(tagThemeTemplate);
    };
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (themeNameValue !== themeTitleDefault || valueUrlImage !== themeImageDefault) {
            return true;
        } else return false;
    }, [
        themeNameValue,
        themeTitleDefault,
        valueUrlImage,
        themeImageDefault
    ]);
    var handleCancelSaveTheme = function() {
        if (isEditDataStatus) {
            es/* Modal.confirm */.u_.confirm({
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                    className: "w-11 h-11",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_cancel_edit_block_title")
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                    children: t("ss_builder_cancel_edit_block_content")
                }),
                confirmText: t("ss_builder_continue_edit_block_label"),
                cancelText: t("ss_builder_cancel_block_btn_label"),
                onConfirm: function() {
                    return;
                },
                onCancel: function() {
                    return handleCancelThemeSaving();
                }
            });
        } else {
            handleCancelThemeSaving();
        }
    };
    var createManyTag = function() {
        var _ref = ThemeTemplateSaving_asyncToGenerator(runtime_default().mark(function _callee(value) {
            var createTagResponse, dataRequest, listTagArr;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        createTagResponse = null;
                        dataRequest = {
                            user_id: userId,
                            list_tags: value
                        };
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,api/* createManyTagThemeTemplate */.Dw)(dataRequest);
                    case 5:
                        createTagResponse = _ctx.sent;
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        console.log(_ctx.t0);
                    case 11:
                        listTagArr = createTagResponse === null || createTagResponse === void 0 ? void 0 : createTagResponse.data;
                        if (listTagArr.error) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return", true);
                    case 14:
                        return _ctx.abrupt("return", false);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return function createManyTag(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleKeyDown = function() {
        var _ref = ThemeTemplateSaving_asyncToGenerator(runtime_default().mark(function _callee(event) {
            var inputValueTagTrim;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (inputValueTag) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (!(event.key === KEY_ENTER || event.key === KEY_COMMA)) {
                            _ctx.next = 7;
                            break;
                        }
                        inputValueTagTrim = inputValueTag.trim().replaceAll(regexPattern, " ").replaceAll(KEY_COMMA, "");
                        if (!suggestions.some(function(x) {
                            return x.value === inputValueTagTrim;
                        })) {
                            handeSetValueTag(ThemeTemplateSaving_toConsumableArray(valueTag).concat([
                                createOption(inputValueTagTrim)
                            ]));
                            setInputValueTag("");
                        } else {
                            if (!valueTag.some(function(x) {
                                return x.value === inputValueTagTrim;
                            })) {
                                handeSetValueTag(ThemeTemplateSaving_toConsumableArray(valueTag).concat([
                                    createOption(inputValueTagTrim)
                                ]));
                                setInputValueTag("");
                            }
                        }
                        event.preventDefault();
                        return _ctx.abrupt("return");
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleKeyDown(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var handeSetValueTag = function(value) {
        var newValue = value.map(function(ele) {
            return _objectSpread({}, ele, {
                value: ele.value.trim().replaceAll(regexPattern, " ").replaceAll(KEY_COMMA, ""),
                label: ele.label.trim().replaceAll(regexPattern, " ").replaceAll(KEY_COMMA, "")
            });
        });
        setValueTag(newValue);
        var tagTheme = newValue.map(function(ele) {
            return ele.value;
        });
        setTagThemeTemplate(tagTheme);
    };
    var useDebounceSearch = (0,esm/* useDebounce */.Nr)(inputValueTag, 500);
    (0,react.useEffect)(function() {
        if (useDebounceSearch) {
            requestTagList(inputValueTag);
        }
    }, [
        useDebounceSearch
    ]);
    var handeInputChange = function(options, param) {
        var action = param.action;
        setInputValueTag(options);
        setIsOpenMenu(options.length > 1);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pb-[60px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row text-center items-center justify-center py-3 gap-[10px] relative bg-white",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SaveIcon */.N, {
                        className: "w-[22px] h-[22px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[18px] leading-6",
                        children: titlePageRender
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 py-3 bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-[15px] text-[#666666]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-red-600",
                                children: "*"
                            }),
                            t("ss_builder_add_new_theme_template_image_title")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                        src: valueUrlImage || "https://image.passio.eco/page-builder/page-builder/images-default/image-validate-default-alert.png",
                        fit: "cover",
                        style: {
                            backgroundSize: "cover",
                            aspectRatio: "16/9",
                            border: "1px solid #D9D9D9"
                        }
                    }),
                    isValidFileFormat && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center mt-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                fillColor: "#FF3141",
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#FF3141]",
                                children: t("ss_builder_upload_file_format_invalid_content")
                            })
                        ]
                    }),
                    isValidFileSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-1 items-center mt-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                fillColor: "#FF3141",
                                className: "w-4 h-4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#FF3141]",
                                children: t("ss_builder_upload_file_size_invalid_content")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-2 mt-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                size: "middle",
                                color: "primary",
                                fill: "outline",
                                className: "",
                                onClick: valueUrlImage ? handleOpenThemeTemplatePreview : function() {},
                                style: {
                                    opacity: !valueUrlImage ? "0.4" : ""
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PreviewThemeIcon */.gc, {
                                    className: "w-[17px] h-[17px]",
                                    fillColor: "#EE3244"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                                onChange: handleImageUrl,
                                upload: function(file) {
                                    return (0,lib/* mockUpload */.Hq)(file, 514);
                                },
                                className: "image-slider-upload ".concat(uploadedImageArr.length > 0 ? "image-uploaded-hidden" : ""),
                                value: uploadedImageArr,
                                // disableUpload={isDisableUploadBtn}
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                    block: true,
                                    color: "primary",
                                    fill: "solid",
                                    size: "middle",
                                    className: "w-full grow",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row gap-2 justify-center items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* UploadIcon */.e3, {
                                                className: "w-[17px] h-[17px]",
                                                fillColor: "white"
                                            }),
                                            t("ss_builder_upload_button_label")
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[15px] text-[#666666]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    }),
                                    t("ss_builder_add_new_theme_template_name_title")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                placeholder: t("ss_builder_add_new_theme_template_name_placeholder"),
                                onChange: handleChangeThemeTemplateName,
                                value: themeNameValue,
                                maxLength: THEME_NAME_MAXIMUM
                            }),
                            checkDuplicateNameTheme && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[13px] leading-[17px] text-[#FF3141]",
                                children: t("ss_builder_duplicated_theme_template_name_warning")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(themeNameValue ? themeNameValue.length : 0, "/").concat(THEME_NAME_MAXIMUM)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] text-[#666666] leading-[150%]",
                                children: t("ss_builder_theme_template_label_tag")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_creatable_esm/* default */.Z, {
                                    isClearable: true,
                                    isMulti: true,
                                    options: suggestions,
                                    inputValue: inputValueTag,
                                    onChange: function(newValue) {
                                        return handeSetValueTag(newValue);
                                    },
                                    onInputChange: function(newValue, param) {
                                        var action = param.action;
                                        return handeInputChange(newValue, {
                                            action: action
                                        });
                                    },
                                    onKeyDown: handleKeyDown,
                                    value: valueTag,
                                    placeholder: t("ss_builder_theme_template_label_tag_placeholder"),
                                    classNames: {
                                        control: function(state) {
                                            return "".concat((ThemeTemplateSaving_style_module_default()).borderTag);
                                        }
                                    },
                                    className: "react-select-container",
                                    classNamePrefix: "react-select",
                                    menuIsOpen: isOpenMenu,
                                    components: {
                                        DropdownIndicator: function() {
                                            return null;
                                        },
                                        IndicatorSeparator: function() {
                                            return null;
                                        }
                                    },
                                    formatCreateLabel: function(userInput) {
                                        return "".concat(t("ss_builder_theme_template_format_create_label"), ' "').concat(userInput, '"');
                                    },
                                    noOptionsMessage: function() {
                                        return null;
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[1] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            onClick: handleCancelSaveTheme,
                            children: t("ss_builder_editor_btn-cancel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            color: "primary",
                            onClick: function() {
                                return handleSaveTheme();
                            },
                            disabled: isDisableSaveBtn,
                            children: buttonSaveLabelRender
                        })
                    })
                ]
            }),
            isOpenThemeTemplatePreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenThemeTemplatePreview,
                onMaskClick: function() {
                    setIsOpenThemeTemplatePreview(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeTemplatePreviewByImage/* default */.Z, {
                    handleCancelThemeTemplatePreview: function() {
                        return setIsOpenThemeTemplatePreview(false);
                    },
                    imageSrc: valueUrlImage,
                    KEY: configs_const/* THEME_PREVIEW_BY_IMAGE_KEY.PREVIEW */.cQ.PREVIEW
                })
            })
        ]
    });
};
/* harmony default export */ var ThemeTemplateHandler_ThemeTemplateSaving = (ThemeTemplateSaving);

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./src/features/design/components/ThemeTemplateHandler/ThemeTemplateOverwrite/index.tsx
function ThemeTemplateOverwrite_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ThemeTemplateOverwrite_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ThemeTemplateOverwrite_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ThemeTemplateOverwrite_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ThemeTemplateOverwrite_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ThemeTemplateOverwrite_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ThemeTemplateOverwrite_defineProperty(target, key, source[key]);
        });
    }
    return target;
}














var ThemeTemplateOverwrite = function(props) {
    var onCancelThemeTemplateOverwrite = props.onCancelThemeTemplateOverwrite, onSaveThemeTemplateOverwrite = props.onSaveThemeTemplateOverwrite, user = props.user;
    var ref10 = (0,react.useState)(null), selectedThemeData = ref10[0], setSelectedThemeData = ref10[1];
    var ref1 = (0,react.useState)([]), themeTemplateArr = ref1[0], setThemeTemplateArr = ref1[1];
    var ref2 = (0,react.useState)(false), isOpenOverwriteThemeSaving = ref2[0], setIsOpenOverwriteThemeSaving = ref2[1];
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var creator_role = passioPageProfile === null || passioPageProfile === void 0 ? void 0 : passioPageProfile.creator_role;
    var isAdminRole = (0,react.useMemo)(function() {
        return creator_role === store_interface/* CREATOR_ROLE_ENUM.ADMIN */.lp.ADMIN;
    }, [
        creator_role
    ]);
    (0,react.useEffect)(function() {
        var requestThemeTemplateList = function() {
            var _ref = ThemeTemplateOverwrite_asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, ref3, ref4, ref5, ref6, ref7, ref8, ref9, listThemeResponse, packageSASS, dataRequest, listThemePremium, listThemeArr, listThemeArrClone;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            listThemeResponse = null;
                            packageSASS = null;
                            dataRequest = {
                                per_page: 100,
                                keyword: "",
                                is_admin: isAdminRole
                            };
                            _ctx.prev = 4;
                            _ctx.next = 7;
                            return (0,api/* requestSearchThemeTemplate */.IU)(dataRequest);
                        case 7:
                            listThemeResponse = _ctx.sent;
                            _ctx.next = 10;
                            return (0,api/* getPackageSass */.Xg)();
                        case 10:
                            packageSASS = _ctx.sent;
                            _ctx.next = 16;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](4);
                            console.log(_ctx.t0);
                        case 16:
                            listThemePremium = (ref5 = packageSASS === null || packageSASS === void 0 ? void 0 : (ref = packageSASS.data) === null || ref === void 0 ? void 0 : (ref3 = ref.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.packages) === null || ref4 === void 0 ? void 0 : ref4.find(function(item) {
                                return item.id === 1;
                            })) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.params) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.passio_page_service) === null || ref7 === void 0 ? void 0 : ref7.premium_theme;
                            listThemeArr = listThemeResponse === null || listThemeResponse === void 0 ? void 0 : (ref8 = listThemeResponse.data) === null || ref8 === void 0 ? void 0 : ref8.map(function(theme) {
                                if (listThemePremium === null || listThemePremium === void 0 ? void 0 : listThemePremium.includes(theme === null || theme === void 0 ? void 0 : theme.id)) return ThemeTemplateOverwrite_objectSpread({}, theme, {
                                    is_premium: true
                                });
                                return ThemeTemplateOverwrite_objectSpread({}, theme, {
                                    is_premium: false
                                });
                            });
                            // check thi truong PH
                            if (listThemeArr && (user === null || user === void 0 ? void 0 : (ref9 = user.kol) === null || ref9 === void 0 ? void 0 : ref9.country) === configs_const/* COUNTRY_PH */.KP) {
                                setThemeTemplateArr(listThemeArr);
                            } else {
                                listThemeArrClone = listThemeArr === null || listThemeArr === void 0 ? void 0 : listThemeArr.filter(function(item) {
                                    return !(item === null || item === void 0 ? void 0 : item.is_premium);
                                });
                                setThemeTemplateArr(listThemeArrClone);
                            }
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        13
                    ]
                ]);
            }));
            return function requestThemeTemplateList() {
                return _ref.apply(this, arguments);
            };
        }();
        requestThemeTemplateList();
    }, []);
    var handleSelectTheme = function(val) {
        setSelectedThemeData(val);
    };
    var handleSaveThemeTemplateOverwrite = function() {
        es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("ss_builder_confirm_overwrite_theme_template_modal_title")
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_confirm_overwrite_theme_template_modal_content")
            }),
            confirmText: t("ss_builder_confirm_overwrite_theme_template_btn_label"),
            cancelText: t("ss_builder_cancel_overwrite_theme_template_btn_label"),
            onConfirm: function() {
                setIsOpenOverwriteThemeSaving(true);
            },
            onCancel: function() {
                return;
            }
        });
    };
    var themeSelectData = (0,react.useMemo)(function() {
        return themeTemplateArr === null || themeTemplateArr === void 0 ? void 0 : themeTemplateArr.find(function(x) {
            return x.id === (selectedThemeData === null || selectedThemeData === void 0 ? void 0 : selectedThemeData.id);
        });
    }, [
        themeTemplateArr,
        selectedThemeData
    ]);
    var handleCancelOverwriteThemeSaving = function() {
        setIsOpenOverwriteThemeSaving(false);
    };
    var handleConfirmOverwriteTheme = function(data) {
        onSaveThemeTemplateOverwrite(data, handleCancelOverwriteThemeSaving);
    };
    var handleRequestSearchTheme = function() {
        var _ref = ThemeTemplateOverwrite_asyncToGenerator(runtime_default().mark(function _callee(value) {
            var searchResponseData, dataRequest, listThemeArr;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        searchResponseData = null;
                        dataRequest = {
                            per_page: 100,
                            keyword: value.trim(),
                            is_admin: isAdminRole
                        };
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,api/* requestSearchThemeTemplate */.IU)(dataRequest);
                    case 5:
                        searchResponseData = _ctx.sent;
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        console.log(_ctx.t0);
                    case 11:
                        listThemeArr = searchResponseData === null || searchResponseData === void 0 ? void 0 : searchResponseData.data;
                        if (listThemeArr) setThemeTemplateArr(listThemeArr);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return function handleRequestSearchTheme(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSearchThemeTemplate = (0,react.useCallback)(debounce_default()(handleRequestSearchTheme, 1000), []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sticky top-0 bg-white pb-3 z-[6]",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row text-center items-center justify-center py-3 gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SaveIcon */.N, {
                                className: "w-6 h-6"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[18px] leading-6",
                                children: t("ss_builder_overwrite_theme_template_title")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SearchBar */.E1, {
                        placeholder: t("ss_builder_theme_template_search_bar_placeholder"),
                        className: "mx-4",
                        onChange: function(val) {
                            return handleSearchThemeTemplate(val);
                        },
                        onSearch: function(val) {
                            return handleRequestSearchTheme(val);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeTemplateLists/* default */.Z, {
                onSelectTheme: handleSelectTheme,
                KEY: configs_const/* THEME_RENDER_LIST_KEY.THEME_OVERWRITE_SELECTION */.q9.THEME_OVERWRITE_SELECTION,
                themeTemplateData: themeTemplateArr
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[1] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            onClick: onCancelThemeTemplateOverwrite,
                            children: t("ss_builder_editor_btn-cancel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            color: "primary",
                            onClick: handleSaveThemeTemplateOverwrite,
                            disabled: !selectedThemeData,
                            children: t("ss_builder_overwrite_theme_btn_label")
                        })
                    })
                ]
            }),
            isOpenOverwriteThemeSaving && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenOverwriteThemeSaving,
                onMaskClick: function() {
                    setIsOpenOverwriteThemeSaving(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeTemplateHandler_ThemeTemplateSaving, {
                    handleCancelThemeSaving: function() {
                        return setIsOpenOverwriteThemeSaving(false);
                    },
                    KEY: configs_const/* THEME_TEMPLATE_KEY.OVERWRITE */.vF.OVERWRITE,
                    handleConfirmThemeSaving: handleConfirmOverwriteTheme,
                    themeTemplateData: themeSelectData
                })
            })
        ]
    });
};
/* harmony default export */ var ThemeTemplateHandler_ThemeTemplateOverwrite = (ThemeTemplateOverwrite);

// EXTERNAL MODULE: ./src/features/share/icons/line-icon.tsx
var line_icon = __webpack_require__(45297);
// EXTERNAL MODULE: ./src/features/share/hooks/modal.tsx
var modal = __webpack_require__(5996);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 16 modules
var react_redux_es = __webpack_require__(92145);
// EXTERNAL MODULE: ./src/features/user/userSlice.ts
var userSlice = __webpack_require__(79206);
;// CONCATENATED MODULE: ./src/features/design/components/ThemeTemplateHandler/ThemeTemplatePreview/component/ButtonViewTheme/index.tsx
function ButtonViewTheme_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ButtonViewTheme_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ButtonViewTheme_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var ButtonViewTheme = function(param) {
    var _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, icon = param.icon, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {
        return null;
    } : _onClick, extra = param.extra, label = param.label, style = param.style;
    var handleClick = function() {
        onClick();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("flex items-center h-[32px] bg-[#F5F5F5] cursor-pointer rounded-full", {
                "bg-[#EE3244]": isActive,
                "bg-[#F5F5F5]": !isActive,
                "text-white": isActive,
                "text-[#333333]": !isActive
            }),
            onClick: handleClick,
            style: ButtonViewTheme_objectSpread({}, style),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center pl-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "pr-1",
                            children: icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[15px] leading-5",
                            children: label
                        })
                    ]
                }),
                extra
            ]
        })
    });
};
/* harmony default export */ var component_ButtonViewTheme = (ButtonViewTheme);

// EXTERNAL MODULE: ./src/features/design/components/ListItemScrollHorizontal/index.tsx
var ListItemScrollHorizontal = __webpack_require__(82071);
// EXTERNAL MODULE: ./src/features/design/components/ThemeTemplateHandler/ThemeTemplatePreview/style.module.scss
var ThemeTemplatePreview_style_module = __webpack_require__(52706);
var ThemeTemplatePreview_style_module_default = /*#__PURE__*/__webpack_require__.n(ThemeTemplatePreview_style_module);
;// CONCATENATED MODULE: ./src/features/design/components/UpgradeAccount/index.tsx
function UpgradeAccount_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function UpgradeAccount_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                UpgradeAccount_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                UpgradeAccount_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function UpgradeAccount_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function UpgradeAccount_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            UpgradeAccount_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var MESSAGE_START_PURCHASE = "start-purchase";
var MESSAGE_SUCCESS_PURCHASE = "purchase-success";
var KOL_PRICING = "https://dev.account.passio.eco/kol/pricing";
var NEXT_PUBLIC_PASSIO_ACCOUNT = "https://dev.account.passio.eco";
var UpgradeAccount = function(param) {
    var user = param.user, onClose = param.onClose, handleSetPackageType = param.handleSetPackageType;
    var ref11, ref1;
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var ref2 = (0,react.useState)({
        package_type: user === null || user === void 0 ? void 0 : (ref11 = user.kol) === null || ref11 === void 0 ? void 0 : ref11.package_type,
        package_name: user === null || user === void 0 ? void 0 : (ref1 = user.kol) === null || ref1 === void 0 ? void 0 : ref1.package_name
    }), packageUser = ref2[0], setPackageUser = ref2[1];
    var ref3 = (0,react.useState)(false), visible = ref3[0], setVisible = ref3[1];
    var ref4 = (0,react.useState)(true), visibleIcon = ref4[0], setVisibleIcon = ref4[1];
    var handleMessage = function() {
        var _ref = UpgradeAccount_asyncToGenerator(runtime_default().mark(function _callee(event) {
            var ref, data, isMatchDomain, ref5, ref6, ref7, ref8, ref9, ref10, getPackageOfUse, packageOfUser;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        data = (ref = event.data) === null || ref === void 0 ? void 0 : ref.key;
                        isMatchDomain = event.origin === NEXT_PUBLIC_PASSIO_ACCOUNT;
                        if (data === MESSAGE_START_PURCHASE) {
                            handleVisibleIcon(false);
                        }
                        if (!(data === MESSAGE_SUCCESS_PURCHASE && isMatchDomain)) {
                            _ctx.next = 19;
                            break;
                        }
                        _ctx.prev = 5;
                        ;
                        _ctx.next = 9;
                        return (0,api/* getPackageOfUser */.iF)();
                    case 9:
                        getPackageOfUse = _ctx.sent;
                        packageOfUser = {
                            package_type: getPackageOfUse === null || getPackageOfUse === void 0 ? void 0 : (ref5 = getPackageOfUse.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.language) === null || ref7 === void 0 ? void 0 : ref7.id,
                            package_name: getPackageOfUse === null || getPackageOfUse === void 0 ? void 0 : (ref8 = getPackageOfUse.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.language) === null || ref10 === void 0 ? void 0 : ref10.name
                        };
                        dispatch((0,userSlice/* setProfile */.RG)(UpgradeAccount_objectSpread({}, user === null || user === void 0 ? void 0 : user.kol, packageOfUser)));
                        handleSetPackageType(packageOfUser.package_type);
                        if (getPackageOfUse) {
                            handleClosePopup();
                        }
                        _ctx.next = 19;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](5);
                        console.log(_ctx.t0);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    16
                ]
            ]);
        }));
        return function handleMessage(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleVisibleIcon = function(value) {
        setVisibleIcon(value);
    };
    var handleClosePopup = function() {
        setVisible(false);
        onClose();
    };
    (0,react.useEffect)(function() {
        window.addEventListener("message", handleMessage, false);
        return function() {
            return window.removeEventListener("message", handleMessage);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-full w-full relative max-w-[414px] m-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                id: "iframe-sass",
                src: KOL_PRICING,
                className: "h-full w-full"
            }),
            visibleIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-4 right-4 cursor-pointer",
                onClick: function() {
                    return handleClosePopup();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* XIconV2 */.fx, {})
            })
        ]
    });
};
/* harmony default export */ var components_UpgradeAccount = (UpgradeAccount);

;// CONCATENATED MODULE: ./src/features/share/components/PopupFull/index.tsx
function PopupFull_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PopupFull_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PopupFull_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





function PopupFull(param) {
    var visible = param.visible, onMaskClick = param.onMaskClick, children = param.children, _position = param.position, position = _position === void 0 ? "bottom" : _position, _heightPopup = param.heightPopup, heightPopup = _heightPopup === void 0 ? "100%" : _heightPopup, _popupPanel = param.popupPanel, popupPanel = _popupPanel === void 0 ? false : _popupPanel, _isLimitWidth = param.isLimitWidth, isLimitWidth = _isLimitWidth === void 0 ? true : _isLimitWidth, _style = param.style, style = _style === void 0 ? {} : _style, _className = param.className, className = _className === void 0 ? "" : _className, _reduceMotionAnt = param.reduceMotionAnt, reduceMotionAnt = _reduceMotionAnt === void 0 ? false : _reduceMotionAnt;
    var stylePopup = style;
    if (popupPanel) {
        stylePopup = PopupFull_objectSpread({}, stylePopup, {
            maxWidth: "".concat(configs_const/* MAX_WIDTH_CONTENT_LAYOUT */.t, "px"),
            borderRadius: "8px 8px 0 0"
        });
    }
    (0,react.useEffect)(function() {
        if (reduceMotionAnt) {
            (0,es/* reduceMotion */.r)();
        }
    }, [
        reduceMotionAnt
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popup */.GI, {
        visible: visible,
        onMaskClick: onMaskClick,
        position: position,
        className: popupPanel ? "".concat(className) : "".concat(className, " full-screen-popup"),
        bodyClassName: popupPanel ? "adm-popup-body-position-bottom-panel" : "full-screen-popup-body m-auto",
        bodyStyle: {
            backgroundColor: "none"
        },
        children: visible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("full-screen-popup-content bg-[#f5f5f5] m-auto relative"),
            style: PopupFull_objectSpread({
                overflow: "overlay",
                height: heightPopup ? heightPopup : "100%"
            }, stylePopup),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()(isLimitWidth && "max-width-content-class", "w-full h-full m-auto"),
                children: children
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/features/design/components/ThemeTemplateHandler/ThemeTemplatePreview/index.tsx
function ThemeTemplatePreview_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ThemeTemplatePreview_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ThemeTemplatePreview_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ThemeTemplatePreview_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ThemeTemplatePreview_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ThemeTemplatePreview_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ThemeTemplatePreview_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
























var BUTTON_VIEW_THEME = {
    VIEW: "view",
    PREVIEW: "preview"
};
var ThemeTemplatePreview = function(props) {
    var ref17;
    var selectedThemeData = props.selectedThemeData, user = props.user, onCancelThemeTemplatePreview = props.onCancelThemeTemplatePreview, onConfirmThemeTemplatePreview = props.onConfirmThemeTemplatePreview, KEY = props.KEY, _siteSettingUserRootId = props.siteSettingUserRootId, siteSettingUserRootId = _siteSettingUserRootId === void 0 ? null : _siteSettingUserRootId, _userRootId = props.userRootId, userRootId = _userRootId === void 0 ? null : _userRootId, _isViewTheme = props.isViewTheme, isViewTheme = _isViewTheme === void 0 ? false : _isViewTheme;
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(selectedThemeData), dataTheme = ref1[0], setDataTheme = ref1[1];
    // const [packageUser, setPackageUser] = useState({
    //   package_type: user?.kol?.package_type,
    //   package_name: user?.kol?.package_name,
    // });
    var package_type = (user === null || user === void 0 ? void 0 : (ref17 = user.kol) === null || ref17 === void 0 ? void 0 : ref17.package_type) || null;
    var ref2 = (0,react.useState)(package_type), packageType = ref2[0], setPackageType = ref2[1];
    var ref3 = (0,react.useState)(false), flag = ref3[0], setFlag = ref3[1];
    var ref4 = (0,react.useState)(false), openIframe = ref4[0], setOpenIframe = ref4[1];
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var themeName = selectedThemeData === null || selectedThemeData === void 0 ? void 0 : selectedThemeData.title;
    var ConfirmModal = (0,modal/* useModal */.dd)().ConfirmModal;
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var creator_role = passioPageProfile === null || passioPageProfile === void 0 ? void 0 : passioPageProfile.creator_role;
    var isAdminRole = (0,react.useMemo)(function() {
        return creator_role === store_interface/* CREATOR_ROLE_ENUM.ADMIN */.lp.ADMIN;
    }, [
        creator_role
    ]);
    (0,react.useEffect)(function() {
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.THEME_TEMPLATE */.Bt.THEME_TEMPLATE, "ThemeTemplate_".concat(ga_events/* ACTION_CONFIG.VIEW */.AN.VIEW, "_").concat(themeName), themeName, ga_events/* ACTION_CONFIG.VIEW */.AN.VIEW);
    }, []);
    (0,react.useEffect)(function() {
        console.log("@@@: fetch data ");
        var fetchPermission = function() {
            var _ref = ThemeTemplatePreview_asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, getPackageOfUse, packageOfUser;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            _ctx.next = 4;
                            return (0,api/* getPackageOfUser */.iF)();
                        case 4:
                            getPackageOfUse = _ctx.sent;
                            packageOfUser = {
                                package_type: getPackageOfUse === null || getPackageOfUse === void 0 ? void 0 : (ref = getPackageOfUse.data) === null || ref === void 0 ? void 0 : (ref9 = ref.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.language) === null || ref10 === void 0 ? void 0 : ref10.id,
                                package_name: getPackageOfUse === null || getPackageOfUse === void 0 ? void 0 : (ref11 = getPackageOfUse.data) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.language) === null || ref13 === void 0 ? void 0 : ref13.name
                            };
                            dispatch((0,userSlice/* setProfile */.RG)(ThemeTemplatePreview_objectSpread({}, user === null || user === void 0 ? void 0 : user.kol, packageOfUser)));
                            // setPackageUser(packageOfUser);
                            setPackageType(getPackageOfUse === null || getPackageOfUse === void 0 ? void 0 : (ref14 = getPackageOfUse.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.data) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.language) === null || ref16 === void 0 ? void 0 : ref16.id);
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return function fetchPermission() {
                return _ref.apply(this, arguments);
            };
        }();
        var fetchPackageSASS = function() {
            var _ref = ThemeTemplatePreview_asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, ref18, ref19, ref20, ref21, ref22, dataSass, listThemPremium;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            _ctx.next = 4;
                            return (0,api/* getPackageSass */.Xg)();
                        case 4:
                            dataSass = _ctx.sent;
                            listThemPremium = (ref20 = dataSass === null || dataSass === void 0 ? void 0 : (ref = dataSass.data) === null || ref === void 0 ? void 0 : (ref18 = ref.data) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.packages) === null || ref19 === void 0 ? void 0 : ref19.find(function(item) {
                                return item.id === 1;
                            })) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.params) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.passio_page_service) === null || ref22 === void 0 ? void 0 : ref22.premium_theme;
                            setDataTheme(ThemeTemplatePreview_objectSpread({}, selectedThemeData, {
                                is_premium: listThemPremium === null || listThemPremium === void 0 ? void 0 : listThemPremium.includes(selectedThemeData === null || selectedThemeData === void 0 ? void 0 : selectedThemeData.id)
                            }));
                            _ctx.next = 12;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9
                    ]
                ]);
            }));
            return function fetchPackageSASS() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPermission();
        fetchPackageSASS();
    }, [
        openIframe
    ]);
    var CONFIRM_TEXT = "OK";
    var ref5 = (0,react.useState)(null), valueConfirmText = ref5[0], setValueConfirmText = ref5[1];
    var ref6 = (0,react.useState)(false), isOpenConfirmEnterText = ref6[0], setIsOpenConfirmEnterText = ref6[1];
    var ref7 = (0,react.useState)(false), isViewThemeState = ref7[0], setIsViewThemeState = ref7[1];
    var debouncedValueConfirmText = (0,esm/* useDebounce */.Nr)(valueConfirmText, 500);
    var ref8 = (0,react.useState)({
        preview: false,
        view: false
    }), popOverState = ref8[0], setpopOverState = ref8[1];
    var handleCompareConfirmText = function(val) {
        setValueConfirmText(val);
    };
    var handleCloseModalConfirmText = function() {
        setIsOpenConfirmEnterText(false);
        setValueConfirmText(null);
    };
    var isEnableConfirm = (0,react.useMemo)(function() {
        return !(typeof debouncedValueConfirmText === "string" && debouncedValueConfirmText.toLowerCase() === CONFIRM_TEXT.toLowerCase());
    }, [
        debouncedValueConfirmText
    ]);
    var previewUrl = (0,react.useMemo)(function() {
        var ref;
        var domain = user === null || user === void 0 ? void 0 : (ref = user.kol) === null || ref === void 0 ? void 0 : ref.domain;
        var siteSettingId = dataTheme === null || dataTheme === void 0 ? void 0 : dataTheme.site_setting_id;
        if (isViewThemeState) {
            return "https://".concat(domain, "/preview?id=").concat(siteSettingId, "&isDisableLink=true");
        }
        if (siteSettingUserRootId && userRootId) {
            return "https://".concat(domain, "/preview?id=").concat(siteSettingId, "&site_setting_user_root_id=").concat(siteSettingUserRootId, "&user_root_id=").concat(userRootId, "&isDisableLink=true");
        }
        if (siteSettingUserRootId && !userRootId) {
            return "https://".concat(domain, "/preview?id=").concat(siteSettingId, "&site_setting_user_root_id=").concat(siteSettingUserRootId, "&isDisableLink=true");
        }
        return "https://".concat(domain, "/preview?id=").concat(siteSettingId, "&isDisableLink=true");
    }, [
        user,
        dataTheme,
        siteSettingUserRootId,
        userRootId,
        isViewThemeState
    ]);
    var hasPermission = (0,react.useMemo)(function() {
        var ref;
        console.log("update permission");
        if ((user === null || user === void 0 ? void 0 : (ref = user.kol) === null || ref === void 0 ? void 0 : ref.country) !== "PH") return true;
        if (packageType === 1 || isAdminRole) return true;
        return packageType === 2 && !(dataTheme === null || dataTheme === void 0 ? void 0 : dataTheme.is_premium);
    }, [
        user,
        dataTheme,
        isAdminRole,
        packageType
    ]);
    var isShowIcon = (0,react.useMemo)(function() {
        return (packageType === 1 || isAdminRole) && (dataTheme === null || dataTheme === void 0 ? void 0 : dataTheme.is_premium);
    }, [
        packageType,
        dataTheme,
        isAdminRole
    ]);
    var handleConfirmThemeTemplatePreview = function() {
        var _ref = ThemeTemplatePreview_asyncToGenerator(runtime_default().mark(function _callee() {
            var hasPermissionFetchNew, ref38, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, getPackageOfUse, dataSass, listThemPremiumFetchNew, packageOfUserFetchNew, dataThemeFetchNew;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        hasPermissionFetchNew = false;
                        _ctx.prev = 1;
                        ;
                        _ctx.next = 5;
                        return (0,api/* getPackageOfUser */.iF)();
                    case 5:
                        getPackageOfUse = _ctx.sent;
                        _ctx.next = 8;
                        return (0,api/* getPackageSass */.Xg)();
                    case 8:
                        dataSass = _ctx.sent;
                        listThemPremiumFetchNew = (ref25 = dataSass === null || dataSass === void 0 ? void 0 : (ref38 = dataSass.data) === null || ref38 === void 0 ? void 0 : (ref23 = ref38.data) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.packages) === null || ref24 === void 0 ? void 0 : ref24.find(function(item) {
                            return item.id === 1;
                        })) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.params) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.passio_page_service) === null || ref27 === void 0 ? void 0 : ref27.premium_theme;
                        packageOfUserFetchNew = {
                            package_type: getPackageOfUse === null || getPackageOfUse === void 0 ? void 0 : (ref28 = getPackageOfUse.data) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.data) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.language) === null || ref30 === void 0 ? void 0 : ref30.id,
                            package_name: getPackageOfUse === null || getPackageOfUse === void 0 ? void 0 : (ref31 = getPackageOfUse.data) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.data) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.language) === null || ref33 === void 0 ? void 0 : ref33.name
                        };
                        dataThemeFetchNew = ThemeTemplatePreview_objectSpread({}, selectedThemeData, {
                            is_premium: listThemPremiumFetchNew === null || listThemPremiumFetchNew === void 0 ? void 0 : listThemPremiumFetchNew.includes(selectedThemeData === null || selectedThemeData === void 0 ? void 0 : selectedThemeData.id)
                        });
                        dispatch((0,userSlice/* setProfile */.RG)(ThemeTemplatePreview_objectSpread({}, user === null || user === void 0 ? void 0 : user.kol, packageOfUserFetchNew)));
                        // setPackageUser(packageOfUserFetchNew);
                        setPackageType(getPackageOfUse === null || getPackageOfUse === void 0 ? void 0 : (ref34 = getPackageOfUse.data) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.data) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.language) === null || ref36 === void 0 ? void 0 : ref36.id);
                        if ((packageOfUserFetchNew === null || packageOfUserFetchNew === void 0 ? void 0 : packageOfUserFetchNew.package_type) === 1 || isAdminRole) {
                            hasPermissionFetchNew = true;
                        } else {
                            hasPermissionFetchNew = packageType === 2 && !(dataThemeFetchNew === null || dataThemeFetchNew === void 0 ? void 0 : dataThemeFetchNew.is_premium);
                        }
                        if ((user === null || user === void 0 ? void 0 : (ref37 = user.kol) === null || ref37 === void 0 ? void 0 : ref37.country) !== "PH") hasPermissionFetchNew = true;
                        _ctx.next = 21;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](1);
                        console.log(_ctx.t0);
                    case 21:
                        if (!hasPermissionFetchNew) {
                            es/* Modal.alert */.u_.alert({
                                className: "confirm-preview-apply-content ",
                                bodyClassName: "custom-button-confirm-modal-alert",
                                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CrownIcon */.CE, {
                                    width: 60,
                                    height: 60
                                }),
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: t("ss_builder_apply_theme_premium_warning_title")
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                                    children: t("ss_builder_apply_theme_premium_warning")
                                }),
                                confirmText: t("ss_builder_update_account"),
                                showCloseButton: true,
                                onConfirm: function() {
                                    ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.THEME_TEMPLATE */.Bt.THEME_TEMPLATE, "".concat(ga_events/* EVENT_CONFIG.THEME_TEMPLATE */.f1.THEME_TEMPLATE, "_").concat((0,lib/* handleCapitalizeFirstLetter */.Tz)(ga_events/* ACTION_CONFIG.UPGRADE_PLAN */.AN.UPGRADE_PLAN), "_").concat(selectedThemeData === null || selectedThemeData === void 0 ? void 0 : selectedThemeData.title), "", ga_events/* ACTION_CONFIG.UPGRADE_PLAN */.AN.UPGRADE_PLAN);
                                    setOpenIframe(true);
                                }
                            });
                        } else {
                            if (KEY === configs_const/* THEME_PREVIEW_KEY.PREVIEW_AND_APPLY_CONTENT */.Sl.PREVIEW_AND_APPLY_CONTENT) {
                                ConfirmModal({
                                    title: t("ss_builder_replace_theme_modal_title"),
                                    className: "confirm-preview-apply-content",
                                    description: t("ss_builder_replace_theme_modal_content"),
                                    confirmText: t("ss_builder_confirm_replace_theme_template_btn_label"),
                                    cancelText: t("ss_builder_cancel_replace_theme_template_btn_label"),
                                    onConfirm: function() {
                                        return setIsOpenConfirmEnterText(true);
                                    },
                                    onCancel: function() {
                                        var ref;
                                        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.APPLY_SAMPLE_CONTENT */.Bt.APPLY_SAMPLE_CONTENT, "ApplySampleContent_Cancel", user === null || user === void 0 ? void 0 : (ref = user.kol) === null || ref === void 0 ? void 0 : ref.domain, ga_events/* ACTION_CONFIG.CANCEL */.AN.CANCEL);
                                        return;
                                    }
                                });
                            }
                            if (KEY === configs_const/* THEME_PREVIEW_KEY.PREVIEW_AND_APPLY */.Sl.PREVIEW_AND_APPLY) {
                                ConfirmModal({
                                    title: t("ss_builder_confirm_apply_theme_template_title"),
                                    icon: "info-primary-triangle",
                                    // className: "confirm-preview-apply-content",
                                    description: t("ss_builder_confirm_apply_theme_template_content"),
                                    confirmText: t("ss_builder_confirm_apply_theme_template_btn_label"),
                                    cancelText: t("ss_builder_cancel_apply_theme_template_btn_label"),
                                    onConfirm: function() {
                                        onConfirmThemeTemplatePreview();
                                        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.THEME_TEMPLATE */.Bt.THEME_TEMPLATE, "ThemeTemplate_".concat(ga_events/* ACTION_CONFIG.APPLY */.AN.APPLY, "_").concat(themeName), themeName, ga_events/* ACTION_CONFIG.APPLY */.AN.APPLY);
                                    },
                                    onCancel: function() {
                                        return;
                                    }
                                });
                            }
                        }
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    18
                ]
            ]);
        }));
        return function handleConfirmThemeTemplatePreview() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancelThemeTemplatePreview = function() {
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.THEME_TEMPLATE */.Bt.THEME_TEMPLATE, "ThemeTemplate_".concat(ga_events/* ACTION_CONFIG.CANCEL */.AN.CANCEL, "_").concat(themeName), themeName, ga_events/* ACTION_CONFIG.CANCEL */.AN.CANCEL);
        onCancelThemeTemplatePreview();
    };
    var handleSwapViewTheme = function(isView, nameButton) {
        if (isViewThemeState !== isView) {
            setIsViewThemeState(isView);
            var popOverStateTmp = cloneDeep_default()(popOverState);
            for(var key in popOverStateTmp){
                if (key !== nameButton) {
                    popOverStateTmp[key] = false;
                }
            }
            setpopOverState(popOverStateTmp);
        }
    };
    var handleShowPopOver = function(visible, nameButton) {
        var popOverStateTmp = cloneDeep_default()(popOverState);
        for(var key in popOverStateTmp){
            if (key === nameButton) {
                popOverStateTmp[key] = visible;
            } else if (key !== nameButton && visible) {
                popOverStateTmp[key] = !visible;
            }
        }
        setpopOverState(popOverStateTmp);
    };
    var _obj, _obj1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white",
                style: {
                    borderBottom: "1px solid rgb(238, 238, 238)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-row text-center items-center justify-center py-1.5 gap-[10px] sticky top-0 max-width-content-class ml-auto mr-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-[18px] leading-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "p-1 text-center absolute top-[50%] translate-y-[-50%] left-0 cursor-pointer",
                                onClick: function() {
                                    return handleCancelThemeTemplatePreview();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BackAngelIcon */.Nz, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemScrollHorizontal/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_ButtonViewTheme, {
                                        isActive: !isViewThemeState,
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PreviewThemeIcon */.gc, {
                                            width: 16,
                                            height: 16,
                                            fillColor: !isViewThemeState ? "#FFFFFF" : "#333333"
                                        }),
                                        label: t("ss_builder_preview"),
                                        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                            content: t("ss_builder_theme_template_preview_info"),
                                            trigger: "click",
                                            placement: "bottom",
                                            mode: "dark",
                                            visible: popOverState.preview,
                                            onVisibleChange: function(visible) {
                                                return handleShowPopOver(visible, BUTTON_VIEW_THEME.PREVIEW);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[31px] flex items-center justify-center h-full py-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(line_icon/* InfoCirclesIcon */.xh, {
                                                    className: "cursor-pointer",
                                                    width: 15,
                                                    height: 15,
                                                    fillColor: !isViewThemeState ? "#FFFFFF" : "#333333"
                                                })
                                            })
                                        }),
                                        onClick: function() {
                                            return handleSwapViewTheme(false, BUTTON_VIEW_THEME.PREVIEW);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(component_ButtonViewTheme, {
                                        isActive: isViewThemeState,
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ThemeStoreIcon */.X0, {
                                            width: 16,
                                            height: 16,
                                            fillColor: isViewThemeState ? "#FFFFFF" : "#333333"
                                        }),
                                        label: t("ss_builder_theme_template_view_theme_title"),
                                        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                            content: t("ss_builder_theme_template_view_theme_info"),
                                            trigger: "click",
                                            placement: "bottom",
                                            mode: "dark",
                                            visible: popOverState.view,
                                            onVisibleChange: function(visible) {
                                                return handleShowPopOver(visible, BUTTON_VIEW_THEME.VIEW);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[31px] flex items-center justify-center h-full py-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(line_icon/* InfoCirclesIcon */.xh, {
                                                    className: "cursor-pointer",
                                                    width: 15,
                                                    height: 15,
                                                    fillColor: isViewThemeState ? "#FFFFFF" : "#333333"
                                                })
                                            })
                                        }),
                                        onClick: function() {
                                            return handleSwapViewTheme(true, BUTTON_VIEW_THEME.VIEW);
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                style: {
                    height: !isViewThemeState ? "calc(100% - 105px)" : "calc(100% - 45px)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    id: "theme-preview-iframe",
                    src: previewUrl,
                    className: "h-full w-full"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("fixed bottom-0 p-2 w-full bg-[#FFFFFF]", (_obj = {}, ThemeTemplatePreview_defineProperty(_obj, (ThemeTemplatePreview_style_module_default()).showing, !isViewThemeState), ThemeTemplatePreview_defineProperty(_obj, (ThemeTemplatePreview_style_module_default()).notShowing, isViewThemeState), _obj)),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("max-width-content-class fixed left-[50%] translate-x-[-50%] bottom-0 p-2 flex w-full justify-between gap-2 z-[1] bg-[#FFFFFF]", (_obj1 = {}, ThemeTemplatePreview_defineProperty(_obj1, (ThemeTemplatePreview_style_module_default()).showing, !isViewThemeState), ThemeTemplatePreview_defineProperty(_obj1, (ThemeTemplatePreview_style_module_default()).notShowing, isViewThemeState), _obj1)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-1/2 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                className: "w-full",
                                onClick: handleCancelThemeTemplatePreview,
                                children: t("ss_builder_editor_btn-cancel")
                            })
                        }),
                        hasPermission ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-1/2 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                className: "w-full",
                                color: "primary",
                                onClick: function() {
                                    setFlag(!flag);
                                    handleConfirmThemeTemplatePreview();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-2 justify-center text-center items-center",
                                    children: [
                                        isShowIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CrownIconV2 */.jS, {
                                            className: "my-auto"
                                        }),
                                        t("ss_builder_confirm_theme_template_preview_mode_btn_label")
                                    ]
                                })
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-1/2 text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                className: "w-full",
                                onClick: function() {
                                    setFlag(!flag);
                                    handleConfirmThemeTemplatePreview();
                                },
                                style: {
                                    backgroundColor: "#fa8c16",
                                    color: "white"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-2 justify-center text-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CrownIconNoColor */.gn, {
                                            className: "my-auto"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-white",
                                            children: t("ss_builder_confirm_theme_template_preview_mode_btn_label")
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            isOpenConfirmEnterText && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Modal */.u_, {
                visible: isOpenConfirmEnterText,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                            children: t("ss_builder_confirm_replace_theme_template_content")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-3 mb-1 text-[#666]",
                            children: t("ss_builder_confirm_replace_theme_template_label_enter_ok")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                            placeholder: t("ss_builder_confirm_replace_theme_template_input_placeholder"),
                            onChange: function(val) {
                                handleCompareConfirmText(val);
                            },
                            className: "input-rounded",
                            maxLength: 20,
                            minLength: 1
                        })
                    ]
                }),
                closeOnAction: true,
                onClose: function() {
                    var ref;
                    ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.APPLY_SAMPLE_CONTENT */.Bt.APPLY_SAMPLE_CONTENT, "ApplySampleContent_Cancel", user === null || user === void 0 ? void 0 : (ref = user.kol) === null || ref === void 0 ? void 0 : ref.domain, ga_events/* ACTION_CONFIG.CANCEL */.AN.CANCEL);
                    handleCloseModalConfirmText();
                },
                className: "confirm-text-preview-apply-content",
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                    className: "w-11 h-11",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_confirm_replace_theme_template_warining")
                }),
                actions: [
                    {
                        key: "confirm",
                        text: t("ss_builder_confirm_replace_theme_template_understood"),
                        className: "confirm-text",
                        primary: true,
                        disabled: isEnableConfirm,
                        onClick: function() {
                            return onConfirmThemeTemplatePreview();
                        }
                    },
                    {
                        key: "cancel",
                        text: t("ss_builder_cancel_replace_theme_template_btn_label"),
                        className: "cancel-text"
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupFull, {
                visible: openIframe,
                onMaskClick: function() {
                    return setOpenIframe(false);
                },
                reduceMotionAnt: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UpgradeAccount, {
                    visble: openIframe,
                    user: user,
                    onClose: function() {
                        return setOpenIframe(false);
                    },
                    handleSetPackageType: function(val) {
                        return setPackageType(val);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var ThemeTemplateHandler_ThemeTemplatePreview = (ThemeTemplatePreview);

;// CONCATENATED MODULE: ./src/features/design/components/ThemeTemplateHandler/ThemeTourOpening/ThemeTour/const.ts
var THEME_TOUR_CLASS_NAME = {
    STEP_1: "theme-store-tour-step-1",
    STEP_2: "theme-store-tour-step-2"
};
var STEP_INDEX = {
    STEP_1: 0,
    STEP_2: 1
};
var steps = [
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/theme-store-tour/theme-store-tour-step-1.gif",
        title_key: "ss_builder_theme_store_tour_title_step_1",
        intro_key: "ss_builder_theme_store_tour_content_step_1",
        element_class: THEME_TOUR_CLASS_NAME.STEP_1,
        tooltip_class: "show-label-text",
        position: "bottom"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/theme-store-tour/theme-store-tour-step-2.gif",
        title_key: "ss_builder_theme_store_tour_title_step_2",
        intro_key: "ss_builder_theme_store_tour_content_step_2",
        element_class: THEME_TOUR_CLASS_NAME.STEP_2,
        tooltip_class: "show-label-text product-tour-custom",
        position: "bottom-middle-aligned"
    }, 
];

;// CONCATENATED MODULE: ./src/features/setting/components/body/component/SettingTourOpening/SettingTour/setting-tour-config.ts
var SETTING_TOUR_CLASS_NAME = {
    STEP_1: "setting-tour-link",
    STEP_2: "setting-tour-setting-interface",
    STEP_3: "setting-tour-setting-page"
};
var setting_tour_config_STEP_INDEX = {
    STEP_1: 0,
    STEP_2: 1,
    STEP_3: 2
};
var setting_tour_config_steps = [
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/setting-tour/setting-tour-1.gif",
        title_key: "ss_builder_setting_tour_title_step_1",
        intro_key: "ss_builder_setting_tour_content_step_1",
        element_class: SETTING_TOUR_CLASS_NAME.STEP_1,
        tooltip_class: "show-label-text",
        position: "bottom"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/setting-tour/setting-tour-2.gif",
        title_key: "ss_builder_setting_tour_title_step_2",
        intro_key: "ss_builder_setting_tour_content_step_2",
        element_class: SETTING_TOUR_CLASS_NAME.STEP_2,
        tooltip_class: "",
        position: "bottom"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/setting-tour/setting-tour-3.gif",
        title_key: "ss_builder_setting_tour_title_step_3",
        intro_key: "ss_builder_setting_tour_content_step_3",
        element_class: SETTING_TOUR_CLASS_NAME.STEP_3,
        tooltip_class: "auto show-label-text product-tour-custom",
        position: "top"
    }, 
];

;// CONCATENATED MODULE: ./src/features/design/components/ThemeTemplateHandler/ThemeTourOpening/ThemeTour/index.tsx
function ThemeTour_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ThemeTour_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ThemeTour_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ThemeTour_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








var ThemeStoreTour = function(props) {
    var handleHideSettingTour = props.handleHideSettingTour;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var productTourRef = (0,react.useRef)(null);
    var setRef = function(ref) {
        productTourRef.current = ref;
    };
    var stepsDefault = steps.map(function(ele) {
        return {
            title: '<div class="wrapper-image">' + product_tour_icon/* placeHolderImageIcon */.GT + '\n        <img class="img-product-tour" src='.concat(ele.image_header, ' /> </div>\n        <div class="title">').concat(t(ele.title_key), "<div/>"),
            element: ele.using_selector ? document.querySelector(".".concat(ele.element_class)) : ".".concat(ele.element_class),
            intro: "<div> ".concat(t(ele.intro_key), "<div/>"),
            tooltipClass: "tooltip-product-tour ".concat(ele.tooltip_class),
            position: (ele === null || ele === void 0 ? void 0 : ele.position) || "auto"
        };
    });
    var onExit = function() {
        handleHideSettingTour();
    };
    var onBeforeExit = function(stepIndex) {};
    var onChangeProductTour = function() {
        var _ref = ThemeTour_asyncToGenerator(runtime_default().mark(function _callee(nextStepIndex, nextElement) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (nextStepIndex === setting_tour_config_STEP_INDEX.STEP_2) {
                            window.scrollTo(0, document.body.scrollHeight);
                        } else {
                            window.scrollTo({
                                top: 0
                            });
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onChangeProductTour(nextStepIndex, nextElement) {
            return _ref.apply(this, arguments);
        };
    }();
    var onCompleteProductTour = function() {};
    var onBeforeChange = function() {
        var _ref = ThemeTour_asyncToGenerator(runtime_default().mark(function _callee(nextStepIndex, nextElement) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onBeforeChange(nextStepIndex, nextElement) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTourComponent/* default */.Z, {
        steps: stepsDefault,
        onExit: onExit,
        onBeforeExit: onBeforeExit,
        onChange: onChangeProductTour,
        onComplete: onCompleteProductTour,
        onBeforeChange: onBeforeChange,
        setRef: setRef
    });
};
/* harmony default export */ var ThemeTour = (ThemeStoreTour);

;// CONCATENATED MODULE: ./src/features/design/components/ThemeTemplateHandler/ThemeTourOpening/index.tsx
function _throw(e) {
    throw e;
}






var ThemeTourOpening = function(param) {
    var param = param !== null ? param : _throw(new TypeError("Cannot destructure undefined"));
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(false), isOpenThemeStoreTour = ref[0], setIsOpenThemeStoreTour = ref[1];
    var popoverRef = (0,react.useRef)(null);
    var popoverManualRef = (0,react.useRef)(null);
    var handleHidePopoverManual = function() {
        popoverManualRef.current.hide();
    };
    var handleHideSettingTour = function() {
        setIsOpenThemeStoreTour(false);
    };
    var contentPopoverManual = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-[320px] relative max-w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[32px] h-[32px] absolute p-1 right-2 top-2 cursor-pointer z-[3]",
                    onClick: function() {
                        return handleHidePopoverManual();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ClosePopupIconV2 */.gz, {
                        fillColor: "#fff"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://image.passio.eco/page-builder/page-builder/theme-store-tour/theme-store-tour-step-0.gif",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "p-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-2 text-lg leading-[25px] font-bold",
                            children: t("ss_builder_theme_store_popover_manual_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[15px] font-normal leading-[140%] text-textColorDefault mb-5",
                            children: t("ss_builder_theme_store_popover_manual_content")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            color: "primary",
                            size: "middle",
                            fill: "solid",
                            onClick: function() {
                                handleHidePopoverManual();
                                setIsOpenThemeStoreTour(true);
                            },
                            block: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "flex items-center w-full justify-center gap-2 text-[17px]",
                                children: [
                                    t("ss_builder_popover_manual_button"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowRightIcon */.LZ, {
                                        fillColor: "#fff"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "user-manual",
                ref: popoverRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                    className: "popover-user-manual",
                    content: contentPopoverManual(),
                    placement: "bottom-end",
                    trigger: "click",
                    stopPropagation: [
                        "click"
                    ],
                    getContainer: function() {
                        return popoverRef.current;
                    },
                    ref: popoverManualRef,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* QuestionIcon */.UO, {
                            width: 20,
                            height: 20,
                            className: "cursor-pointer"
                        })
                    })
                })
            }),
            isOpenThemeStoreTour && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeTour, {
                handleHideSettingTour: handleHideSettingTour
            })
        ]
    });
};
/* harmony default export */ var ThemeTemplateHandler_ThemeTourOpening = (ThemeTourOpening);

// EXTERNAL MODULE: ./node_modules/immutability-helper/index.js
var immutability_helper = __webpack_require__(7145);
var immutability_helper_default = /*#__PURE__*/__webpack_require__.n(immutability_helper);
;// CONCATENATED MODULE: ./src/features/design/components/ThemeTemplateHandler/ThemeTemplateStore/index.tsx
function ThemeTemplateStore_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ThemeTemplateStore_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ThemeTemplateStore_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ThemeTemplateStore_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ThemeTemplateStore_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ThemeTemplateStore_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ThemeTemplateStore_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





















var ThemeTemplateStore = function(props) {
    var handleRedirectTabs = props.handleRedirectTabs, onCancelThemeTemplateStore = props.onCancelThemeTemplateStore, siteSettings = props.siteSettings, user = props.user, activeIndex = props.activeIndex;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var siteSettingUserRootId = siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.id;
    var userRootId = siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.user_id;
    var ref15 = (0,react.useState)(false), isOpenThemeTemplatePreview = ref15[0], setIsOpenThemeTemplatePreview = ref15[1];
    var ref1 = (0,react.useState)(false), isOpenEditThemeSaving = ref1[0], setIsOpenEditThemeSaving = ref1[1];
    var ref2 = (0,react.useState)([]), themeTemplateArr = ref2[0], setThemeTemplateArr = ref2[1];
    var ref3 = (0,react.useState)([]), searchedTemplates = ref3[0], setSearchedTemplate = ref3[1];
    var ref4 = (0,react.useState)(false), isSearchMode = ref4[0], setIsSearchMode = ref4[1];
    var ref5 = (0,react.useState)(null), themeSelectData = ref5[0], setThemeSelectData = ref5[1];
    var ref6 = (0,react.useState)(""), value1 = ref6[0], setValue = ref6[1];
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var creator_role = passioPageProfile === null || passioPageProfile === void 0 ? void 0 : passioPageProfile.creator_role;
    var isAdminRole = (0,react.useMemo)(function() {
        return creator_role === store_interface/* CREATOR_ROLE_ENUM.ADMIN */.lp.ADMIN;
    }, [
        creator_role
    ]);
    var userState = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.user;
    });
    var packageId = userState && userState.kol && userState.kol.package_type;
    (0,react.useEffect)(function() {
        var requestThemeTemplateList = function() {
            var _ref = ThemeTemplateStore_asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, listThemeResponse, packageSASS, dataRequest, listThemePremium, listThemeArr, listThemeArrClone;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            listThemeResponse = null;
                            packageSASS = null;
                            dataRequest = {
                                per_page: 100,
                                keyword: "",
                                is_admin: isAdminRole
                            };
                            _ctx.prev = 4;
                            _ctx.next = 7;
                            return (0,api/* requestSearchThemeTemplate */.IU)(dataRequest);
                        case 7:
                            listThemeResponse = _ctx.sent;
                            _ctx.next = 10;
                            return (0,api/* getPackageSass */.Xg)();
                        case 10:
                            packageSASS = _ctx.sent;
                            _ctx.next = 16;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](4);
                            console.log(_ctx.t0);
                        case 16:
                            listThemePremium = (ref9 = packageSASS === null || packageSASS === void 0 ? void 0 : (ref = packageSASS.data) === null || ref === void 0 ? void 0 : (ref7 = ref.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.packages) === null || ref8 === void 0 ? void 0 : ref8.find(function(item) {
                                return item.id === 1;
                            })) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.params) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.passio_page_service) === null || ref11 === void 0 ? void 0 : ref11.premium_theme;
                            listThemeArr = listThemeResponse === null || listThemeResponse === void 0 ? void 0 : (ref12 = listThemeResponse.data) === null || ref12 === void 0 ? void 0 : ref12.map(function(theme) {
                                if (listThemePremium === null || listThemePremium === void 0 ? void 0 : listThemePremium.includes(theme === null || theme === void 0 ? void 0 : theme.id)) return ThemeTemplateStore_objectSpread({}, theme, {
                                    is_premium: true
                                });
                                return ThemeTemplateStore_objectSpread({}, theme, {
                                    is_premium: false
                                });
                            });
                            // check thi truong PH
                            if (listThemeArr && ((user === null || user === void 0 ? void 0 : (ref13 = user.kol) === null || ref13 === void 0 ? void 0 : ref13.country) === "PH" || isAdminRole)) {
                                setThemeTemplateArr(listThemeArr);
                            }
                            if (listThemeArr && (user === null || user === void 0 ? void 0 : (ref14 = user.kol) === null || ref14 === void 0 ? void 0 : ref14.country) !== "PH" && !isAdminRole) {
                                listThemeArrClone = listThemeArr === null || listThemeArr === void 0 ? void 0 : listThemeArr.filter(function(item) {
                                    return !(item === null || item === void 0 ? void 0 : item.is_premium);
                                });
                                setThemeTemplateArr(listThemeArrClone);
                            }
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        13
                    ]
                ]);
            }));
            return function requestThemeTemplateList() {
                return _ref.apply(this, arguments);
            };
        }();
        requestThemeTemplateList();
    }, [
        activeIndex
    ]);
    var handleSelectTheme = function(val) {
        if (val) {
            setThemeSelectData(val);
            setIsOpenThemeTemplatePreview(true);
        }
    };
    var handleEditTheme = function(val) {
        if (val) {
            setThemeSelectData(val);
            setIsOpenEditThemeSaving(true);
        }
    };
    var handleDeleteTheme = function() {
        var _ref = ThemeTemplateStore_asyncToGenerator(runtime_default().mark(function _callee(themeId) {
            var ref, responseDeleteTheme, themeTemplateArrClone, newThemeTemplateArr;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        responseDeleteTheme = null;
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,api/* requestDeleteThemeTemplate */.ty)(themeId);
                    case 5:
                        responseDeleteTheme = _ctx.sent;
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        console.log(_ctx.t0);
                    case 11:
                        if (/^20[0-9]$/.test(responseDeleteTheme === null || responseDeleteTheme === void 0 ? void 0 : responseDeleteTheme.status.toString()) && (responseDeleteTheme === null || responseDeleteTheme === void 0 ? void 0 : (ref = responseDeleteTheme.data) === null || ref === void 0 ? void 0 : ref.success)) {
                            themeTemplateArrClone = cloneDeep_default()(themeTemplateArr);
                            newThemeTemplateArr = themeTemplateArrClone === null || themeTemplateArrClone === void 0 ? void 0 : themeTemplateArrClone.filter(function(ele) {
                                return ele.id !== themeId;
                            });
                            setThemeTemplateArr(newThemeTemplateArr);
                            es/* Toast.show */.FN.show({
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                    className: "text-center inline-block",
                                    fillColor: "#00B578"
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: t("ss_builder_delete_theme_template_successfully_label")
                                })
                            });
                        }
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return function handleDeleteTheme(themeId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleShowHideTheme = function() {
        var _ref = ThemeTemplateStore_asyncToGenerator(runtime_default().mark(function _callee(themeId) {
            var response, themeSelected, status, dataRequest, themeTemplateArrClone, newThemeTemplateArr;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        response = null;
                        themeSelected = themeTemplateArr.find(function(item) {
                            return item.id === themeId;
                        });
                        status = themeSelected.status;
                        dataRequest = {
                            user_id: siteSettings.user_id,
                            site_setting_id: siteSettings.id,
                            title: themeSelected.title,
                            image: themeSelected.image,
                            id: themeId,
                            status: status === 1 ? 2 : 1
                        };
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return (0,api/* requestUpdateThemeTemplate */.T_)(dataRequest);
                    case 7:
                        response = _ctx.sent;
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](4);
                        console.log(_ctx.t0);
                    case 13:
                        if (/^20[0-9]$/.test(response === null || response === void 0 ? void 0 : response.status.toString()) && (response === null || response === void 0 ? void 0 : response.data)) {
                            themeTemplateArrClone = cloneDeep_default()(themeTemplateArr);
                            newThemeTemplateArr = themeTemplateArrClone === null || themeTemplateArrClone === void 0 ? void 0 : themeTemplateArrClone.map(function(ele) {
                                if (ele.id === themeId) {
                                    return ThemeTemplateStore_objectSpread({}, ele, {
                                        status: status === 1 ? 2 : 1
                                    });
                                }
                                return ele;
                            });
                            setThemeTemplateArr(newThemeTemplateArr);
                            es/* Toast.show */.FN.show({
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                    className: "text-center inline-block w-[30px] h-[30px]",
                                    fillColor: "#00B578"
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: status === 1 ? t("ss_builder_disable_theme_successfully_label") : t("ss_builder_enable_theme_successfully_label")
                                })
                            });
                        }
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    10
                ]
            ]);
        }));
        return function handleShowHideTheme(themeId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirmThemeTemplatePreview = function() {
        var _ref = ThemeTemplateStore_asyncToGenerator(runtime_default().mark(function _callee() {
            var reponseApplyTheme, dataRequest, ref, statusCode, ref16, ref17, ref18, ref19, ref20;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        reponseApplyTheme = null;
                        dataRequest = {
                            user_id: siteSettings.user_id,
                            template_id: themeSelectData === null || themeSelectData === void 0 ? void 0 : themeSelectData.id
                        };
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,api/* requestApplyThemeTemplate */.h4)(dataRequest);
                    case 5:
                        reponseApplyTheme = _ctx.sent;
                        _ctx.next = 14;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        ;
                        console.log(_ctx.t0);
                        statusCode = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : ref.status;
                        if (statusCode == 404) {
                            es/* Modal.show */.u_.show({
                                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                    className: "w-11 h-11",
                                    fillColor: "#FF8F1F",
                                    onClick: function() {}
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col text-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-lg font-bold leading-[25px]",
                                            children: t("ss_builder_dont_apply_theme_content_modal_label")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "",
                                            children: t("ss_builder_dont_apply_theme_content_modal_description")
                                        })
                                    ]
                                }),
                                className: "modal-error-class",
                                closeOnAction: true,
                                actions: [
                                    {
                                        key: "confirm",
                                        text: t("ss_builder_dont_apply_theme_content_modal_btn_confirm_label")
                                    }, 
                                ]
                            });
                        }
                    case 14:
                        if (/^20[0-9]$/.test(reponseApplyTheme === null || reponseApplyTheme === void 0 ? void 0 : reponseApplyTheme.status.toString())) {
                            ;
                            dispatch((0,siteSettingSlice/* setSiteInfo */.cP)({
                                sites: reponseApplyTheme === null || reponseApplyTheme === void 0 ? void 0 : (ref16 = reponseApplyTheme.data) === null || ref16 === void 0 ? void 0 : ref16.data
                            }));
                            if (reponseApplyTheme === null || reponseApplyTheme === void 0 ? void 0 : (ref17 = reponseApplyTheme.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.data) === null || ref18 === void 0 ? void 0 : ref18.positions) {
                                ;
                                dispatch((0,positionsSlice/* setPosition */.wq)({
                                    positions: reponseApplyTheme === null || reponseApplyTheme === void 0 ? void 0 : (ref19 = reponseApplyTheme.data) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.data) === null || ref20 === void 0 ? void 0 : ref20.positions
                                }));
                            }
                            es/* Toast.show */.FN.show({
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                    className: "text-center inline-block",
                                    fillColor: "#00B578"
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: t("ss_builder_apply_theme_template_successfully_label")
                                })
                            });
                            onCancelThemeTemplateStore && onCancelThemeTemplateStore();
                            handleRedirectTabs && handleRedirectTabs();
                            setIsOpenThemeTemplatePreview(false);
                        }
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return function handleConfirmThemeTemplatePreview() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRequestUpdateTheme = function() {
        var _ref = ThemeTemplateStore_asyncToGenerator(runtime_default().mark(function _callee(title, image, id) {
            var tags, reponseSaveTheme, dataRequest, themeTemplateArrClone, newThemeTemplateArr, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        tags = _args.length > 3 && _args[3] !== void 0 ? _args[3] : [];
                        reponseSaveTheme = null;
                        dataRequest = {
                            user_id: siteSettings.user_id,
                            site_setting_id: siteSettings.id,
                            title: title,
                            image: image,
                            id: id,
                            tags: tags !== null && tags !== void 0 ? tags : []
                        };
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return (0,api/* requestUpdateThemeTemplate */.T_)(dataRequest);
                    case 6:
                        reponseSaveTheme = _ctx.sent;
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](3);
                        console.log(_ctx.t0);
                    case 12:
                        if (/^20[0-9]$/.test(reponseSaveTheme === null || reponseSaveTheme === void 0 ? void 0 : reponseSaveTheme.status.toString())) {
                            themeTemplateArrClone = cloneDeep_default()(themeTemplateArr);
                            newThemeTemplateArr = themeTemplateArrClone === null || themeTemplateArrClone === void 0 ? void 0 : themeTemplateArrClone.map(function(ele) {
                                var ref;
                                return ele.id === (reponseSaveTheme === null || reponseSaveTheme === void 0 ? void 0 : (ref = reponseSaveTheme.data) === null || ref === void 0 ? void 0 : ref.id) ? reponseSaveTheme === null || reponseSaveTheme === void 0 ? void 0 : reponseSaveTheme.data : ele;
                            });
                            setThemeTemplateArr(newThemeTemplateArr);
                            es/* Toast.show */.FN.show({
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                    className: "text-center inline-block",
                                    fillColor: "#00B578"
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: t("ss_builder_edit_theme_template_successfully_label")
                                })
                            });
                            setIsOpenEditThemeSaving(false);
                        }
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    9
                ]
            ]);
        }));
        return function handleRequestUpdateTheme(title, image, id) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirmEditTheme = function() {
        var _ref = ThemeTemplateStore_asyncToGenerator(runtime_default().mark(function _callee(data) {
            var image, image_name, title, id, _tags, tags, responseImage, dataResquestUploadImage, imageUrl;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        image = data.image, image_name = data.image_name, title = data.title, id = data.id, _tags = data.tags, tags = _tags === void 0 ? [] : _tags;
                        responseImage = null;
                        if (image === null || image === void 0 ? void 0 : image.startsWith("http")) {
                            _ctx.next = 16;
                            break;
                        }
                        dataResquestUploadImage = {
                            id: siteSettings.id,
                            user_id: siteSettings.user_id,
                            name: image_name,
                            content: image
                        };
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return (0,api/* requestUploadImage */.MR)(dataResquestUploadImage);
                    case 7:
                        responseImage = _ctx.sent;
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](4);
                        console.log(_ctx.t0);
                    case 13:
                        if (responseImage) {
                            imageUrl = responseImage.url;
                            handleRequestUpdateTheme(title, imageUrl, id, tags);
                        }
                        _ctx.next = 17;
                        break;
                    case 16:
                        {
                            handleRequestUpdateTheme(title, image, id, tags);
                        }
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    10
                ]
            ]);
        }));
        return function handleConfirmEditTheme(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var themeEditData = (0,react.useMemo)(function() {
        return themeTemplateArr === null || themeTemplateArr === void 0 ? void 0 : themeTemplateArr.find(function(x) {
            return x.id === (themeSelectData === null || themeSelectData === void 0 ? void 0 : themeSelectData.id);
        });
    }, [
        themeTemplateArr,
        themeSelectData
    ]);
    var handleSearchThemeTemplate = function(value) {
        var searchKeys = searchStringTransformed(value);
        var allTheme = immutability_helper_default()([], {
            $push: themeTemplateArr
        });
        if (searchKeys.length > 0) {
            ga_events/* default.submitEventSearch */.ZP.submitEventSearch(window.location.origin, "themeStore", value);
            var searchedThemes = [];
            allTheme.forEach(function(theme) {
                if (isThemeMatchSearchKey(theme, searchKeys)) {
                    searchedThemes.push(theme);
                }
            });
            setSearchedTemplate(searchedThemes);
            setIsSearchMode(true);
        } else {
            setSearchedTemplate(themeTemplateArr);
            setIsSearchMode(false);
        }
    };
    var handleClearSearch = function() {
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.THEME_TEMPLATE */.Bt.THEME_TEMPLATE, ga_events/* BLOCK_TYPE_EVENT_CONFIG.THEME_TEMPLATE_SEARCH_CLEAR */.Aw.THEME_TEMPLATE_SEARCH_CLEAR, ga_events/* LABEL_CONFIG.CLEAR_SEARCH */.tW.CLEAR_SEARCH, ga_events/* ACTION_CONFIG.SEARCH */.AN.SEARCH);
    };
    var numberThemeTemplates = searchedTemplates.length;
    var isThemeMatchSearchKey = function(theme, searchKey) {
        var tagsAndTitleArr = getTagsAndTitleList(theme);
        var isMatch = tagsAndTitleArr.some(function(tag) {
            var splitedTagsArr = searchStringTransformed(tag);
            var isTagIncludeAllKey = searchKey.every(function(key) {
                return splitedTagsArr.includes(key);
            });
            return isTagIncludeAllKey;
        });
        return isMatch;
    };
    var searchStringTransformed = function(str) {
        return str.toLowerCase().split(/[ ,]+/).filter(function(e) {
            return !!e;
        });
    };
    var getTagsAndTitleList = function(theme) {
        var tags = immutability_helper_default()([], {
            $push: (theme === null || theme === void 0 ? void 0 : theme.tags) || []
        });
        var name = [
            theme.title
        ];
        return immutability_helper_default()(tags, {
            $push: name
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-width-content-class m-auto h-full bg-white relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed top-0 w-full bg-white pb-3 z-[10]",
                style: {
                    borderBottom: "1px solid #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-center py-3 relative",
                        children: [
                            activeIndex !== configs_const/* TAB_BAR_INDEX.TEMPLATE */.F.TEMPLATE && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: function() {
                                    return onCancelThemeTemplateStore();
                                },
                                className: "absolute left-3 cursor-pointer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* BackArrow */.D1, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "items-center flex justify-center gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* StoreIcon */.Vt, {
                                        className: "inline-block w-[22px] h-[22px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-[18px] leading-6",
                                        children: t("ss_builder_theme_template_store_title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-[50%] right-[1rem] translate-y-[-50%]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeTemplateHandler_ThemeTourOpening, {})
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full bg-white search-block h-[36px] px-4 theme-store-tour-step-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SearchBar */.E1, {
                                icon: function() {
                                    return null;
                                },
                                placeholder: t("ss_builder_theme_template_search_bar_placeholder"),
                                onSearch: handleSearchThemeTemplate,
                                onChange: function(val) {
                                    setValue(val);
                                },
                                style: {
                                    width: "100%"
                                },
                                onClear: function() {
                                    return handleClearSearch();
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-[#EE3244] flex h-43 w-43 cursor-pointer",
                                style: {
                                    width: "43px",
                                    height: "36px",
                                    borderRadius: "0 6px 6px 0"
                                },
                                onClick: function() {
                                    handleSearchThemeTemplate(value1);
                                    ga_events/* default.submitEventSearch */.ZP.submitEventSearch(window.location.origin, "themeStore", value1);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SearchIcon */.W1, {
                                    className: "m-auto"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white px-4 pt-[6.5rem]",
                children: [
                    isSearchMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-lg leading-6",
                            children: t("ss_builder_search_results_theme_store")
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-lg leading-6",
                                children: t("ss_builder_theme_template_store_instruction_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[13px] leading-[17px] text-[#737373]",
                                children: t("ss_builder_theme_template_store_instruction_subtitle")
                            })
                        ]
                    }),
                    numberThemeTemplates > 0 && isSearchMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[13px] leading-[17px] text-[#737373]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("ss_builder_theme_template_theme_store", {
                                    num_results: numberThemeTemplates
                                })
                            })
                        })
                    })
                ]
            }),
            numberThemeTemplates === 0 && isSearchMode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 pt-4 pb-[65px] bg-white text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center items-center mb-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SwatchBookIcon */.n6, {
                            width: 32,
                            height: 32
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-lg leading-6",
                        children: t("ss_builder_no_themes_found_theme_store")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[13px] leading-[17px] text-[#737373] mt-1",
                        children: t("ss_builder_try_another_keyword_theme_store")
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeTemplateLists/* default */.Z, {
                onSelectTheme: handleSelectTheme,
                onEditTheme: handleEditTheme,
                onDeleteTheme: handleDeleteTheme,
                KEY: configs_const/* THEME_RENDER_LIST_KEY.THEME_STORE */.q9.THEME_STORE,
                themeTemplateData: isSearchMode ? searchedTemplates : themeTemplateArr,
                onShowHideTheme: handleShowHideTheme
            }),
            isOpenThemeTemplatePreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenThemeTemplatePreview,
                onMaskClick: function() {
                    return setIsOpenThemeTemplatePreview(false);
                },
                isLimitWidth: false,
                style: {
                    background: "#fff"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeTemplateHandler_ThemeTemplatePreview, {
                    onCancelThemeTemplatePreview: function() {
                        return setIsOpenThemeTemplatePreview(false);
                    },
                    onConfirmThemeTemplatePreview: handleConfirmThemeTemplatePreview,
                    user: user,
                    selectedThemeData: themeSelectData,
                    KEY: configs_const/* THEME_PREVIEW_KEY.PREVIEW_AND_APPLY */.Sl.PREVIEW_AND_APPLY,
                    siteSettingUserRootId: siteSettingUserRootId,
                    userRootId: userRootId,
                    isViewTheme: true
                })
            }),
            isOpenEditThemeSaving && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenEditThemeSaving,
                onMaskClick: function() {
                    setIsOpenEditThemeSaving(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeTemplateHandler_ThemeTemplateSaving, {
                    handleCancelThemeSaving: function() {
                        return setIsOpenEditThemeSaving(false);
                    },
                    KEY: configs_const/* THEME_TEMPLATE_KEY.EDIT */.vF.EDIT,
                    handleConfirmThemeSaving: handleConfirmEditTheme,
                    themeTemplateData: themeEditData
                })
            })
        ]
    });
};
/* harmony default export */ var ThemeTemplateHandler_ThemeTemplateStore = (ThemeTemplateStore);

;// CONCATENATED MODULE: ./src/features/design/components/ThemeTemplateHandler/index.tsx
function ThemeTemplateHandler_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ThemeTemplateHandler_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ThemeTemplateHandler_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ThemeTemplateHandler_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}












var ThemeTemplateHandler = function(props) {
    var isOpenAddNewThemeSelectionPanel = props.isOpenAddNewThemeSelectionPanel, handleCancelAddNewThemeSelectionPanel = props.handleCancelAddNewThemeSelectionPanel, siteSettings = props.siteSettings, user = props.user, handleRedirectTabs = props.handleRedirectTabs;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref3 = (0,react.useState)(false), isOpenThemeTemplateOverwrite = ref3[0], setIsOpenThemeTemplateOverwrite = ref3[1];
    var ref1 = (0,react.useState)(false), isOpenAddNewTheme = ref1[0], setIsOpenAddNewTheme = ref1[1];
    var ref2 = (0,react.useState)(false), isOpenThemeTemplateStore = ref2[0], setIsOpenThemeTemplateStore = ref2[1];
    var handleOverwriteTheme = function() {
        setIsOpenThemeTemplateOverwrite(true);
        handleCancelAddNewThemeSelectionPanel();
    };
    var handleAddNewTheme = function() {
        setIsOpenAddNewTheme(true);
        handleCancelAddNewThemeSelectionPanel();
    };
    var handleConfirmAddNewTheme = function() {
        var _ref = ThemeTemplateHandler_asyncToGenerator(runtime_default().mark(function _callee(data) {
            var image, image_name, title, _tags, tags, responseImage, reponseSaveTheme, dataResquestUploadImage, dataRequest;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        image = data.image, image_name = data.image_name, title = data.title, _tags = data.tags, tags = _tags === void 0 ? [] : _tags;
                        responseImage = null;
                        reponseSaveTheme = null;
                        if (!image) {
                            _ctx.next = 26;
                            break;
                        }
                        dataResquestUploadImage = {
                            id: siteSettings.id,
                            user_id: siteSettings.user_id,
                            name: image_name,
                            content: image
                        };
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return (0,api/* requestUploadImage */.MR)(dataResquestUploadImage);
                    case 8:
                        responseImage = _ctx.sent;
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](5);
                        console.log(_ctx.t0);
                    case 14:
                        if (!responseImage) {
                            _ctx.next = 26;
                            break;
                        }
                        dataRequest = {
                            user_id: siteSettings.user_id,
                            site_setting_id: siteSettings.id,
                            title: title,
                            image: responseImage.url,
                            tags: tags !== null && tags !== void 0 ? tags : []
                        };
                        _ctx.prev = 16;
                        _ctx.next = 19;
                        return (0,api/* requestSaveThemeTemplate */.Ic)(dataRequest);
                    case 19:
                        reponseSaveTheme = _ctx.sent;
                        _ctx.next = 25;
                        break;
                    case 22:
                        _ctx.prev = 22;
                        _ctx.t1 = _ctx["catch"](16);
                        console.log(_ctx.t1);
                    case 25:
                        if (/^20[0-9]$/.test(reponseSaveTheme === null || reponseSaveTheme === void 0 ? void 0 : reponseSaveTheme.status.toString())) {
                            setIsOpenAddNewTheme(false);
                            setIsOpenThemeTemplateStore(true);
                            es/* Toast.show */.FN.show({
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                    className: "text-center inline-block",
                                    fillColor: "#00B578"
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: t("ss_builder_save_new_theme_template_successfully_label")
                                })
                            });
                        }
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    11
                ],
                [
                    16,
                    22
                ]
            ]);
        }));
        return function handleConfirmAddNewTheme(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRequestOverwriteTheme = function() {
        var _ref = ThemeTemplateHandler_asyncToGenerator(runtime_default().mark(function _callee(title, image, id, tags, handleCancelOverwriteThemeSaving) {
            var reponseSaveTheme, dataRequest, ref, statusCode;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        reponseSaveTheme = null;
                        dataRequest = {
                            user_id: siteSettings.user_id,
                            site_setting_id: siteSettings.id,
                            title: title,
                            image: image,
                            id: id,
                            tags: tags
                        };
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,api/* requestSaveThemeTemplate */.Ic)(dataRequest);
                    case 5:
                        reponseSaveTheme = _ctx.sent;
                        _ctx.next = 14;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        ;
                        console.log(_ctx.t0);
                        statusCode = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : ref.status;
                        if (statusCode == 404) {
                            es/* Modal.show */.u_.show({
                                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                    className: "w-11 h-11",
                                    fillColor: "#FF8F1F",
                                    onClick: function() {}
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col text-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-lg font-bold leading-[25px]",
                                            children: t("ss_builder_dont_apply_theme_content_modal_label")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "",
                                            children: t("ss_builder_dont_apply_theme_content_modal_description")
                                        })
                                    ]
                                }),
                                className: "modal-error-class",
                                closeOnAction: true,
                                actions: [
                                    {
                                        key: "confirm",
                                        text: t("ss_builder_dont_apply_theme_content_modal_btn_confirm_label")
                                    }, 
                                ]
                            });
                        }
                    case 14:
                        if (/^20[0-9]$/.test(reponseSaveTheme === null || reponseSaveTheme === void 0 ? void 0 : reponseSaveTheme.status.toString())) {
                            setIsOpenThemeTemplateOverwrite(false);
                            setIsOpenThemeTemplateStore(true);
                            handleCancelOverwriteThemeSaving();
                            es/* Toast.show */.FN.show({
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                    className: "text-center inline-block",
                                    fillColor: "#00B578"
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: t("ss_builder_overwrite_theme_template_successfully_label")
                                })
                            });
                        }
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return function handleRequestOverwriteTheme(title, image, id, tags, handleCancelOverwriteThemeSaving) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOverwriteThemeTemplate = function() {
        var _ref = ThemeTemplateHandler_asyncToGenerator(runtime_default().mark(function _callee(data, handleCancelOverwriteThemeSaving) {
            var image, image_name, title, id, _tags, tags, responseImage, dataResquestUploadImage, imageUrl;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        image = data.image, image_name = data.image_name, title = data.title, id = data.id, _tags = data.tags, tags = _tags === void 0 ? [] : _tags;
                        responseImage = null;
                        if (image === null || image === void 0 ? void 0 : image.startsWith("http")) {
                            _ctx.next = 16;
                            break;
                        }
                        dataResquestUploadImage = {
                            id: siteSettings.id,
                            user_id: siteSettings.user_id,
                            name: image_name,
                            content: image
                        };
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return (0,api/* requestUploadImage */.MR)(dataResquestUploadImage);
                    case 7:
                        responseImage = _ctx.sent;
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](4);
                        console.log(_ctx.t0);
                    case 13:
                        if (responseImage) {
                            imageUrl = responseImage.url;
                            handleRequestOverwriteTheme(title, imageUrl, id, tags, handleCancelOverwriteThemeSaving);
                        }
                        _ctx.next = 17;
                        break;
                    case 16:
                        {
                            handleRequestOverwriteTheme(title, image, id, tags, handleCancelOverwriteThemeSaving);
                        }
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    10
                ]
            ]);
        }));
        return function handleOverwriteThemeTemplate(data, handleCancelOverwriteThemeSaving) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Modal */.u_, {
                bodyClassName: "theme-template-selection-modal",
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InfomationCircleIcon */.Hw, {
                    className: "w-11 h-11",
                    fillColor: "#1890FF"
                }),
                visible: isOpenAddNewThemeSelectionPanel,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-center items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-lg font-bold leading-[25px]",
                            children: t("ss_builder_add_new_theme_selection_panel_label")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: t("ss_builder_add_new_theme_selection_panel_description")
                        })
                    ]
                }),
                actions: [
                    {
                        key: "add-new",
                        text: t("ss_builder_add_new_theme_btn_label"),
                        primary: true,
                        onClick: handleAddNewTheme,
                        style: {
                            padding: "7px 0"
                        }
                    },
                    {
                        key: "overwrite",
                        text: t("ss_builder_overwrite_theme_btn_label"),
                        style: {
                            border: "1px solid #EE3244",
                            padding: "7px 0"
                        },
                        onClick: handleOverwriteTheme
                    },
                    {
                        key: "cancel",
                        text: t("ss_builder_cancel_theme_selection_panel_label"),
                        onClick: function() {
                            return handleCancelAddNewThemeSelectionPanel();
                        }
                    }, 
                ]
            }),
            isOpenAddNewTheme && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenAddNewTheme,
                onMaskClick: function() {
                    setIsOpenAddNewTheme(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeTemplateHandler_ThemeTemplateSaving, {
                    handleCancelThemeSaving: function() {
                        return setIsOpenAddNewTheme(false);
                    },
                    KEY: configs_const/* THEME_TEMPLATE_KEY.SAVE_NEW */.vF.SAVE_NEW,
                    handleConfirmThemeSaving: handleConfirmAddNewTheme
                })
            }),
            isOpenThemeTemplateOverwrite && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenThemeTemplateOverwrite,
                onMaskClick: function() {
                    setIsOpenThemeTemplateOverwrite(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeTemplateHandler_ThemeTemplateOverwrite, {
                    onCancelThemeTemplateOverwrite: function() {
                        return setIsOpenThemeTemplateOverwrite(false);
                    },
                    onSaveThemeTemplateOverwrite: handleOverwriteThemeTemplate,
                    user: user
                })
            }),
            isOpenThemeTemplateStore && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenThemeTemplateStore,
                onMaskClick: function() {
                    setIsOpenThemeTemplateStore(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeTemplateHandler_ThemeTemplateStore, {
                    onCancelThemeTemplateStore: function() {
                        return setIsOpenThemeTemplateStore(false);
                    },
                    handleRedirectTabs: handleRedirectTabs,
                    siteSettings: siteSettings,
                    user: user
                })
            })
        ]
    });
};
/* harmony default export */ var components_ThemeTemplateHandler = (ThemeTemplateHandler);

// EXTERNAL MODULE: ./src/features/design/store/externalStateSlice.ts
var externalStateSlice = __webpack_require__(42372);
;// CONCATENATED MODULE: ./src/features/share/components/ModalInfo/index.tsx





var ModalInfo = function(props) {
    var visible = props.visible, info = props.info, onClose = props.onClose;
    var ModalContent = function() {
        var ref, ref1, ref2;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
            className: "position-info-content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "cursor-pointer p-1 position-info-icon",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ClosePositionInfoIcon */.Wr, {
                        width: 24,
                        height: 24,
                        className: "",
                        onClick: onClose
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-2 text-[18px] leading-[25px] font-bold text-[#333333]",
                    children: info === null || info === void 0 ? void 0 : info.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-[#333333]",
                    children: info === null || info === void 0 ? void 0 : info.desctiption
                }),
                (info === null || info === void 0 ? void 0 : info.button) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                        color: "primary",
                        size: "middle",
                        fill: "solid",
                        block: true,
                        onClick: info === null || info === void 0 ? void 0 : (ref = info.button) === null || ref === void 0 ? void 0 : ref.onClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row justify-center items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "mr-1",
                                    children: info === null || info === void 0 ? void 0 : (ref1 = info.button) === null || ref1 === void 0 ? void 0 : ref1.icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: info === null || info === void 0 ? void 0 : (ref2 = info.button) === null || ref2 === void 0 ? void 0 : ref2.title
                                })
                            ]
                        })
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(portal/* default */.Z, {
        elementId: "modalPortal",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Modal */.u_, {
            // header={
            //   <CloseCircleIconV2 width={48} height={48} fillColor="#FF3141" />
            // }
            bodyClassName: "modal-position-info",
            forceRender: true,
            onClose: onClose,
            visible: visible,
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent, {}),
            closeOnMaskClick: true,
            showCloseButton: false,
            image: info === null || info === void 0 ? void 0 : info.image
        })
    });
};
/* harmony default export */ var components_ModalInfo = (ModalInfo);

// EXTERNAL MODULE: ./src/features/share/hooks/index.ts
var share_hooks = __webpack_require__(16565);
;// CONCATENATED MODULE: ./src/features/design/components/ModalGuide/index.tsx
function ModalGuide_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}








var ModalGuide_FormData = function(props, ref) {
    var _$ref = (0,share_hooks/* usePopup */.BF)(), visible = _$ref.visible, openPopup = _$ref.openPopup, closePopup = _$ref.closePopup;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var userId = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.siteSettings.user_id;
    });
    var guideState = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.externalState.guide_state;
    });
    var _obj;
    var nextFirstGuide = (_obj = {}, ModalGuide_defineProperty(_obj, externalStateSlice/* FirstGuideStateEnum.ADD_BLOCK */.x9.ADD_BLOCK, externalStateSlice/* FirstGuideStateEnum.PREVIEW */.x9.PREVIEW), ModalGuide_defineProperty(_obj, externalStateSlice/* FirstGuideStateEnum.PREVIEW */.x9.PREVIEW, externalStateSlice/* FirstGuideStateEnum.PUBLISH */.x9.PUBLISH), ModalGuide_defineProperty(_obj, externalStateSlice/* FirstGuideStateEnum.PUBLISH */.x9.PUBLISH, externalStateSlice/* FirstGuideStateEnum.DONE */.x9.DONE), _obj);
    var changeFirstGuide = function() {
        if (guideState !== externalStateSlice/* FirstGuideStateEnum.DONE */.x9.DONE) {
            dispatch((0,externalStateSlice/* setFirstGuideState */.lA)(nextFirstGuide[guideState]));
        }
    };
    var addBlockContent = {
        image: "https://image.passio.eco/page-builder/page-builder/position-modal/add_block.gif",
        title: t("ss_builder_first_guide_add_block_title"),
        desctiption: t("ss_builder_first_guide_add_block_description"),
        button: {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                className: ""
            }),
            title: t("ss_builder_first_guide_add_block_btn_title"),
            onClick: function() {
                closePopup();
                props.onOpenPositionSelection();
            }
        }
    };
    var previewContent = {
        image: "https://image.passio.eco/page-builder/page-builder/position-modal/preview.gif",
        title: t("ss_builder_first_guide_preview_title"),
        desctiption: t("ss_builder_first_guide_preview_description"),
        button: {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PreviewThemeIcon */.gc, {
                className: "",
                fillColor: "#fff"
            }),
            title: t("ss_builder_first_guide_preview_btn_title"),
            onClick: function() {
                closePopup();
                props.onOpenPreview();
            }
        }
    };
    var publishContent = {
        image: "https://image.passio.eco/page-builder/page-builder/position-modal/publish.gif",
        title: t("ss_builder_first_guide_publish_title"),
        desctiption: t("ss_builder_first_guide_publish_description"),
        button: {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PubLishIcon */.FS, {
                width: 15,
                height: 15,
                className: ""
            }),
            title: t("ss_builder_first_guide_publish_btn_title"),
            onClick: function() {
                closePopup();
                props.onPublish();
            }
        }
    };
    var _obj1;
    var guideSteps = (_obj1 = {}, ModalGuide_defineProperty(_obj1, externalStateSlice/* FirstGuideStateEnum.ADD_BLOCK */.x9.ADD_BLOCK, addBlockContent), ModalGuide_defineProperty(_obj1, externalStateSlice/* FirstGuideStateEnum.PREVIEW */.x9.PREVIEW, previewContent), ModalGuide_defineProperty(_obj1, externalStateSlice/* FirstGuideStateEnum.PUBLISH */.x9.PUBLISH, publishContent), ModalGuide_defineProperty(_obj1, externalStateSlice/* FirstGuideStateEnum.DONE */.x9.DONE, null), _obj1);
    var guide = (0,react.useMemo)(function() {
        return guideSteps[guideState];
    }, [
        guideState
    ]);
    (0,react.useImperativeHandle)(ref, function() {
        return {
            closeModal: closePopup,
            openModal: openPopup,
            changeFirstGuide: changeFirstGuide
        };
    });
    (0,react.useEffect)(function() {
        if (userId) dispatch((0,externalStateSlice/* getExternalState */.DH)());
    }, [
        userId
    ]);
    return guide ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModalInfo, {
        info: guide,
        visible: visible,
        onClose: closePopup
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var ModalGuide = (/*#__PURE__*/react.forwardRef(ModalGuide_FormData));

;// CONCATENATED MODULE: ./src/features/design/context/context.ts

var DesignContext = react.createContext(null);
var useDesignContext = function() {
    return (0,react.useContext)(DesignContext);
};

// EXTERNAL MODULE: ./src/features/block/components/BlockEditV2/index.tsx + 5 modules
var BlockEditV2 = __webpack_require__(13641);
// EXTERNAL MODULE: ./src/features/design/design.config.ts + 88 modules
var design_config = __webpack_require__(56214);
;// CONCATENATED MODULE: ./src/features/mini-store/block/TruthOrDare/sideFnc.tsx
function sideFnc_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sideFnc_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sideFnc_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function handleOnKeyPress(e) {
    if (!/[+0-9]/.test(e === null || e === void 0 ? void 0 : e.key)) e === null || e === void 0 ? void 0 : e.preventDefault();
}
var CloseModalIcon = function() {
    return /*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M6 6L18 18M6 18L18 6L6 18Z",
            stroke: "#3F3F46",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var AlertIcon = function() {
    return /*#__PURE__*/ _jsx("svg", {
        width: "45",
        height: "44",
        viewBox: "0 0 45 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M22.5001 16.5V22.5M22.5001 27.5H22.5184M9.79877 34.8334H35.2014C38.0248 34.8334 39.7884 31.7772 38.3768 29.3334L25.6754 7.33336C24.2638 4.88953 20.7364 4.88953 19.3248 7.33336L6.62344 29.3334C5.21177 31.7772 6.97544 34.8334 9.79877 34.8334Z",
            stroke: "#DC2626",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
function IconSuccess(props) {
    return /*#__PURE__*/ _jsxs("svg", sideFnc_objectSpread({}, props, {
        width: "200",
        height: "128",
        viewBox: "0 0 200 128",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M100.5 19C77.6102 19 59 37.6102 59 60.5C59 83.3898 77.6102 102 100.5 102C123.39 102 142 83.3898 142 60.5C142 37.6102 123.39 19 100.5 19Z",
                fill: "#389E0D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M92.508 79.483C87.207 74.182 81.9385 68.8324 76.6213 63.5315C76.0377 62.9479 76.0377 61.9752 76.6213 61.3916L82.7328 55.2801C83.3164 54.6965 84.2891 54.6965 84.8727 55.2801L93.6103 64.0178L116.079 41.5332C116.679 40.9496 117.635 40.9496 118.235 41.5332L124.362 47.6609C124.962 48.2608 124.962 49.2172 124.362 49.8008L94.6478 79.483C94.0643 80.0828 93.1078 80.0828 92.508 79.483Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M157.589 109.128C161.186 105.717 165.06 103.958 170.216 102.306L172.18 104.696C166.196 106.209 163.345 106.342 161.396 110.475L157.589 109.128Z",
                fill: "#007BFF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M30.1242 72.8123C25.9719 75.7148 22.0615 76.555 17.0369 76.8694L16 73.3992C21.7036 73.5282 24.2498 74.2861 27.1636 70L30.1242 72.8123Z",
                fill: "#007BFF"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M164.834 53.0877C168.633 50.8512 170.741 47.9276 172.844 43.8592L170.518 41.5016C168.509 46.3393 168.158 48.7968 163.734 49.4031L164.834 53.0877Z",
                fill: "#FF5C33"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M46.6125 29.2251C47.5031 29.2251 48.2251 28.5031 48.2251 27.6125C48.2251 26.722 47.5031 26 46.6125 26C45.722 26 45 26.722 45 27.6125C45 28.5031 45.722 29.2251 46.6125 29.2251Z",
                fill: "#FF5C33"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M41.6125 99.2251C42.5031 99.2251 43.2251 98.5031 43.2251 97.6125C43.2251 96.722 42.5031 96 41.6125 96C40.722 96 40 96.722 40 97.6125C40 98.5031 40.722 99.2251 41.6125 99.2251Z",
                fill: "#FF5C33"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M145.101 35.4708C145.991 35.4708 146.713 34.7488 146.713 33.8583C146.713 32.9677 145.991 32.2457 145.101 32.2457C144.21 32.2457 143.488 32.9677 143.488 33.8583C143.488 34.7488 144.21 35.4708 145.101 35.4708Z",
                fill: "#FFB900"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M169 85C170.657 85 172 83.6569 172 82C172 80.3431 170.657 79 169 79C167.343 79 166 80.3431 166 82C166 83.6569 167.343 85 169 85Z",
                fill: "#FF5C33"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.2246 44L13 47.2246L16.2246 50.4492L19.4492 47.2246L16.2246 44Z",
                fill: "#FFB900"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M98.2246 117L95 120.225L98.2246 123.449L101.449 120.225L98.2246 117Z",
                fill: "#FFB900"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M175.225 5L172 8.22459L175.225 11.4492L178.449 8.22459L175.225 5Z",
                fill: "#FFB900"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M195.71 63.5691L192.485 66.7937L195.71 70.0183L198.935 66.7937L195.71 63.5691Z",
                fill: "#14CCA1"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M42.605 7.94127C38.4414 10.3907 34.6262 10.8842 29.7869 10.781L29 7.36237C34.4713 7.94772 36.8724 8.883 39.9298 5L42.605 7.94127Z",
                fill: "#FFB900"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.7712 112.63C16.7295 108.877 15.6738 105.178 15.0558 100.377L18.3192 99.0905C18.5545 104.588 17.9869 107.102 22.2817 109.547L19.7712 112.63Z",
                fill: "#FFB900"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M101.177 15.0558C97.707 13.3433 95.4607 10.8632 93 7.34141L94.4142 5C96.9459 9.22808 97.6957 11.434 101.348 11.6114L101.177 15.0558Z",
                fill: "#14CCA1"
            })
        ]
    }));
}
function IconTime(props) {
    return /*#__PURE__*/ _jsxs("svg", sideFnc_objectSpread({}, props, {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M5.72056 1.76875C6.05807 1.49874 6.11279 1.00625 5.84278 0.668745C5.57277 0.331236 5.08029 0.276515 4.74278 0.546523L2.13408 2.63348C1.79657 2.90348 1.74185 3.39597 2.01186 3.73349C2.28187 4.071 2.77435 4.12572 3.11186 3.85571L5.72056 1.76875Z",
                fill: "url(#paint0_linear_1570_49708)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M5.72056 1.76875C6.05807 1.49874 6.11279 1.00625 5.84278 0.668745C5.57277 0.331236 5.08029 0.276515 4.74278 0.546523L2.13408 2.63348C1.79657 2.90348 1.74185 3.39597 2.01186 3.73349C2.28187 4.071 2.77435 4.12572 3.11186 3.85571L5.72056 1.76875Z",
                fill: "url(#paint1_linear_1570_49708)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.2857 0.546523C18.9483 0.276515 18.4558 0.331236 18.1857 0.668745C17.9158 1.00625 17.9704 1.49874 18.308 1.76875L20.9167 3.85571C21.2542 4.12572 21.7467 4.071 22.0167 3.73349C22.2867 3.39597 22.232 2.90348 21.8944 2.63348L19.2857 0.546523Z",
                fill: "url(#paint2_linear_1570_49708)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M19.2857 0.546523C18.9483 0.276515 18.4558 0.331236 18.1857 0.668745C17.9158 1.00625 17.9704 1.49874 18.308 1.76875L20.9167 3.85571C21.2542 4.12572 21.7467 4.071 22.0167 3.73349C22.2867 3.39597 22.232 2.90348 21.8944 2.63348L19.2857 0.546523Z",
                fill: "url(#paint3_linear_1570_49708)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0143 1.15765C5.81907 1.15765 0.796875 6.17985 0.796875 12.375C0.796875 18.5702 5.81907 23.5924 12.0143 23.5924C18.2095 23.5924 23.2317 18.5702 23.2317 12.375C23.2317 6.17985 18.2095 1.15765 12.0143 1.15765Z",
                fill: "url(#paint4_linear_1570_49708)"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0143 1.15765C5.81907 1.15765 0.796875 6.17985 0.796875 12.375C0.796875 18.5702 5.81907 23.5924 12.0143 23.5924C18.2095 23.5924 23.2317 18.5702 23.2317 12.375C23.2317 6.17985 18.2095 1.15765 12.0143 1.15765Z",
                fill: "url(#paint5_linear_1570_49708)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11 6.14562C11 5.51292 11.5129 5 12.1456 5C12.5275 4.99206 13.2912 5.21008 13.2912 6.14562V10.2555L13.3369 12.1685L13.5471 12.9739L14.1396 13.5587C14.507 13.8222 15.0088 14.1131 15.7734 14.5547L16.687 15.0822C17.2351 15.3985 17.4228 16.0992 17.1065 16.6471C16.7901 17.195 16.0895 17.3829 15.5415 17.0666L14.5817 16.5124L14.5814 16.5122C13.8754 16.1046 13.2748 15.7579 12.8047 15.421C12.304 15.0622 11.8774 14.6644 11.5627 14.1196C11.2482 13.5747 11.1172 13.0065 11.0567 12.3933C11 11.8176 11 11.1241 11 10.3088V6.14562Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_1570_49708",
                        x1: "12.0143",
                        y1: "0.375",
                        x2: "12.0143",
                        y2: "23.5924",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#F97794"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#9708CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_1570_49708",
                        x1: "1.84033",
                        y1: "0.375",
                        x2: "6.4424",
                        y2: "1.03297",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#EA1A71"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FD7718"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint2_linear_1570_49708",
                        x1: "12.0143",
                        y1: "0.375",
                        x2: "12.0143",
                        y2: "23.5924",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#F97794"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#9708CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint3_linear_1570_49708",
                        x1: "18.0142",
                        y1: "0.375",
                        x2: "22.6163",
                        y2: "1.03298",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#EA1A71"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FD7718"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint4_linear_1570_49708",
                        x1: "12.0143",
                        y1: "0.375014",
                        x2: "12.0143",
                        y2: "23.5924",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#F97794"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#9708CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint5_linear_1570_49708",
                        x1: "0.796875",
                        y1: "1.15765",
                        x2: "25.6493",
                        y2: "4.26675",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#EA1A71"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FD7718"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
}
var IconTooltip = function() {
    return /*#__PURE__*/ _jsx("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            position: "relative"
        },
        children: /*#__PURE__*/ _jsx("path", {
            fill: "#DDDDDD",
            d: "M7.99968 1.83337C4.31967 1.83337 1.33301 4.82004 1.33301 8.50004C1.33301 12.18 4.31967 15.1667 7.99968 15.1667C11.6797 15.1667 14.6663 12.18 14.6663 8.50004C14.6663 4.82004 11.6797 1.83337 7.99968 1.83337ZM8.66634 11.8334H7.33301V10.5H8.66634V11.8334ZM8.66634 9.16671H7.33301V5.16671H8.66634V9.16671Z"
        })
    });
};
function TrashIcon(props) {
    return /*#__PURE__*/ _jsxs("svg", sideFnc_objectSpread({}, props, {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M0 10C0 4.47718 4.47715 3.05176e-05 10 3.05176e-05C15.5228 3.05176e-05 20 4.47718 20 10C20 15.5229 15.5228 20 10 20C4.47715 20 0 15.5229 0 10Z",
                fill: "#DC2626"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.42857 5.00003C9.32248 5.00009 9.2185 5.02968 9.12827 5.08549C9.03804 5.1413 8.96514 5.22113 8.91771 5.31603L8.504 6.14289H6.57143C6.41988 6.14289 6.27453 6.20309 6.16737 6.31026C6.0602 6.41742 6 6.56276 6 6.71432C6 6.86587 6.0602 7.01121 6.16737 7.11838C6.27453 7.22554 6.41988 7.28574 6.57143 7.28574V13C6.57143 13.3031 6.69184 13.5938 6.90616 13.8082C7.12049 14.0225 7.41118 14.1429 7.71429 14.1429H12.2857C12.5888 14.1429 12.8795 14.0225 13.0938 13.8082C13.3082 13.5938 13.4286 13.3031 13.4286 13V7.28574C13.5801 7.28574 13.7255 7.22554 13.8326 7.11838C13.9398 7.01121 14 6.86587 14 6.71432C14 6.56276 13.9398 6.41742 13.8326 6.31026C13.7255 6.20309 13.5801 6.14289 13.4286 6.14289H11.496L11.0823 5.31603C11.0349 5.22113 10.962 5.1413 10.8717 5.08549C10.7815 5.02968 10.6775 5.00009 10.5714 5.00003H9.42857ZM8.28571 8.4286C8.28571 8.27705 8.34592 8.1317 8.45308 8.02454C8.56025 7.91738 8.70559 7.85717 8.85714 7.85717C9.0087 7.85717 9.15404 7.91738 9.2612 8.02454C9.36837 8.1317 9.42857 8.27705 9.42857 8.4286V11.8572C9.42857 12.0087 9.36837 12.1541 9.2612 12.2612C9.15404 12.3684 9.0087 12.4286 8.85714 12.4286C8.70559 12.4286 8.56025 12.3684 8.45308 12.2612C8.34592 12.1541 8.28571 12.0087 8.28571 11.8572V8.4286ZM11.1429 7.85717C10.9913 7.85717 10.846 7.91738 10.7388 8.02454C10.6316 8.1317 10.5714 8.27705 10.5714 8.4286V11.8572C10.5714 12.0087 10.6316 12.1541 10.7388 12.2612C10.846 12.3684 10.9913 12.4286 11.1429 12.4286C11.2944 12.4286 11.4398 12.3684 11.5469 12.2612C11.6541 12.1541 11.7143 12.0087 11.7143 11.8572V8.4286C11.7143 8.27705 11.6541 8.1317 11.5469 8.02454C11.4398 7.91738 11.2944 7.85717 11.1429 7.85717Z",
                fill: "white"
            })
        ]
    }));
}
var ClearIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _style = param.style, style1 = _style === void 0 ? {} : _style, _width = param.width, width = _width === void 0 ? 16 : _width, _height = param.height, height = _height === void 0 ? 16 : _height, _fillColor = param.fillColor, fillColor = _fillColor === void 0 ? "#fff" : _fillColor;
    return /*#__PURE__*/ _jsx("svg", {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        style: style1,
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.9999 21.5999C14.546 21.5999 16.9878 20.5885 18.7881 18.7881C20.5885 16.9878 21.5999 14.546 21.5999 11.9999C21.5999 9.45382 20.5885 7.01203 18.7881 5.21168C16.9878 3.41133 14.546 2.3999 11.9999 2.3999C9.45382 2.3999 7.01203 3.41133 5.21168 5.21168C3.41133 7.01203 2.3999 9.45382 2.3999 11.9999C2.3999 14.546 3.41133 16.9878 5.21168 18.7881C7.01203 20.5885 9.45382 21.5999 11.9999 21.5999V21.5999ZM10.4483 8.7515C10.222 8.53291 9.91886 8.41196 9.60422 8.41469C9.28959 8.41743 8.98861 8.54363 8.76612 8.76612C8.54363 8.98861 8.41743 9.28959 8.41469 9.60422C8.41196 9.91886 8.53291 10.222 8.7515 10.4483L10.3031 11.9999L8.7515 13.5515C8.63689 13.6622 8.54547 13.7946 8.48258 13.941C8.41969 14.0874 8.38659 14.2449 8.3852 14.4042C8.38382 14.5636 8.41418 14.7216 8.47452 14.869C8.53485 15.0165 8.62396 15.1505 8.73663 15.2632C8.8493 15.3758 8.98328 15.465 9.13076 15.5253C9.27823 15.5856 9.43625 15.616 9.59558 15.6146C9.75492 15.6132 9.91238 15.5801 10.0588 15.5172C10.2052 15.4543 10.3376 15.3629 10.4483 15.2483L11.9999 13.6967L13.5515 15.2483C13.7778 15.4669 14.0809 15.5878 14.3956 15.5851C14.7102 15.5824 15.0112 15.4562 15.2337 15.2337C15.4562 15.0112 15.5824 14.7102 15.5851 14.3956C15.5878 14.0809 15.4669 13.7778 15.2483 13.5515L13.6967 11.9999L15.2483 10.4483C15.4669 10.222 15.5878 9.91886 15.5851 9.60422C15.5824 9.28959 15.4562 8.98861 15.2337 8.76612C15.0112 8.54363 14.7102 8.41743 14.3956 8.41469C14.0809 8.41196 13.7778 8.53291 13.5515 8.7515L11.9999 10.3031L10.4483 8.7515Z",
            fill: "#BFBFBF"
        })
    });
};
var INPUT_MAX_INVITATION = 60;
var INPUT_MAX_TXTBTN = 40;
var INPUT_MIN_PRICE_GB = 1;
var INPUT_MAX_PRICE_GB = 10000;
var INPUT_MIN_PRICE = 2000; // for vietnam
var INPUT_MAX_PRICE = 9999999999;
var COUNTRY_VN = "VN";
var COUNTRY_EN = "OTHER";
var COUNTRY_ID = "ID";
var COUNTRY_SG = "SG";
var COUNTRY_PH = "PH";
var COUNTRY_MY = "MY";
var COUNTRY_TH = "TH";
var CURRENCY_ID = "IDR";
var CURRENCY_VN = "VND";
function HintPrice(param) {
    var price1 = param.price1, isShow = param.isShow, handleChoicePrice = param.handleChoicePrice, country = param.country;
    var price = price1.toString().replace(/\D/g, "").replace(",", "");
    var multi = country == "VN" ? [
        1000,
        10000,
        100000
    ] : [
        10,
        100
    ];
    var maxPrice = country == "VN" ? INPUT_MAX_PRICE : INPUT_MAX_PRICE_GB;
    var minPrice = country == "VN" ? INPUT_MIN_PRICE : INPUT_MIN_PRICE_GB;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            className: style.listPrice,
            children: price && isShow ? multi.map(function(xs, index) {
                return xs * price <= maxPrice && xs * price >= minPrice && xs * price != 0 ? /*#__PURE__*/ _jsx("div", {
                    onClick: function() {
                        return handleChoicePrice(xs * price);
                    },
                    className: "".concat(style.choicePrice, " text-sm font-medium text-center"),
                    children: (price * xs).toString().replace(/\D/g, "").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                }, index) : "";
            }) : ""
        })
    });
}

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
;// CONCATENATED MODULE: ./src/features/design/components/IntroductionNewFeature/BrandGiftFloat/ModalWaringFloatingFull.tsx






var ModalWaringFloatingFull = function(props) {
    var visible = props.visible, onContinue = props.onContinue, onReject = props.onReject, onOpenIntroductionBrandGift = props.onOpenIntroductionBrandGift;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ModalContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-full w-full bg-[#fff] text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-2 flex justify-center align-items",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* WarningIconIntroBrandGift */.cD, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-2 text-[18px] leading-[25px] font-bold text-[#333333]",
                        children: t("ss_builder_warning_brand_gift_floating_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-[#333333]",
                        children: [
                            t("ss_builder_warning_brand_gift_floating_description"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "pl-1 text-[#1890ff] cursor-pointer",
                                onClick: onOpenIntroductionBrandGift,
                                children: t("ss_builder_warning_brand_gift_floating_description_link")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                color: "primary",
                                size: "middle",
                                fill: "solid",
                                block: true,
                                onClick: onContinue,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-row justify-center items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("ss_builder_warning_brand_gift_floating_continue")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                style: {
                                    marginTop: "8px"
                                },
                                color: "primary",
                                size: "middle",
                                block: true,
                                onClick: onReject,
                                fill: "none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-row justify-center items-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("ss_builder_warning_brand_gift_floating_reject")
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(portal/* default */.Z, {
            elementId: "modalPortal",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Modal */.u_, {
                className: "modal-brand-gift-golive",
                visible: visible,
                forceRender: true,
                onClose: onContinue,
                closeOnMaskClick: false,
                //   image={image}
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent, {})
            })
        })
    });
};
/* harmony default export */ var BrandGiftFloat_ModalWaringFloatingFull = (ModalWaringFloatingFull);

// EXTERNAL MODULE: ./src/features/share/components/lazy-image/index.tsx
var lazy_image = __webpack_require__(70464);
;// CONCATENATED MODULE: ./src/features/design/components/IntroductionNewFeature/BrandGiftFloat/PopupIntroductionBrandGift.tsx








var PopupIntroductionBrandGift = function(props) {
    var visible = props.visible, onBack = props.onBack, onContinue = props.onContinue;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var listImgs = [
        "https://image.passio.eco/page-builder/page-builder/intro-new-feature/IntroductBrandGift-1.jpg",
        "https://image.passio.eco/page-builder/page-builder/intro-new-feature/IntroductBrandGift-2.jpg",
        "https://image.passio.eco/page-builder/page-builder/intro-new-feature/IntroductBrandGift-3.jpg",
        "https://image.passio.eco/page-builder/page-builder/intro-new-feature/IntroductBrandGift-4.jpg", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
            visible: visible,
            onMaskClick: onBack,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "block-editor-wrapper relative h-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pb-[60px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sticky top-0 z-[11]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "relative bg-white",
                                    style: {
                                        boxShadow: "inset 0px -1px 0px #EEEEEE"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* NavBar */.l2, {
                                        backArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BackAngelIcon */.Nz, {}),
                                        onBack: onBack,
                                        className: "w-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-row text-center items-center justify-center gap-[10px] text-[13px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-ellipsis whitespace-nowrap overflow-hidden max-w-[70vw] md:max-w-[20vw] text-titleFontSize",
                                                children: t("ss_brand_gift_introduction_popup_title")
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "list-img-introduction-brand-gift",
                                children: listImgs.map(function(src, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy_image/* default */.ZP, {
                                        src: src,
                                        style: {
                                            marginBottom: "-1px"
                                        }
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            className: "w-full",
                            color: "primary",
                            onClick: onContinue,
                            children: t("ss_builder_continue_add_brand_gift")
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var BrandGiftFloat_PopupIntroductionBrandGift = (PopupIntroductionBrandGift);

;// CONCATENATED MODULE: ./src/features/design/components/IntroductionNewFeature/BrandGiftFloat/index.tsx
function BrandGiftFloat_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BrandGiftFloat_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BrandGiftFloat_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BrandGiftFloat_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function BrandGiftFloat_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BrandGiftFloat_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BrandGiftFloat_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

















var BRAND_GIFT_FOOTER;
(function(BRAND_GIFT_FOOTER) {
    BRAND_GIFT_FOOTER["NOT_SHOW"] = "NOT_SHOW";
    BRAND_GIFT_FOOTER["SHOW_INTRO"] = "SHOW_INTRO";
    BRAND_GIFT_FOOTER["SHOW_WARNING"] = "SHOW_WARNING";
})(BRAND_GIFT_FOOTER || (BRAND_GIFT_FOOTER = {}));
var BrandGiftIntroduction = function(props) {
    var ref3 = (0,react.useState)(BRAND_GIFT_FOOTER.NOT_SHOW), state1 = ref3[0], setState = ref3[1];
    var ref1 = (0,share_hooks/* usePopup */.BF)(), visible = ref1.visible, openPopup = ref1.openPopup, closePopup = ref1.closePopup;
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var allPositions = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.positions;
    });
    var productTourState = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.creatorProfile.finish_product_tour;
    });
    var modalIntroBrandGiftState = (0,react_redux_es/* useSelector */.v9)(function(state) {
        var ref, ref2;
        return ((ref = state.externalState) === null || ref === void 0 ? void 0 : ref.floating_icon) && ((ref2 = state.externalState) === null || ref2 === void 0 ? void 0 : ref2.floating_icon[externalStateSlice/* FLOATING.BRAND_GIFT_FOOTER */.kh.BRAND_GIFT_FOOTER]);
    });
    var userId = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.siteSettings.user_id;
    });
    var country = (0,react_redux_es/* useSelector */.v9)(function(state) {
        var ref, ref4;
        return state === null || state === void 0 ? void 0 : (ref = state.user) === null || ref === void 0 ? void 0 : (ref4 = ref.kol) === null || ref4 === void 0 ? void 0 : ref4.country;
    });
    var floatingBlocks = (0,react_redux_es/* useSelector */.v9)((0,positionsSlice/* getBlocksBySlug */.WZ)(config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND, design_config/* BLOCK_TYPE_BY_GROUP.FLOATING */.Vm.FLOATING));
    var hideAllModal = function() {
        return setState(BRAND_GIFT_FOOTER.NOT_SHOW);
    };
    var addBrandGiftFooterBlock = function() {
        var _ref = BrandGiftFloat_asyncToGenerator(runtime_default().mark(function _callee() {
            var isBrandGiftFooterExist, UID, expand, defaultBrandGift, data, blockData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        isBrandGiftFooterExist = floatingBlocks.find(function(block) {
                            return block.block_type === block_conf/* BLOCK_TYPE.BRAND_GIFT_FOOTER */.bF.BRAND_GIFT_FOOTER;
                        });
                        if (isBrandGiftFooterExist) {
                            _ctx.next = 16;
                            break;
                        }
                        UID = "brand-gift-footer-".concat((0,v4/* default */.Z)());
                        expand = allPositions.find(function(position) {
                            return position.slug === config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND;
                        });
                        defaultBrandGift = {
                            uid: UID,
                            sort_order: 1,
                            enable: 1,
                            block_type: block_conf/* BLOCK_TYPE.BRAND_GIFT_FOOTER */.bF.BRAND_GIFT_FOOTER,
                            title: "Brand Gift Footer",
                            content_attributes: {},
                            style_attributes: {}
                        };
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return (0,BlockEditV2/* runMiddleware */.U)(block_conf/* BLOCK_TYPE.BRAND_GIFT_FOOTER */.bF.BRAND_GIFT_FOOTER, defaultBrandGift, {
                            user_id: userId
                        }, function() {});
                    case 8:
                        data = _ctx.sent;
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](5);
                        console.log("e", _ctx.t0);
                    case 14:
                        blockData = BrandGiftFloat_objectSpread({}, data, {
                            tab_uid: "0",
                            position_id: expand === null || expand === void 0 ? void 0 : expand.id,
                            parent_id: "0",
                            sort_order: floatingBlocks.length > 0 ? floatingBlocks.length + 1 : 1
                        });
                        dispatch((0,positionsSlice/* addBlock */.U6)({
                            tabUid: blockData.tab,
                            positionSlug: config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND,
                            blockData: blockData,
                            positionId: expand === null || expand === void 0 ? void 0 : expand.id
                        }));
                    case 16:
                        hideAllModalAndScrollToFloating();
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    11
                ]
            ]);
        }));
        return function addBrandGiftFooterBlock() {
            return _ref.apply(this, arguments);
        };
    }();
    var checkConditionToAddBrandGift = function() {
        var isFloatingNotFull = floatingBlocks.length < design_config/* COUNT_OF_FLOATING_BLOCK_MAXIMUM */.Y3;
        if (isFloatingNotFull) {
            addBrandGiftFooterBlock();
            hideAllModal();
        } else {
            setState(BRAND_GIFT_FOOTER.SHOW_WARNING);
        }
    };
    var hideAllModalAndScrollToFloating = function() {
        hideAllModal();
        closePopup();
        var floatingAreaElement = document.getElementById("floating-icons-footer");
        setTimeout(function() {
            floatingAreaElement.scrollIntoView({
                behavior: "smooth"
            });
        }, 300);
    };
    (0,react.useEffect)(function() {
        if (country !== COUNTRY_VN) {
            return;
        }
        var isProductTourFinished = productTourState === store_interface/* FINISH_PRODUCT_TOUR_ENUM.TRUE */.Gx.TRUE;
        var isBrandGiftFooterExist = floatingBlocks.find(function(block) {
            return block.block_type === block_conf/* BLOCK_TYPE.BRAND_GIFT_FOOTER */.bF.BRAND_GIFT_FOOTER;
        });
        if (modalIntroBrandGiftState !== externalStateSlice/* FloatingIntroStatus.DISABLE */.dK.DISABLE && isBrandGiftFooterExist) {
            dispatch((0,externalStateSlice/* setFloatingIntroductionState */.m5)(BrandGiftFloat_defineProperty({}, externalStateSlice/* FLOATING.BRAND_GIFT_FOOTER */.kh.BRAND_GIFT_FOOTER, externalStateSlice/* FloatingIntroStatus.DISABLE */.dK.DISABLE)));
            return;
        }
        if (modalIntroBrandGiftState !== externalStateSlice/* FloatingIntroStatus.DISABLE */.dK.DISABLE && isProductTourFinished && userId) {
            setState(BRAND_GIFT_FOOTER.SHOW_INTRO);
            dispatch((0,externalStateSlice/* setFloatingIntroductionState */.m5)(BrandGiftFloat_defineProperty({}, externalStateSlice/* FLOATING.BRAND_GIFT_FOOTER */.kh.BRAND_GIFT_FOOTER, externalStateSlice/* FloatingIntroStatus.DISABLE */.dK.DISABLE)));
        }
    }, [
        modalIntroBrandGiftState,
        userId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandGiftFloat_ModalWaringFloatingFull, {
                visible: state1 === BRAND_GIFT_FOOTER.SHOW_WARNING,
                onContinue: hideAllModalAndScrollToFloating,
                onReject: hideAllModal,
                onOpenIntroductionBrandGift: openPopup
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandGiftFloat_PopupIntroductionBrandGift, {
                visible: visible,
                onBack: closePopup,
                onContinue: hideAllModalAndScrollToFloating
            })
        ]
    });
};
/* harmony default export */ var BrandGiftFloat = (BrandGiftIntroduction);

;// CONCATENATED MODULE: ./src/features/design/components/IntroductionNewFeature/BrandRatingFloat/ModalWaringFloatingFull.tsx






var ModalWaringFloatingFull_ModalWaringFloatingFull = function(props) {
    var visible = props.visible, onContinue = props.onContinue, onReject = props.onReject;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ModalContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-full w-full bg-[#fff] text-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-2 flex justify-center align-items",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* WarningIconIntroBrandGift */.cD, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-2 text-[18px] leading-[25px] font-bold text-[#333333]",
                        children: t("ss_builder_warning_brand_rating_floating_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-[#333333]",
                        children: t("ss_builder_warning_brand_gift_rating_description")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            color: "primary",
                            size: "middle",
                            fill: "solid",
                            block: true,
                            onClick: onContinue,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row justify-center items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("ss_builder_warning_brand_rating_floating_continue")
                                })
                            })
                        })
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(portal/* default */.Z, {
            elementId: "modalPortal",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Modal */.u_, {
                className: "modal-brand-gift-golive",
                visible: visible,
                forceRender: true,
                onClose: onContinue,
                closeOnMaskClick: true,
                showCloseButton: true,
                //   image={image}
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent, {})
            })
        })
    });
};
/* harmony default export */ var BrandRatingFloat_ModalWaringFloatingFull = (ModalWaringFloatingFull_ModalWaringFloatingFull);

;// CONCATENATED MODULE: ./src/features/design/components/IntroductionNewFeature/BrandRatingFloat/ModalBrandRatingGolive.tsx





var ModalBrandRatingGolive = function(props) {
    var visible = props.visible, onAddBlock = props.onAddBlock, onReject = props.onReject;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var image = "https://i.ecomobi.com/ssp/mini-store/Brand-Rating/Brand-rating-popup.png";
    var ModalContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "h-full w-full bg-[#fff] text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-2 text-[18px] leading-[25px] font-bold text-[#333333]",
                    children: t("ss_builder_intro_brand_rating_floating_title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-[#333333]",
                    children: t("ss_builder_intro_brand_rating_floating_description")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            color: "primary",
                            size: "middle",
                            fill: "solid",
                            block: true,
                            onClick: onAddBlock,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("ss_builder_intro_brand_gift_floating_continue")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            style: {
                                marginTop: "8px",
                                border: "1px solid #EEEEEE"
                            },
                            size: "middle",
                            block: true,
                            onClick: onReject,
                            fill: "none",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("ss_builder_intro_brand_gift_floating_reject")
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(portal/* default */.Z, {
            elementId: "modalPortal",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Modal */.u_, {
                className: "modal-brand-gift-golive",
                visible: visible,
                forceRender: true,
                onClose: onReject,
                closeOnMaskClick: true,
                image: image,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContent, {})
            })
        })
    });
};
/* harmony default export */ var BrandRatingFloat_ModalBrandRatingGolive = (ModalBrandRatingGolive);

// EXTERNAL MODULE: ./src/features/block/store/helper/index.tsx
var helper = __webpack_require__(80560);
;// CONCATENATED MODULE: ./src/features/design/components/IntroductionNewFeature/BrandRatingFloat/index.tsx
function BrandRatingFloat_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BrandRatingFloat_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BrandRatingFloat_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BrandRatingFloat_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function BrandRatingFloat_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BrandRatingFloat_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BrandRatingFloat_defineProperty(target, key, source[key]);
        });
    }
    return target;
}















var BRAND_RATING_BLOCK;
(function(BRAND_RATING_BLOCK) {
    BRAND_RATING_BLOCK["NOT_SHOW"] = "NOT_SHOW";
    BRAND_RATING_BLOCK["SHOW_INTRO"] = "SHOW_INTRO";
    BRAND_RATING_BLOCK["SHOW_WARNING"] = "SHOW_WARNING";
})(BRAND_RATING_BLOCK || (BRAND_RATING_BLOCK = {}));
var BrandRatingIntroduction = function(props) {
    var ref2 = (0,react.useState)(BRAND_RATING_BLOCK.NOT_SHOW), state1 = ref2[0], setState = ref2[1];
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var allPositions = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.positions;
    });
    var productTourState = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.passioPageProfile.finish_product_tour;
    });
    var modalIntroBrandRatingState = (0,react_redux_es/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return ((ref = state.externalState) === null || ref === void 0 ? void 0 : ref.floating_block) && ((ref1 = state.externalState) === null || ref1 === void 0 ? void 0 : ref1.floating_block[externalStateSlice/* FLOATING.BRAND_RATING_BLOCK */.kh.BRAND_RATING_BLOCK]);
    });
    var modalIntroBrandGiftState = (0,react_redux_es/* useSelector */.v9)(function(state) {
        var ref, ref3;
        return ((ref = state.externalState) === null || ref === void 0 ? void 0 : ref.floating_block) && ((ref3 = state.externalState) === null || ref3 === void 0 ? void 0 : ref3.floating_icon[externalStateSlice/* FLOATING.BRAND_GIFT_FOOTER */.kh.BRAND_GIFT_FOOTER]);
    });
    var userId = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.siteSettings.user_id;
    });
    var country = (0,react_redux_es/* useSelector */.v9)(function(state) {
        var ref, ref4;
        return state === null || state === void 0 ? void 0 : (ref = state.user) === null || ref === void 0 ? void 0 : (ref4 = ref.kol) === null || ref4 === void 0 ? void 0 : ref4.country;
    });
    var floatingBlocksBody = (0,react_redux_es/* useSelector */.v9)((0,positionsSlice/* getBlocksBySlug */.WZ)(config_interface/* POSITION_TYPE.BODY */.Rz.BODY));
    var floatingBlocksHeader = (0,react_redux_es/* useSelector */.v9)((0,positionsSlice/* getBlocksBySlug */.WZ)(config_interface/* POSITION_TYPE.HEADER */.Rz.HEADER));
    var floatingBlocksFooter = (0,react_redux_es/* useSelector */.v9)((0,positionsSlice/* getBlocksBySlug */.WZ)(config_interface/* POSITION_TYPE.FOOTER */.Rz.FOOTER));
    var floatingBlocks = floatingBlocksHeader === null || floatingBlocksHeader === void 0 ? void 0 : floatingBlocksHeader.concat(floatingBlocksBody === null || floatingBlocksBody === void 0 ? void 0 : floatingBlocksBody.concat(floatingBlocksFooter));
    var hideAllModal = function() {
        setState(BRAND_RATING_BLOCK.NOT_SHOW);
        dispatch((0,externalStateSlice/* setFloatingBlockIntroductionState */.z1)(BrandRatingFloat_defineProperty({}, externalStateSlice/* FLOATING.BRAND_RATING_BLOCK */.kh.BRAND_RATING_BLOCK, externalStateSlice/* FloatingIntroStatus.DISABLE */.dK.DISABLE)));
    };
    var addBrandRatingFooterBlock = function() {
        var _ref = BrandRatingFloat_asyncToGenerator(runtime_default().mark(function _callee() {
            var isBrandGiftFooterExist, ref, ref5, ref6, UID, body, tabBlock, tabList, parentId, defaultBrandRating, blockData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        isBrandGiftFooterExist = floatingBlocks.find(function(block) {
                            return block.block_type === block_conf/* BLOCK_TYPE.BRAND_RATING */.bF.BRAND_RATING;
                        });
                        if (!isBrandGiftFooterExist) {
                            ;
                            UID = "brand-rating-".concat((0,v4/* default */.Z)());
                            body = allPositions.find(function(position) {
                                return position.slug === config_interface/* POSITION_TYPE.BODY */.Rz.BODY;
                            });
                            tabBlock = body.block_list[0] || {};
                            tabList = (tabBlock === null || tabBlock === void 0 ? void 0 : (ref = tabBlock.content_attributes) === null || ref === void 0 ? void 0 : ref.tabs) || [];
                            parentId = (0,helper/* getParentId */.r)(allPositions, {
                                positionSlug: config_interface/* POSITION_TYPE.BODY */.Rz.BODY,
                                tabUid: (ref5 = tabList[0]) === null || ref5 === void 0 ? void 0 : ref5.uid
                            });
                            defaultBrandRating = {
                                uid: UID,
                                sort_order: 1,
                                enable: 1,
                                block_type: block_conf/* BLOCK_TYPE.BRAND_RATING */.bF.BRAND_RATING,
                                title: "Brand Rating",
                                content_attributes: {},
                                style_attributes: {}
                            };
                            blockData = BrandRatingFloat_objectSpread({}, defaultBrandRating, {
                                tab_uid: (ref6 = tabList[0]) === null || ref6 === void 0 ? void 0 : ref6.uid,
                                parent_id: parentId,
                                sort_order: 1,
                                position_id: "0"
                            });
                            dispatch((0,positionsSlice/* addBlock */.U6)({
                                tabUid: blockData.tab_uid,
                                positionSlug: config_interface/* POSITION_TYPE.BODY */.Rz.BODY,
                                blockData: blockData
                            }));
                        }
                        hideAllModalAndScrollToFloating();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function addBrandRatingFooterBlock() {
            return _ref.apply(this, arguments);
        };
    }();
    var checkConditionToAddBrandGift = function() {
        var isFloatingNotFull = floatingBlocks.length < design_config/* COUNT_OF_BLOCK_MAXIMUM */.xs;
        if (isFloatingNotFull) {
            addBrandRatingFooterBlock();
        // hideAllModal();
        } else {
            setState(BRAND_RATING_BLOCK.SHOW_WARNING);
        }
    };
    var hideAllModalAndScrollToFloating = function() {
        hideAllModal();
        var floatingAreaElement = document.getElementById("content_blocks_body");
        setTimeout(function() {
            floatingAreaElement.scrollIntoView({
                behavior: "smooth"
            });
        }, 300);
    };
    (0,react.useEffect)(function() {
        if (country !== COUNTRY_VN) {
            return;
        }
        var isProductTourFinished = productTourState === 1;
        var isBrandRatingExist = floatingBlocks === null || floatingBlocks === void 0 ? void 0 : floatingBlocks.find(function(block) {
            return block.block_type === block_conf/* BLOCK_TYPE.BRAND_RATING */.bF.BRAND_RATING;
        });
        if (modalIntroBrandRatingState !== externalStateSlice/* FloatingIntroStatus.DISABLE */.dK.DISABLE && isBrandRatingExist) {
            dispatch((0,externalStateSlice/* setFloatingBlockIntroductionState */.z1)(BrandRatingFloat_defineProperty({}, externalStateSlice/* FLOATING.BRAND_RATING_BLOCK */.kh.BRAND_RATING_BLOCK, externalStateSlice/* FloatingIntroStatus.DISABLE */.dK.DISABLE)));
            return;
        }
        if (modalIntroBrandRatingState !== externalStateSlice/* FloatingIntroStatus.DISABLE */.dK.DISABLE && isProductTourFinished && userId && modalIntroBrandGiftState === externalStateSlice/* FloatingIntroStatus.DISABLE */.dK.DISABLE) {
            setState(BRAND_RATING_BLOCK.SHOW_INTRO);
        }
    }, [
        modalIntroBrandRatingState,
        userId,
        productTourState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandRatingFloat_ModalBrandRatingGolive, {
                visible: state1 === BRAND_RATING_BLOCK.SHOW_INTRO,
                onAddBlock: checkConditionToAddBrandGift,
                onReject: hideAllModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandRatingFloat_ModalWaringFloatingFull, {
                visible: state1 === BRAND_RATING_BLOCK.SHOW_WARNING,
                onContinue: hideAllModalAndScrollToFloating,
                onReject: hideAllModal
            })
        ]
    });
};
/* harmony default export */ var BrandRatingFloat = (BrandRatingIntroduction);

// EXTERNAL MODULE: ./node_modules/react-beautiful-dnd/dist/react-beautiful-dnd.esm.js + 26 modules
var react_beautiful_dnd_esm = __webpack_require__(9276);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/features/design/components/MappingTypeComponent/index.tsx
var MappingTypeComponent = __webpack_require__(5954);
;// CONCATENATED MODULE: ./src/features/design/components/PositionInfo/index.tsx




var PositionInfo = function(props) {
    var actionBtn = props.actionBtn, info = props.info;
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var openModal = function() {
        return setVisible(true);
    };
    var closeModal = function() {
        return setVisible(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                onClick: openModal,
                children: actionBtn
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModalInfo, {
                visible: visible,
                info: info,
                onClose: closeModal
            })
        ]
    });
};
/* harmony default export */ var components_PositionInfo = (PositionInfo);

;// CONCATENATED MODULE: ./src/features/design/components/EmptyBlock/index.tsx






var EmptyBlock = function(props) {
    var data = props.data;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref = useDesignContext(), setSelectedBlock = ref.setSelectedBlock, setIsOpenAddBlockFloatingPanel = ref.setIsOpenAddBlockFloatingPanel;
    var handleAddBlock = function() {
        // setSelectedBlock({position: 'body', uid: 'my-choice-26573-Cw8tLdT6tv'})
        setSelectedBlock(data);
        setIsOpenAddBlockFloatingPanel(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " items-center w-[auto] block-class mb-3",
        style: {
            padding: "20px 0px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EmptyIcon */.tL, {
                    className: "m-auto"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[8px] default-font-family text-center design-class lead-2",
                style: {
                    color: "var(--text-color-6)"
                },
                children: t("ss_builder_empty_block")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[4px] text-center default-font-family design-class",
                style: {
                    color: "var(--text-color-5)"
                },
                children: t("ss_build_no_blocks_have_been_added")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[8px] flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                    style: {
                        backgroundColor: "#2563EB",
                        display: "flex",
                        color: "#FFFFFF",
                        border: "none",
                        fontSize: "15px",
                        fontWeight: "21px",
                        gap: "8px"
                    },
                    className: " default-font-family font-normal",
                    onClick: function() {
                        return handleAddBlock();
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                            className: "m-auto",
                            width: 15,
                            height: 15
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                " ",
                                t("ss_builder_add_block_label")
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_EmptyBlock = (EmptyBlock);

;// CONCATENATED MODULE: ./src/features/design/components/DesignMainLayout/PlaceholderCustom/index.tsx
function PlaceholderCustom_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PlaceholderCustom_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PlaceholderCustom_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var PlaceholderCustom = function(param) {
    var placeholderProps = param.placeholderProps, isFullBlock = param.isFullBlock;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var block_style = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref, ref1, ref2;
        return (ref = state.siteSettings) === null || ref === void 0 ? void 0 : (ref1 = ref.display_setting) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.block_setting) === null || ref2 === void 0 ? void 0 : ref2.block_style;
    });
    var outside_space = (block_style || {}).outside_space;
    var placeholderWidth = !outside_space ? placeholderProps.clientWidth : placeholderProps.clientWidth - configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER * 2;
    var iconRender = isFullBlock ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIconAlert */.bR, {
        width: 16,
        height: 16,
        fillColor: "#8C8C8C"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddCircleIcon */.ag, {
        width: 16,
        height: 16,
        fillColor: "#1890FF"
    });
    var labelRender = isFullBlock ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "text-[#8C8C8C]",
        children: t("ss_builder_exceeding_label")
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "text-[#1890FF]",
        children: t("ss_builder_drop_here_label")
    });
    var styleRender = isFullBlock ? {
        backgroundColor: "rgba(245, 245, 245, 0.75)",
        border: "1px dashed #8C8C8C"
    } : {
        backgroundColor: "rgba(230, 247, 255, 0.75)",
        border: "1px dashed #1890FF"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "absolute flex justify-center items-center flex-row gap-1",
        style: PlaceholderCustom_objectSpread({
            top: placeholderProps.clientY,
            left: outside_space ? placeholderProps.clientX + 12 : placeholderProps.clientX,
            height: placeholderProps.clientHeight,
            width: placeholderWidth,
            borderRadius: "var(--block-border-radius)"
        }, styleRender),
        children: [
            iconRender,
            labelRender
        ]
    });
};
/* harmony default export */ var DesignMainLayout_PlaceholderCustom = (PlaceholderCustom);

;// CONCATENATED MODULE: ./src/features/design/components/DesignMainLayout/BlockDraggingSpace/index.tsx





var BlockDraggingSpace = function(param) {
    var addNewBlockButtonDrag = param.addNewBlockButtonDrag, children = param.children;
    var block_style = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref, ref1, ref2;
        return (ref = state.siteSettings) === null || ref === void 0 ? void 0 : (ref1 = ref.display_setting) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.block_setting) === null || ref2 === void 0 ? void 0 : ref2.block_style;
    });
    var ref3 = block_style !== null && block_style !== void 0 ? block_style : {}, _block_space = ref3.block_space, block_space = _block_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_SPACE */.eJ.BLOCK_SPACE : _block_space, outside_space = ref3.outside_space;
    var Space = function() {
        return addNewBlockButtonDrag ? /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
            style: {
                height: "".concat(block_space / 2, "px"),
                margin: "0px",
                visibility: addNewBlockButtonDrag ? "hidden" : "unset",
                opacity: addNewBlockButtonDrag ? 0 : 1,
                paddingLeft: outside_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px") : "",
                paddingRight: outside_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px") : ""
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Space, {}),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Space, {})
        ]
    });
};
/* harmony default export */ var DesignMainLayout_BlockDraggingSpace = (BlockDraggingSpace);

// EXTERNAL MODULE: ./src/features/block/config/block-selection.ts + 3 modules
var block_selection = __webpack_require__(60329);
;// CONCATENATED MODULE: ./src/features/design/components/DesignMainLayout/BodyDesign/index.tsx
function BodyDesign_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BodyDesign_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BodyDesign_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




















var BodyDesign = function(props) {
    var ref6, ref1, ref2;
    var bodyState = props.bodyState, bodyDrag = props.bodyDrag, addNewBlockButtonDrag = props.addNewBlockButtonDrag, placeholderProps = props.placeholderProps;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var block_style = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref, ref4, ref5;
        return (ref = state.siteSettings) === null || ref === void 0 ? void 0 : (ref4 = ref.display_setting) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.block_setting) === null || ref5 === void 0 ? void 0 : ref5.block_style;
    });
    var country = (0,react_redux_es/* useSelector */.v9)(function(state) {
        var ref, ref7;
        return state === null || state === void 0 ? void 0 : (ref = state.user) === null || ref === void 0 ? void 0 : (ref7 = ref.kol) === null || ref7 === void 0 ? void 0 : ref7.country;
    });
    var ref3 = block_style !== null && block_style !== void 0 ? block_style : {}, _block_space = ref3.block_space, block_space = _block_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_SPACE */.eJ.BLOCK_SPACE : _block_space, outside_space = ref3.outside_space;
    var activeKeyTab = dynamicConfig && dynamicConfig.tabs && dynamicConfig.tabs.activeKeyTab;
    var listTabBody = (ref1 = bodyState === null || bodyState === void 0 ? void 0 : (ref6 = bodyState.block_list) === null || ref6 === void 0 ? void 0 : ref6.find(function(item) {
        return item.block_type == block_conf/* BLOCK_TYPE.TAB */.bF.TAB;
    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.tabs;
    var listTabBodySortOrder = listTabBody && orderBy_default()(listTabBody, [
        "sort_order"
    ], [
        "asc"
    ]);
    var activeKey = (0,react.useMemo)(function() {
        var isExistActiveTab = listTabBodySortOrder === null || listTabBodySortOrder === void 0 ? void 0 : listTabBodySortOrder.find(function(x) {
            return (x === null || x === void 0 ? void 0 : x.uid) === activeKeyTab;
        });
        if (activeKeyTab && isExistActiveTab) {
            return activeKeyTab;
        } else {
            var ref;
            var tabDefault = listTabBodySortOrder === null || listTabBodySortOrder === void 0 ? void 0 : listTabBodySortOrder.find(function(x) {
                return x.isDefault === true;
            });
            var activeKeyDefault = tabDefault ? tabDefault.uid : (ref = listTabBodySortOrder[0]) === null || ref === void 0 ? void 0 : ref.uid;
            return activeKeyDefault;
        }
    }, [
        activeKeyTab,
        listTabBodySortOrder
    ]);
    var tabBodyActive = listTabBodySortOrder && activeKey ? listTabBodySortOrder.find(function(x) {
        return x.uid === activeKey;
    }) : null;
    var listBlockBody = tabBodyActive ? tabBodyActive.block_list : listTabBodySortOrder[0].block_list;
    var listBlocksData = country === configs_const/* COUNTRY_TH */.Un ? listBlockBody === null || listBlockBody === void 0 ? void 0 : listBlockBody.filter(function(block) {
        return !block_selection/* COUNTRY_TH_BLOCK_HIDDEN.includes */.I.includes(block === null || block === void 0 ? void 0 : block.block_type);
    }) : listBlockBody;
    var listBlocksSortOrder = listBlocksData && orderBy_default()(listBlocksData, [
        "sort_order"
    ], [
        "asc"
    ]);
    var positionSlug = bodyState && bodyState.slug;
    var isDropDisabled = !bodyDrag && !addNewBlockButtonDrag || addNewBlockButtonDrag && (listBlocksSortOrder === null || listBlocksSortOrder === void 0 ? void 0 : listBlocksSortOrder.length) === 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                contentPosition: "left",
                className: classnames_default()("body-design divider-design ", product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_7 */.uN.STEP_7),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-center items-center font-normal",
                    id: "content_blocks_body",
                    children: [
                        t("ss_builder_body_title"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PositionInfo, {
                            actionBtn: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cursor-pointer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InfomationPositionIcon */.fX, {
                                    width: 13,
                                    height: 13,
                                    className: "ml-1"
                                })
                            }),
                            info: {
                                image: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-7.gif",
                                title: t("ss_builder_body_introduction_title"),
                                desctiption: t("ss_builder_body_introduction_description")
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                droppableId: positionSlug ? "designs-".concat(positionSlug) : "designs-body-default",
                isDropDisabled: isDropDisabled,
                children: function(provided1, snapshot1) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", BodyDesign_objectSpread({}, provided1.droppableProps, {
                        ref: provided1.innerRef,
                        className: "relative",
                        children: [
                            (listBlocksSortOrder === null || listBlocksSortOrder === void 0 ? void 0 : listBlocksSortOrder.length) > 0 ? listBlocksSortOrder.map(function(block, index) {
                                return !configs_const/* BLOCK_NOT_DISPLAY.includes */.FU.includes(block.block_type) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    id: block.uid,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                        draggableId: "designs-".concat(block.uid),
                                        index: index,
                                        children: function(provided, snapshot) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", BodyDesign_objectSpread({
                                                ref: provided.innerRef
                                            }, provided.draggableProps, provided.dragHandleProps, {
                                                className: classnames_default()(// "outside-space",
                                                "block-cursor-default", snapshot.isDragging && "adm-item-custom-design bg-drag-drop blur-none"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignMainLayout_BlockDraggingSpace, {
                                                        addNewBlockButtonDrag: addNewBlockButtonDrag,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MappingTypeComponent/* default */.Z, {
                                                            blockData: block,
                                                            // key={index}
                                                            positionSlug: positionSlug,
                                                            tabUid: activeKey,
                                                            index: index,
                                                            listBlocksSortOrder: listBlocksSortOrder
                                                        })
                                                    }),
                                                    !addNewBlockButtonDrag && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                                        style: {
                                                            color: "#1890FF",
                                                            borderColor: "#1890FF",
                                                            borderStyle: "dashed",
                                                            height: "".concat(block_space, "px"),
                                                            margin: "0px",
                                                            visibility: bodyDrag || addNewBlockButtonDrag || index === listBlocksSortOrder.length - 1 ? "hidden" : "unset",
                                                            opacity: !isDropDisabled ? 0 : 1,
                                                            paddingLeft: outside_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px") : "",
                                                            paddingRight: outside_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px") : ""
                                                        }
                                                    })
                                                ]
                                            }));
                                        }
                                    }, "designs-".concat(block.uid))
                                }, block.uid) : null;
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EmptyBlock, {
                                data: {
                                    position: "body",
                                    uid: tabBodyActive === null || tabBodyActive === void 0 ? void 0 : tabBodyActive.uid
                                }
                            }),
                            provided1.placeholder,
                            !isEmpty_default()(placeholderProps) && snapshot1.isDraggingOver && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignMainLayout_PlaceholderCustom, {
                                placeholderProps: placeholderProps,
                                isFullBlock: (listBlocksSortOrder === null || listBlocksSortOrder === void 0 ? void 0 : listBlocksSortOrder.length) >= 10
                            })
                        ]
                    }));
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: "".concat(block_space, "px"),
                    marginTop: "-".concat(block_space, "px"),
                    marginBottom: "-".concat(block_space, "px")
                }
            })
        ]
    });
};
/* harmony default export */ var DesignMainLayout_BodyDesign = (BodyDesign);

;// CONCATENATED MODULE: ./src/features/design/components/DesignMainLayout/ExpandDesign/components/BlockGroup.tsx
function BlockGroup_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BlockGroup_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BlockGroup_defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var BlockGroup = function(props) {
    var blocks = props.blocks, positionSlug = props.positionSlug, listOrderedBlock = props.listOrderedBlock, addNewBlockButtonDrag = props.addNewBlockButtonDrag, droppableId = props.droppableId, isDrag = props.isDrag, placeholderProps = props.placeholderProps;
    var block_style = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref, ref2, ref3;
        return (ref = state.siteSettings) === null || ref === void 0 ? void 0 : (ref2 = ref.display_setting) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.block_setting) === null || ref3 === void 0 ? void 0 : ref3.block_style;
    });
    var ref4;
    var ref1 = (ref4 = block_style) !== null && ref4 !== void 0 ? ref4 : {}, _block_space = ref1.block_space, block_space = _block_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_SPACE */.eJ.BLOCK_SPACE : _block_space, outside_space = ref1.outside_space;
    var isDropDisabled = !isDrag && !addNewBlockButtonDrag || addNewBlockButtonDrag && (blocks === null || blocks === void 0 ? void 0 : blocks.length) === 0;
    var placeholderPropsCustom = BlockGroup_objectSpread({}, placeholderProps, {
        clientY: placeholderProps.clientY + 12
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
            droppableId: droppableId,
            isDropDisabled: isDropDisabled,
            children: function(provided1, snapshot1) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", BlockGroup_objectSpread({}, provided1.droppableProps, {
                    ref: provided1.innerRef,
                    children: [
                        blocks.length > 0 && blocks.map(function(block, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                id: block.uid,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                    draggableId: "designs-".concat(block.uid),
                                    index: index,
                                    children: function(provided, snapshot) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", BlockGroup_objectSpread({
                                            ref: provided.innerRef
                                        }, provided.draggableProps, provided.dragHandleProps, {
                                            className: classnames_default()(// "outside-space",
                                            snapshot.isDragging && "adm-item-custom-design blur-none"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignMainLayout_BlockDraggingSpace, {
                                                    addNewBlockButtonDrag: addNewBlockButtonDrag,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MappingTypeComponent/* default */.Z, {
                                                        blockData: block,
                                                        positionSlug: positionSlug,
                                                        index: index,
                                                        listBlocksSortOrder: listOrderedBlock
                                                    })
                                                }),
                                                !addNewBlockButtonDrag && index !== (blocks === null || blocks === void 0 ? void 0 : blocks.length) - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                                    style: {
                                                        color: "#1890FF",
                                                        borderColor: "#1890FF",
                                                        borderStyle: "dashed",
                                                        height: "".concat(block_space, "px"),
                                                        margin: "0px",
                                                        visibility: isDrag || addNewBlockButtonDrag || index === blocks.length - 1 ? "hidden" : "unset",
                                                        opacity: isDrag ? 0 : 1,
                                                        paddingLeft: outside_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px") : "",
                                                        paddingRight: outside_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px") : ""
                                                    }
                                                })
                                            ]
                                        }));
                                    }
                                }, "designs-".concat(block.uid))
                            }, block.uid);
                        }),
                        provided1.placeholder,
                        !isEmpty_default()(placeholderProps) && snapshot1.isDraggingOver && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignMainLayout_PlaceholderCustom, {
                            placeholderProps: placeholderPropsCustom,
                            isFullBlock: (listOrderedBlock === null || listOrderedBlock === void 0 ? void 0 : listOrderedBlock.length) >= 5
                        })
                    ]
                }));
            }
        })
    });
};
/* harmony default export */ var components_BlockGroup = (BlockGroup);

;// CONCATENATED MODULE: ./src/features/design/components/DesignMainLayout/ExpandDesign/components/BlockGroupWrapper.tsx




var BlockGroupWrapper = function(props) {
    var labelText = props.labelText, icon = props.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cursor-pointer relative",
            style: {
                paddingTop: "12px",
                paddingBottom: "12px",
                border: "2px solid #00B578",
                borderRadius: "4px",
                marginLeft: "12px",
                marginRight: "12px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                    contentPosition: "left",
                    className: classnames_default()("divider-design adm-default", "expand-block-title"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "flex justify-center items-center",
                        children: [
                            labelText,
                            icon
                        ]
                    })
                }),
                props.children
            ]
        })
    });
};
/* harmony default export */ var components_BlockGroupWrapper = (BlockGroupWrapper);

;// CONCATENATED MODULE: ./src/features/design/components/CopyRight/index.tsx




var CopyRight = function() {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var handleClickLogo = function() {};
    var handleClickText = function() {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-3 flex",
        style: {
            color: "#FFFFFF"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "m-auto",
            style: {
                margin: " 20px auto 8px",
                filter: "drop-shadow(rgba(0, 0, 0, 1) 0px 0px 60px)"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: handleClickLogo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Logo */.TR, {
                        className: "m-auto"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center default-font-family font-normal text-[12px] leading-[15px] mt-1",
                    onClick: handleClickText,
                    children: t("ss_builder_powered_by_passio")
                })
            ]
        })
    });
};
/* harmony default export */ var components_CopyRight = (CopyRight);

;// CONCATENATED MODULE: ./src/features/design/components/DesignMainLayout/ExpandDesign/index.tsx
function ExpandDesign_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



















var POSITON_STATUS;
(function(POSITON_STATUS) {
    POSITON_STATUS[POSITON_STATUS["ENABLE"] = 1] = "ENABLE";
    POSITON_STATUS[POSITON_STATUS["DISABLE"] = 0] = "DISABLE";
})(POSITON_STATUS || (POSITON_STATUS = {}));
var PopupInfoIcon = function(param) {
    var image = param.image, titleKey = param.titleKey, desKey = param.desKey;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PositionInfo, {
        actionBtn: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cursor-pointer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InfomationPositionIcon */.fX, {
                width: 13,
                height: 13,
                className: "ml-1"
            })
        }),
        info: {
            image: image,
            title: t(titleKey),
            desctiption: t(desKey)
        }
    });
};
var ExpandDesign = function(props) {
    var ref2;
    var position = props.position, expandPopupDrag = props.expandPopupDrag, expandFloatingIconsDrag = props.expandFloatingIconsDrag, addNewBlockButtonDrag = props.addNewBlockButtonDrag, placeholderProps = props.placeholderProps;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var country = (0,react_redux_es/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return state === null || state === void 0 ? void 0 : (ref = state.user) === null || ref === void 0 ? void 0 : (ref1 = ref.kol) === null || ref1 === void 0 ? void 0 : ref1.country;
    });
    var creatorType = passioPageProfile === null || passioPageProfile === void 0 ? void 0 : passioPageProfile.creator_type;
    var isPositionEnabled = Object.is(position.enable, POSITON_STATUS.ENABLE);
    var listBlocksData = country === configs_const/* COUNTRY_TH */.Un ? position === null || position === void 0 ? void 0 : (ref2 = position.block_list) === null || ref2 === void 0 ? void 0 : ref2.filter(function(block) {
        return !block_selection/* COUNTRY_TH_BLOCK_HIDDEN.includes */.I.includes(block === null || block === void 0 ? void 0 : block.block_type);
    }) : position === null || position === void 0 ? void 0 : position.block_list;
    var imgPopupBlocks = (0,react_redux_es/* useSelector */.v9)((0,positionsSlice/* getBlocksBySlug */.WZ)(config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND, design_config/* BLOCK_TYPE_BY_GROUP.POPUP */.Vm.POPUP));
    var floatingBlocks = (0,react_redux_es/* useSelector */.v9)((0,positionsSlice/* getBlocksBySlug */.WZ)(config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND, design_config/* BLOCK_TYPE_BY_GROUP.FLOATING */.Vm.FLOATING));
    var _obj;
    var BUNCH_OF_BLOCK_GROUP = (_obj = {}, ExpandDesign_defineProperty(_obj, design_config/* BLOCK_GROUP_TYPE.POPUP */.dv.POPUP, {
        includeType: design_config/* BLOCK_TYPE_BY_GROUP.POPUP */.Vm.POPUP,
        type: design_config/* BLOCK_GROUP_TYPE.POPUP */.dv.POPUP,
        label_language_key: "ss_builder_design_group_image_popup_title",
        blocks: imgPopupBlocks,
        droppable_id: configs_const/* POSITION_DROPPABLE_ID.EXPAND_POPUP */.lN.EXPAND_POPUP,
        introModal: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupInfoIcon, {
            titleKey: "ss_builder_image_popup_introduction_title",
            desKey: "ss_builder_image_popup_introduction_description",
            image: "https://image.passio.eco/page-builder/page-builder/position-modal/Popup.gif"
        })
    }), ExpandDesign_defineProperty(_obj, design_config/* BLOCK_GROUP_TYPE.FLOATING */.dv.FLOATING, {
        includeType: design_config/* BLOCK_TYPE_BY_GROUP.FLOATING */.Vm.FLOATING,
        type: design_config/* BLOCK_GROUP_TYPE.FLOATING */.dv.FLOATING,
        label_language_key: "ss_builder_design_group_floating_title",
        blocks: floatingBlocks,
        droppable_id: configs_const/* POSITION_DROPPABLE_ID.EXPAND_FLOATING_ICONS */.lN.EXPAND_FLOATING_ICONS,
        introModal: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupInfoIcon, {
            titleKey: "ss_builder_floating_introduction_title",
            desKey: "ss_builder_floating_introduction_description",
            image: "https://image.passio.eco/page-builder/page-builder/position-modal/Floating.gif"
        })
    }), _obj);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                contentPosition: "left",
                className: classnames_default()("divider-design adm-default", "expand-position-title"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-center items-center font-normal",
                    children: [
                        t("ss_builder_add_block_expand_title"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PositionInfo, {
                            actionBtn: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cursor-pointer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InfomationPositionIcon */.fX, {
                                    width: 13,
                                    height: 13,
                                    className: "ml-1"
                                })
                            }),
                            info: {
                                image: "https://image.passio.eco/page-builder/page-builder/position-modal/Expand-position.gif",
                                title: t("ss_builder_expand_introduction_title"),
                                desctiption: t("ss_builder_expand_introduction_description")
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("position-wrapper", isPositionEnabled ? "" : "hide-position"),
                children: (listBlocksData === null || listBlocksData === void 0 ? void 0 : listBlocksData.length) > 0 ? Object.values(BUNCH_OF_BLOCK_GROUP).map(function(block_group, index) {
                    return block_group.blocks.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-2",
                        children: [
                            block_group.type === design_config/* BLOCK_GROUP_TYPE.FLOATING */.dv.FLOATING && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "floating-icons-footer"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BlockGroupWrapper, {
                                labelText: t(block_group.label_language_key),
                                icon: block_group.introModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BlockGroup, {
                                    isDrag: (block_group === null || block_group === void 0 ? void 0 : block_group.type) === design_config/* BLOCK_GROUP_TYPE.POPUP */.dv.POPUP ? expandPopupDrag : expandFloatingIconsDrag,
                                    blocks: block_group.blocks,
                                    listOrderedBlock: listBlocksData,
                                    positionSlug: position.slug,
                                    addNewBlockButtonDrag: addNewBlockButtonDrag,
                                    droppableId: block_group.droppable_id,
                                    placeholderProps: placeholderProps
                                })
                            })
                        ]
                    }, index);
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "floating-icons-footer"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EmptyBlock, {
                            data: {
                                position: "expand",
                                uid: ""
                            }
                        })
                    ]
                })
            }),
            creatorType === store_interface/* CREATOR_TYPE_ENUM.NORMAL */.sG.NORMAL && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CopyRight, {})
        ]
    });
};
/* harmony default export */ var DesignMainLayout_ExpandDesign = (/*#__PURE__*/react.memo(ExpandDesign));

;// CONCATENATED MODULE: ./src/features/design/components/DesignMainLayout/FooterDesign/index.tsx
function FooterDesign_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FooterDesign_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FooterDesign_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





















var FooterDesign = function(props) {
    var footerState = props.footerState, footerDrag = props.footerDrag, addNewBlockButtonDrag = props.addNewBlockButtonDrag, placeholderProps = props.placeholderProps;
    var block_style = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref, ref1, ref2;
        return (ref = state.siteSettings) === null || ref === void 0 ? void 0 : (ref1 = ref.display_setting) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.block_setting) === null || ref2 === void 0 ? void 0 : ref2.block_style;
    });
    var country = (0,react_redux_es/* useSelector */.v9)(function(state) {
        var ref, ref4;
        return state === null || state === void 0 ? void 0 : (ref = state.user) === null || ref === void 0 ? void 0 : (ref4 = ref.kol) === null || ref4 === void 0 ? void 0 : ref4.country;
    });
    var ref3 = block_style !== null && block_style !== void 0 ? block_style : {}, _block_space = ref3.block_space, block_space = _block_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_SPACE */.eJ.BLOCK_SPACE : _block_space, outside_space = ref3.outside_space;
    var listBlocksSortOrder = (0,react.useMemo)(function() {
        var ref;
        var listBlocksData = country === configs_const/* COUNTRY_TH */.Un ? footerState === null || footerState === void 0 ? void 0 : (ref = footerState.block_list) === null || ref === void 0 ? void 0 : ref.filter(function(block) {
            return !block_selection/* COUNTRY_TH_BLOCK_HIDDEN.includes */.I.includes(block === null || block === void 0 ? void 0 : block.block_type);
        }) : footerState === null || footerState === void 0 ? void 0 : footerState.block_list;
        var newListBlocksData = listBlocksData && orderBy_default()(listBlocksData, [
            "sort_order"
        ], [
            "asc"
        ]);
        return newListBlocksData;
    }, [
        footerState,
        country
    ]);
    var positionSlug = footerState && footerState.slug;
    var isChecked = (0,react.useMemo)(function() {
        return !!(footerState && footerState.enable && footerState.enable === 1);
    }, [
        footerState
    ]);
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var handleChangeSwitch = function(value) {
        if (value) {
            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.POSITION */.Bt.POSITION, "Footer_TurnOn", "Footer", ga_events/* ACTION_CONFIG.TURN_ON */.AN.TURN_ON);
        } else {
            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.POSITION */.Bt.POSITION, "Footer_TurnOff", "Footer", ga_events/* ACTION_CONFIG.TURN_OFF */.AN.TURN_OFF);
        }
        var enableValue = value ? 1 : 0;
        dispatch((0,positionsSlice/* disableEnablePosition */.uX)({
            enableValue: enableValue,
            positionSlug: positionSlug
        }));
    };
    var isDropDisabled = !footerDrag && !addNewBlockButtonDrag || addNewBlockButtonDrag && (listBlocksSortOrder === null || listBlocksSortOrder === void 0 ? void 0 : listBlocksSortOrder.length) === 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Divider */.iz, {
                contentPosition: "left",
                className: classnames_default()("footer-design divider-design adm-default ", product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_8 */.uN.STEP_8, isChecked ? "" : "hidden-divider"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-center items-center font-normal",
                        children: [
                            t("ss_builder_footer_title"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PositionInfo, {
                                actionBtn: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cursor-pointer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InfomationPositionIcon */.fX, {
                                        width: 13,
                                        height: 13,
                                        className: "ml-1"
                                    })
                                }),
                                info: {
                                    image: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-8.gif",
                                    title: t("ss_builder_footer_introduction_title"),
                                    desctiption: t("ss_builder_footer_introduction_description")
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 right-[var(--block-outside-space)]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                            style: {
                                "--height": "18px",
                                "--width": "34px"
                            },
                            checked: isChecked,
                            onChange: handleChangeSwitch
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("position-wrapper", isChecked ? "" : "hide-position"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                        droppableId: positionSlug ? "designs-".concat(positionSlug) : "designs-footer-default",
                        isDropDisabled: isDropDisabled,
                        children: function(provided1, snapshot1) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", FooterDesign_objectSpread({}, provided1.droppableProps, {
                                ref: provided1.innerRef,
                                className: "relative",
                                children: [
                                    (listBlocksSortOrder === null || listBlocksSortOrder === void 0 ? void 0 : listBlocksSortOrder.length) > 0 ? listBlocksSortOrder.map(function(block, index) {
                                        return !configs_const/* BLOCK_NOT_DISPLAY.includes */.FU.includes(block.block_type) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                            id: block.uid,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                                draggableId: "designs-".concat(block.uid),
                                                index: index,
                                                children: function(provided, snapshot) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", FooterDesign_objectSpread({
                                                        ref: provided.innerRef
                                                    }, provided.draggableProps, provided.dragHandleProps, {
                                                        className: classnames_default()("block-cursor-default", snapshot.isDragging && "adm-item-custom-design bg-drag-drop blur-none"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignMainLayout_BlockDraggingSpace, {
                                                                addNewBlockButtonDrag: addNewBlockButtonDrag,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MappingTypeComponent/* default */.Z, {
                                                                    blockData: block,
                                                                    // key={index}
                                                                    positionSlug: positionSlug,
                                                                    index: index,
                                                                    listBlocksSortOrder: listBlocksSortOrder
                                                                })
                                                            }),
                                                            !addNewBlockButtonDrag && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                                                style: {
                                                                    color: "#1890FF",
                                                                    borderColor: "#1890FF",
                                                                    borderStyle: "dashed",
                                                                    height: "".concat(block_space, "px"),
                                                                    margin: "0px",
                                                                    visibility: footerDrag || addNewBlockButtonDrag || index === listBlocksSortOrder.length - 1 ? "hidden" : "unset",
                                                                    opacity: !isDropDisabled ? 0 : 1,
                                                                    paddingLeft: outside_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px") : "",
                                                                    paddingRight: outside_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px") : ""
                                                                }
                                                            })
                                                        ]
                                                    }));
                                                }
                                            }, "designs-".concat(block.uid))
                                        }, block.uid) : null;
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EmptyBlock, {
                                        data: {
                                            position: "footer",
                                            uid: ""
                                        }
                                    }),
                                    provided1.placeholder,
                                    !isEmpty_default()(placeholderProps) && snapshot1.isDraggingOver && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignMainLayout_PlaceholderCustom, {
                                        placeholderProps: placeholderProps,
                                        isFullBlock: (listBlocksSortOrder === null || listBlocksSortOrder === void 0 ? void 0 : listBlocksSortOrder.length) >= 4
                                    })
                                ]
                            }));
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            height: "".concat(block_space, "px"),
                            marginTop: "-".concat(block_space, "px"),
                            marginBottom: "-".concat(block_space, "px")
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var DesignMainLayout_FooterDesign = (FooterDesign);

;// CONCATENATED MODULE: ./src/features/design/components/DesignMainLayout/HeaderDesign/index.tsx
function HeaderDesign_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HeaderDesign_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HeaderDesign_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






















var HeaderDesign = function(props) {
    var headerState = props.headerState, headingDrag = props.headingDrag, addNewBlockButtonDrag = props.addNewBlockButtonDrag, placeholderProps = props.placeholderProps;
    var block_style = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref, ref1, ref2;
        return (ref = state.siteSettings) === null || ref === void 0 ? void 0 : (ref1 = ref.display_setting) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.block_setting) === null || ref2 === void 0 ? void 0 : ref2.block_style;
    });
    var country = (0,react_redux_es/* useSelector */.v9)(function(state) {
        var ref, ref4;
        return state === null || state === void 0 ? void 0 : (ref = state.user) === null || ref === void 0 ? void 0 : (ref4 = ref.kol) === null || ref4 === void 0 ? void 0 : ref4.country;
    });
    var ref3 = block_style !== null && block_style !== void 0 ? block_style : {}, _block_space = ref3.block_space, block_space = _block_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_SPACE */.eJ.BLOCK_SPACE : _block_space, outside_space = ref3.outside_space;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var listBlocksSortOrder = (0,react.useMemo)(function() {
        var ref;
        var listBlocksData = country === configs_const/* COUNTRY_TH */.Un ? headerState === null || headerState === void 0 ? void 0 : (ref = headerState.block_list) === null || ref === void 0 ? void 0 : ref.filter(function(block) {
            return !block_selection/* COUNTRY_TH_BLOCK_HIDDEN.includes */.I.includes(block === null || block === void 0 ? void 0 : block.block_type);
        }) : headerState === null || headerState === void 0 ? void 0 : headerState.block_list;
        var newListBlocksData = listBlocksData && orderBy_default()(listBlocksData, [
            "sort_order"
        ], [
            "asc"
        ]);
        return newListBlocksData;
    }, [
        headerState,
        country
    ]);
    var positionSlug = headerState && headerState.slug;
    var isChecked = (0,react.useMemo)(function() {
        return (headerState === null || headerState === void 0 ? void 0 : headerState.enable) ? !!(headerState && headerState.enable && headerState.enable === 1) : false;
    }, [
        headerState
    ]);
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    (0,react_beautiful_dnd_esm/* resetServerContext */.sO)();
    var handleChangeSwitch = function(value) {
        if (value) {
            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.POSITION */.Bt.POSITION, "Header_TurnOn", "Header", ga_events/* ACTION_CONFIG.TURN_ON */.AN.TURN_ON);
        } else {
            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.POSITION */.Bt.POSITION, "Header_TurnOff", "Header", ga_events/* ACTION_CONFIG.TURN_OFF */.AN.TURN_OFF);
        }
        var enableValue = value ? 1 : 0;
        dispatch((0,positionsSlice/* disableEnablePosition */.uX)({
            enableValue: enableValue,
            positionSlug: positionSlug
        }));
    };
    var isDropDisabled = !addNewBlockButtonDrag && !headingDrag || addNewBlockButtonDrag && (listBlocksSortOrder === null || listBlocksSortOrder === void 0 ? void 0 : listBlocksSortOrder.length) === 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Divider */.iz, {
                contentPosition: "left",
                className: classnames_default()("divider-design adm-default ", product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_6 */.uN.STEP_6, isChecked ? "" : "hidden-divider"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-center items-center font-normal",
                        children: [
                            t("ss_builder_header_title"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PositionInfo, {
                                actionBtn: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cursor-pointer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InfomationPositionIcon */.fX, {
                                        width: 13,
                                        height: 13,
                                        className: "ml-1"
                                    })
                                }),
                                info: {
                                    image: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-6.gif",
                                    title: t("ss_builder_header_introduction_title"),
                                    desctiption: t("ss_builder_header_introduction_description")
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 right-[var(--block-outside-space)]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                            style: {
                                "--height": "18px",
                                "--width": "34px"
                            },
                            checked: isChecked,
                            onChange: handleChangeSwitch
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("position-wrapper", isChecked ? "" : "hide-position"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
                        droppableId: positionSlug ? "designs-".concat(positionSlug) : "designs-header-default",
                        isDropDisabled: isDropDisabled,
                        children: function(provided1, snapshot1) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", HeaderDesign_objectSpread({}, provided1.droppableProps, {
                                ref: provided1.innerRef,
                                className: "design-header-class relative",
                                children: [
                                    (listBlocksSortOrder === null || listBlocksSortOrder === void 0 ? void 0 : listBlocksSortOrder.length) > 0 ? listBlocksSortOrder.map(function(block, index) {
                                        var ref6, ref5;
                                        var isFirstItem = false;
                                        if ((listBlocksSortOrder === null || listBlocksSortOrder === void 0 ? void 0 : listBlocksSortOrder.length) === 1 || index === 0 && (block === null || block === void 0 ? void 0 : block.block_type) !== block_conf/* BLOCK_TYPE.TAB_BAR */.bF.TAB_BAR) {
                                            isFirstItem = true;
                                        } else if (listBlocksSortOrder[0].block_type === block_conf/* BLOCK_TYPE.TAB_BAR */.bF.TAB_BAR && index === 1) {
                                            isFirstItem = true;
                                        }
                                        return !configs_const/* BLOCK_NOT_DISPLAY.includes */.FU.includes(block.block_type) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                            id: block.uid,
                                            className: classnames_default()(block.block_type === "tab_bar" && (block === null || block === void 0 ? void 0 : (ref6 = block.style_attributes) === null || ref6 === void 0 ? void 0 : ref6.ghim_style) === configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM && "hidden"),
                                            style: {
                                                display: block.block_type === "tab_bar" && (block === null || block === void 0 ? void 0 : (ref5 = block.style_attributes) === null || ref5 === void 0 ? void 0 : ref5.ghim_style) === configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM ? "none" : ""
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                                                draggableId: "designs-".concat(block.uid),
                                                index: index,
                                                children: function(provided, snapshot) {
                                                    var ref;
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", HeaderDesign_objectSpread({
                                                        ref: provided.innerRef
                                                    }, provided.draggableProps, provided.dragHandleProps, {
                                                        className: classnames_default()("block-cursor-default", snapshot.isDragging && "adm-item-custom-design bg-drag-drop blur-none"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignMainLayout_BlockDraggingSpace, {
                                                                addNewBlockButtonDrag: addNewBlockButtonDrag,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MappingTypeComponent/* default */.Z, {
                                                                    blockData: block,
                                                                    positionSlug: positionSlug,
                                                                    index: index,
                                                                    listBlocksSortOrder: listBlocksSortOrder,
                                                                    isFirstItem: isFirstItem
                                                                })
                                                            }),
                                                            !addNewBlockButtonDrag && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                                                style: {
                                                                    color: "#1890FF",
                                                                    borderColor: "#1890FF",
                                                                    borderStyle: "dashed",
                                                                    height: "".concat(block_space, "px"),
                                                                    margin: "0px",
                                                                    visibility: !(index !== listBlocksSortOrder.length - 1 && (block === null || block === void 0 ? void 0 : (ref = block.style_attributes) === null || ref === void 0 ? void 0 : ref.ghim_style) !== configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM) || headingDrag || addNewBlockButtonDrag ? "hidden" : "unset",
                                                                    opacity: !isDropDisabled ? 0 : 1,
                                                                    paddingLeft: outside_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px") : "",
                                                                    paddingRight: outside_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px") : ""
                                                                }
                                                            })
                                                        ]
                                                    }));
                                                }
                                            }, "designs-".concat(block.uid))
                                        }, block.uid) : null;
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EmptyBlock, {
                                        data: {
                                            position: "footer",
                                            uid: ""
                                        }
                                    }),
                                    provided1.placeholder,
                                    !isEmpty_default()(placeholderProps) && snapshot1.isDraggingOver && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignMainLayout_PlaceholderCustom, {
                                        placeholderProps: placeholderProps,
                                        isFullBlock: (listBlocksSortOrder === null || listBlocksSortOrder === void 0 ? void 0 : listBlocksSortOrder.length) >= 4
                                    })
                                ]
                            }));
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            height: "".concat(block_space, "px"),
                            marginTop: "-".concat(block_space, "px"),
                            marginBottom: "-".concat(block_space, "px")
                        }
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var DesignMainLayout_HeaderDesign = (HeaderDesign);

;// CONCATENATED MODULE: ./src/features/design/components/DesignMainLayout/AddNewButtonDragging/index.tsx
function AddNewButtonDragging_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AddNewButtonDragging_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AddNewButtonDragging_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var ADD_NEW_BUTTON_DRAGGABLE_ID = "add-new-block-button-dragging-enable";
var AddNewButtonDragging = function(props) {
    var handleOpenPositionSelectedList = props.handleOpenPositionSelectedList, showFirstGuide = props.showFirstGuide, addNewBlockStyle = props.addNewBlockStyle, isHideButtonAddBlock = props.isHideButtonAddBlock, addNewBlockButtonDragBeforeCapture = props.addNewBlockButtonDragBeforeCapture;
    var guideState = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.externalState.guide_state;
    });
    var renderAddBlockAnimation = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("flex items-center justify-center w-[48px] h-[48px] rounded-full bg-[#EE3244] cursor-pointer ", product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_2 */.uN.STEP_2),
            style: {
                boxShadow: "0px 0px 30px rgba(51, 51, 51, 0.4)",
                margin: "auto"
            },
            onClick: showFirstGuide,
            children: [
                !addNewBlockButtonDragBeforeCapture && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pointer-events-none",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "add-block-circle"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "add-block-circle-fill"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                    className: !addNewBlockButtonDragBeforeCapture ? "icon-shake" : ""
                })
            ]
        });
    };
    var getItemStyle = function(isDragging, draggableStyle) {
        return AddNewButtonDragging_objectSpread({
            width: isDragging ? "100vw" : "auto",
            maxWidth: "500px"
        }, draggableStyle);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Droppable */.bK, {
        droppableId: configs_const/* POSITION_DROPPABLE_ID.ADD_NEW_BLOCK_BUTTON_DRAGGING */.lN.ADD_NEW_BLOCK_BUTTON_DRAGGING,
        isDropDisabled: true,
        children: function(provided1, snapshot1) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", AddNewButtonDragging_objectSpread({}, provided1.droppableProps, {
                ref: provided1.innerRef,
                children: !isHideButtonAddBlock ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    id: configs_const/* POSITION_DROPPABLE_ID.ADD_NEW_BLOCK_BUTTON_DRAGGING */.lN.ADD_NEW_BLOCK_BUTTON_DRAGGING,
                    className: "fixed left-[50%] translate-x-[-50%] z-10",
                    style: AddNewButtonDragging_objectSpread({}, addNewBlockStyle),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_beautiful_dnd_esm/* Draggable */._l, {
                            draggableId: ADD_NEW_BUTTON_DRAGGABLE_ID,
                            index: -1,
                            children: function(provided, snapshot) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", AddNewButtonDragging_objectSpread({
                                    ref: provided.innerRef
                                }, provided.draggableProps, provided.dragHandleProps, {
                                    className: classnames_default()(snapshot.isDragging && "adm-item-custom-design bg-drag-drop blur-none"),
                                    style: getItemStyle(snapshot.isDragging || addNewBlockButtonDragBeforeCapture, provided.draggableProps.style),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: guideState === externalStateSlice/* FirstGuideStateEnum.ADD_BLOCK */.x9.ADD_BLOCK ? renderAddBlockAnimation() : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()("flex items-center justify-center w-[48px] h-[48px] rounded-full bg-[#EE3244] cursor-pointer ", product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_2 */.uN.STEP_2),
                                            style: {
                                                boxShadow: "0px 0px 30px rgba(51, 51, 51, 0.4)",
                                                margin: "auto"
                                            },
                                            onClick: handleOpenPositionSelectedList,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AddIcon */.T8, {
                                                className: ""
                                            })
                                        })
                                    })
                                }));
                            }
                        }, ADD_NEW_BUTTON_DRAGGABLE_ID),
                        provided1.placeholder
                    ]
                }, configs_const/* POSITION_DROPPABLE_ID.ADD_NEW_BLOCK_BUTTON_DRAGGING */.lN.ADD_NEW_BLOCK_BUTTON_DRAGGING) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            }));
        }
    });
};
/* harmony default export */ var DesignMainLayout_AddNewButtonDragging = (AddNewButtonDragging);

;// CONCATENATED MODULE: ./src/features/design/components/DesignMainLayout/index.tsx
function DesignMainLayout_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function DesignMainLayout_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function DesignMainLayout_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return DesignMainLayout_arrayLikeToArray(arr);
}
function DesignMainLayout_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function DesignMainLayout_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function DesignMainLayout_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function DesignMainLayout_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function DesignMainLayout_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function DesignMainLayout_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DesignMainLayout_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function DesignMainLayout_slicedToArray(arr, i) {
    return DesignMainLayout_arrayWithHoles(arr) || DesignMainLayout_iterableToArrayLimit(arr, i) || DesignMainLayout_unsupportedIterableToArray(arr, i) || DesignMainLayout_nonIterableRest();
}
function DesignMainLayout_toConsumableArray(arr) {
    return DesignMainLayout_arrayWithoutHoles(arr) || DesignMainLayout_iterableToArray(arr) || DesignMainLayout_unsupportedIterableToArray(arr) || DesignMainLayout_nonIterableSpread();
}
function DesignMainLayout_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return DesignMainLayout_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return DesignMainLayout_arrayLikeToArray(o, minLen);
}


















var DesignMainLayout = function(props) {
    var ref11, ref1, ref2;
    var headerState = props.headerState, bodyState = props.bodyState, isEnableBody = props.isEnableBody, footerState = props.footerState, expandPosition = props.expandPosition, addNewBlockStyle = props.addNewBlockStyle, handleOpenPositionSelectedList = props.handleOpenPositionSelectedList, showFirstGuide = props.showFirstGuide, onUpdatePositionWhenDragBtn = props.onUpdatePositionWhenDragBtn;
    var ref3 = (0,react.useState)(false), headingDrag = ref3[0], setHeadingDrag = ref3[1];
    var ref4 = (0,react.useState)(false), bodyDrag = ref4[0], setBodyDrag = ref4[1];
    var ref5 = (0,react.useState)(false), footerDrag = ref5[0], setFooterDrag = ref5[1];
    var ref6 = (0,react.useState)(false), expandPopupDrag = ref6[0], setExpandPopupDrag = ref6[1];
    var ref7 = (0,react.useState)(false), expandFloatingIconsDrag = ref7[0], setExpandFloatingIconsDrag = ref7[1];
    var ref8 = (0,react.useState)(false), addNewBlockButtonDrag = ref8[0], setAddNewBlockButtonDrag = ref8[1];
    var ref9 = (0,react.useState)({}), placeholderProps = ref9[0], setPlaceholderProps = ref9[1];
    var ref10 = (0,react.useState)(false), addNewBlockButtonDragBeforeCapture = ref10[0], setAddNewBlockButtonDragBeforeCapture = ref10[1];
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var queryAttr = "data-rbd-droppable-id";
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var imgPopupBlocks = (0,hooks/* useAppSelector */.CG)((0,positionsSlice/* getBlocksBySlug */.WZ)(config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND, design_config/* BLOCK_TYPE_BY_GROUP.POPUP */.Vm.POPUP));
    var floatingBlocks = (0,hooks/* useAppSelector */.CG)((0,positionsSlice/* getBlocksBySlug */.WZ)(config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND, design_config/* BLOCK_TYPE_BY_GROUP.FLOATING */.Vm.FLOATING));
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var activeKeyTab = dynamicConfig && dynamicConfig.tabs && dynamicConfig.tabs.activeKeyTab;
    var listTabBody = (ref1 = bodyState === null || bodyState === void 0 ? void 0 : (ref11 = bodyState.block_list) === null || ref11 === void 0 ? void 0 : ref11.find(function(item) {
        return item.block_type == block_conf/* BLOCK_TYPE.TAB */.bF.TAB;
    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.content_attributes) === null || ref2 === void 0 ? void 0 : ref2.tabs;
    var listTabBodySortOrder = listTabBody && orderBy_default()(listTabBody, [
        "sort_order"
    ], [
        "asc"
    ]);
    var activeKey = (0,react.useMemo)(function() {
        var isExistActiveTab = listTabBodySortOrder === null || listTabBodySortOrder === void 0 ? void 0 : listTabBodySortOrder.find(function(x) {
            return (x === null || x === void 0 ? void 0 : x.uid) === activeKeyTab;
        });
        if (activeKeyTab && isExistActiveTab) {
            return activeKeyTab;
        } else {
            var tabDefault = listTabBodySortOrder && listTabBodySortOrder.find(function(x) {
                return x.isDefault === true;
            });
            var activeKeyDefault = tabDefault && tabDefault.uid;
            return activeKeyDefault;
        }
    }, [
        activeKeyTab,
        listTabBodySortOrder
    ]);
    var tabBodyActive = listTabBodySortOrder && activeKey ? listTabBodySortOrder.find(function(x) {
        return x.uid === activeKey;
    }) : null;
    var listBlockBody = tabBodyActive ? tabBodyActive.block_list : listTabBodySortOrder[0].block_list;
    var listBlocksSortOrderBody = listBlockBody && orderBy_default()(listBlockBody, [
        "sort_order"
    ], [
        "asc"
    ]);
    (0,react_beautiful_dnd_esm/* resetServerContext */.sO)();
    var getBlockListsOfPosition = function(positionData) {
        var listBlocksData = positionData === null || positionData === void 0 ? void 0 : positionData.block_list;
        var newListBlocksData = listBlocksData && orderBy_default()(listBlocksData, [
            "sort_order"
        ], [
            "asc"
        ]);
        return newListBlocksData;
    };
    var reorder = function(blockLists, startIndex, endIndex) {
        var result = Array.from(blockLists);
        var ref = DesignMainLayout_slicedToArray(result.splice(startIndex, 1), 1), removed = ref[0];
        result.splice(endIndex, 0, removed);
        var orderedBlockList = result.map(function(ele, idx) {
            return DesignMainLayout_objectSpread({}, ele, {
                sort_order: idx + 1
            });
        });
        return orderedBlockList;
    };
    var onDragEnd = function(result) {
        setPlaceholderProps({});
        headingDrag && setHeadingDrag(false);
        bodyDrag && setBodyDrag(false);
        footerDrag && setFooterDrag(false);
        expandPopupDrag && setExpandPopupDrag(false);
        expandFloatingIconsDrag && setExpandFloatingIconsDrag(false);
        addNewBlockButtonDrag && setAddNewBlockButtonDrag(false);
        addNewBlockButtonDragBeforeCapture && setAddNewBlockButtonDragBeforeCapture(false);
        var blockType = null;
        var itemsOrder = null;
        var positionSlug = null;
        var tabUid = null;
        var gaLabel = null;
        var ref = (result === null || result === void 0 ? void 0 : result.source) || {}, startIndex = ref.index, startDroppableId = ref.droppableId;
        var ref12 = (result === null || result === void 0 ? void 0 : result.destination) || {}, endIndex = ref12.index, endDroppableId = ref12.droppableId;
        var blockListsHeader = getBlockListsOfPosition(headerState);
        var blockListsFooter = getBlockListsOfPosition(footerState);
        var isFullBlock = endDroppableId === configs_const/* POSITION_DROPPABLE_ID.HEADER */.lN.HEADER && blockListsHeader.length >= 4 || endDroppableId === configs_const/* POSITION_DROPPABLE_ID.FOOTER */.lN.FOOTER && (blockListsFooter === null || blockListsFooter === void 0 ? void 0 : blockListsFooter.length) >= 4 || endDroppableId === configs_const/* POSITION_DROPPABLE_ID.BODY */.lN.BODY && (listBlocksSortOrderBody === null || listBlocksSortOrderBody === void 0 ? void 0 : listBlocksSortOrderBody.length) >= 10;
        if (!result.destination || startIndex === endIndex || addNewBlockButtonDrag && isFullBlock) {
            return;
        }
        switch(endDroppableId){
            case configs_const/* POSITION_DROPPABLE_ID.HEADER */.lN.HEADER:
                var ref13;
                blockType = (ref13 = blockListsHeader === null || blockListsHeader === void 0 ? void 0 : blockListsHeader.find(function(x, idx) {
                    return idx === startIndex;
                })) === null || ref13 === void 0 ? void 0 : ref13.block_type;
                itemsOrder = reorder(blockListsHeader, startIndex, endIndex);
                positionSlug = store_interface/* POSITION_SLUG.HEADER */.bW.HEADER;
                gaLabel = "Header";
                break;
            case configs_const/* POSITION_DROPPABLE_ID.BODY */.lN.BODY:
                var ref14;
                var indexTab = listTabBodySortOrder.findIndex(function(item) {
                    return (item === null || item === void 0 ? void 0 : item.uid) === activeKey;
                }) + 1;
                blockType = (ref14 = listBlocksSortOrderBody === null || listBlocksSortOrderBody === void 0 ? void 0 : listBlocksSortOrderBody.find(function(x, idx) {
                    return idx === startIndex;
                })) === null || ref14 === void 0 ? void 0 : ref14.block_type;
                itemsOrder = reorder(listBlocksSortOrderBody, startIndex, endIndex);
                positionSlug = store_interface/* POSITION_SLUG.BODY */.bW.BODY;
                tabUid = activeKey;
                gaLabel = "Body - Tab ".concat(indexTab);
                break;
            case configs_const/* POSITION_DROPPABLE_ID.FOOTER */.lN.FOOTER:
                var ref15;
                blockType = (ref15 = blockListsFooter === null || blockListsFooter === void 0 ? void 0 : blockListsFooter.find(function(x, idx) {
                    return idx === startIndex;
                })) === null || ref15 === void 0 ? void 0 : ref15.block_type;
                itemsOrder = reorder(blockListsFooter, startIndex, endIndex);
                positionSlug = store_interface/* POSITION_SLUG.FOOTER */.bW.FOOTER;
                gaLabel = "Footer";
                break;
            case configs_const/* POSITION_DROPPABLE_ID.EXPAND_FLOATING_ICONS */.lN.EXPAND_FLOATING_ICONS:
                itemsOrder = imgPopupBlocks.concat(reorder(floatingBlocks, startIndex, endIndex)).map(function(e, index) {
                    return DesignMainLayout_objectSpread({}, e, {
                        sort_order: index + 1
                    });
                });
                positionSlug = store_interface/* POSITION_SLUG.EXPAND */.bW.EXPAND;
                gaLabel = "Extended - Floating Icons";
                break;
            case configs_const/* POSITION_DROPPABLE_ID.EXPAND_POPUP */.lN.EXPAND_POPUP:
                itemsOrder = imgPopupBlocks.concat(reorder(floatingBlocks, startIndex, endIndex)).map(function(e, index) {
                    return DesignMainLayout_objectSpread({}, e, {
                        sort_order: index + 1
                    });
                });
                positionSlug = store_interface/* POSITION_SLUG.EXPAND */.bW.EXPAND;
                gaLabel = "Extended - Popup";
                break;
        }
        if (startDroppableId === configs_const/* POSITION_DROPPABLE_ID.ADD_NEW_BLOCK_BUTTON_DRAGGING */.lN.ADD_NEW_BLOCK_BUTTON_DRAGGING) {
            onUpdatePositionWhenDragBtn({
                position: positionSlug,
                uid: tabUid,
                sort_order: endIndex + 1
            });
            if (gaLabel) {
                ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.ADD_BLOCK_BUTTON */.Bt.ADD_BLOCK_BUTTON, "AddBlockButton_DragDrop", gaLabel, ga_events/* ACTION_CONFIG.DRAG_AND_DROP */.AN.DRAG_AND_DROP);
            }
            return;
        }
        if (blockType) {
            var blockTypeEvent = ga_events/* BLOCK_TYPE_EVENT_CONFIG */.Aw[blockType === null || blockType === void 0 ? void 0 : blockType.toUpperCase()] || (0,lib/* handleCapitalizeFirstLetter */.Tz)(blockType);
            if (startIndex > endIndex) {
                ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK */.Bt.BLOCK, "Block_DragDropUp_".concat(blockTypeEvent), blockTypeEvent, ga_events/* ACTION_CONFIG.DRAG_DROP_UP */.AN.DRAG_DROP_UP);
            } else {
                ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BLOCK */.Bt.BLOCK, "Block_DragDropDown_".concat(blockTypeEvent), blockTypeEvent, ga_events/* ACTION_CONFIG.DRAG_DROP_DOWN */.AN.DRAG_DROP_DOWN);
            }
        }
        if (itemsOrder && positionSlug) {
            dispatch((0,positionsSlice/* sortBlock */.K6)({
                itemsOrder: itemsOrder,
                positionSlug: positionSlug,
                tabUid: tabUid
            }));
        }
    };
    var onDragStart = function(result) {
        var ref;
        var startDroppableId = result === null || result === void 0 ? void 0 : (ref = result.source) === null || ref === void 0 ? void 0 : ref.droppableId;
        switch(startDroppableId){
            case configs_const/* POSITION_DROPPABLE_ID.HEADER */.lN.HEADER:
                setHeadingDrag(true);
                break;
            case configs_const/* POSITION_DROPPABLE_ID.BODY */.lN.BODY:
                setBodyDrag(true);
                break;
            case configs_const/* POSITION_DROPPABLE_ID.FOOTER */.lN.FOOTER:
                setFooterDrag(true);
                break;
            case configs_const/* POSITION_DROPPABLE_ID.EXPAND_POPUP */.lN.EXPAND_POPUP:
                setExpandPopupDrag(true);
                break;
            case configs_const/* POSITION_DROPPABLE_ID.EXPAND_FLOATING_ICONS */.lN.EXPAND_FLOATING_ICONS:
                setExpandFloatingIconsDrag(true);
                break;
            case configs_const/* POSITION_DROPPABLE_ID.ADD_NEW_BLOCK_BUTTON_DRAGGING */.lN.ADD_NEW_BLOCK_BUTTON_DRAGGING:
                setAddNewBlockButtonDrag(true);
                break;
        }
    };
    var onDragUpdate = function(event) {
        // console.log("event", event);
        if (!event.destination) {
            return;
        }
        var clientHeight = 48;
        var clientWidth = 0;
        var clientY = 0;
        var clientX = 0;
        var destinationIndex = event.destination.index;
        var sourceIndex = event.source.index;
        var draggableId = event.draggableId;
        if (draggableId === ADD_NEW_BUTTON_DRAGGABLE_ID) {
            var droppableDOM = getDroppableDom(event.destination.droppableId);
            if (!droppableDOM) {
                return;
            }
            clientWidth = droppableDOM.clientWidth;
            var childrenArray = DesignMainLayout_toConsumableArray(droppableDOM.children);
            clientY = parseFloat(window.getComputedStyle(droppableDOM).paddingTop) + childrenArray.slice(0, destinationIndex).reduce(function(total, curr) {
                var style = (curr === null || curr === void 0 ? void 0 : curr.currentStyle) || window.getComputedStyle(curr);
                var marginBottom = parseFloat(style.marginBottom);
                return total + curr.clientHeight + marginBottom;
            }, 0);
            setPlaceholderProps({
                clientHeight: clientHeight,
                clientWidth: clientWidth,
                clientY: clientY,
                clientX: clientX
            });
        }
    };
    var onBeforeCapture = function(event) {
        if (event.draggableId === ADD_NEW_BUTTON_DRAGGABLE_ID) {
            setAddNewBlockButtonDragBeforeCapture(true);
        }
    };
    var getDroppableDom = function(dropId) {
        var domQuery = "[".concat(queryAttr, "='").concat(dropId, "']");
        var element = document.querySelector(domQuery);
        return element;
    };
    var isHideButtonAddBlock = (0,react.useMemo)(function() {
        return headingDrag || bodyDrag || footerDrag || expandFloatingIconsDrag || expandPopupDrag;
    }, [
        headingDrag,
        bodyDrag,
        footerDrag,
        expandFloatingIconsDrag,
        expandPopupDrag, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_beautiful_dnd_esm/* DragDropContext */.Z5, {
            onDragEnd: onDragEnd,
            onDragStart: onDragStart,
            onDragUpdate: onDragUpdate,
            onBeforeCapture: onBeforeCapture,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                    className: expandFloatingIconsDrag || expandPopupDrag || bodyDrag || footerDrag ? "inactive-position" : "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignMainLayout_HeaderDesign, {
                        headerState: headerState,
                        headingDrag: headingDrag,
                        addNewBlockButtonDrag: addNewBlockButtonDrag,
                        placeholderProps: placeholderProps
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: expandFloatingIconsDrag || expandPopupDrag || headingDrag || footerDrag ? "inactive-position" : "",
                    children: isEnableBody ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignMainLayout_BodyDesign, {
                        bodyState: bodyState,
                        bodyDrag: bodyDrag,
                        addNewBlockButtonDrag: addNewBlockButtonDrag,
                        placeholderProps: placeholderProps
                    }) : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                    className: expandFloatingIconsDrag || expandPopupDrag || bodyDrag || headingDrag ? "inactive-position" : "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignMainLayout_FooterDesign, {
                        footerState: footerState,
                        footerDrag: footerDrag,
                        addNewBlockButtonDrag: addNewBlockButtonDrag,
                        placeholderProps: placeholderProps
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: footerDrag || bodyDrag || headingDrag ? "inactive-position" : "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignMainLayout_ExpandDesign, {
                        position: expandPosition,
                        expandPopupDrag: expandPopupDrag,
                        expandFloatingIconsDrag: expandFloatingIconsDrag,
                        addNewBlockButtonDrag: addNewBlockButtonDrag,
                        placeholderProps: placeholderProps
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignMainLayout_AddNewButtonDragging, {
                        handleOpenPositionSelectedList: handleOpenPositionSelectedList,
                        showFirstGuide: showFirstGuide,
                        addNewBlockStyle: addNewBlockStyle,
                        isHideButtonAddBlock: isHideButtonAddBlock,
                        addNewBlockButtonDragBeforeCapture: addNewBlockButtonDragBeforeCapture
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_DesignMainLayout = (DesignMainLayout);

;// CONCATENATED MODULE: ./src/features/design/libs/index.ts


function hasDigitalProductOnSite(positions) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = positions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var position = _step.value;
            var ref, ref1;
            var blockLists = (position === null || position === void 0 ? void 0 : position.slug) === store_interface/* POSITION_SLUG.BODY */.bW.BODY ? (ref = position === null || position === void 0 ? void 0 : position.block_list[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.content_attributes) === null || ref1 === void 0 ? void 0 : ref1.tabs.flatMap(function(tab) {
                return tab.block_list;
            }) : position === null || position === void 0 ? void 0 : position.block_list;
            if (blockLists === null || blockLists === void 0 ? void 0 : blockLists.some(function(block) {
                return (block === null || block === void 0 ? void 0 : block.block_type) === block_conf/* BLOCK_TYPE.DIGITAL_PRODUCT */.bF.DIGITAL_PRODUCT;
            })) {
                return true;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}

;// CONCATENATED MODULE: ./src/features/design/hooks/useGetHeaderMoreActions.tsx




var useGetHeaderMoreActions = function(isAdminRole, positions) {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var hasDigitalProduct = hasDigitalProductOnSite(positions);
    var actions = [
        {
            key: "restore",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* RestoreIcon */.v, {
                className: "w-5 h-5",
                fillColor: "#FFFFFF"
            }),
            text: t("ss_builder_restore_theme_label")
        }, 
    ];
    !hasDigitalProduct && actions.push({
        key: "replace-theme",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ReplaceIcon */.l1, {
            className: "w-5 h-5",
            fillColor: "#FFFFFF"
        }),
        text: t("ss_builder_replace_theme_label")
    });
    isAdminRole && actions.push({
        key: "create-new-theme",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CopyIcon */.TI, {
            className: "w-5 h-5",
            fillColor: "#FFFFFF"
        }),
        text: t("ss_builder_create_new_theme_template_label")
    });
    return actions;
};
/* harmony default export */ var hooks_useGetHeaderMoreActions = (useGetHeaderMoreActions);

;// CONCATENATED MODULE: ./src/features/design/components/index.tsx
function components_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function components_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                components_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                components_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function components_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function components_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            components_defineProperty(target, key, source[key]);
        });
    }
    return target;
}










































var Design = function(props) {
    var ref20, ref1, ref2, ref3, ref4, ref5;
    var callbackShowResultPublish = props.callbackShowResultPublish, activeIndex = props.activeIndex, handleRedirectTabs = props.handleRedirectTabs, isOpenFloatingAddBlock = props.isOpenFloatingAddBlock, setIsOpenPositionSelectedList = props.setIsOpenPositionSelectedList, setIsOpenAddBlockFloatingPanel = props.setIsOpenAddBlockFloatingPanel, isOpenPositionSelectedList = props.isOpenPositionSelectedList, isOpenAddBlockFloatingPanel = props.isOpenAddBlockFloatingPanel;
    var designMoreRef = (0,react.useRef)(null);
    var productTourRef = (0,react.useRef)(null);
    var popoverManualRef = (0,react.useRef)(null);
    var tabBarHeaderRef = (0,react.useRef)(null);
    var guideState = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.externalState.guide_state;
    });
    var ref6 = (0,react.useState)(null), tabBarHeaderHeight = ref6[0], setTabBarHeaderHeight = ref6[1];
    var ref7 = (0,react.useState)(null), tabBarFooterHeight = ref7[0], setTabBarFooterHeight = ref7[1];
    var ref8 = (0,react.useState)(null), tabMenuHeight = ref8[0], setTabMenuHeight = ref8[1];
    var ref9 = (0,react.useState)(false), isOpenAddNewThemeSelectionPanel = ref9[0], setIsOpenAddNewThemeSelectionPanel = ref9[1];
    var ref10 = (0,react.useState)(false), checkLoadingBtnPublish = ref10[0], setCheckLoadingBtnPublish = ref10[1];
    var ref11 = (0,react.useState)(false), isOpenPreviewAndReplaceTheme = ref11[0], setIsOpenPreviewAndReplaceTheme = ref11[1];
    var ref12 = (0,react.useState)(null), selectedThemeTemplate = ref12[0], setSelectedThemeTemplate = ref12[1];
    var ref13 = (0,react.useState)(false), isOpenPreview = ref13[0], setIsOpenPreview = ref13[1];
    var ref14 = (0,react.useState)(false), isOpenProductTour = ref14[0], setIsOpenProductTour = ref14[1];
    var ref15 = (0,react.useState)(false), isProductTourManual = ref15[0], setIsProductTourManual = ref15[1];
    var ref16 = (0,react.useState)(false), isShowTextCustomUserManual = ref16[0], setIsShowTextCustomUserManual = ref16[1];
    var ref17 = (0,react.useState)(), selectedBlock = ref17[0], setSelectedBlock = ref17[1];
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var positionState = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.positions;
    });
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var siteSettingUserRootId = siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.id;
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var user = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.user;
    });
    var domain = user === null || user === void 0 ? void 0 : (ref20 = user.kol) === null || ref20 === void 0 ? void 0 : ref20.domain;
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var creatorProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.creatorProfile;
    });
    var isRenderContent = (0,react.useMemo)(function() {
        return (siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.user_id) ? !!(siteSettings && siteSettings.user_id) : false;
    }, [
        siteSettings
    ]);
    var outside_space = siteSettings === null || siteSettings === void 0 ? void 0 : (ref1 = siteSettings.display_setting) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.block_setting) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.block_style) === null || ref3 === void 0 ? void 0 : ref3.outside_space;
    var headerState = positionState.find(function(x) {
        return x.slug === config_interface/* POSITION_TYPE.HEADER */.Rz.HEADER;
    });
    var bodyState = positionState.find(function(x) {
        return x.slug === config_interface/* POSITION_TYPE.BODY */.Rz.BODY;
    });
    var footerState = positionState.find(function(x) {
        return x.slug === config_interface/* POSITION_TYPE.FOOTER */.Rz.FOOTER;
    });
    var expandPosition = positionState.find(function(x) {
        return x.slug === config_interface/* POSITION_TYPE.EXPAND */.Rz.EXPAND;
    });
    var hasChange = (0,react.useMemo)(function() {
        return (siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.has_change) ? !!(siteSettings && siteSettings.has_change) : false;
    }, [
        siteSettings
    ]);
    var isSaving = dynamicConfig === null || dynamicConfig === void 0 ? void 0 : dynamicConfig.isSaving;
    var isOpenProductTourDynamic = dynamicConfig === null || dynamicConfig === void 0 ? void 0 : dynamicConfig.isOpenProductTourDynamic;
    var creator_role = passioPageProfile === null || passioPageProfile === void 0 ? void 0 : passioPageProfile.creator_role;
    var finishProductTour = creatorProfile === null || creatorProfile === void 0 ? void 0 : creatorProfile.finish_product_tour;
    var isSavingProductTour = (0,esm/* useDebounce */.Nr)(dynamicConfig === null || dynamicConfig === void 0 ? void 0 : dynamicConfig.isSavingProductTour, 300);
    var isAdminRole = (0,react.useMemo)(function() {
        return creator_role === store_interface/* CREATOR_ROLE_ENUM.ADMIN */.lp.ADMIN;
    }, [
        creator_role
    ]);
    var actions = hooks_useGetHeaderMoreActions(isAdminRole, positionState);
    var modalGuideRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (isOpenFloatingAddBlock === true) {
            setIsOpenPositionSelectedList(false);
        }
    }, [
        isOpenFloatingAddBlock
    ]);
    var requestSelectedThemeTemplate = function() {
        var _ref = components_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, themeResponse, ref19, themeData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        themeResponse = null;
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,api/* requestGetSelectedThemeTemplate */.e4)(siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.user_id);
                    case 5:
                        themeResponse = _ctx.sent;
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        console.log(_ctx.t0);
                    case 11:
                        if (!((themeResponse === null || themeResponse === void 0 ? void 0 : (ref = themeResponse.data) === null || ref === void 0 ? void 0 : ref.success) == true)) {
                            _ctx.next = 16;
                            break;
                        }
                        ;
                        themeData = themeResponse === null || themeResponse === void 0 ? void 0 : (ref19 = themeResponse.data) === null || ref19 === void 0 ? void 0 : ref19.data;
                        setSelectedThemeTemplate(themeData);
                        return _ctx.abrupt("return", themeData);
                    case 16:
                        return _ctx.abrupt("return", null);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return function requestSelectedThemeTemplate() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (activeIndex === configs_const/* TAB_BAR_INDEX.DESIGN */.F.DESIGN && (siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.user_id)) {
            requestSelectedThemeTemplate();
        }
    }, [
        activeIndex,
        siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.user_id
    ]);
    var tabListBody = (ref4 = bodyState === null || bodyState === void 0 ? void 0 : bodyState.block_list[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.content_attributes) === null || ref5 === void 0 ? void 0 : ref5.tabs;
    var newHeaderState = (0,react.useMemo)(function() {
        if (tabListBody) {
            var newHeaderBlock = headerState && headerState.block_list && headerState.block_list.map(function(ele) {
                return ele.block_type === configs_const/* BLOCK_TYPE_CONFIG.TAB_BAR */.x_.TAB_BAR ? components_objectSpread({}, ele, {
                    content_attributes: components_objectSpread({}, ele.content_attributes, {
                        tabListBody: tabListBody
                    })
                }) : ele;
            });
            return components_objectSpread({}, headerState, {
                block_list: newHeaderBlock
            });
        } else return headerState;
    }, [
        headerState,
        tabListBody
    ]);
    var newFooterState = (0,react.useMemo)(function() {
        if (tabListBody) {
            var newFooterBlock = footerState && footerState.block_list && footerState.block_list.map(function(ele) {
                return ele.block_type === configs_const/* BLOCK_TYPE_CONFIG.TAB_BAR */.x_.TAB_BAR ? components_objectSpread({}, ele, {
                    content_attributes: components_objectSpread({}, ele.content_attributes, {
                        tabListBody: tabListBody
                    })
                }) : ele;
            });
            return components_objectSpread({}, footerState, {
                block_list: newFooterBlock
            });
        } else return footerState;
    }, [
        footerState,
        tabListBody
    ]);
    var isEnableHeader = !!(headerState && headerState.enable && headerState.enable === 1);
    var isEnableBody = !!(bodyState && bodyState.enable && bodyState.enable === 1);
    var tabMenuStyle = (0,react.useMemo)(function() {
        var blockListHeader = headerState && headerState.block_list;
        var tabBarBlock = blockListHeader && blockListHeader.find(function(x) {
            return x.block_type === block_conf/* BLOCK_TYPE.TAB_BAR */.bF.TAB_BAR;
        });
        var style_attributes = tabBarBlock && tabBarBlock.style_attributes;
        return style_attributes;
    }, [
        headerState
    ]);
    (0,react.useEffect)(function() {
        var tabBarHeaderElement = document.querySelector(".tab-bar-design-header");
        var tabBarFooterElement = document.querySelector(".tab-bar-footer");
        var tabMenuAlwaysGhimElement = document.querySelector(".tab-design-always-ghim");
        var timer = setTimeout(function() {
            if (tabBarHeaderElement) {
                setTabBarHeaderHeight(tabBarHeaderElement.offsetHeight);
            } else {
                setTabBarHeaderHeight(null);
            }
            if (tabBarFooterElement) {
                setTabBarFooterHeight(tabBarFooterElement.offsetHeight);
            } else {
                setTabBarFooterHeight(null);
            }
            if (tabMenuAlwaysGhimElement) {
                setTabMenuHeight(tabMenuAlwaysGhimElement.offsetHeight);
            } else {
                setTabMenuHeight(null);
            }
        }, 300);
        return function() {
            return clearTimeout(timer);
        };
    });
    var backToPassio = function() {
        if (dynamicConfig === null || dynamicConfig === void 0 ? void 0 : dynamicConfig.isSaving) {
            es/* Dialog.alert */.Vq.alert({
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_ExclamationCircleFill, {
                    style: {
                        fontSize: 40,
                        color: "var(--adm-color-warning)"
                    }
                }),
                confirmText: t("ss_builder_close_panel_edit_text_block"),
                title: t("ss_builder_setting_saving"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center",
                        children: t("ss_builder_wait_for_saving")
                    })
                })
            });
        } else {
            var castWindow = window;
            if (castWindow.flutter_inappwebview !== undefined) {
                castWindow.flutter_inappwebview.callHandler("closeWebView");
            } else {
                window.location.href = system/* PASSIO_HOME_PAGE */.n4;
            }
        }
    };
    var handleShowResultPublish = function(value) {
        callbackShowResultPublish(value);
    };
    var handleHideLoadingBtn = function() {
        setCheckLoadingBtnPublish(false);
    };
    var handleClickPublishThemeAndChangeGuideIfExist = function() {
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.PUBLISH_SITE */.Bt.PUBLISH_SITE, "PublishSite", domain);
        setCheckLoadingBtnPublish(true);
        dispatch((0,thunk/* publishSite */.xF)(handleShowResultPublish, handleHideLoadingBtn));
        if (guideState === externalStateSlice/* FirstGuideStateEnum.PUBLISH */.x9.PUBLISH) changeFirstGuide();
    };
    var handleReplaceTheme = function() {
        var _ref = components_asyncToGenerator(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (selectedThemeTemplate) {
                            _ctx.next = 4;
                            break;
                        }
                        {
                            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.APPLY_SAMPLE_CONTENT */.Bt.APPLY_SAMPLE_CONTENT, "ApplySampleContent_DoesNotExist", domain, ga_events/* ACTION_CONFIG.THEME_NOT_EXITS */.AN.THEME_NOT_EXITS);
                            es/* Modal.show */.u_.show({
                                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                    className: "w-11 h-11",
                                    fillColor: "#FF8F1F",
                                    onClick: function() {}
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col text-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-lg font-bold leading-[25px]",
                                            children: t("ss_builder_dont_apply_theme_content_modal_label")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "",
                                            children: t("ss_builder_dont_apply_theme_content_modal_description")
                                        })
                                    ]
                                }),
                                className: "modal-error-class",
                                closeOnAction: true,
                                actions: [
                                    {
                                        key: "confirm",
                                        text: t("ss_builder_dont_apply_theme_content_modal_btn_confirm_label")
                                    }, 
                                ]
                            });
                        }
                        _ctx.next = 8;
                        break;
                    case 4:
                        _ctx.next = 6;
                        return requestSelectedThemeTemplate();
                    case 6:
                        data = _ctx.sent;
                        if (data) {
                            setIsOpenPreviewAndReplaceTheme(true);
                        } else {
                            es/* Modal.show */.u_.show({
                                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                    className: "w-11 h-11",
                                    fillColor: "#FF8F1F",
                                    onClick: function() {}
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col text-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-lg font-bold leading-[25px]",
                                            children: t("ss_builder_dont_apply_theme_content_modal_label")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "",
                                            children: t("ss_builder_dont_apply_theme_content_modal_description")
                                        })
                                    ]
                                }),
                                className: "modal-error-class",
                                closeOnAction: true,
                                actions: [
                                    {
                                        key: "confirm",
                                        text: t("ss_builder_dont_apply_theme_content_modal_btn_confirm_label")
                                    }, 
                                ]
                            });
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleReplaceTheme() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickPopoverItem = function(item) {
        var key = item && item.key;
        switch(key){
            case "undo":
                break;
            case "redo":
                break;
            case "restore":
                confirmRestoreTheme();
                break;
            case "replace-theme":
                handleReplaceTheme();
                break;
            case "create-new-theme":
                handleCreateNewTheme();
                break;
            default:
        }
    };
    var handleCreateNewTheme = function() {
        setIsOpenAddNewThemeSelectionPanel(true);
    };
    var handleRestoreTheme = function() {
        var handleShowRestoreSuccessfully = function() {
            return es/* Toast.show */.FN.show({
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                    className: "text-center inline-block w-[30px] h-[30px]",
                    fillColor: "#00B578"
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center",
                    children: t("ss_builder_restore_theme_successfully_label")
                })
            });
        };
        dispatch((0,thunk/* restoreTheme */.PK)(handleShowRestoreSuccessfully));
    };
    var contentPopoverManual = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-[320px] relative max-w-full popover-manual",
            children: [
                !isShowTextCustomUserManual && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[32px] h-[32px] absolute p-1 right-2 top-2 cursor-pointer z-[3]",
                    onClick: function() {
                        handleHiddenPopoverManual();
                        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.PRODUCT_TOUR */.Bt.PRODUCT_TOUR, "ProductTour_Step0", domain, "Step 0");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ClosePopupIconV2 */.gz, {
                        fillColor: "#fff"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "wrapper-image",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PlaceHolderImageIcon */.kI, {
                            className: "img-placeholder"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "img-popover relative z-[2]",
                            src: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-17.gif"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "p-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-2 text-lg leading-[25px] font-bold",
                            children: t("ss_builder_popover_manual_title")
                        }),
                        isShowTextCustomUserManual ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault mb-5",
                                    children: t("ss_builder_popover_review_manual_content")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                    color: "primary",
                                    size: "middle",
                                    fill: "solid",
                                    onClick: handleHiddenPopoverManual,
                                    block: true,
                                    children: t("ss_builder_popover_manual_button_close")
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault mb-5",
                                    children: t("ss_builder_popover_manual_content")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                    color: "primary",
                                    size: "middle",
                                    fill: "solid",
                                    onClick: handleOpenModalManual,
                                    block: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "flex items-center w-full justify-center gap-2",
                                        children: [
                                            t("ss_builder_popover_manual_button"),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowRightIcon */.LZ, {
                                                fillColor: "#fff"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var ref18 = (0,react.useState)(false), forceVisiblePopoverHeader = ref18[0], setForceVisiblePopoverHeader = ref18[1];
    var confirmRestoreTheme = function() {
        return es/* Modal.confirm */.u_.confirm({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("ss_builder_restore_theme_title")
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_restore_theme_content")
            }),
            confirmText: t("ss_builder_confirm_restore_theme_label"),
            cancelText: t("ss_builder_cancel-restore_theme_label"),
            onConfirm: function() {
                ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.RESTORE_EDITS */.Bt.RESTORE_EDITS, "RestoreEdits_Confirm", domain, ga_events/* ACTION_CONFIG.CONFIRM */.AN.CONFIRM);
                handleRestoreTheme();
            },
            onCancel: function() {
                ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.RESTORE_EDITS */.Bt.RESTORE_EDITS, "RestoreEdits_Cancel", domain, ga_events/* ACTION_CONFIG.CANCEL */.AN.CANCEL);
                return;
            }
        });
    };
    var renderStyleWithTabMenu = (0,react.useMemo)(function() {
        var styleObj = {};
        var position_style = tabMenuStyle && tabMenuStyle.position_style;
        var ghim_style = tabMenuStyle && tabMenuStyle.ghim_style;
        if (ghim_style === configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM && position_style === "top") {
            styleObj = {
                paddingBottom: "".concat(tabBarFooterHeight, "px"),
                paddingTop: "".concat(tabMenuHeight + tabBarHeaderHeight, "px")
            };
        } else if (ghim_style === configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM && position_style === "bottom") {
            styleObj = {
                paddingTop: "".concat(tabBarHeaderHeight, "px")
            };
        } else {
            styleObj = {
                paddingTop: "".concat(tabBarHeaderHeight, "px")
            };
        }
        return styleObj;
    }, [
        tabMenuStyle,
        tabMenuHeight,
        tabBarHeaderHeight,
        tabBarFooterHeight
    ]);
    var paddingDesignContent1 = (0,react.useMemo)(function() {
        var offsetHeightTab = tabMenuHeight !== null && tabMenuHeight !== void 0 ? tabMenuHeight : 0;
        var position_style = tabMenuStyle && tabMenuStyle.position_style;
        var ghim_style = tabMenuStyle && tabMenuStyle.ghim_style;
        var paddingDesignContent = {
            paddingBottom: "".concat(tabBarFooterHeight, "px")
        };
        if (ghim_style === configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM && position_style === "bottom") {
            var paddingBottom = offsetHeightTab ? offsetHeightTab + 60 : 60;
            paddingDesignContent = {
                paddingBottom: offsetHeightTab ? "".concat(paddingBottom, "px") : "60px"
            };
        }
        return paddingDesignContent;
    }, [
        tabMenuStyle,
        tabMenuHeight,
        tabBarFooterHeight
    ]);
    var addNewBlockStyle1 = (0,react.useMemo)(function() {
        var offsetHeightTab = tabMenuHeight !== null && tabMenuHeight !== void 0 ? tabMenuHeight : 0;
        var bottom = offsetHeightTab ? offsetHeightTab + 68 : 70;
        var position_style = tabMenuStyle && tabMenuStyle.position_style;
        var ghim_style = tabMenuStyle && tabMenuStyle.ghim_style;
        var addNewBlockStyle = {
            bottom: "70px"
        };
        if (ghim_style === configs_const/* TAB_GHIM_STYLE.ALWAYS_GHIM */.EK.ALWAYS_GHIM && position_style !== configs_const/* TAB_POSITION.TOP */.Fe.TOP) {
            addNewBlockStyle = {
                bottom: "".concat(bottom, "px")
            };
        }
        return addNewBlockStyle;
    }, [
        tabMenuStyle,
        tabMenuHeight
    ]);
    var isEnableLoadingPublishBtn = (0,react.useMemo)(function() {
        return isSaving || checkLoadingBtnPublish;
    }, [
        isSaving,
        checkLoadingBtnPublish,
        hasChange
    ]);
    var isEnablePublishBtn = (0,react.useMemo)(function() {
        return isSaving || checkLoadingBtnPublish || !hasChange;
    }, [
        isSaving,
        checkLoadingBtnPublish,
        hasChange
    ]);
    var handleConfirmThemeTemplatePreviewAndReplace = function() {
        var _ref = components_asyncToGenerator(runtime_default().mark(function _callee() {
            var reponseReplaceTheme, dataRequest, ref, statusCode, ref21, siteResponseData, payloadPosition, siteResponseDataClone;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.APPLY_SAMPLE_CONTENT */.Bt.APPLY_SAMPLE_CONTENT, "ApplySampleContent_Confirm", domain, ga_events/* ACTION_CONFIG.CONFIRM */.AN.CONFIRM);
                        reponseReplaceTheme = null;
                        dataRequest = {
                            user_id: siteSettings.user_id
                        };
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return (0,api/* requestReplaceThemeTemplate */.B5)(dataRequest);
                    case 6:
                        reponseReplaceTheme = _ctx.sent;
                        _ctx.next = 14;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](3);
                        ;
                        statusCode = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : ref.status;
                        if (statusCode == 404) {
                            es/* Modal.show */.u_.show({
                                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                                    className: "w-11 h-11",
                                    fillColor: "#FF8F1F",
                                    onClick: function() {}
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col text-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-lg font-bold leading-[25px]",
                                            children: t("ss_builder_dont_apply_theme_content_modal_label")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "",
                                            children: t("ss_builder_dont_apply_theme_content_modal_description")
                                        })
                                    ]
                                }),
                                className: "modal-error-class",
                                closeOnAction: true,
                                actions: [
                                    {
                                        key: "confirm",
                                        text: t("ss_builder_dont_apply_theme_content_modal_btn_confirm_label")
                                    }, 
                                ]
                            });
                        }
                    case 14:
                        if (/^20[0-9]$/.test(reponseReplaceTheme === null || reponseReplaceTheme === void 0 ? void 0 : reponseReplaceTheme.status.toString())) {
                            ;
                            siteResponseData = reponseReplaceTheme === null || reponseReplaceTheme === void 0 ? void 0 : (ref21 = reponseReplaceTheme.data) === null || ref21 === void 0 ? void 0 : ref21.data;
                            payloadPosition = siteResponseData === null || siteResponseData === void 0 ? void 0 : siteResponseData.positions;
                            siteResponseDataClone = cloneDeep_default()(siteResponseData);
                            if (siteResponseDataClone) siteResponseDataClone === null || siteResponseDataClone === void 0 ? void 0 : delete siteResponseDataClone.positions;
                            dispatch((0,positionsSlice/* setPosition */.wq)({
                                positions: payloadPosition
                            }));
                            dispatch((0,siteSettingSlice/* setSiteInfo */.cP)({
                                sites: siteResponseDataClone
                            }));
                            dispatch((0,dynamicSlice/* setParamsTab */.qS)({
                                data: {
                                    activeKeyTab: null
                                }
                            }));
                            setIsOpenPreviewAndReplaceTheme(false);
                            es/* Toast.show */.FN.show({
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                    className: "text-center inline-block",
                                    fillColor: "#00B578"
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: t("ss_builder_replace_theme_template_successfully_label")
                                })
                            });
                        } else {
                            dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
                                data: {
                                    isErrorNetwork: true
                                }
                            }));
                        }
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    9
                ]
            ]);
        }));
        return function handleConfirmThemeTemplatePreviewAndReplace() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOpenPositionSelectedList = function() {
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.ADD_BLOCK_BUTTON */.Bt.ADD_BLOCK_BUTTON, "AddBlockButton_Click", null, ga_events/* ACTION_CONFIG.CLICK */.AN.CLICK);
        setIsOpenPositionSelectedList(true);
    };
    var buttonPublish = function() {
        var elementPublish = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SpinLoading */.wW, {
                    color: "#fff",
                    style: {
                        "--size": "15px"
                    }
                }),
                t("ss_builder_publish_saving")
            ]
        });
        if (!isSaving) {
            if (checkLoadingBtnPublish) {
                elementPublish = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SpinLoading */.wW, {
                            color: "#fff",
                            style: {
                                "--size": "15px"
                            }
                        }),
                        t("ss_builder_publish_button_label")
                    ]
                });
            } else {
                elementPublish = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PubLishIcon */.FS, {
                            width: 15,
                            height: 15,
                            className: ""
                        }),
                        t("ss_builder_publish_button_label")
                    ]
                });
            }
        }
        return elementPublish;
    };
    (0,react.useEffect)(function() {
        if (!siteSettings.user_id) {
            return;
        }
        if (isSavingProductTour === false && typeof finishProductTour === "number" && finishProductTour !== configs_const/* FINISH_PRODUCT_TOUR */.GR) {
            if (!isEnableHeader) {
                var enableValue = 1;
                dispatch((0,positionsSlice/* disableEnablePosition */.uX)({
                    enableValue: enableValue,
                    positionSlug: configs_const/* POSITION_MAIN_LAYOUT.HEADER */.Kw.HEADER
                }));
            }
            es/* Modal.alert */.u_.alert({
                image: "https://image.passio.eco/page-builder/page-builder/product-tour/product-tour-0.png",
                title: t("ss_builder_product_tour_title_step_0"),
                className: "modal-product-tour",
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                    children: t("ss_builder_product_tour_content_step_0")
                }),
                confirmText: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "flex items-center w-full justify-center gap-2",
                    children: [
                        t("ss_builder_product_tour_button_step_0"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowRightIcon */.LZ, {
                            fillColor: "#fff"
                        })
                    ]
                }),
                onConfirm: function() {
                    setIsOpenProductTour(true);
                    handleDispatchOpenProductTour();
                    return;
                }
            });
        }
    }, [
        siteSettings.user_id,
        finishProductTour,
        isSavingProductTour
    ]);
    var handleHiddenPopoverManual = function() {
        var ref;
        popoverManualRef === null || popoverManualRef === void 0 ? void 0 : (ref = popoverManualRef.current) === null || ref === void 0 ? void 0 : ref.hide();
    };
    var handleOpenModalManual = function() {
        // gaEvents.submitEventV2(
        //   passioPageProfile,
        //   CATEGORY_CONFIG.PRODUCT_TOUR,
        //   `ProductTour_Step0`,
        //   domain,
        //   `Step 0`
        // );
        productTourRef.current.scrollIntoView({});
        handleHiddenPopoverManual();
        setIsOpenProductTour(true);
        setIsProductTourManual(true);
        if (!isEnableHeader) {
            var enableValue = 1;
            dispatch((0,positionsSlice/* disableEnablePosition */.uX)({
                enableValue: enableValue,
                positionSlug: configs_const/* POSITION_MAIN_LAYOUT.HEADER */.Kw.HEADER
            }));
        }
        handleDispatchOpenProductTour();
    };
    var handleOpenProductTour = function() {
        var _ref = components_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsOpenProductTour(false);
                        if (isProductTourManual) {
                            _ctx.next = 7;
                            break;
                        }
                        ;
                        setIsShowTextCustomUserManual(true);
                        _ctx.next = 6;
                        return (0,sleep/* sleep */._)(300);
                    case 6:
                        popoverManualRef === null || popoverManualRef === void 0 ? void 0 : (ref = popoverManualRef.current) === null || ref === void 0 ? void 0 : ref.show();
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOpenProductTour() {
            return _ref.apply(this, arguments);
        };
    }();
    var onVisibleChangePopoverManual = function(visible) {
        if (!visible) {
            setIsShowTextCustomUserManual(false);
        }
    };
    var handleDispatchOpenProductTour = function() {
        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
            data: {
                isOpenProductTourDynamic: true
            }
        }));
    };
    (0,react.useEffect)(function() {
        var castWindow = window;
        castWindow.triggerVisiblePopoverHeader = setForceVisiblePopoverHeader;
        (function() {
            if (castWindow.triggerVisiblePopoverHeader) {
                castWindow.triggerVisiblePopoverHeader = undefined;
                setForceVisiblePopoverHeader(false);
            }
        });
    }, []);
    var handleOpenPreviewOrShowGuide = function() {
        if (guideState === externalStateSlice/* FirstGuideStateEnum.PREVIEW */.x9.PREVIEW) {
            showFirstGuide();
        } else {
            handleOpenPreviewAndTrakingGAAndChangeGuideIfExist();
        }
    };
    var handleClosePreview = function() {
        return setIsOpenPreviewAndReplaceTheme(false);
    };
    var handleOpenPreviewAndTrakingGAAndChangeGuideIfExist = function() {
        setIsOpenPreview(true);
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.PREVIEW_SITE */.Bt.PREVIEW_SITE, "PreviewSite", domain, ga_events/* ACTION_CONFIG.PREVIEW_SITE */.AN.PREVIEW_SITE);
        if (guideState === externalStateSlice/* FirstGuideStateEnum.PREVIEW */.x9.PREVIEW) changeFirstGuide();
    };
    var showFirstGuide = function() {
        modalGuideRef && modalGuideRef.current && modalGuideRef.current.openModal();
    };
    var changeFirstGuide = function() {
        modalGuideRef && modalGuideRef.current && modalGuideRef.current.changeFirstGuide();
    };
    var handleShowFirtGuideOrPublish = function() {
        if (guideState === externalStateSlice/* FirstGuideStateEnum.PUBLISH */.x9.PUBLISH) {
            showFirstGuide();
        } else {
            handleClickPublishThemeAndChangeGuideIfExist();
        }
    };
    var PrevewAnimation = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "button-anim-square-fill"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                    onClick: handleOpenPreviewOrShowGuide,
                    className: product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_11 */.uN.STEP_11,
                    disabled: isEnableLoadingPublishBtn,
                    size: "small",
                    style: {
                        padding: "6px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PreviewThemeIcon */.gc, {
                        className: "icon-shake"
                    })
                })
            ]
        });
    };
    var handleUpdatePosition = function(data) {
        setSelectedBlock({
            position: data === null || data === void 0 ? void 0 : data.position,
            uid: data === null || data === void 0 ? void 0 : data.uid,
            sort_order: data === null || data === void 0 ? void 0 : data.sort_order
        });
        setIsOpenAddBlockFloatingPanel(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DesignContext.Provider, {
        value: {
            setSelectedBlock: setSelectedBlock,
            setIsOpenAddBlockFloatingPanel: setIsOpenAddBlockFloatingPanel
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "design-class",
            id: "passio-design-class",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(portal/* default */.Z, {
                    elementId: "tabBarHeaderPortal",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tab-bar-design-header fixed top-0 w-[100%] bg-white px-3 py-2 z-[9998] left-[50%] translate-x-[-50%]",
                        style: {
                            borderBottom: "1px solid #EEEEEE"
                        },
                        ref: designMoreRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "max-width-content-class flex flex-row justify-between items-center mx-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                        onClick: backToPassio,
                                        size: "small",
                                        style: {
                                            padding: "4px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row text-center items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BackIcon */.xC, {
                                                    className: ""
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PassioIcon */.ki, {
                                                    className: "",
                                                    fillColor: "var(--adm-color-primary)"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                isRenderContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-2 items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex flex-row items-center gap-[15px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover.Menu */.J2.Menu, components_objectSpread({}, forceVisiblePopoverHeader ? {
                                                    visible: true
                                                } : {}, {
                                                    className: classnames_default()("".concat(product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_9 */.uN.STEP_9, " ").concat(product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_10 */.uN.STEP_10, " "), isOpenProductTourDynamic ? "open-product-tour-popover" : "open-product-tour-popover", isAdminRole ? "admin-role" : ""),
                                                    mode: "dark",
                                                    actions: actions,
                                                    placement: "bottom",
                                                    trigger: "click",
                                                    stopPropagation: [
                                                        "click"
                                                    ],
                                                    getContainer: function() {
                                                        return designMoreRef.current;
                                                    },
                                                    onAction: function(item) {
                                                        return handleClickPopoverItem(item);
                                                    },
                                                    style: {
                                                        "--z-index": "9998"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                        style: {
                                                            padding: "6px"
                                                        },
                                                        size: "small",
                                                        disabled: isEnableLoadingPublishBtn,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MoreIcon */.nX, {
                                                            className: "w-[15px] h-[15px]"
                                                        })
                                                    })
                                                }))
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "user-manual",
                                            ref: tabBarHeaderRef,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                                                className: "popover-user-manual",
                                                content: contentPopoverManual(),
                                                placement: "bottom",
                                                trigger: "click",
                                                stopPropagation: [
                                                    "click"
                                                ],
                                                getContainer: function() {
                                                    return tabBarHeaderRef.current;
                                                },
                                                ref: popoverManualRef,
                                                onVisibleChange: onVisibleChangePopoverManual,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                    className: product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_17 */.uN.STEP_17,
                                                    disabled: isEnableLoadingPublishBtn,
                                                    size: "small",
                                                    style: {
                                                        padding: "6px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* QuestionIcon */.UO, {
                                                        className: ""
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: guideState === externalStateSlice/* FirstGuideStateEnum.PREVIEW */.x9.PREVIEW ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevewAnimation, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                onClick: handleOpenPreviewOrShowGuide,
                                                className: product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_11 */.uN.STEP_11,
                                                disabled: isEnableLoadingPublishBtn,
                                                size: "small",
                                                style: {
                                                    padding: "6px"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PreviewThemeIcon */.gc, {
                                                    className: ""
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative",
                                            children: [
                                                guideState === externalStateSlice/* FirstGuideStateEnum.PUBLISH */.x9.PUBLISH && !isEnablePublishBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: " button-anim-square-fill button-anim-publish",
                                                    onClick: showFirstGuide
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                    color: "primary",
                                                    size: "small",
                                                    fill: "solid",
                                                    onClick: handleShowFirtGuideOrPublish,
                                                    disabled: isEnablePublishBtn,
                                                    style: {
                                                        display: "flex",
                                                        padding: "3px 8px"
                                                    },
                                                    className: classnames_default()("flex justify-center items-center gap-2 btn-publish-header", product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_4 */.uN.STEP_4),
                                                    children: guideState === externalStateSlice/* FirstGuideStateEnum.PUBLISH */.x9.PUBLISH && !isEnablePublishBtn ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "relative flex items-center gap-2 publish-button-animating",
                                                        children: buttonPublish()
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: buttonPublish()
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "design-content-class w-full ",
                    style: components_objectSpread({}, paddingDesignContent1, renderStyleWithTabMenu),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: isRenderContent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    ref: productTourRef
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DesignMainLayout, {
                                    headerState: newHeaderState,
                                    footerState: newFooterState,
                                    bodyState: bodyState,
                                    isEnableBody: isEnableBody,
                                    expandPosition: expandPosition,
                                    addNewBlockStyle: addNewBlockStyle1,
                                    handleOpenPositionSelectedList: handleOpenPositionSelectedList,
                                    showFirstGuide: showFirstGuide,
                                    onUpdatePositionWhenDragBtn: handleUpdatePosition
                                }),
                                !isSavingProductTour && isOpenProductTour && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProductTour, {
                                    handleOpenProductTour: handleOpenProductTour,
                                    isProductTourManual: isProductTourManual
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute",
                            style: {
                                left: "calc(50% - 16px)",
                                top: "calc(50% - 16px)"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SpinLoading */.wW, {
                                color: "primary",
                                style: {
                                    "--size": "32px"
                                }
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(portal/* default */.Z, {
                    elementId: "themeTemplateHandlerPortal",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ThemeTemplateHandler, {
                        isOpenAddNewThemeSelectionPanel: isOpenAddNewThemeSelectionPanel,
                        handleCancelAddNewThemeSelectionPanel: function() {
                            return setIsOpenAddNewThemeSelectionPanel(false);
                        },
                        siteSettings: siteSettings,
                        user: user,
                        handleRedirectTabs: handleRedirectTabs
                    })
                }),
                isOpenPreviewAndReplaceTheme && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                    visible: isOpenPreviewAndReplaceTheme,
                    onMaskClick: handleClosePreview,
                    isLimitWidth: false,
                    style: {
                        background: "#fff"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeTemplateHandler_ThemeTemplatePreview, {
                        onCancelThemeTemplatePreview: handleClosePreview,
                        onConfirmThemeTemplatePreview: handleConfirmThemeTemplatePreviewAndReplace,
                        user: user,
                        selectedThemeData: selectedThemeTemplate,
                        KEY: configs_const/* THEME_PREVIEW_KEY.PREVIEW_AND_APPLY_CONTENT */.Sl.PREVIEW_AND_APPLY_CONTENT,
                        siteSettingUserRootId: siteSettingUserRootId
                    })
                }),
                isOpenPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                    visible: isOpenPreview,
                    onMaskClick: function() {
                        setIsOpenPreview(false);
                    },
                    isLimitWidth: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Preview, {
                        onCancelPreview: function() {
                            return setIsOpenPreview(false);
                        },
                        siteSettings: siteSettings,
                        user: user
                    })
                }),
                isOpenAddBlockFloatingPanel && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                    anchors: 600,
                    visible: isOpenAddBlockFloatingPanel,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockSelectionV2/* default */.ZP, {
                        cancleFP: function() {
                            setIsOpenAddBlockFloatingPanel(false);
                            setIsOpenPositionSelectedList(false);
                        },
                        backFP: function() {
                            return setIsOpenAddBlockFloatingPanel(false);
                        },
                        positionSlug: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.position,
                        tabUid: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.uid,
                        sortOrder: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.sort_order,
                        tabListBody: tabListBody
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                    visible: isOpenPositionSelectedList,
                    onMaskClick: function() {
                        return setIsOpenPositionSelectedList(false);
                    },
                    title: t("ss_builder_select_position_add_block"),
                    onClose: function() {
                        return setIsOpenPositionSelectedList(false);
                    },
                    style: {
                        borderRadius: "8px 8px 0px 0px",
                        maxWidth: outside_space ? "".concat(configs_const/* MAX_WIDTH_OUTSIDE_ON */.NY, "px") : "".concat(configs_const/* MAX_WIDTH_CONTENT_LAYOUT */.t, "px")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddNewBlock/* default */.Z, {
                        position: positionState,
                        onSelectBlock: function(data) {
                            setSelectedBlock(data);
                            setIsOpenAddBlockFloatingPanel(true);
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalGuide, {
                    onOpenPositionSelection: handleOpenPositionSelectedList,
                    onOpenPreview: handleOpenPreviewAndTrakingGAAndChangeGuideIfExist,
                    onPublish: handleClickPublishThemeAndChangeGuideIfExist,
                    ref: modalGuideRef
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandGiftFloat, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandRatingFloat, {})
            ]
        })
    });
};
/* harmony default export */ var components = (Design);

// EXTERNAL MODULE: ./src/features/share/helper/browser.ts
var browser = __webpack_require__(52741);
;// CONCATENATED MODULE: ./src/features/design/components/ResultPublish/index.tsx
function ResultPublish_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ResultPublish_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ResultPublish_arrayLikeToArray(arr);
}
function ResultPublish_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ResultPublish_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ResultPublish_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ResultPublish_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ResultPublish_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ResultPublish_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ResultPublish_toConsumableArray(arr) {
    return ResultPublish_arrayWithoutHoles(arr) || ResultPublish_iterableToArray(arr) || ResultPublish_unsupportedIterableToArray(arr) || ResultPublish_nonIterableSpread();
}
function ResultPublish_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ResultPublish_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ResultPublish_arrayLikeToArray(o, minLen);
}










var ResultPublishComponent = function(props) {
    var callbackClosePublishResult = props.callbackClosePublishResult;
    var userState = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.user;
    });
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state === null || state === void 0 ? void 0 : state.siteSettings;
    });
    var kol = userState && userState.kol;
    var valueLink = kol && kol.domain;
    var user_id = kol && kol._id;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref2 = (0,react.useState)(""), metaTitle = ref2[0], setMetaTitle = ref2[1];
    var ref1 = (0,react.useState)(""), metaDescription = ref1[0], setMetaDescription = ref1[1];
    (0,react.useEffect)(function() {
        var getWebsiteConfig = function() {
            var _ref = ResultPublish_asyncToGenerator(runtime_default().mark(function _callee() {
                var response, data, meta_title, ref, meta_description;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            response = null;
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return (0,api/* requestGetSiteSetting */.s2)(user_id);
                        case 4:
                            response = _ctx.sent;
                            _ctx.next = 10;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](1);
                            console.log(_ctx.t0);
                        case 10:
                            if (response) {
                                data = response === null || response === void 0 ? void 0 : response.data;
                                if (data) {
                                    meta_title = (data === null || data === void 0 ? void 0 : data.meta_title) || "";
                                    ;
                                    meta_description = (ref = data === null || data === void 0 ? void 0 : data.meta_description) !== null && ref !== void 0 ? ref : t("ss_builder_default_meta_description");
                                    setMetaTitle(meta_title);
                                    setMetaDescription(meta_description);
                                }
                            }
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        7
                    ]
                ]);
            }));
            return function getWebsiteConfig() {
                return _ref.apply(this, arguments);
            };
        }();
        getWebsiteConfig();
    }, [
        user_id
    ]);
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var handleClickCoppyLink = function() {
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.PUBLISH_RESULT */.Bt.PUBLISH_RESULT, "PublishResult_CopyDomain", valueLink, ga_events/* ACTION_CONFIG.COPY_DOMAIN */.AN.COPY_DOMAIN);
        (0,browser/* copyToClipboard */.v)("https://".concat(valueLink));
        es/* Toast.show */.FN.show({
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                className: "text-center inline-block w-[30px] h-[30px]",
                fillColor: "#00B578"
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: t("ss_builder_personal_link_coppy_successfully_label")
            })
        });
    };
    var handleBackPublishResult = function() {
        callbackClosePublishResult();
    };
    var handleClickToLink = function(link) {
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.PUBLISH_RESULT */.Bt.PUBLISH_RESULT, "PublishResult_ViewSiteInBrowser", valueLink, ga_events/* ACTION_CONFIG.VIEW_SITE */.AN.VIEW_SITE);
        var castWindow = window;
        if (castWindow.flutter_inappwebview !== undefined) {
            var _flutter_inappwebview;
            var args = [
                {
                    url: "https://".concat(link)
                }
            ];
            (_flutter_inappwebview = castWindow.flutter_inappwebview).callHandler.apply(_flutter_inappwebview, [
                "openInBrowser"
            ].concat(ResultPublish_toConsumableArray(args)));
        } else {
            window.open("https://".concat(link), "_blank");
        }
    };
    var handleShare = function(url) {
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.PUBLISH_RESULT */.Bt.PUBLISH_RESULT, "PublishResult_ShareSite", valueLink, ga_events/* ACTION_CONFIG.SHARE */.AN.SHARE);
        var castWindow = window;
        var args2 = [
            {
                url: url
            }
        ];
        if (castWindow.flutter_inappwebview !== undefined) {
            var _flutter_inappwebview;
            (_flutter_inappwebview = castWindow.flutter_inappwebview).callHandler.apply(_flutter_inappwebview, [
                "share"
            ].concat(ResultPublish_toConsumableArray(args2)));
        } else if (!!(navigator === null || navigator === void 0 ? void 0 : navigator.share)) {
            navigator === null || navigator === void 0 ? void 0 : navigator.share({
                title: metaTitle,
                text: metaDescription,
                url: url
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-full w-full bg-[#fff]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[26px] h-[26px] absolute right-2 top-2 flex justify-center items-center",
                onClick: function() {
                    return handleBackPublishResult();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ClosePopupIcon */.Hn, {
                    className: "cursor-pointer"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-3 flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                    width: 48,
                    height: 48,
                    fillColor: "#00B578"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-2 text-[18px] leading-[25px] text-center font-bold",
                children: t("ss_builder_publish_result_successfully")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center mb-4",
                children: t("ss_builder_publish_result_description")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[#666] mb-1",
                        children: t("ss_builder_personal_link_title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between bg-[#F5F5F5]",
                        style: {
                            borderRadius: "4px",
                            height: "40px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center overflow-hidden h-full pl-3",
                                style: {
                                    width: "calc(100% - 40px)"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-[17px]",
                                    children: "".concat(valueLink)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                size: "middle",
                                onClick: handleClickCoppyLink,
                                style: {
                                    border: "none",
                                    width: "40px",
                                    backgroundColor: "unset",
                                    display: "flex",
                                    height: "100%"
                                },
                                block: true,
                                className: "flex justify-center items-center ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CoppyAltIcon */.tO, {
                                    width: 18,
                                    height: 18
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                        className: "flex items-center justify-center gap-2 w-full",
                        fill: "solid",
                        size: "middle",
                        onClick: function() {
                            return handleClickToLink(valueLink);
                        },
                        style: {
                            display: "flex",
                            overflow: "hidden",
                            marginTop: "12px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* GlobalIcon */.ww, {
                                width: 17,
                                height: 17
                            }),
                            t("ss_builder_publish_view_page")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                        className: "flex items-center justify-center gap-2 w-full mt-3",
                        fill: "solid",
                        size: "middle",
                        onClick: function() {
                            handleShare("https://".concat(valueLink));
                        },
                        style: {
                            display: "flex",
                            overflow: "hidden",
                            marginTop: "12px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ShareIconV3 */.s9, {
                                width: 17,
                                height: 17
                            }),
                            t("ss_builder_publish_share")
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ResultPublish = (ResultPublishComponent);

// EXTERNAL MODULE: ./src/features/user/userApi.ts
var userApi = __webpack_require__(63681);
// EXTERNAL MODULE: ./src/features/share/hooks/toast.tsx
var toast = __webpack_require__(95880);
;// CONCATENATED MODULE: ./src/features/setting/components/body/component/SiteSetting/PersonalDomainSetting/index.tsx
function PersonalDomainSetting_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function PersonalDomainSetting_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                PersonalDomainSetting_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                PersonalDomainSetting_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}














var DOMAIN_MAX_LENGTH = 50;
var EXTENSION_DOMAIN = ".passio.eco";
var PersonalDomainSetting = function(props) {
    var onCancelPersonalDomainSetting = props.onCancelPersonalDomainSetting;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var SuccessToast = (0,toast/* useToast */.p)().SuccessToast;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var kol = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.user) === null || ref === void 0 ? void 0 : ref.kol;
    });
    var domain = (kol || {}).domain;
    var ref7;
    var domainDefault = (ref7 = domain === null || domain === void 0 ? void 0 : domain.split(".")[0]) !== null && ref7 !== void 0 ? ref7 : "";
    var ref1 = (0,react.useState)(domainDefault), valueDomain = ref1[0], setValueDomain = ref1[1];
    var ref2 = (0,react.useState)(""), errorCode1 = ref2[0], setErrorCode = ref2[1];
    var ref3 = (0,react.useState)(false), isValidDomain = ref3[0], setIsValidDomain = ref3[1];
    var ref4 = (0,react.useState)(false), isAllowedDomain = ref4[0], setIsAllowedDomain = ref4[1];
    var ref5 = (0,react.useState)(false), checkDisableBtn = ref5[0], setCheckDisableBtn = ref5[1];
    var ref6 = (0,react.useState)(false), checkLoadingBtn = ref6[0], setCheckLoadingBtn = ref6[1];
    var extensionDomain = (0,react.useMemo)(function() {
        var splitString = domain === null || domain === void 0 ? void 0 : domain.split(".");
        if (!splitString) {
            return EXTENSION_DOMAIN;
        }
        var indexLast1 = splitString[splitString.length - 1];
        var indexLast2 = splitString[splitString.length - 2];
        return ".".concat(indexLast2, ".").concat(indexLast1);
    }, [
        domain
    ]);
    var isDisableBtnSave = (0,react.useMemo)(function() {
        if (isValidDomain || !valueDomain || checkDisableBtn || errorCode1 || valueDomain === domainDefault) {
            return true;
        } else return false;
    }, [
        isValidDomain,
        valueDomain,
        checkDisableBtn,
        errorCode1,
        domainDefault
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (valueDomain !== domainDefault) {
            return true;
        } else return false;
    }, [
        valueDomain,
        domainDefault
    ]);
    var validateDomain = function(data) {
        if (data && data !== domainDefault) {
            var valueRequest = data.toLowerCase();
            var validate = function() {
                var _ref = PersonalDomainSetting_asyncToGenerator(runtime_default().mark(function _callee() {
                    var response, ref, isSuccess, ref8, ref9, errorCode;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                response = null;
                                _ctx.prev = 1;
                                _ctx.next = 4;
                                return (0,api/* requestValidateDomain */.aY)(valueRequest);
                            case 4:
                                response = _ctx.sent;
                                _ctx.next = 10;
                                break;
                            case 7:
                                _ctx.prev = 7;
                                _ctx.t0 = _ctx["catch"](1);
                                console.log(_ctx.t0);
                            case 10:
                                if (response) {
                                    ;
                                    setCheckLoadingBtn(false);
                                    setCheckDisableBtn(false);
                                    isSuccess = response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.success;
                                    if (!isSuccess) {
                                        ;
                                        errorCode = response === null || response === void 0 ? void 0 : (ref8 = response.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.message) === null || ref9 === void 0 ? void 0 : ref9.code;
                                        setErrorCode(errorCode);
                                        setIsAllowedDomain(false);
                                    } else {
                                        setIsAllowedDomain(true);
                                        setErrorCode(null);
                                    }
                                }
                            case 11:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                return function validate() {
                    return _ref.apply(this, arguments);
                };
            }();
            var checkValidDomain = (0,lib/* validDomain */.vR)(data);
            if (checkValidDomain) {
                setCheckLoadingBtn(true);
                validate();
                setIsValidDomain(false);
            } else {
                setIsValidDomain(true);
                setErrorCode(null);
                setIsAllowedDomain(false);
            }
        } else {
            setErrorCode(null);
            setIsValidDomain(false);
        }
    };
    var handleChangeDomain = (0,react.useCallback)(debounce_default()(validateDomain, 1000), []);
    var fetchAccount = function() {
        var _ref = PersonalDomainSetting_asyncToGenerator(runtime_default().mark(function _callee() {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return userApi/* default.me */.ZP.me();
                    case 3:
                        response = _ctx.sent;
                        dispatch((0,userSlice/* setProfile */.RG)(response));
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log(_ctx.t0);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function fetchAccount() {
            return _ref.apply(this, arguments);
        };
    }();
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var handleSaveDomainSetting = function() {
        var _ref = PersonalDomainSetting_asyncToGenerator(runtime_default().mark(function _callee() {
            var response, valueRequest;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        response = null;
                        valueRequest = valueDomain.toLowerCase();
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,api/* requestSaveDomain */.OW)(valueRequest);
                    case 5:
                        response = _ctx.sent;
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        console.log(_ctx.t0);
                    case 11:
                        if (response && /^20[0-9]$/.test(response.status.toString())) {
                            fetchAccount();
                            SuccessToast(t("ss_builder_save_succesfully_label"));
                            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.SITE_SETTINGS */.Bt.SITE_SETTINGS, "SiteSettings_Domain_".concat(ga_events/* LABEL_CONFIG.EDIT */.tW.EDIT), ga_events/* LABEL_CONFIG.EDIT */.tW.EDIT, ga_events/* ACTION_CONFIG.DOMAIN */.AN.DOMAIN);
                            onCancelPersonalDomainSetting();
                        } else handleShowFailAlert();
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return function handleSaveDomainSetting() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleShowFailAlert = function() {
        es/* Modal.alert */.u_.alert({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("ss_builder_theme_setting_save_failed_title")
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_theme_setting_save_failed_content")
            }),
            confirmText: t("ss_builder_close_panel_edit_text_block"),
            onConfirm: function() {
                return;
            }
        });
    };
    var handleCancelDomainSetting = (0,react.useCallback)(function() {
        if (isEditDataStatus) {
            es/* Modal.confirm */.u_.confirm({
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                    className: "w-11 h-11",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_cancel_edit_block_title")
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                    children: t("ss_builder_cancel_edit_block_content")
                }),
                confirmText: t("ss_builder_continue_edit_block_label"),
                cancelText: t("ss_builder_cancel_block_btn_label"),
                onConfirm: function() {
                    return;
                },
                onCancel: function() {
                    ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.SITE_SETTINGS */.Bt.SITE_SETTINGS, "SiteSettings_Domain_".concat(ga_events/* LABEL_CONFIG.CANCEL */.tW.CANCEL), ga_events/* LABEL_CONFIG.CANCEL */.tW.CANCEL, ga_events/* ACTION_CONFIG.DOMAIN */.AN.DOMAIN);
                    onCancelPersonalDomainSetting();
                }
            });
        } else {
            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.SITE_SETTINGS */.Bt.SITE_SETTINGS, "SiteSettings_Domain_".concat(ga_events/* LABEL_CONFIG.CANCEL */.tW.CANCEL), ga_events/* LABEL_CONFIG.CANCEL */.tW.CANCEL, ga_events/* ACTION_CONFIG.DOMAIN */.AN.DOMAIN);
            onCancelPersonalDomainSetting();
        }
    }, [
        isEditDataStatus
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative h-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-lg text-[#333333] font-normal flex text-center items-center gap-1 bg-white p-3 justify-center",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* GlobalIcon */.ww, {
                        className: "inline-block"
                    }),
                    t("ss_builder_site_domain_setting_label")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row gap-1 mb-3 p-3 bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                        className: "ml-1 w-[14px] h-[14px]",
                        onClick: function() {},
                        fillColor: "#1890FF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-3 text-[#333333] leading-4",
                        children: t("ss_builder_domain_site_setting_alert_infomation")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 py-[13px] bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-[15px] leading-[150%] text-[#666666]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-red-600",
                                children: "*"
                            }),
                            t("ss_builder_enter_domain_site_setting_label")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                value: valueDomain || "",
                                onChange: function(val) {
                                    setValueDomain(val);
                                    handleChangeDomain(val);
                                    setCheckDisableBtn(true);
                                },
                                placeholder: t("ss_builder_affiliate_product_btn_see_more_placeholder"),
                                maxLength: DOMAIN_MAX_LENGTH
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[13px] leading-[131%] text-[#333333]",
                                children: extensionDomain
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[13px] leading-[17px] text-[#999999] mt-1",
                        children: t("ss_builder_domain_site_setting_rule")
                    }),
                    isValidDomain && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[13px] leading-[17px] text-[#FF3141]",
                        children: t("ss_builder_malformed_domain_warning")
                    }),
                    errorCode1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[13px] leading-[17px] text-[#FF3141]",
                        children: t("ss_validate_domain_error_".concat(errorCode1))
                    }),
                    isAllowedDomain && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-[13px] leading-[17px] text-[#00B578] flex flex-row gap-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                className: "text-center inline-block w-[16px] h-[16px]",
                                fillColor: "#00B578"
                            }),
                            t("ss_builder_allowed_domain_label")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            onClick: handleCancelDomainSetting,
                            className: "adm-button adm-button-default adm-button-shape-default w-full",
                            children: t("ss_builder_close_panel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            color: "primary",
                            disabled: isDisableBtnSave,
                            className: "adm-button adm-button-primary adm-button-shape-default w-full",
                            onClick: function() {
                                return handleSaveDomainSetting();
                            },
                            loading: checkLoadingBtn,
                            children: t("ss_builder_save")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SiteSetting_PersonalDomainSetting = (PersonalDomainSetting);

// EXTERNAL MODULE: ./src/features/main/store/websiteConfigSlice.ts
var websiteConfigSlice = __webpack_require__(50049);
;// CONCATENATED MODULE: ./src/features/setting/components/body/component/SiteSetting/PersonalBrandSetting/index.tsx
function PersonalBrandSetting_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function PersonalBrandSetting_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                PersonalBrandSetting_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                PersonalBrandSetting_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}















var HEADING_MAX_LENGTH = 60;
var SITE_TITLE_MAX_LENGTH = 30;
var SUBTITLE_MAX_LENGTH = 155;
var PersonalBrandSetting = function(props) {
    var onCancelPersonalBrandSetting = props.onCancelPersonalBrandSetting;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var SuccessToast = (0,toast/* useToast */.p)().SuccessToast;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state === null || state === void 0 ? void 0 : state.siteSettings;
    });
    var websiteConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state === null || state === void 0 ? void 0 : state.websiteConfig;
    });
    var faviconDefault = websiteConfig === null || websiteConfig === void 0 ? void 0 : websiteConfig.favicon;
    var metaTitleDefault = websiteConfig === null || websiteConfig === void 0 ? void 0 : websiteConfig.meta_title;
    var metaDescriptionDefault = websiteConfig === null || websiteConfig === void 0 ? void 0 : websiteConfig.meta_description;
    var siteTitleDefault = websiteConfig === null || websiteConfig === void 0 ? void 0 : websiteConfig.site_title;
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var creatorType = passioPageProfile === null || passioPageProfile === void 0 ? void 0 : passioPageProfile.creator_type;
    var ref14 = (0,react.useState)([]), uploadedImageArr = ref14[0], setUploadedImageArr = ref14[1];
    var ref1 = (0,react.useState)(faviconDefault), valueUrlImage = ref1[0], setValueUrlImage = ref1[1];
    var ref2 = (0,react.useState)(metaTitleDefault), valueMetaTitle = ref2[0], setValueMetaTitle = ref2[1];
    var ref3 = (0,react.useState)(siteTitleDefault), valueSiteTitle = ref3[0], setValueSiteTitle = ref3[1];
    var ref4 = (0,react.useState)(metaDescriptionDefault), valueMetaDescription = ref4[0], setValueMetaDescription = ref4[1];
    var ref5 = (0,react.useState)(null), valueNameImage = ref5[0], setValueNameImage = ref5[1];
    var ref6 = (0,react.useState)(null), valueImageBase64 = ref6[0], setValueImageBase64 = ref6[1];
    var ref7 = (0,react.useState)(false), isValidFileFormat = ref7[0], setIsValidFileFormat = ref7[1];
    var ref8 = (0,react.useState)(false), isValidFileSize = ref8[0], setIsValidFileSize = ref8[1];
    var ref9 = (0,react.useState)(false), isInvalidMinimumSize = ref9[0], setIsInvalidMinimumSize = ref9[1];
    var isDisableButtonSave = (0,react.useMemo)(function() {
        if (valueSiteTitle && valueSiteTitle.trim().length > 0 && valueMetaTitle && valueMetaTitle.trim().length > 0 && valueMetaDescription && valueMetaDescription.trim().length > 0 && (valueMetaTitle !== metaTitleDefault || valueSiteTitle !== siteTitleDefault || valueMetaDescription !== metaDescriptionDefault || valueUrlImage !== faviconDefault)) {
            return false;
        } else return true;
    }, [
        valueSiteTitle,
        siteTitleDefault,
        valueMetaDescription,
        valueMetaTitle,
        metaTitleDefault,
        metaDescriptionDefault,
        faviconDefault,
        valueUrlImage, 
    ]);
    var isEditDataStatus = (0,react.useMemo)(function() {
        if (valueSiteTitle !== siteTitleDefault || valueMetaTitle !== metaTitleDefault || valueMetaDescription !== metaDescriptionDefault || valueUrlImage !== faviconDefault) {
            return true;
        } else return false;
    }, [
        valueSiteTitle,
        siteTitleDefault,
        valueMetaDescription,
        valueMetaTitle,
        metaTitleDefault,
        metaDescriptionDefault,
        faviconDefault,
        valueUrlImage, 
    ]);
    var handleDeleteImage = function() {
        setValueUrlImage(creatorType === store_interface/* CREATOR_TYPE_ENUM.FOURTEEN */.sG.FOURTEEN ? configs_const/* CREATOR_FOURTEEN_DEFAULT_ICON */.kH : configs_const/* PASSIO_DEFAULT_ICON */.wO);
        setValueImageBase64(null);
        setValueNameImage(null);
        setUploadedImageArr([]);
        setIsValidFileFormat(false);
        setIsValidFileSize(false);
        setIsInvalidMinimumSize(false);
    };
    var handleImageUrl = function(value) {
        var imgFileItems = value && value[value.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
            setIsInvalidMinimumSize(false);
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
            setIsInvalidMinimumSize(false);
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isInvalidMinimumSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(false);
            setIsInvalidMinimumSize(true);
        } else {
            setUploadedImageArr(value);
            setValueImageBase64(imgFileItems.dataBase64);
            setValueUrlImage(imgFileItems.url);
            setValueNameImage(imgFileItems.fileName);
            setIsValidFileFormat(false);
            setIsValidFileSize(false);
            setIsInvalidMinimumSize(false);
        }
    };
    var handleSaveSiteSetting = function() {
        var _ref = PersonalBrandSetting_asyncToGenerator(runtime_default().mark(function _callee() {
            var dataResquestUploadImage, response, responseImage, dataResquest, dataResquest1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataResquestUploadImage = {
                            id: siteSettings.id,
                            user_id: siteSettings.user_id,
                            name: valueNameImage,
                            content: valueImageBase64 || valueUrlImage
                        };
                        response = null;
                        responseImage = null;
                        if (!valueNameImage) {
                            _ctx.next = 27;
                            break;
                        }
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return (0,api/* requestUploadImage */.MR)(dataResquestUploadImage);
                    case 7:
                        responseImage = _ctx.sent;
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](4);
                        console.log(_ctx.t0);
                    case 13:
                        if (!responseImage) {
                            _ctx.next = 25;
                            break;
                        }
                        dataResquest = {
                            user_id: siteSettings.user_id,
                            data: {
                                favicon: responseImage === null || responseImage === void 0 ? void 0 : responseImage.url,
                                site_title: valueSiteTitle,
                                meta_title: valueMetaTitle,
                                meta_description: valueMetaDescription
                            }
                        };
                        _ctx.prev = 15;
                        _ctx.next = 18;
                        return (0,api/* requestSaveSiteSetting */.vL)(dataResquest);
                    case 18:
                        response = _ctx.sent;
                        _ctx.next = 24;
                        break;
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t1 = _ctx["catch"](15);
                        console.log(_ctx.t1);
                    case 24:
                        if (response && /^20[0-9]$/.test(response.status.toString())) {
                            updateWebsiteConfigFromResponse(response);
                            SuccessToast(t("ss_builder_save_succesfully_label"));
                            onCancelPersonalBrandSetting();
                        } else handleShowFailAlert();
                    case 25:
                        _ctx.next = 38;
                        break;
                    case 27:
                        dataResquest1 = {
                            user_id: siteSettings.user_id,
                            data: {
                                favicon: valueUrlImage,
                                site_title: valueSiteTitle,
                                meta_title: valueMetaTitle,
                                meta_description: valueMetaDescription
                            }
                        };
                        _ctx.prev = 28;
                        _ctx.next = 31;
                        return (0,api/* requestSaveSiteSetting */.vL)(dataResquest1);
                    case 31:
                        response = _ctx.sent;
                        _ctx.next = 37;
                        break;
                    case 34:
                        _ctx.prev = 34;
                        _ctx.t2 = _ctx["catch"](28);
                        console.log(_ctx.t2);
                    case 37:
                        if (response && /^20[0-9]$/.test(response.status.toString())) {
                            updateWebsiteConfigFromResponse(response);
                            SuccessToast(t("ss_builder_save_succesfully_label"));
                            onCancelPersonalBrandSetting();
                            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.SITE_SETTINGS */.Bt.SITE_SETTINGS, "SiteSettings_PersonalBrand_".concat(ga_events/* LABEL_CONFIG.EDIT */.tW.EDIT), ga_events/* LABEL_CONFIG.EDIT */.tW.EDIT, ga_events/* ACTION_CONFIG.PERSONAL_BRAND */.AN.PERSONAL_BRAND);
                        } else handleShowFailAlert();
                    case 38:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    10
                ],
                [
                    15,
                    21
                ],
                [
                    28,
                    34
                ]
            ]);
        }));
        return function handleSaveSiteSetting() {
            return _ref.apply(this, arguments);
        };
    }();
    var updateWebsiteConfigFromResponse = function(response) {
        var ref, ref10, ref11, ref12, ref13;
        var newWebsiteConfig = {
            id: response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.id,
            favicon: response === null || response === void 0 ? void 0 : (ref10 = response.data) === null || ref10 === void 0 ? void 0 : ref10.favicon,
            meta_title: response === null || response === void 0 ? void 0 : (ref11 = response.data) === null || ref11 === void 0 ? void 0 : ref11.meta_title,
            meta_description: response === null || response === void 0 ? void 0 : (ref12 = response.data) === null || ref12 === void 0 ? void 0 : ref12.meta_description,
            site_title: response === null || response === void 0 ? void 0 : (ref13 = response.data) === null || ref13 === void 0 ? void 0 : ref13.site_title
        };
        dispatch((0,websiteConfigSlice/* setWebsiteConfig */.me)({
            data: newWebsiteConfig
        }));
    };
    var handleShowFailAlert = function() {
        es/* Modal.alert */.u_.alert({
            header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                className: "w-11 h-11",
                fillColor: "var(--adm-color-primary)",
                onClick: function() {}
            }),
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("ss_builder_theme_setting_save_failed_title")
            }),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                children: t("ss_builder_theme_setting_save_failed_content")
            }),
            confirmText: t("ss_builder_close_panel_edit_text_block"),
            onConfirm: function() {
                return;
            }
        });
    };
    var handleCancelBrandSetting = (0,react.useCallback)(function() {
        if (isEditDataStatus) {
            es/* Modal.confirm */.u_.confirm({
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                    className: "w-11 h-11",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: t("ss_builder_cancel_edit_block_title")
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[15px] font-normal leading-[140%] text-textColorDefault text-center",
                    children: t("ss_builder_cancel_edit_block_content")
                }),
                confirmText: t("ss_builder_continue_edit_block_label"),
                cancelText: t("ss_builder_cancel_block_btn_label"),
                onConfirm: function() {
                    return;
                },
                onCancel: function() {
                    ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.SITE_SETTINGS */.Bt.SITE_SETTINGS, "SiteSettings_PersonalBrand_".concat(ga_events/* LABEL_CONFIG.CANCEL */.tW.CANCEL), ga_events/* LABEL_CONFIG.CANCEL */.tW.CANCEL, ga_events/* ACTION_CONFIG.PERSONAL_BRAND */.AN.PERSONAL_BRAND);
                    onCancelPersonalBrandSetting();
                }
            });
        } else {
            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.SITE_SETTINGS */.Bt.SITE_SETTINGS, "SiteSettings_PersonalBrand_".concat(ga_events/* LABEL_CONFIG.CANCEL */.tW.CANCEL), ga_events/* LABEL_CONFIG.CANCEL */.tW.CANCEL, ga_events/* ACTION_CONFIG.PERSONAL_BRAND */.AN.PERSONAL_BRAND);
            onCancelPersonalBrandSetting();
        }
    }, [
        isEditDataStatus
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative h-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-lg text-[#333333] font-normal flex text-center items-center gap-1 bg-white p-3 justify-center",
                style: {
                    boxShadow: "inset 0px -1px 0px #EEEEEE"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* AwardIcon */.M3, {
                        className: "inline-block"
                    }),
                    t("ss_builder_site_brand_setting_label")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 py-[13px] bg-white",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[15px] leading-[150%] text-[#666666]",
                                children: t("ss_builder_site_setting_favicon_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-[120px_auto] gap-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                                        src: valueUrlImage,
                                        fit: "cover",
                                        width: 120,
                                        height: 120,
                                        style: {
                                            borderRadius: "8px",
                                            maxWidth: "120px",
                                            maxHeight: "120px",
                                            backgroundColor: "#EEEEEE",
                                            border: "1px solid #EEEEEE"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-8 leading-4 text-[#8C8C8C] text-xs",
                                                children: t("ss_builder_site_setting_favicon_upload_description")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                        size: "middle",
                                                        color: valueUrlImage !== configs_const/* PASSIO_DEFAULT_ICON */.wO || valueUrlImage !== configs_const/* CREATOR_FOURTEEN_DEFAULT_ICON */.kH ? "primary" : "default",
                                                        fill: "solid",
                                                        className: "",
                                                        onClick: handleDeleteImage,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TrashIcon */.XH, {
                                                            className: "w-[17px] h-[17px]",
                                                            fillColor: valueUrlImage !== configs_const/* PASSIO_DEFAULT_ICON */.wO || valueUrlImage !== configs_const/* CREATOR_FOURTEEN_DEFAULT_ICON */.kH ? "#FFFFFF" : "#CCCCCC"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                                                        onChange: handleImageUrl,
                                                        upload: function(file) {
                                                            return (0,lib/* mockUpload */.Hq)(file, 256, 256, [], 2, true);
                                                        },
                                                        className: "flex-grow",
                                                        value: uploadedImageArr,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                            color: "primary",
                                                            fill: "solid",
                                                            size: "middle",
                                                            className: "w-full",
                                                            children: t("ss_builder_upload_button_label")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isValidFileFormat && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row gap-1 items-center mt-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                        fillColor: "#FF3141",
                                        className: "w-4 h-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#FF3141]",
                                        children: t("ss_builder_upload_file_format_invalid_content")
                                    })
                                ]
                            }),
                            isValidFileSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row gap-1 items-center mt-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                        fillColor: "#FF3141",
                                        className: "w-4 h-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#FF3141]",
                                        children: t("ss_builder_upload_file_size_invalid_content")
                                    })
                                ]
                            }),
                            isInvalidMinimumSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row gap-1 items-center mt-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                        fillColor: "#FF3141",
                                        className: "w-4 h-4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#FF3141]",
                                        children: t("ss_builder_upload_file_size_invalid_content_min_256")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                style: {
                                    marginTop: "12px",
                                    marginBottom: "12px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[15px] leading-[150%] text-[#666666]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    }),
                                    t("ss_builder_website_config_site_title_label")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-xs text-[#999999] leading-4 mb-1",
                                children: t("ss_builder_website_config_site_title_description")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                value: valueSiteTitle || "",
                                onChange: function(val) {
                                    if (val.length <= SITE_TITLE_MAX_LENGTH) setValueSiteTitle(val);
                                },
                                maxLength: SITE_TITLE_MAX_LENGTH,
                                placeholder: t("ss_builder_website_config_site_title_placeholder")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueSiteTitle ? valueSiteTitle.length : 0, "/").concat(SITE_TITLE_MAX_LENGTH)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                style: {
                                    marginTop: "12px",
                                    marginBottom: "12px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[15px] leading-[150%] text-[#666666]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    }),
                                    t("ss_builder_heading_site_setting_label")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-xs text-[#999999] leading-4 mb-1",
                                children: t("ss_builder_heading_site_setting_description")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                value: valueMetaTitle || "",
                                onChange: function(val) {
                                    if (val.length <= HEADING_MAX_LENGTH) setValueMetaTitle(val);
                                },
                                maxLength: HEADING_MAX_LENGTH,
                                placeholder: t("ss_builder_affiliate_product_btn_see_more_placeholder")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueMetaTitle ? valueMetaTitle.length : 0, "/").concat(HEADING_MAX_LENGTH)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                        style: {
                            marginTop: "12px",
                            marginBottom: "12px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-[15px] leading-[150%] text-[#666666]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-red-600",
                                        children: "*"
                                    }),
                                    t("ss_builder_subtitle_site_setting_label")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-xs text-[#999999] leading-4 mb-1",
                                children: t("ss_builder_subtitle_site_setting_description")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                value: valueMetaDescription || "",
                                onChange: function(val) {
                                    if (val.length <= SUBTITLE_MAX_LENGTH) setValueMetaDescription(val);
                                },
                                maxLength: SUBTITLE_MAX_LENGTH,
                                placeholder: t("ss_builder_affiliate_product_btn_see_more_placeholder"),
                                rows: 6
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                children: "".concat(valueMetaDescription ? valueMetaDescription.length : 0, "/").concat(SUBTITLE_MAX_LENGTH)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            onClick: handleCancelBrandSetting,
                            className: "adm-button adm-button-default adm-button-shape-default w-full",
                            children: t("ss_builder_close_panel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            color: "primary",
                            disabled: isDisableButtonSave,
                            className: "adm-button adm-button-primary adm-button-shape-default w-full",
                            onClick: function() {
                                return handleSaveSiteSetting();
                            },
                            children: t("ss_builder_save")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SiteSetting_PersonalBrandSetting = (PersonalBrandSetting);

;// CONCATENATED MODULE: ./src/features/setting/components/body/component/SettingTourOpening/SettingTour/index.tsx
function SettingTour_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function SettingTour_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                SettingTour_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                SettingTour_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}









var SettingTour = function(props) {
    var handleHideSettingTour = props.handleHideSettingTour;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var productTourRef = (0,react.useRef)(null);
    var setRef = function(ref) {
        productTourRef.current = ref;
    };
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var stepsDefault = setting_tour_config_steps.map(function(ele) {
        return {
            title: '<div class="wrapper-image">' + product_tour_icon/* placeHolderImageIcon */.GT + '\n        <img class="img-product-tour" src='.concat(ele.image_header, ' /> </div>\n        <div class="title">').concat(t(ele.title_key), "<div/>"),
            element: ele.using_selector ? document.querySelector(".".concat(ele.element_class)) : ".".concat(ele.element_class),
            intro: "<div> ".concat(t(ele.intro_key), "<div/>"),
            tooltipClass: "tooltip-product-tour ".concat(ele.tooltip_class),
            position: (ele === null || ele === void 0 ? void 0 : ele.position) || "auto"
        };
    });
    var onExit = function() {
        handleHideSettingTour();
    };
    var onBeforeExit = function(stepIndex) {};
    var onChangeProductTour = function() {
        var _ref = SettingTour_asyncToGenerator(runtime_default().mark(function _callee(nextStepIndex, nextElement) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        console.log("222");
                        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
                            data: {
                                isMarginSettingTour: nextStepIndex === setting_tour_config_STEP_INDEX.STEP_2
                            }
                        }));
                        if (nextStepIndex === setting_tour_config_STEP_INDEX.STEP_2) {
                            window.scrollTo(0, document.body.scrollHeight);
                        } else {
                            window.scrollTo({
                                top: 0
                            });
                        }
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onChangeProductTour(nextStepIndex, nextElement) {
            return _ref.apply(this, arguments);
        };
    }();
    var onCompleteProductTour = function() {};
    var onBeforeChange = function() {
        var _ref = SettingTour_asyncToGenerator(runtime_default().mark(function _callee(nextStepIndex, nextElement) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onBeforeChange(nextStepIndex, nextElement) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTourComponent/* default */.Z, {
        steps: stepsDefault,
        onExit: onExit,
        onBeforeExit: onBeforeExit,
        onChange: onChangeProductTour,
        onComplete: onCompleteProductTour,
        onBeforeChange: onBeforeChange,
        setRef: setRef
    });
};
/* harmony default export */ var SettingTourOpening_SettingTour = (SettingTour);

;// CONCATENATED MODULE: ./src/features/setting/components/body/component/SettingTourOpening/index.tsx
function SettingTourOpening_throw(e) {
    throw e;
}






var SettingTourOpening = function(param) {
    var param = param !== null ? param : SettingTourOpening_throw(new TypeError("Cannot destructure undefined"));
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(false), isOpenSettingTour = ref[0], setIsOpenSettingTour = ref[1];
    var popoverRef = (0,react.useRef)(null);
    var popoverManualRef = (0,react.useRef)(null);
    var handleHidePopoverManual = function() {
        popoverManualRef.current.hide();
    };
    var handleHideSettingTour = function() {
        setIsOpenSettingTour(false);
    };
    var contentPopoverManual = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-[320px] relative max-w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[32px] h-[32px] absolute p-1 right-2 top-2 cursor-pointer z-[3]",
                    onClick: function() {
                        return handleHidePopoverManual();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ClosePopupIconV2 */.gz, {
                        fillColor: "#fff"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://image.passio.eco/page-builder/page-builder/setting-tour/setting-tour-0.gif",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "p-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-2 text-lg leading-[25px] font-bold",
                            children: t("ss_builder_setting_popover_manual_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[15px] font-normal leading-[140%] text-textColorDefault mb-5",
                            children: t("ss_builder_setting_popover_manual_content")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            color: "primary",
                            size: "middle",
                            fill: "solid",
                            onClick: function() {
                                handleHidePopoverManual();
                                setIsOpenSettingTour(true);
                            },
                            block: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "flex items-center w-full justify-center gap-2 text-[17px]",
                                children: [
                                    t("ss_builder_popover_manual_button"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowRightIcon */.LZ, {
                                        fillColor: "#fff"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "user-manual",
                ref: popoverRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                    className: "popover-user-manual",
                    content: contentPopoverManual(),
                    placement: "bottom-end",
                    trigger: "click",
                    stopPropagation: [
                        "click"
                    ],
                    getContainer: function() {
                        return popoverRef.current;
                    },
                    ref: popoverManualRef,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* QuestionIcon */.UO, {
                            width: 20,
                            height: 20,
                            className: "cursor-pointer"
                        })
                    })
                })
            }),
            isOpenSettingTour && /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingTourOpening_SettingTour, {
                handleHideSettingTour: handleHideSettingTour
            })
        ]
    });
};
/* harmony default export */ var component_SettingTourOpening = (SettingTourOpening);

// EXTERNAL MODULE: ./src/features/setting/components/heading/index.module.scss
var index_module = __webpack_require__(35157);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/features/share/icons/solid-icon.tsx
var solid_icon = __webpack_require__(77105);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
;// CONCATENATED MODULE: ./src/features/setting/components/heading/index.tsx
function heading_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function heading_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return heading_arrayLikeToArray(arr);
}
function heading_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function heading_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function heading_toConsumableArray(arr) {
    return heading_arrayWithoutHoles(arr) || heading_iterableToArray(arr) || heading_unsupportedIterableToArray(arr) || heading_nonIterableSpread();
}
function heading_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return heading_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return heading_arrayLikeToArray(o, minLen);
}






















var Heading = function() {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var user = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state === null || state === void 0 ? void 0 : state.user;
    });
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var websiteConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.websiteConfig;
    });
    var urlFavicon = websiteConfig === null || websiteConfig === void 0 ? void 0 : websiteConfig.favicon;
    var metaTitle = websiteConfig === null || websiteConfig === void 0 ? void 0 : websiteConfig.meta_title;
    var metaDescription = websiteConfig === null || websiteConfig === void 0 ? void 0 : websiteConfig.meta_description;
    var kol = user === null || user === void 0 ? void 0 : user.kol;
    var domain1 = kol === null || kol === void 0 ? void 0 : kol.domain;
    var country = kol === null || kol === void 0 ? void 0 : kol.country;
    var package_type = (kol === null || kol === void 0 ? void 0 : kol.package_type) || null;
    var ref = (0,react.useState)(false), openSite = ref[0], setOpenSite = ref[1];
    var ref1 = (0,react.useState)(false), openFavicon = ref1[0], setOpenFavicon = ref1[1];
    var ref2 = (0,react.useState)(false), isOpenPopupUpgradeAccount = ref2[0], setIsOpenPopupUpgradeAccount = ref2[1];
    var ref3 = (0,react.useState)(package_type), packageType = ref3[0], setPackageType = ref3[1];
    var handleClickToLink = function(link) {
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.SETTINGS */.Bt.SETTINGS, "Settings_".concat((0,lib/* handleCapitalizeFirstLetter */.Tz)(ga_events/* ACTION_CONFIG.VIEW_SITE_IN_BROWSER */.AN.VIEW_SITE_IN_BROWSER)), domain1, ga_events/* ACTION_CONFIG.VIEW_SITE_IN_BROWSER */.AN.VIEW_SITE_IN_BROWSER);
        var castWindow = window;
        if (castWindow.flutter_inappwebview !== undefined) {
            var _flutter_inappwebview;
            var args = [
                {
                    url: "https://".concat(link)
                }
            ];
            (_flutter_inappwebview = castWindow.flutter_inappwebview).callHandler.apply(_flutter_inappwebview, [
                "openInBrowser"
            ].concat(heading_toConsumableArray(args)));
        } else {
            window.open("https://".concat(link), "_blank");
        }
    };
    var handleCopy = function(domain) {
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.SETTINGS */.Bt.SETTINGS, "Settings_".concat((0,lib/* handleCapitalizeFirstLetter */.Tz)(ga_events/* ACTION_CONFIG.COPY_DOMAIN */.AN.COPY_DOMAIN)), domain, ga_events/* ACTION_CONFIG.COPY_DOMAIN */.AN.COPY_DOMAIN);
        var castWindow = window;
        var text = "https://".concat(domain);
        var args2 = [
            {
                text: text
            }
        ];
        if (castWindow.flutter_inappwebview !== undefined) {
            var _flutter_inappwebview;
            (_flutter_inappwebview = castWindow.flutter_inappwebview).callHandler.apply(_flutter_inappwebview, [
                "copyToClipboard"
            ].concat(heading_toConsumableArray(args2)));
        } else {
            navigator === null || navigator === void 0 ? void 0 : navigator.clipboard.writeText("https://".concat(domain));
        }
    };
    var handleShare = function(url) {
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.SETTINGS */.Bt.SETTINGS, "Settings_".concat((0,lib/* handleCapitalizeFirstLetter */.Tz)(ga_events/* ACTION_CONFIG.SHARE_SITE */.AN.SHARE_SITE)), domain1, ga_events/* ACTION_CONFIG.SHARE_SITE */.AN.SHARE_SITE);
        var castWindow = window;
        var args2 = [
            {
                url: url
            }
        ];
        if (castWindow.flutter_inappwebview !== undefined) {
            var _flutter_inappwebview;
            (_flutter_inappwebview = castWindow.flutter_inappwebview).callHandler.apply(_flutter_inappwebview, [
                "share"
            ].concat(heading_toConsumableArray(args2)));
        } else if (!!(navigator === null || navigator === void 0 ? void 0 : navigator.share)) {
            navigator === null || navigator === void 0 ? void 0 : navigator.share({
                title: metaTitle,
                text: metaDescription,
                url: "https://".concat(domain1)
            });
        }
    };
    var handleClickFaviconIcon = function() {
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.SETTINGS */.Bt.SETTINGS, "Settings_".concat((0,lib/* handleCapitalizeFirstLetter */.Tz)(ga_events/* ACTION_CONFIG.FAVICON_ICON */.AN.FAVICON_ICON)), domain1, ga_events/* ACTION_CONFIG.FAVICON_ICON */.AN.FAVICON_ICON);
        setOpenFavicon(true);
    };
    var handleClickEditDomain = function() {
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.SETTINGS */.Bt.SETTINGS, "Settings_".concat((0,lib/* handleCapitalizeFirstLetter */.Tz)(ga_events/* ACTION_CONFIG.EDIT_DOMAIN */.AN.EDIT_DOMAIN)), domain1, ga_events/* ACTION_CONFIG.EDIT_DOMAIN */.AN.EDIT_DOMAIN);
        setOpenSite(true);
    };
    var listItemSwiper = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(solid_icon/* CrownIcon */.CE, {
                width: 20,
                height: 20
            }),
            title: t("ss_builder_swiper_setting_premium_title_1"),
            description: t("ss_builder_swiper_setting_premium_description_1")
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(solid_icon/* SwatchBookIcon */.n6, {
                width: 20,
                height: 20
            }),
            title: t("ss_builder_swiper_setting_premium_title_2")
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(solid_icon/* GlobeIcon */.n9, {
                width: 20,
                height: 20
            }),
            title: t("ss_builder_swiper_setting_premium_title_3")
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(solid_icon/* SoundIcon */.yI, {
                width: 20,
                height: 20
            }),
            title: t("ss_builder_swiper_setting_premium_title_4")
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(solid_icon/* CardAtmIcon */.Mi, {
                width: 20,
                height: 20
            }),
            title: t("ss_builder_swiper_setting_premium_title_5")
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(solid_icon/* DollarIcon */.te, {
                width: 20,
                height: 20
            }),
            title: t("ss_builder_swiper_setting_premium_title_6")
        }, 
    ];
    var pagination = {
        clickable: true
    };
    var handleOpenPopupUpgradeAccount = function(val) {
        if (val) {
            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.SETTINGS */.Bt.SETTINGS, "".concat(ga_events/* EVENT_CONFIG.SETTINGS */.f1.SETTINGS, "_").concat((0,lib/* handleCapitalizeFirstLetter */.Tz)(ga_events/* ACTION_CONFIG.SETTING_UPGRADE_PLAN */.AN.SETTING_UPGRADE_PLAN)), "", ga_events/* ACTION_CONFIG.SETTING_UPGRADE_PLAN */.AN.SETTING_UPGRADE_PLAN);
        }
        setIsOpenPopupUpgradeAccount(val);
    };
    var handleSetPackageType = function(val) {
        setPackageType(val);
    };
    (0,react.useEffect)(function() {
        handleSetPackageType(package_type);
    }, [
        isOpenPopupUpgradeAccount,
        package_type
    ]);
    var LabelSettingAccount = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((index_module_default()).labelSettingBox),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("flex w-full gap-3 items-center p-4", SETTING_TOUR_CLASS_NAME.STEP_1),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                            src: urlFavicon,
                            fit: "cover",
                            onClick: handleClickFaviconIcon,
                            style: {
                                "--width": "60px",
                                "--height": "60px",
                                borderRadius: 8
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex justify-between items-center w-full ".concat((index_module_default()).headerRight),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        packageType === configs_const/* PACKAGE_TYPE.PREMIUM */.uG.PREMIUM ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                            size: "mini",
                                            fill: "solid",
                                            className: "".concat((index_module_default()).crown),
                                            style: {
                                                "--border-color": "#FA8C16",
                                                "--background-color": "#FA8C16",
                                                "--text-color": "var(--adm-color-white)"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(solid_icon/* CrownPremiumIcon */.Bo, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "".concat((index_module_default()).btnTextSpan),
                                                    children: t("ss_builder_site_setting_premium")
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                            size: "mini",
                                            fill: "solid",
                                            className: "".concat((index_module_default()).crown),
                                            style: {
                                                "--border-color": "var(--adm-color-white)",
                                                "--background-color": "var(--adm-color-white)",
                                                "--text-color": "#595959"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(solid_icon/* CrownFreeIcon */.oS, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "".concat((index_module_default()).btnTextSpan),
                                                    children: t("ss_builder_site_setting_standard")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((index_module_default()).domain),
                                            children: domain1
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((index_module_default()).btnEditDomain),
                                    onClick: handleClickEditDomain,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(line_icon/* EditAltIcon */.CL, {
                                        width: 20,
                                        height: 20,
                                        fillColor: "#fff"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                packageType !== configs_const/* PACKAGE_TYPE.PREMIUM */.uG.PREMIUM && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((index_module_default()).wrapperPremium),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "swiperPremium ".concat((index_module_default()).swiperPremium),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                    modules: [
                                        swiper_esm/* Pagination */.tl
                                    ],
                                    pagination: pagination,
                                    children: listItemSwiper === null || listItemSwiper === void 0 ? void 0 : listItemSwiper.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((index_module_default()).itemSwiperPremium),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat((index_module_default()).icon),
                                                        children: item.icon
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat((index_module_default()).introItem),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat((index_module_default()).titleItem),
                                                                children: item.title
                                                            }),
                                                            item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat((index_module_default()).descriptionItem),
                                                                children: item.description
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        });
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((index_module_default()).btnUpgradeBox),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                    size: "mini",
                                    fill: "solid",
                                    className: "".concat((index_module_default()).btnUpgrade),
                                    onClick: function() {
                                        return handleOpenPopupUpgradeAccount(true);
                                    },
                                    style: {
                                        "--border-radius": "999px",
                                        "--background-color": "#FA8C16",
                                        "--border-color": "#FA8C16",
                                        "--text-color": "var(--adm-color-white)"
                                    },
                                    children: t("ss_builder_site_setting_upgrade")
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((index_module_default()).action),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cursor-pointer basis-1/3 ".concat((index_module_default()).actionItem),
                            onClick: function() {
                                handleCopy(domain1);
                                es/* Toast.show */.FN.show({
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                        className: "text-center inline-block w-[30px] h-[30px]",
                                        fillColor: "#00B578"
                                    }),
                                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-center",
                                        children: t("ss_builder_personal_link_coppy_successfully_label")
                                    })
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(line_icon/* CoppyAltIcon */.tO, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((index_module_default()).textAction),
                                    children: t("ss_builder_site_setting_coppy_label")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cursor-pointer basis-1/3 ".concat((index_module_default()).actionItem),
                            onClick: function() {
                                domain1 ? handleClickToLink(domain1) : null;
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(solid_icon/* GlobeIcon */.n9, {
                                    fillColor: "#333"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((index_module_default()).textAction),
                                    children: t("ss_builder_site_setting_browser_label")
                                })
                            ]
                        }),
                        typeof navigator != "undefined" && typeof (navigator === null || navigator === void 0 ? void 0 : navigator.share) === "function" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cursor-pointer basis-1/3 ".concat((index_module_default()).actionItem),
                            onClick: function() {
                                handleShare("https://".concat(domain1));
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(line_icon/* ShareIcon */.aA, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((index_module_default()).textAction),
                                    children: t("ss_builder_site_setting_share_label")
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var handleCancelPersonalBrandSetting = function() {
        setOpenFavicon(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            backgroundColor: "#FFFFFF"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-lg text-[#333333] font-normal flex text-center items-center gap-1 bg-white p-3 justify-center relative",
                style: {
                    borderBottom: "1px solid #EEEEEE",
                    padding: "12px 12px 10px 12px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SettingIcon */.qY, {
                        fillColor: "#333333"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            fontStyle: "18px"
                        },
                        children: t("ss_builder_settings_label")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-[50%] right-3 translate-y-[-50%]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(component_SettingTourOpening, {})
                    })
                ]
            }),
            country === configs_const/* COUNTRY_PH */.KP ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelSettingAccount, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("flex w-full pt-4 pb-3 px-1", SETTING_TOUR_CLASS_NAME.STEP_1),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                            src: urlFavicon,
                            fit: "cover",
                            style: {
                                borderRadius: "8px",
                                width: "64px",
                                height: "64px",
                                cursor: "pointer"
                            },
                            onClick: handleClickFaviconIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                marginLeft: "12px",
                                flexGrow: 1
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex ",
                                    style: {
                                        width: "100%",
                                        height: "28px",
                                        marginBottom: "8px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                width: "auto",
                                                height: "28px",
                                                background: "#F5F5F5",
                                                borderRadius: "4px",
                                                padding: "4px 12px",
                                                flexGrow: 1,
                                                fontSize: "16px",
                                                lineHeight: "1.3"
                                            },
                                            children: domain1
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                marginLeft: "12px",
                                                cursor: "pointer"
                                            },
                                            onClick: handleClickEditDomain,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* EditIconV2 */._H, {
                                                width: 28,
                                                height: 28
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            style: {
                                                cursor: "pointer"
                                            },
                                            onClick: function() {
                                                handleCopy(domain1);
                                                es/* Toast.show */.FN.show({
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                                        className: "text-center inline-block w-[30px] h-[30px]",
                                                        fillColor: "#00B578"
                                                    }),
                                                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-center",
                                                        children: t("ss_builder_personal_link_coppy_successfully_label")
                                                    })
                                                });
                                            },
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CopyIconV2 */.V7, {}),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                cursor: "pointer"
                                            },
                                            onClick: function() {
                                                domain1 ? handleClickToLink(domain1) : null;
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* OpenNewTab */.mw, {})
                                        }),
                                        typeof navigator != "undefined" && typeof (navigator === null || navigator === void 0 ? void 0 : navigator.share) === "function" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                cursor: "pointer"
                                            },
                                            onClick: function() {
                                                handleShare("https://".concat(domain1));
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ShareIconV2 */.AY, {})
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: openSite,
                onMaskClick: function() {
                    setOpenSite(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteSetting_PersonalDomainSetting, {
                    onCancelPersonalDomainSetting: function() {
                        return setOpenSite(false);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: openFavicon,
                onMaskClick: function() {
                    setOpenFavicon(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteSetting_PersonalBrandSetting, {
                    onCancelPersonalBrandSetting: handleCancelPersonalBrandSetting
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupFull, {
                visible: isOpenPopupUpgradeAccount,
                onMaskClick: function() {
                    return handleOpenPopupUpgradeAccount(false);
                },
                reduceMotionAnt: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UpgradeAccount, {
                    visble: isOpenPopupUpgradeAccount,
                    user: user,
                    onClose: function() {
                        return handleOpenPopupUpgradeAccount(false);
                    },
                    handleSetPackageType: function() {
                        return handleSetPackageType;
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var heading = (Heading);

;// CONCATENATED MODULE: ./src/features/setting/components/body/component/SiteSetting/index.tsx












var SiteSetting = function() {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(false), isOpenDomainSetting = ref[0], setIsOpenDomainSetting = ref[1];
    var ref1 = (0,react.useState)(false), isOpenBrandSetting = ref1[0], setIsOpenBrandSetting = ref1[1];
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var handleOpenBrandSetting = function() {
        setIsOpenBrandSetting(true);
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.SITE_SETTINGS */.Bt.SITE_SETTINGS, "SiteSettings_PersonalBrand_".concat(ga_events/* LABEL_CONFIG.CLICK_ON */.tW.CLICK_ON), ga_events/* LABEL_CONFIG.CLICK_ON */.tW.CLICK_ON, ga_events/* ACTION_CONFIG.PERSONAL_BRAND */.AN.PERSONAL_BRAND);
    };
    var handleOpenDomainSetting = function() {
        setIsOpenDomainSetting(true);
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.SITE_SETTINGS */.Bt.SITE_SETTINGS, "SiteSettings_Domain_".concat(ga_events/* LABEL_CONFIG.CLICK_ON */.tW.CLICK_ON), ga_events/* LABEL_CONFIG.CLICK_ON */.tW.CLICK_ON, ga_events/* ACTION_CONFIG.DOMAIN */.AN.DOMAIN);
    };
    var handleCancelPersonalBrandSetting = function(data) {
        setIsOpenBrandSetting(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("p-3 bg-[#fff] rounded-[4px] mb-3", SETTING_TOUR_CLASS_NAME.STEP_3),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    fontStyle: "normal",
                    fontWeight: "400",
                    fontSize: "16px",
                    lineHeight: "130%",
                    color: "#666666"
                },
                children: t("ss_builder_setup_site_setting")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    margin: "16px 0px 12px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: handleOpenBrandSetting,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* AwardIconV2 */.J7, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: " my-auto lead-2",
                                style: {
                                    marginLeft: "12px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "131%",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#333333"
                                },
                                children: t("ss_builder_site_brand_setting_label")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                        style: {
                            margin: "8px 0px 8px 56px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: handleOpenDomainSetting,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SiteIconV2 */.m6, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: " my-auto lead-2",
                                style: {
                                    marginLeft: "12px",
                                    fontStyle: "normal",
                                    fontWeight: 400,
                                    fontSize: "16px",
                                    lineHeight: "131%",
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#333333"
                                },
                                children: t("ss_builder_site_domain_setting_label")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenDomainSetting,
                onMaskClick: function() {
                    setIsOpenDomainSetting(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteSetting_PersonalDomainSetting, {
                    onCancelPersonalDomainSetting: function() {
                        return setIsOpenDomainSetting(false);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: isOpenBrandSetting,
                onMaskClick: function() {
                    setIsOpenBrandSetting(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteSetting_PersonalBrandSetting, {
                    onCancelPersonalBrandSetting: handleCancelPersonalBrandSetting
                })
            })
        ]
    });
};
/* harmony default export */ var component_SiteSetting = (SiteSetting);

;// CONCATENATED MODULE: ./src/features/setting/components/body/component/ThemeSetting/Item.tsx



var Item = function(props) {
    var Icon = props.Icon, title = props.title, onClick = props.onClick;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            onClick: onClick,
            className: "text-center item-center justify-center",
            style: {
                width: "76px",
                height: "68px",
                alignItems: "center",
                margin: "auto",
                cursor: "pointer"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginTop: "4px",
                        fontStyle: "normal",
                        fontWeight: "400",
                        fontSize: "13px",
                        lineHeight: "131%"
                    },
                    children: t(title)
                })
            ]
        })
    });
};
/* harmony default export */ var ThemeSetting_Item = (Item);

// EXTERNAL MODULE: ./src/features/setting/components/ThemeSetting/SettingHeader/index.tsx
var SettingHeader = __webpack_require__(95431);
// EXTERNAL MODULE: ./src/features/setting/hooks/index.tsx
var setting_hooks = __webpack_require__(12272);
// EXTERNAL MODULE: ./src/features/share/configs/rxjs.ts + 20 modules
var rxjs = __webpack_require__(18109);
// EXTERNAL MODULE: ./src/features/setting/components/ThemeSetting/ColorPicker/index.tsx + 218 modules
var ColorPicker = __webpack_require__(76034);
// EXTERNAL MODULE: ./src/features/share/components/DisplayColor/index.tsx
var DisplayColor = __webpack_require__(26340);
;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/GeneralSetting/components/PrimaryColor/index.tsx











var ColorIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "22",
                height: "22",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.80458 14.246C6.63385 14.4178 6.53802 14.6501 6.53802 14.8923C6.53802 15.1344 6.63385 15.3668 6.80458 15.5385C6.8898 15.6244 6.99118 15.6926 7.10289 15.7392C7.21459 15.7857 7.33441 15.8097 7.45542 15.8097C7.57643 15.8097 7.69624 15.7857 7.80795 15.7392C7.91965 15.6926 8.02104 15.6244 8.10625 15.5385C8.27698 15.3668 8.37281 15.1344 8.37281 14.8923C8.37281 14.6501 8.27698 14.4178 8.10625 14.246C8.02104 14.1601 7.91965 14.0919 7.80795 14.0454C7.69624 13.9988 7.57643 13.9749 7.45542 13.9749C7.33441 13.9749 7.21459 13.9988 7.10289 14.0454C6.99118 14.0919 6.8898 14.1601 6.80458 14.246ZM6.80458 6.4635C6.63385 6.63525 6.53802 6.86758 6.53802 7.10975C6.53802 7.35192 6.63385 7.58425 6.80458 7.756C6.8898 7.84192 6.99118 7.91011 7.10289 7.95665C7.21459 8.00319 7.33441 8.02715 7.45542 8.02715C7.57643 8.02715 7.69624 8.00319 7.80795 7.95665C7.91965 7.91011 8.02104 7.84192 8.10625 7.756C8.27698 7.58425 8.37281 7.35192 8.37281 7.10975C8.37281 6.86758 8.27698 6.63525 8.10625 6.4635C8.02104 6.37758 7.91965 6.30939 7.80795 6.26285C7.69624 6.21631 7.57643 6.19235 7.45542 6.19235C7.33441 6.19235 7.21459 6.21631 7.10289 6.26285C6.99118 6.30939 6.8898 6.37758 6.80458 6.4635ZM11.3421 15.6302C11.1608 15.6302 10.9836 15.6839 10.8328 15.7847C10.6821 15.8854 10.5646 16.0285 10.4952 16.196C10.4258 16.3635 10.4077 16.5479 10.443 16.7257C10.4784 16.9035 10.5657 17.0668 10.6939 17.195C10.8221 17.3232 10.9854 17.4105 11.1633 17.4459C11.3411 17.4813 11.5254 17.4631 11.6929 17.3937C11.8604 17.3243 12.0035 17.2069 12.1043 17.0561C12.205 16.9054 12.2587 16.7281 12.2587 16.5468C12.265 16.4227 12.2459 16.2985 12.2026 16.182C12.1593 16.0654 12.0928 15.9589 12.007 15.8688C11.9213 15.7788 11.8181 15.7071 11.7038 15.6582C11.5895 15.6093 11.4664 15.5842 11.3421 15.5843V15.6302ZM5.84208 10.1302C5.66078 10.1302 5.48356 10.1839 5.33281 10.2847C5.18207 10.3854 5.06457 10.5285 4.99519 10.696C4.92581 10.8635 4.90766 11.0479 4.94303 11.2257C4.9784 11.4035 5.06571 11.5668 5.1939 11.695C5.3221 11.8232 5.48544 11.9105 5.66325 11.9459C5.84107 11.9813 6.02538 11.9631 6.19288 11.8937C6.36038 11.8243 6.50354 11.7069 6.60426 11.5561C6.70499 11.4054 6.75875 11.2281 6.75875 11.0468C6.76497 10.9227 6.74586 10.7985 6.70258 10.6819C6.65931 10.5654 6.59277 10.4589 6.50702 10.3688C6.42128 10.2788 6.31811 10.2071 6.2038 10.1582C6.08948 10.1093 5.96642 10.0842 5.84208 10.0843V10.1302ZM11.3421 4.63017C11.1608 4.63017 10.9836 4.68393 10.8328 4.78465C10.6821 4.88538 10.5646 5.02854 10.4952 5.19604C10.4258 5.36354 10.4077 5.54785 10.443 5.72567C10.4784 5.90348 10.5657 6.06682 10.6939 6.19502C10.8221 6.32321 10.9854 6.41052 11.1633 6.44589C11.3411 6.48126 11.5254 6.4631 11.6929 6.39372C11.8604 6.32434 12.0035 6.20685 12.1043 6.05611C12.205 5.90536 12.2587 5.72813 12.2587 5.54684C12.265 5.42266 12.2459 5.29851 12.2026 5.18195C12.1593 5.06539 12.0928 4.95885 12.007 4.86882C11.9213 4.77878 11.8181 4.70713 11.7038 4.65823C11.5895 4.60932 11.4664 4.58418 11.3421 4.58434V4.63017ZM14.5871 6.50934C14.4583 6.63731 14.3705 6.80064 14.3347 6.9786C14.2989 7.15657 14.3167 7.34116 14.3859 7.50898C14.4551 7.67679 14.5726 7.82028 14.7235 7.92124C14.8744 8.02221 15.0518 8.07611 15.2333 8.07611C15.4149 8.07611 15.5923 8.02221 15.7432 7.92124C15.894 7.82028 16.0115 7.67679 16.0807 7.50898C16.15 7.34116 16.1678 7.15657 16.132 6.9786C16.0962 6.80064 16.0083 6.63731 15.8796 6.50934C15.714 6.33238 15.485 6.22821 15.2428 6.21962C15.0006 6.21103 14.7648 6.29872 14.5871 6.4635V6.50934ZM20.3621 6.50934C19.524 4.83394 18.2358 3.42514 16.6419 2.44089C15.048 1.45665 13.2114 0.935894 11.3381 0.937014C9.46474 0.938133 7.62878 1.46109 6.03604 2.44723C4.4433 3.43338 3.15676 4.84372 2.32069 6.52012C1.48462 8.19651 1.13209 10.0727 1.30261 11.9382C1.47313 13.8037 2.15997 15.5849 3.28611 17.0819C4.41225 18.579 5.93316 19.7327 7.6783 20.4137C9.42343 21.0948 11.3238 21.2762 13.1663 20.9377C13.6296 20.8505 14.0709 20.6718 14.4644 20.4121C14.8578 20.1524 15.1956 19.8169 15.4579 19.4252C15.7406 18.9993 15.9356 18.5214 16.0316 18.0193C16.1276 17.5173 16.1227 17.0011 16.0171 16.501C15.9594 16.1988 15.9287 15.892 15.9254 15.5843C15.9294 14.696 16.1915 13.8281 16.6797 13.086C17.1679 12.3439 17.8613 11.7596 18.6754 11.4043C19.1144 11.2078 19.5084 10.9234 19.8332 10.5686C20.158 10.2139 20.4066 9.79639 20.5638 9.34183C20.7227 8.87735 20.7868 8.38567 20.7521 7.89596C20.7175 7.40625 20.5848 6.92849 20.3621 6.491V6.50934ZM18.8038 8.746C18.7255 8.96538 18.6041 9.16683 18.4466 9.33845C18.2892 9.51008 18.0989 9.64837 17.8871 9.74517C16.7596 10.2499 15.8017 11.0693 15.1285 12.1051C14.4553 13.1409 14.0955 14.349 14.0921 15.5843C14.0934 16.0152 14.1364 16.445 14.2204 16.8677C14.2764 17.126 14.2801 17.3929 14.2313 17.6527C14.1825 17.9124 14.0822 18.1598 13.9362 18.3802C13.8128 18.573 13.6503 18.7379 13.4593 18.8642C13.2683 18.9905 13.0529 19.0754 12.8271 19.1135C12.3375 19.2055 11.8403 19.2515 11.3421 19.251C10.2367 19.2515 9.14256 19.0299 8.12452 18.5994C7.10647 18.1688 6.18533 17.5381 5.4158 16.7446C4.64626 15.9511 4.04403 15.0111 3.64485 13.9804C3.24567 12.9496 3.0577 11.8491 3.09208 10.7443C3.16323 8.68439 3.99867 6.72471 5.43566 5.24705C6.87265 3.76939 8.80826 2.87959 10.8654 2.751H11.3329C12.869 2.75139 14.3745 3.18063 15.6799 3.9904C16.9852 4.80016 18.0385 5.95828 18.7213 7.33434C18.9314 7.76973 18.961 8.27051 18.8038 8.72767V8.746ZM11.3421 10.0843C11.1608 10.0843 10.9836 10.1381 10.8328 10.2388C10.6821 10.3395 10.5646 10.4827 10.4952 10.6502C10.4258 10.8177 10.4077 11.002 10.443 11.1798C10.4784 11.3576 10.5657 11.521 10.6939 11.6492C10.8221 11.7774 10.9854 11.8647 11.1633 11.9001C11.3411 11.9354 11.5254 11.9173 11.6929 11.8479C11.8604 11.7785 12.0035 11.661 12.1043 11.5103C12.205 11.3595 12.2587 11.1823 12.2587 11.001C12.2587 10.7579 12.1622 10.5247 11.9903 10.3528C11.8184 10.1809 11.5852 10.0843 11.3421 10.0843Z",
                fill: "#333333"
            })
        ]
    });
};
var PrimaryColor = function(props) {
    var onUpdateColor = props.onUpdateColor, onUpdateSecondColor = props.onUpdateSecondColor;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var displaySettings = siteSettings && Object.values(siteSettings).length > 0 && siteSettings.display_setting;
    var _primary_color = displaySettings.primary_color, primary_color = _primary_color === void 0 ? configs_const/* GENERAL_SETTING_DEFAULT_VALUE.PRIMARY_COLOR */.yv.PRIMARY_COLOR : _primary_color, _second_color = displaySettings.second_color, second_color = _second_color === void 0 ? configs_const/* GENERAL_SETTING_DEFAULT_VALUE.SECONDARY_COLOR */.yv.SECONDARY_COLOR : _second_color;
    var ref = (0,react.useState)(primary_color), mainColorState = ref[0], setMainColorState = ref[1];
    var ref1 = (0,react.useState)(second_color), secondColorState = ref1[0], setSecondColorState = ref1[1];
    var ref2 = (0,react.useState)(false), isOpenColorPicker = ref2[0], setIsOpenColorPicker = ref2[1];
    var ref3 = (0,react.useState)(false), isOpenSecondColorPicker = ref3[0], setIsOpenSecondColorPicker = ref3[1];
    (0,react.useEffect)(function() {
        var subscription = rxjs/* dataService.getObservable */.c.getObservable().subscribe(function(data) {
            if (data) {
                var selectedMainColor = data.selectedMainColor;
                if (selectedMainColor) {
                    setMainColorState(selectedMainColor);
                }
            }
        });
        return function() {
            return subscription.unsubscribe();
        };
    }, []);
    (0,react.useEffect)(function() {
        onUpdateColor(mainColorState);
    }, [
        mainColorState
    ]);
    (0,react.useEffect)(function() {
        onUpdateSecondColor(secondColorState);
    }, [
        secondColorState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Collapse */.UO, {
                    defaultActiveKey: [
                        "1"
                    ],
                    arrow: function(active) {
                        return active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DropDownIcon1 */.yu, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DropDownIcon2 */.oS, {});
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Collapse.Panel */.UO.Panel, {
                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "mr-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorIcon, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("ss_builder_theme_setting_primary_color")
                                    })
                                ]
                            })
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex mb-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mr-3 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "m-auto mb-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayColor/* default */.Z, {
                                                backgroundColor: mainColorState,
                                                onClickOpenColorPicker: setIsOpenColorPicker
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm mb-4 text-black",
                                            children: t("ss_builder_block_main_color")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mr-3 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "m-auto mb-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayColor/* default */.Z, {
                                                backgroundColor: secondColorState,
                                                onClickOpenColorPicker: setIsOpenSecondColorPicker
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm mb-4 text-black",
                                            children: t("ss_builder_block_second_color")
                                        })
                                    ]
                                })
                            ]
                        })
                    }, "1")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenColorPicker,
                onMaskClick: function() {
                    return setIsOpenColorPicker(false);
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return setIsOpenColorPicker(false);
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPickerV2 */._, {
                    defaultColor: mainColorState,
                    onCancel: function() {
                        return setIsOpenColorPicker(false);
                    },
                    onColorSelected: function(data) {
                        return setMainColorState(data);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenSecondColorPicker,
                onMaskClick: function() {
                    return setIsOpenSecondColorPicker(false);
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return setIsOpenSecondColorPicker(false);
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPickerV2 */._, {
                    defaultColor: secondColorState,
                    onCancel: function() {
                        return setIsOpenSecondColorPicker(false);
                    },
                    onColorSelected: function(data) {
                        return setSecondColorState(data);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var components_PrimaryColor = (PrimaryColor);

// EXTERNAL MODULE: ./src/features/share/lib/generateColor.ts
var generateColor = __webpack_require__(31753);
;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/GeneralSetting/index.tsx
function GeneralSetting_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function GeneralSetting_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return GeneralSetting_arrayLikeToArray(arr);
}
function GeneralSetting_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function GeneralSetting_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function GeneralSetting_toConsumableArray(arr) {
    return GeneralSetting_arrayWithoutHoles(arr) || GeneralSetting_iterableToArray(arr) || GeneralSetting_unsupportedIterableToArray(arr) || GeneralSetting_nonIterableSpread();
}
function GeneralSetting_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return GeneralSetting_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return GeneralSetting_arrayLikeToArray(o, minLen);
}















var HeaderIcon = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: className,
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                width: "22",
                height: "22",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.4193 3.66772H4.58594C3.85659 3.66772 3.15712 3.95746 2.64139 4.47318C2.12567 4.98891 1.83594 5.68838 1.83594 6.41772V15.5844C1.83594 16.3137 2.12567 17.0132 2.64139 17.5289C3.15712 18.0447 3.85659 18.3344 4.58594 18.3344H17.4193C18.1486 18.3344 18.8481 18.0447 19.3638 17.5289C19.8795 17.0132 20.1693 16.3137 20.1693 15.5844V6.41772C20.1693 5.68838 19.8795 4.98891 19.3638 4.47318C18.8481 3.95746 18.1486 3.66772 17.4193 3.66772ZM4.58594 16.5011C4.34282 16.5011 4.10966 16.4045 3.93776 16.2326C3.76585 16.0607 3.66927 15.8275 3.66927 15.5844V13.3661L6.69427 10.3502C6.86562 10.1823 7.096 10.0882 7.33594 10.0882C7.57588 10.0882 7.80625 10.1823 7.9776 10.3502L14.1284 16.5011H4.58594ZM18.3359 15.5844C18.3359 15.8275 18.2394 16.0607 18.0675 16.2326C17.8955 16.4045 17.6624 16.5011 17.4193 16.5011H16.7134L13.2209 12.9902L14.0276 12.1836C14.199 12.0156 14.4293 11.9215 14.6693 11.9215C14.9092 11.9215 15.1396 12.0156 15.3109 12.1836L18.3359 15.1994V15.5844ZM18.3359 12.6144L16.6126 10.9002C16.0902 10.3983 15.3938 10.118 14.6693 10.118C13.9448 10.118 13.2484 10.3983 12.7259 10.9002L11.9193 11.7069L9.27927 9.06689C8.75682 8.56496 8.06043 8.28463 7.33594 8.28463C6.61144 8.28463 5.91505 8.56496 5.3926 9.06689L3.66927 10.7811V6.41772C3.66927 6.17461 3.76585 5.94145 3.93776 5.76954C4.10966 5.59764 4.34282 5.50106 4.58594 5.50106H17.4193C17.6624 5.50106 17.8955 5.59764 18.0675 5.76954C18.2394 5.94145 18.3359 6.17461 18.3359 6.41772V12.6144Z",
                fill: "#333333"
            })
        ]
    });
};
var GeneralSetting = function(props) {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var SuccessToast = (0,toast/* useToast */.p)().SuccessToast;
    var backToAllSetting = props.backToAllSetting, type = props.type;
    var defaultMainColor = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref, ref6;
        return state === null || state === void 0 ? void 0 : (ref = state.siteSettings) === null || ref === void 0 ? void 0 : (ref6 = ref.display_setting) === null || ref6 === void 0 ? void 0 : ref6.primary_color;
    });
    var defaultSecondColor = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref, ref8;
        return state === null || state === void 0 ? void 0 : (ref = state.siteSettings) === null || ref === void 0 ? void 0 : (ref8 = ref.display_setting) === null || ref8 === void 0 ? void 0 : ref8.second_color;
    });
    var ref7 = (0,react.useState)(defaultMainColor || configs_const/* GENERAL_SETTING_DEFAULT_VALUE.PRIMARY_COLOR */.yv.PRIMARY_COLOR), primaryColor = ref7[0], setMainColor = ref7[1];
    var ref1 = (0,react.useState)(defaultSecondColor || configs_const/* GENERAL_SETTING_DEFAULT_VALUE.SECONDARY_COLOR */.yv.SECONDARY_COLOR), secondColor = ref1[0], setSecondColor = ref1[1];
    var defaultSiteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.siteSettings) === null || ref === void 0 ? void 0 : ref.display_setting;
    });
    //generate Primary color
    var COLOR_LENGTH_DEFAULT = 9;
    var opacityPrimaryColor = primaryColor.length == COLOR_LENGTH_DEFAULT ? primaryColor.slice(-2) : "";
    var parseColorValuesPrimary = generateColor/* parseColorValues */.Yu(primaryColor);
    var ref2;
    var calculateShadesPrimary = generateColor/* calculateShades */.ZN((ref2 = parseColorValuesPrimary[0]) !== null && ref2 !== void 0 ? ref2 : primaryColor.replace("#", ""));
    var ref3;
    var calculateTintsPrimary = generateColor/* calculateTints */.SC((ref3 = parseColorValuesPrimary[0]) !== null && ref3 !== void 0 ? ref3 : primaryColor.replace("#", ""));
    var calculateShadesAndTintsPrimary = GeneralSetting_toConsumableArray(calculateTintsPrimary.reverse()).concat(GeneralSetting_toConsumableArray(calculateShadesPrimary));
    var primaryColorGenerate = (0,react.useMemo)(function() {
        var primaryColorObj = {};
        calculateShadesAndTintsPrimary.forEach(function(ele, index) {
            primaryColorObj["primary-".concat(index + 1)] = ele + opacityPrimaryColor;
        });
        return primaryColorObj;
    }, [
        calculateShadesAndTintsPrimary
    ]);
    //generate secondary color
    var opacitySecondColor = secondColor.length == COLOR_LENGTH_DEFAULT ? secondColor.slice(-2) : "";
    var parseColorValuesSecond = generateColor/* parseColorValues */.Yu(secondColor);
    var ref4;
    var calculateShadesSecond = generateColor/* calculateShades */.ZN((ref4 = parseColorValuesSecond[0]) !== null && ref4 !== void 0 ? ref4 : secondColor.replace("#", ""));
    var ref5;
    var calculateTintsSecond = generateColor/* calculateTints */.SC((ref5 = parseColorValuesSecond[0]) !== null && ref5 !== void 0 ? ref5 : secondColor.replace("#", ""));
    var calculateShadesAndTintsSecond = GeneralSetting_toConsumableArray(calculateTintsSecond.reverse()).concat(GeneralSetting_toConsumableArray(calculateShadesSecond));
    var secondaryColorGenerate = (0,react.useMemo)(function() {
        var secondaryColorObj = {};
        calculateShadesAndTintsSecond.forEach(function(ele, index) {
            secondaryColorObj["secondary-".concat(index + 1)] = ele + opacitySecondColor;
        });
        return secondaryColorObj;
    }, [
        calculateShadesAndTintsSecond
    ]);
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var handleSave = function() {
        dispatch((0,thunk/* saveColor */.vV)(primaryColor, secondColor, primaryColorGenerate, secondaryColorGenerate));
        backToAllSetting();
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.THEME_SETTINGS */.Bt.THEME_SETTINGS, "ThemeSettings_".concat((0,lib/* handleCapitalizeFirstLetter */.Tz)(type), "_").concat(ga_events/* LABEL_CONFIG.EDIT */.tW.EDIT), ga_events/* LABEL_CONFIG.EDIT */.tW.EDIT, (0,lib/* handleCapitalizeFirstLetter */.Tz)(type));
        SuccessToast(t("ss_builder_save_succesfully_label"));
    };
    var hasChange = (0,setting_hooks/* useHasChange */.wJ)([
        primaryColor,
        secondColor
    ]);
    var onCancel = (0,setting_hooks/* useOnCancel */.RI)(hasChange, backToAllSetting, type);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingHeader/* default */.Z, {
                        title: t("ss_builder_general_setting_title"),
                        Icon: HeaderIcon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PrimaryColor, {
                            onUpdateSecondColor: setSecondColor,
                            onUpdateColor: function(data) {
                                return setMainColor(data);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            onClick: onCancel,
                            className: "adm-button adm-button-default adm-button-shape-default w-full",
                            children: t("ss_builder_close_panel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            disabled: !hasChange,
                            color: "primary",
                            className: "adm-button adm-button-primary adm-button-shape-default w-full",
                            onClick: handleSave,
                            children: t("ss_builder_save")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ThemeSetting_GeneralSetting = (GeneralSetting);

// EXTERNAL MODULE: ./src/features/setting/components/ThemeSetting/BlockSetting/index.tsx + 2 modules
var BlockSetting = __webpack_require__(42458);
;// CONCATENATED MODULE: ./src/features/share/thunk/setting/index.ts
function setting_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function setting_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                setting_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                setting_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function setting_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function setting_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            setting_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var saveBackgroundSetting = function(data, meta) {
    return function() {
        var _ref = setting_asyncToGenerator(runtime_default().mark(function _callee(dispatch, getState) {
            var currentState, siteSettings, image, responseImage, dataResquestUploadImage, newData, displaySettings;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        currentState = getState();
                        siteSettings = currentState.siteSettings;
                        image = data.image;
                        responseImage = null;
                        if (!data.base64_image) {
                            _ctx.next = 16;
                            break;
                        }
                        dataResquestUploadImage = {
                            id: siteSettings.id,
                            user_id: siteSettings.user_id,
                            name: data.image_name,
                            content: data.base64_image
                        };
                        _ctx.prev = 6;
                        _ctx.next = 9;
                        return (0,api/* requestUploadImage */.MR)(dataResquestUploadImage);
                    case 9:
                        responseImage = _ctx.sent;
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](6);
                        console.log(_ctx.t0);
                    case 15:
                        if (responseImage) image = responseImage.url;
                    case 16:
                        newData = {
                            color: data.color,
                            gradient: data.gradient,
                            image: image,
                            type: data.type,
                            blur: data.blur,
                            enable_overlay: data.enable_overlay,
                            overlay_color: data.overlay_color,
                            color_type: data.color_type
                        };
                        displaySettings = setting_objectSpread({}, siteSettings.display_setting, {
                            background: newData,
                            meta_data: meta
                        });
                        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
                            data: {
                                isSaving: true
                            }
                        }));
                        dispatch((0,siteSettingSlice/* setDisplaySetting */.H9)({
                            data: displaySettings
                        }));
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    6,
                    12
                ]
            ]);
        // dispatch(saveSite(true));
        }));
        return function(dispatch, getState) {
            return _ref.apply(this, arguments);
        };
    }();
};
var updateMetaDataSetting = function(meta) {
    return function(dispatch, getState) {
        var currentState = getState();
        var siteSettings = currentState.siteSettings;
        var displaySettings = setting_objectSpread({}, siteSettings.display_setting, {
            meta_data: meta
        });
        dispatch(setDisplaySetting(displaySettings));
    };
};
var saveThemeTitleSetting = function(data) {
    var headingColorGenerate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function(dispatch, getState) {
        var currentState = getState();
        var siteSettings = currentState.siteSettings;
        var displaySettings = setting_objectSpread({}, siteSettings.display_setting, {
            title_setting: data,
            heading_color_generate: headingColorGenerate
        });
        dispatch((0,siteSettingSlice/* setDisplaySetting */.H9)({
            data: displaySettings
        }));
    // dispatch(saveSite());
    };
};
var saveThemeParagraphSetting = function(data) {
    var textColorGenerate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return function(dispatch, getState) {
        var currentState = getState();
        var siteSettings = currentState.siteSettings;
        var displaySettings = setting_objectSpread({}, siteSettings.display_setting, {
            paragraph_setting: data,
            text_color_generate: textColorGenerate
        });
        dispatch((0,siteSettingSlice/* setDisplaySetting */.H9)({
            data: displaySettings
        }));
    // dispatch(saveSite());
    };
};
var saveButtonThemeSetting = function(data) {
    return function(dispatch, getState) {
        var currentState = getState();
        var siteSettings = currentState.siteSettings;
        var displaySettings = setting_objectSpread({}, siteSettings.display_setting, {
            button_setting: data
        });
        dispatch((0,siteSettingSlice/* setDisplaySetting */.H9)({
            data: displaySettings
        }));
    // dispatch(saveSite());
    };
};

;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/CommonFontSelector/index.tsx
function CommonFontSelector_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CommonFontSelector_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CommonFontSelector_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var COMMON_FONT_FAMILYS = configs_const/* FONT_OPTIONS.slice */.qD.slice(0, 6);
function CommonFontSelector(props) {
    var selectedValue = props.selectedValue, onSelect = props.onSelect;
    var fontOptions = COMMON_FONT_FAMILYS.map(function(item) {
        return CommonFontSelector_objectSpread({}, item, {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    fontFamily: item.value
                },
                children: item.label
            })
        });
    });
    var onChangeOption = function(vals) {
        if (vals.length) {
            onSelect(vals[0]);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
        columns: 2,
        options: fontOptions,
        value: [
            selectedValue
        ],
        onChange: onChangeOption,
        style: {
            "--border": "solid transparent 1px",
            "--checked-border": "solid var(--adm-color-primary) 1px",
            "--checked-color": "#FFFFFF"
        }
    });
};

// EXTERNAL MODULE: ./src/features/share/components/ButtonConfirmPopup/index.tsx
var ButtonConfirmPopup = __webpack_require__(85558);
;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/FontOption/index.tsx









var FontOption = function(props) {
    var callbackCancelFontOption = props.callbackCancelFontOption;
    var t = useTranslation().t;
    var dispatch = useAppDispatch();
    var siteSettings = useAppSelector(function(state) {
        return state.siteSettings;
    });
    var displaySettings = siteSettings && Object.values(siteSettings).length > 0 && siteSettings.display_setting;
    var font_family = displaySettings.font_family;
    var ref = useState(""), selectedFont = ref[0], setSelectedFont = ref[1];
    var handleCancleFontOption = function() {
        // dataService.publish({
        //   isOpenFontOption: false,
        // });
        callbackCancelFontOption();
    };
    var handleSelectFontFamily = function() {
        handleCancleFontOption();
        dataService.publish({
            fontFamily: selectedFont
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "panel-header h-[40px] px-[8px] py-[6px] flex flex-row items-center text-center",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "grow-0 text-specialColorDefault p-1 cursor-pointer",
                        onClick: handleCancleFontOption,
                        children: t("ss_builder_close_panel")
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "grow p-1 text-[15px]",
                        children: t("ss_builder_font_option_panel_title")
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: cls("grow-0 p-1 cursor-pointer", selectedFont ? "text-specialColorDefault" : "text-[#8C8C8C]"),
                        onClick: selectedFont ? handleSelectFontFamily : function() {},
                        children: t("ss_builder_confirm_panel")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SearchBar, {
                placeholder: t("ss_builder_panel_search_label"),
                className: "pt-0 pb-3 px-3",
                // onFocus={onFocus}
                style: {
                    borderColor: "red"
                }
            }),
            /*#__PURE__*/ _jsx(CheckList, {
                value: [
                    selectedFont
                ],
                style: {
                    overflowY: "scroll",
                    height: "500px"
                },
                onChange: function(val) {
                    return setSelectedFont(val[0]);
                },
                children: FONT_OPTIONS.map(function(ele, index) {
                    return /*#__PURE__*/ _jsx(CheckList.Item, {
                        value: ele.value,
                        children: ele.label
                    }, index);
                })
            })
        ]
    });
};
function FontOptionV2(props) {
    var callbackCancelFontOption = props.callbackCancelFontOption, onSelectFont = props.onSelectFont, selectedValue = props.selectedValue;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(selectedValue), selectedFont = ref[0], setSelectedFont = ref[1];
    var handleCancelFontOption = function() {
        callbackCancelFontOption();
    };
    var handleSelectFontFamily = function() {
        onSelectFont(selectedFont);
        handleCancelFontOption();
    };
    (0,react.useEffect)(function() {
        var selector = selectedFont.replaceAll(" ", "-");
        var timer = setTimeout(function() {
            var element = document.getElementsByClassName(selector);
            if (element[0]) {
                element[0].scrollIntoView();
            }
        }, 100);
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* CheckList */.Su, {
                value: [
                    selectedFont
                ],
                style: {
                    overflowY: "scroll",
                    height: "500px"
                },
                onChange: function(val) {
                    return val[0] ? setSelectedFont(val[0]) : {};
                },
                children: configs_const/* FONT_OPTIONS.map */.qD.map(function(ele, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* CheckList.Item */.Su.Item, {
                        style: {
                            fontFamily: ele.value
                        },
                        value: ele.value,
                        className: ele.value.replaceAll(" ", "-"),
                        children: ele.label
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonConfirmPopup/* default */.Z, {
                onConfirm: handleSelectFontFamily
            })
        ]
    });
}
/* harmony default export */ var ThemeSetting_FontOption = ((/* unused pure expression or super */ null && (FontOption)));

;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/ScaleSelector/index.tsx





var SCALE_OPTIONS = [
    [
        {
            value: "1.067",
            label: "1.067 - Minor Second"
        },
        {
            value: "1.125",
            label: "1.125 - Major Second"
        },
        {
            value: "1.200",
            label: "1.200 - Minor Third"
        },
        {
            value: "1.250",
            label: "1.250 - Major Third"
        },
        {
            value: "1.333",
            label: "1.333 - Perfect Fourth"
        },
        {
            value: "1.414",
            label: "1.414 - Augmented Fourth"
        },
        {
            value: "1.500",
            label: "1.500 - Perfect Fifth"
        },
        {
            value: "1.618",
            label: "1.618 - Golden Ratio"
        }, 
    ], 
];
function ScaleSeletor(props) {
    var onClose = props.onClose, onSelect = props.onSelect, value = props.value, visible = props.visible;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Picker */.cW, {
        style: {
            width: "100%"
        },
        title: t("ss_builder_select_ratio_title"),
        popupClassName: "eco-popup",
        className: "eco-picker rounded-tl-lg rounded-tr-lg",
        columns: SCALE_OPTIONS,
        visible: visible,
        onClose: function() {
            onClose();
        },
        cancelText: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ClosePopupIcon */.Hn, {}),
        confirmText: t("ss_builder_confirm_panel"),
        value: [
            value
        ],
        onConfirm: function(v) {
            onSelect(v[0]);
            onClose();
        }
    });
};

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/TitleSetting/components/Preview/index.tsx
function Preview_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Preview_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Preview_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









function Preview_Preview(param) {
    var titleSettingData = param.titleSettingData, background = param.background, blockSetting = param.blockSetting;
    var BACKGROUND_TYPE_IMAGE = "image";
    var BACKGROUND_TYPE_SOLID = "solid";
    var BACKGROUND_TYPE_GRADENT = "gradient";
    var BACKGROUND_TYPE_COLOR = "color";
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var isFontLoading = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref;
        return (state === null || state === void 0 ? void 0 : (ref = state.externalState) === null || ref === void 0 ? void 0 : ref.is_font_loading) || false;
    });
    var ref8 = (0,react.useState)(false), isExpand = ref8[0], setIsExpand = ref8[1];
    var ref1 = titleSettingData || {}, _font_family_preview = ref1.font_family_preview, font_family_preview = _font_family_preview === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_FAMILY */.lI.FONT_FAMILY : _font_family_preview, _font_color = ref1.font_color, font_color = _font_color === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_COLOR */.lI.FONT_COLOR : _font_color, _scale = ref1.scale, scale = _scale === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_SCALE */.lI.FONT_SCALE : _scale, _font_size = ref1.font_size, font_size = _font_size === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_SIZE */.lI.FONT_SIZE : _font_size, _font_weight = ref1.font_weight, font_weight = _font_weight === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.lI.FONT_WEIGHT : _font_weight, _line_height = ref1.line_height, line_height = _line_height === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.lI.LINE_HEIGHT : _line_height, _using_font_custom = ref1.using_font_custom, using_font_custom = _using_font_custom === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.USING_FONT_CUSTOM */.lI.USING_FONT_CUSTOM : _using_font_custom, _font_family_custom = ref1.font_family_custom, font_family_custom = _font_family_custom === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_FAMILY_CUSTOM */.lI.FONT_FAMILY_CUSTOM : _font_family_custom;
    var fontSizeH1 = font_size * scale * scale * scale * scale * scale;
    var fontSizeH2 = font_size * scale * scale * scale * scale;
    var fontSizeH3 = font_size * scale * scale * scale;
    var fontSizeH4 = font_size * scale * scale;
    var fontSizeH5 = font_size * scale;
    var fontSizeH6 = font_size;
    var fontSizeH7 = font_size / scale;
    var fontSizeArr = [
        fontSizeH1,
        fontSizeH2,
        fontSizeH3,
        fontSizeH4,
        fontSizeH5,
        fontSizeH6,
        fontSizeH7, 
    ];
    var ref2 = background || {}, type = ref2.type, color = ref2.color, gradient = ref2.gradient, image = ref2.image, enable_overlay = ref2.enable_overlay, overlay_color = ref2.overlay_color, tmp = ref2.blur, blurBackgroundSetting = tmp === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.BLUR */.Vw.BLUR : tmp;
    var ref3 = blockSetting || {}, block_style = ref3.block_style, block_background = ref3.block_background, block_border = ref3.block_border, block_shadow = ref3.block_shadow;
    var ref4 = block_style || {}, _radius_type = ref4.radius_type, radius_type = _radius_type === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_STYLE */.eJ.BLOCK_STYLE : _radius_type, _radius_value = ref4.radius_value, radius_value = _radius_value === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_RADIUS */.eJ.BORDER_RADIUS : _radius_value, _inner_space = ref4.inner_space, inner_space = _inner_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE */.eJ.INNER_SPACE : _inner_space, _inner_space_number = ref4.inner_space_number, inner_space_number = _inner_space_number === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */.eJ.INNER_SPACE_NUMBER : _inner_space_number, _outside_space = ref4.outside_space, outside_space = _outside_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE */.eJ.OUTSIDE_SPACE : _outside_space;
    var ref5 = block_background || {}, tmp1 = ref5.color, blockBackgroundColor = tmp1 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_COLOR */.eJ.BACKGROUND_COLOR : tmp1, _blur = ref5.blur, blur = _blur === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_BLUR */.eJ.BACKGROUND_BLUR : _blur;
    var ref6 = block_border || {}, tmp2 = ref6.enable, borderEnable = tmp2 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_ENABLE */.eJ.BORDER_ENABLE : tmp2, _border_width = ref6.border_width, border_width = _border_width === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_WIDTH */.eJ.BORDER_WIDTH : _border_width, tmp3 = ref6.color, borderColor = tmp3 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_COLOR */.eJ.BORDER_COLOR : tmp3, tmp4 = ref6.type, borderType = tmp4 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_STYLE */.eJ.BORDER_STYLE : tmp4;
    var ref7 = block_shadow || {}, tmp5 = ref7.enable, shadowEnable = tmp5 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.SHADOW_ENABLE */.eJ.SHADOW_ENABLE : tmp5, tmp6 = ref7.color, shadowColor = tmp6 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.SHADOW_COLOR */.eJ.SHADOW_COLOR : tmp6;
    var boxShadowStyle = shadowEnable === true ? {
        boxShadow: "0px 4px 4px " + shadowColor
    } : {};
    var borderRadiusValue = (0,react.useMemo)(function() {
        var value = "0px";
        if (radius_type === "rounded") {
            value = "8px";
        } else if (radius_type === "custom") {
            value = "".concat(radius_value, "px");
        }
        return value;
    }, [
        radius_type,
        radius_value
    ]);
    var styleBorder = borderEnable === true ? {
        borderWidth: border_width + "px",
        borderStyle: borderType,
        borderColor: borderColor
    } : {
        border: "none"
    };
    var styleBackgroundImage = type === BACKGROUND_TYPE_IMAGE ? {
        backgroundPosition: "center center",
        filter: "blur(".concat(blurBackgroundSetting, "px) "),
        WebkitFilter: "blur(".concat(blurBackgroundSetting, "px) "),
        width: "calc(100% + ".concat(blurBackgroundSetting * 2, "px) "),
        height: "calc(100% + ".concat(blurBackgroundSetting * 2, "px) "),
        transform: "translate(-".concat(blurBackgroundSetting, "px, -").concat(blurBackgroundSetting, "px)")
    } : "";
    var checkStyleBackgroundImage = function() {
        switch(type){
            case BACKGROUND_TYPE_IMAGE:
                return 'url("'.concat(image, '")');
            case BACKGROUND_TYPE_GRADENT:
                return gradient;
            default:
                return "";
        }
    };
    var innerSpaceNumber = typeof inner_space_number === "number" ? "".concat(inner_space_number, "px") : inner_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */.eJ.INNER_SPACE_NUMBER, "px") : 0;
    var styleOutsideSpace = outside_space ? {
        marginLeft: "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px"),
        marginRight: "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px"),
        width: "calc(100% - ".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER * 2, "px) ")
    } : "";
    var setHeightPreview = function() {
        setIsExpand(!isExpand);
    };
    var fontLinkArr = (0,react.useMemo)(function() {
        return configs_const/* FONT_OPTIONS.filter */.qD.filter(function(x) {
            return (x === null || x === void 0 ? void 0 : x.value) !== font_family_preview;
        });
    }, [
        font_family_preview
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: fontLinkArr === null || fontLinkArr === void 0 ? void 0 : fontLinkArr.map(function(font) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            href: "".concat(configs_const/* GG_FONT_URI */.s0, "?family=").concat(font.value.replace(/\s+/g, "+")),
                            rel: "stylesheet"
                        })
                    }, font.value);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-2 bg-white ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-3 p-3 w-full h-full relative overflow-hidden",
                    children: [
                        type === BACKGROUND_TYPE_IMAGE && enable_overlay === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute top-0 left-[50%] translate-x-[-50%] block w-full h-full z-[1]",
                            style: {
                                backgroundColor: overlay_color
                            }
                        }) : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute top-0 left-0 w-full h-full bg-cover bg-no-repeat object-cover",
                            style: Preview_objectSpread({
                                backgroundColor: type === BACKGROUND_TYPE_SOLID || type === BACKGROUND_TYPE_COLOR ? color : "",
                                backgroundImage: "".concat(checkStyleBackgroundImage()),
                                borderBottom: "1px solid var(--adm-color-border)"
                            }, styleBackgroundImage)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative z-[3]",
                            style: Preview_objectSpread({}, styleOutsideSpace, {
                                opacity: isFontLoading ? 0 : ""
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pt-3 pb-3",
                                style: Preview_objectSpread({
                                    backgroundColor: blockBackgroundColor,
                                    borderRadius: borderRadiusValue,
                                    backdropFilter: "blur(".concat(blur, "px) "),
                                    WebkitBackdropFilter: "blur(".concat(blur, "px) "),
                                    paddingLeft: innerSpaceNumber,
                                    paddingRight: innerSpaceNumber
                                }, styleBorder, boxShadowStyle),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()("mt-1  preview-text-block overflow-hidden title-preview ".concat(isExpand ? "expanded" : "collapsed", " ")),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pr-3 grid overflow-hidden ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: " table w-full overflow-hidden",
                                                children: fontSizeArr && fontSizeArr.map(function(ele, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        className: "table-row item-preview-text",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "ml-3 w-[1px] pr-2 table-cell align-middle whitespace-nowrap",
                                                                style: {
                                                                    color: font_color,
                                                                    opacity: 0.8
                                                                },
                                                                children: "H".concat(index + 1)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "table-cell whitespace-nowrap py-2 scale-preview-text align-middle",
                                                                style: {
                                                                    color: font_color,
                                                                    fontSize: ele,
                                                                    lineHeight: line_height,
                                                                    fontWeight: font_weight,
                                                                    fontFamily: font_family_preview
                                                                },
                                                                children: t("ss_builder_deep_blue_sky")
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center font-medium text-[13px] leading-5 items-center",
                                        style: {
                                            color: "var(--adm-color-primary)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "m-auto flex cursor-pointer items-center",
                                            onClick: function() {
                                                return setHeightPreview();
                                            },
                                            children: [
                                                isExpand ? t("ss_builder_collapse") : t("ss_builder_expand"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "ml-1",
                                                    children: isExpand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CollapseIcon */.W5, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ExpandIcon */.Qq, {})
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        isFontLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SpinLoading */.wW, {
                            color: "".concat(font_color),
                            style: {
                                "--size": "48px"
                            },
                            className: "absolute left-[50%] translate-x-[-50%] top-[50%] translate-y-[-50%] z-[3]"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var TitleSetting_components_Preview = (/*#__PURE__*/react.memo(Preview_Preview));

// EXTERNAL MODULE: ./src/features/setting/components/ThemeSetting/ParagraphSetting/styele.module.scss
var styele_module = __webpack_require__(28917);
var styele_module_default = /*#__PURE__*/__webpack_require__.n(styele_module);
;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/ParagraphSetting/components/icon.tsx

var FontGoogle = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _width = param.width, width = _width === void 0 ? 13 : _width, _height = param.height, height = _height === void 0 ? 13 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 13 13",
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_910_743673)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        fillOpacity: "0.01",
                        d: "M0 0H13V13H0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FBBC04",
                        d: "M.443 11.14l5.85-9.28h3.632v1.29l-5.044 7.99"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#1A73E8",
                        d: "M9.925 11.139H6.294v-9.28h3.631v9.28z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#34A853",
                        d: "M12.548 8.513a2.618 2.618 0 01-2.622 2.623V5.89a2.617 2.617 0 012.622 2.622z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#0D652D",
                        d: "M9.925 11.136a2.617 2.617 0 01-2.622-2.623 2.618 2.618 0 012.622-2.622v5.245z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#1A73E8",
                        d: "M11.943 3.877c0 1.13-.888 2.017-2.017 2.017V1.859c1.13 0 2.017.888 2.017 2.018z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#174EA6",
                        d: "M9.926 5.894a1.998 1.998 0 01-2.018-2.017c0-1.13.888-2.018 2.018-2.018v4.035z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#EA4335",
                        d: "M.646 3.675c0-1.009.806-1.816 1.815-1.816 1.008 0 1.815.807 1.815 1.816a1.808 1.808 0 01-1.815 1.816A1.808 1.808 0 01.646 3.675z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_910_743673",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H13V13H0z"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/startCase.js
var startCase = __webpack_require__(18029);
var startCase_default = /*#__PURE__*/__webpack_require__.n(startCase);
;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/TitleSetting/index.tsx
function TitleSetting_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function TitleSetting_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return TitleSetting_arrayLikeToArray(arr);
}
function TitleSetting_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TitleSetting_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function TitleSetting_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function TitleSetting_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TitleSetting_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function TitleSetting_toConsumableArray(arr) {
    return TitleSetting_arrayWithoutHoles(arr) || TitleSetting_iterableToArray(arr) || TitleSetting_unsupportedIterableToArray(arr) || TitleSetting_nonIterableSpread();
}
function TitleSetting_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return TitleSetting_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TitleSetting_arrayLikeToArray(o, minLen);
}





























function TitleSetting(props) {
    var ref12, ref1, ref2;
    var backToAllSetting = props.backToAllSetting, type = props.type;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var SuccessToast = (0,toast/* useToast */.p)().SuccessToast;
    var ref3;
    var defaultSiteSetting = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref;
        return (ref3 = state === null || state === void 0 ? void 0 : (ref = state.siteSettings) === null || ref === void 0 ? void 0 : ref.display_setting) !== null && ref3 !== void 0 ? ref3 : {};
    });
    var ref4;
    var defaultTitleSetting = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref, ref13;
        return (ref4 = state === null || state === void 0 ? void 0 : (ref = state.siteSettings) === null || ref === void 0 ? void 0 : (ref13 = ref.display_setting) === null || ref13 === void 0 ? void 0 : ref13.title_setting) !== null && ref4 !== void 0 ? ref4 : {};
    });
    var isValidFont = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref;
        return (state === null || state === void 0 ? void 0 : (ref = state.externalState) === null || ref === void 0 ? void 0 : ref.is_valid_font) || false;
    });
    var isFontLoading = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref;
        return (state === null || state === void 0 ? void 0 : (ref = state.externalState) === null || ref === void 0 ? void 0 : ref.is_font_loading) || false;
    });
    var ref5 = (0,react.useState)(defaultTitleSetting), titleSettingData = ref5[0], setTitleSettingData = ref5[1];
    var fontWeightAvailable = (0,react_redux_es/* useSelector */.v9)(function(state) {
        return state.externalState.font_weight_available;
    });
    var _font_family = titleSettingData.font_family, font_family = _font_family === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_FAMILY */.lI.FONT_FAMILY : _font_family, _font_color = titleSettingData.font_color, font_color = _font_color === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_COLOR */.lI.FONT_COLOR : _font_color, _scale = titleSettingData.scale, scale = _scale === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_SCALE */.lI.FONT_SCALE : _scale, _font_size = titleSettingData.font_size, font_size = _font_size === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_SIZE */.lI.FONT_SIZE : _font_size, _font_weight = titleSettingData.font_weight, font_weight = _font_weight === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.lI.FONT_WEIGHT : _font_weight, _line_height = titleSettingData.line_height, line_height = _line_height === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.lI.LINE_HEIGHT : _line_height, _using_font_custom = titleSettingData.using_font_custom, using_font_custom = _using_font_custom === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.USING_FONT_CUSTOM */.lI.USING_FONT_CUSTOM : _using_font_custom, _font_family_custom = titleSettingData.font_family_custom, font_family_custom = _font_family_custom === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_FAMILY_CUSTOM */.lI.FONT_FAMILY_CUSTOM : _font_family_custom;
    var debounceValueFontCustom = (0,esm/* useDebounce */.Nr)(using_font_custom === configs_const/* FONT_GOOGLE */.O ? startCase_default()((ref12 = font_family_custom === null || font_family_custom === void 0 ? void 0 : font_family_custom.toString()) === null || ref12 === void 0 ? void 0 : ref12.trim()) : startCase_default()((ref1 = font_family === null || font_family === void 0 ? void 0 : font_family.toString()) === null || ref1 === void 0 ? void 0 : ref1.trim()), 500);
    (0,react.useEffect)(function() {
        if (debounceValueFontCustom) {
            dispatch((0,externalStateSlice/* setFontLoading */.ZR)(true));
        }
    }, [
        debounceValueFontCustom
    ]);
    var ref6 = (0,react.useState)(false), isOpenFontOption = ref6[0], setIsOpenFontOption = ref6[1];
    var ref7 = (0,react.useState)(false), isOpenTextColorPicker = ref7[0], setIsOpenTextColorPicker = ref7[1];
    var ref8 = (0,react.useState)(false), isOpenScaleSelector = ref8[0], setIsOpenScaleSelector = ref8[1];
    var ref9 = (0,react.useState)(false), hasHandler = ref9[0], setHasHandler = ref9[1];
    (0,react.useEffect)(function() {
        if (!isFontLoading) {
            setHasHandler(false);
        }
    }, [
        isFontLoading
    ]);
    var hasChange = (0,setting_hooks/* useHasChange */.wJ)([
        titleSettingData
    ]);
    var isDisabledBtnSave = (0,react.useMemo)(function() {
        if (using_font_custom === configs_const/* FONT_AVAILABLE */.QD) {
            return !hasChange;
        }
        return !hasChange || !(font_family_custom === null || font_family_custom === void 0 ? void 0 : font_family_custom.trim()) || !isValidFont || isFontLoading || hasHandler;
    }, [
        hasChange,
        font_family_custom === null || font_family_custom === void 0 ? void 0 : font_family_custom.trim(),
        isValidFont,
        isFontLoading,
        hasHandler, 
    ]);
    var handleBackToSetting = function() {
        dispatch((0,externalStateSlice/* setDataFont */.AQ)({
            title: "",
            paragraph: ""
        }));
        backToAllSetting();
    };
    var onCancel = (0,setting_hooks/* useOnCancel */.RI)(hasChange, handleBackToSetting, type);
    var fontFamilyTitle = (0,react.useMemo)(function() {
        var selectedOne = configs_const/* FONT_OPTIONS.find */.qD.find(function(item) {
            return item.value == font_family;
        });
        var ref;
        return (ref = selectedOne === null || selectedOne === void 0 ? void 0 : selectedOne.label) !== null && ref !== void 0 ? ref : font_family;
    }, [
        font_family
    ]);
    //generate Heading color
    var COLOR_LENGTH_DEFAULT = 9;
    var FONT_SETTING_OPTIONS = [
        {
            label: t("ss_builder_paragraph_setting_font_available"),
            value: configs_const/* FONT_AVAILABLE */.QD
        },
        {
            label: t("ss_builder_paragraph_setting_font_custom"),
            value: configs_const/* FONT_GOOGLE */.O
        }, 
    ];
    var opacityHeadingColor = font_color.length == COLOR_LENGTH_DEFAULT ? font_color.slice(-2) : "";
    var parseColorValuesHeading = generateColor/* parseColorValues */.Yu(font_color);
    var ref10;
    var calculateShadesHeading = generateColor/* calculateShades */.ZN((ref10 = parseColorValuesHeading[0]) !== null && ref10 !== void 0 ? ref10 : font_color.replace("#", ""));
    var ref11;
    var calculateTintsHeading = generateColor/* calculateTints */.SC((ref11 = parseColorValuesHeading[0]) !== null && ref11 !== void 0 ? ref11 : font_color.replace("#", ""));
    var calculateShadesAndTintsHeading = TitleSetting_toConsumableArray(calculateTintsHeading.reverse()).concat(TitleSetting_toConsumableArray(calculateShadesHeading));
    var headingColorGenerate = (0,react.useMemo)(function() {
        var headingColorObj = {};
        calculateShadesAndTintsHeading.forEach(function(ele, index) {
            headingColorObj["heading-color-".concat(index + 1)] = ele + opacityHeadingColor;
        });
        return headingColorObj;
    }, [
        calculateShadesAndTintsHeading
    ]);
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var onUpdateSettingData = function(key, value) {
        setTitleSettingData(function(state) {
            return TitleSetting_objectSpread({}, state, TitleSetting_defineProperty({}, key, value));
        });
    };
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var onSave = function() {
        var ref;
        dispatch(saveThemeTitleSetting(TitleSetting_objectSpread({}, titleSettingData, {
            font_family_custom: startCase_default()(titleSettingData === null || titleSettingData === void 0 ? void 0 : (ref = titleSettingData.font_family_custom) === null || ref === void 0 ? void 0 : ref.trim()) || configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_FAMILY_CUSTOM */.lI.FONT_FAMILY_CUSTOM,
            font_weight: (titleSettingData === null || titleSettingData === void 0 ? void 0 : titleSettingData.font_weight) || fontWeightAvailable[0],
            is_new: true
        }), headingColorGenerate));
        dispatch((0,externalStateSlice/* setDataFont */.AQ)({
            title: "",
            paragraph: ""
        }));
        backToAllSetting();
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.THEME_SETTINGS */.Bt.THEME_SETTINGS, "ThemeSettings_".concat((0,lib/* handleCapitalizeFirstLetter */.Tz)(type), "_").concat(ga_events/* LABEL_CONFIG.EDIT */.tW.EDIT), ga_events/* LABEL_CONFIG.EDIT */.tW.EDIT, (0,lib/* handleCapitalizeFirstLetter */.Tz)(type));
        SuccessToast(t("ss_builder_save_succesfully_label"));
    };
    var goToGGFont = function() {
        window.open("https://fonts.google.com/", "_blank");
    };
    var handleChangeFontGG = function(val) {
        onUpdateSettingData("font_family_custom", val);
        setHasHandler(true);
    };
    var marksFontWeight = (0,react.useMemo)(function() {
        if (fontWeightAvailable === null || fontWeightAvailable === void 0 ? void 0 : fontWeightAvailable.length) {
            var fisrtValue = fontWeightAvailable[0] || 400;
            var lastValue = fontWeightAvailable[(fontWeightAvailable === null || fontWeightAvailable === void 0 ? void 0 : fontWeightAvailable.length) - 1] || 900;
            return fontWeightAvailable === null || fontWeightAvailable === void 0 ? void 0 : fontWeightAvailable.reduce(function(a, b) {
                if (b === fisrtValue) {
                    return TitleSetting_objectSpread({}, a, TitleSetting_defineProperty({}, b, t("ss_builder_medium")));
                }
                if (b === lastValue) {
                    return TitleSetting_objectSpread({}, a, TitleSetting_defineProperty({}, b, t("ss_builder_bold")));
                }
                return TitleSetting_objectSpread({}, a, TitleSetting_defineProperty({}, b, ""));
            }, {});
        }
        return {
            400: t("ss_builder_medium")
        };
    }, [
        fontWeightAvailable
    ]);
    (0,react.useEffect)(function() {
        if (debounceValueFontCustom) {
            dispatch((0,externalStateSlice/* setDataFont */.AQ)({
                title: debounceValueFontCustom,
                paragraph: ""
            }));
        }
    }, [
        debounceValueFontCustom
    ]);
    var fontWeightval = (0,react.useMemo)(function() {
        if (fontWeightAvailable === null || fontWeightAvailable === void 0 ? void 0 : fontWeightAvailable.includes(font_weight)) {
            return font_weight;
        } else return fontWeightAvailable[0];
    }, [
        fontWeightAvailable,
        font_weight
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full pb-14",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingHeader/* default */.Z, {
                        title: t("ss_builder_title_setting_title"),
                        Icon: Icons/* HeaderIcon */.N9
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sticky z-[999] top-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSetting_components_Preview, {
                            titleSettingData: TitleSetting_objectSpread({}, titleSettingData, {
                                font_weight: fontWeightval,
                                font_family_preview: debounceValueFontCustom
                            }),
                            background: (defaultSiteSetting === null || defaultSiteSetting === void 0 ? void 0 : defaultSiteSetting.background) || {},
                            blockSetting: (defaultSiteSetting === null || defaultSiteSetting === void 0 ? void 0 : defaultSiteSetting.block_setting) || {}
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Collapse */.UO, {
                        defaultActiveKey: [
                            "style",
                            "font"
                        ],
                        accordion: false,
                        arrow: function(active) {
                            return active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DropDownIcon1 */.yu, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DropDownIcon2 */.oS, {});
                        },
                        className: classnames_default()((styele_module_default()).customCollapse),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Collapse.Panel */.UO.Panel, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mr-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* StyleIcon */.qG, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("ss_builder_theme_setting_block_style")
                                            })
                                        ]
                                    })
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-base mb-1",
                                        children: t("ss_builder_paragraph_setting_option")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                        options: FONT_SETTING_OPTIONS,
                                        columns: 2,
                                        onChange: function(val) {
                                            return onUpdateSettingData("using_font_custom", val[0]);
                                        },
                                        value: [
                                            using_font_custom
                                        ],
                                        style: {
                                            "--border": "solid transparent 1px",
                                            "--checked-border": "solid var(--adm-color-primary) 1px",
                                            "--checked-color": "#FFFFFF"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                        className: "!my-3"
                                    }),
                                    using_font_custom === configs_const/* FONT_AVAILABLE */.QD ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_setting_text_font")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-[100%] p-3 bg-[#F5F5F5] rounded border-0 text-[#333333] text-[13px] leading-[17px] flex flex-row justify-between items-center mb-3 cursor-pointer",
                                                onClick: function() {
                                                    return setIsOpenFontOption(true);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            fontFamily: font_family
                                                        },
                                                        children: fontFamilyTitle
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DownIcon */.KL, {
                                                        className: "w-[9px] h-[9px]"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-base mb-4",
                                                        children: t("ss_builder_popular_font_families")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonFontSelector, {
                                                        selectedValue: font_family,
                                                        onSelect: function(val) {
                                                            return onUpdateSettingData("font_family", val);
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex justify-between text-base",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: t("ss_builder_enter_font_name")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex gap-2 py-[3px] cursor-pointer",
                                                        onClick: goToGGFont,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FontGoogle, {
                                                                className: "my-auto"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-[#333]",
                                                                children: t("ss_builder_google_font")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* RightArrowIcon */.AD, {
                                                                width: 13,
                                                                height: 13,
                                                                className: "my-auto"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                                value: font_family_custom,
                                                onChange: function(value) {
                                                    return handleChangeFontGG(value);
                                                },
                                                placeholder: t("ss_bp_enter_font_name")
                                            }),
                                            !isValidFont && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[13px] leading-[17px] text-[#FF3141]",
                                                children: t("ss_builder_font_name_not_exist")
                                            }),
                                            (font_family_custom === null || font_family_custom === void 0 ? void 0 : font_family_custom.trim()) && isValidFont && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                                width: 24,
                                                height: 24,
                                                className: "absolute right-[16px] bottom-[14px] p-1",
                                                fillColor: "#00B578"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                                className: "!my-3"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_title_color")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayColor/* default */.Z, {
                                                backgroundColor: font_color || "black",
                                                onClickOpenColorPicker: setIsOpenTextColorPicker
                                            })
                                        ]
                                    })
                                ]
                            }, "style"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Collapse.Panel */.UO.Panel, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mr-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* TIcon */.Fv, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("ss_builder_theme_setting_font_title")
                                            })
                                        ]
                                    })
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_setting_text_size")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                                                onChange: function(val) {
                                                    return onUpdateSettingData("font_size", parseInt(val.toString()));
                                                },
                                                ticks: true,
                                                marks: {
                                                    13: 13,
                                                    14: 14,
                                                    15: 15,
                                                    16: 16,
                                                    17: 17,
                                                    18: 18,
                                                    19: 19,
                                                    20: 20
                                                },
                                                min: 13,
                                                step: 1,
                                                max: 20,
                                                value: font_size
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_setting_text_scale")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-[100%] p-3 bg-[#F5F5F5] rounded border-0 text-[#333333] text-[13px] leading-[17px] flex flex-row justify-between items-center mb-3 cursor-pointer",
                                                onClick: function() {
                                                    return setIsOpenScaleSelector(true);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: (ref2 = SCALE_OPTIONS[0].find(function(item) {
                                                            return item.value == scale;
                                                        })) === null || ref2 === void 0 ? void 0 : ref2.label
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DownIcon */.KL, {
                                                        className: "w-[9px] h-[9px]"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_setting_font_weight")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                                                onChange: function(val) {
                                                    return onUpdateSettingData("font_weight", parseInt(val.toString()));
                                                },
                                                ticks: true,
                                                marks: marksFontWeight,
                                                min: fontWeightAvailable[0] || 400,
                                                max: fontWeightAvailable[(fontWeightAvailable === null || fontWeightAvailable === void 0 ? void 0 : fontWeightAvailable.length) - 1] || 900,
                                                value: fontWeightval || 400,
                                                popover: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_setting_line_height")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                                                onChange: function(val) {
                                                    return onUpdateSettingData("line_height", parseFloat(val.toString()));
                                                },
                                                ticks: true,
                                                marks: {
                                                    1: 1,
                                                    1.1: 1.1,
                                                    1.2: 1.2,
                                                    1.3: 1.3,
                                                    1.4: 1.4,
                                                    1.5: 1.5,
                                                    1.6: 1.6,
                                                    1.7: 1.7,
                                                    1.8: 1.8,
                                                    1.9: 1.9,
                                                    2: 2
                                                },
                                                min: 1,
                                                step: 0.1,
                                                max: 2,
                                                value: line_height
                                            })
                                        ]
                                    })
                                ]
                            }, "font")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            onClick: onCancel,
                            className: "adm-button adm-button-default adm-button-shape-default w-full",
                            children: t("ss_builder_close_panel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            color: "primary",
                            disabled: isDisabledBtnSave,
                            className: "adm-button adm-button-primary adm-button-shape-default w-full",
                            onClick: function() {
                                return onSave();
                            },
                            children: t("ss_builder_save")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenFontOption,
                onMaskClick: function() {
                    return setIsOpenFontOption(false);
                },
                title: t("ss_builder_font_option_panel_title"),
                onClose: function() {
                    return setIsOpenFontOption(false);
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FontOptionV2, {
                    selectedValue: font_family,
                    onSelectFont: function(val) {
                        return onUpdateSettingData("font_family", val);
                    },
                    callbackCancelFontOption: function() {
                        return setIsOpenFontOption(false);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenTextColorPicker,
                onMaskClick: function() {
                    return setIsOpenTextColorPicker(false);
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return setIsOpenTextColorPicker(false);
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPickerV2 */._, {
                    defaultColor: font_color,
                    onCancel: function() {
                        setIsOpenTextColorPicker(false);
                    },
                    onColorSelected: function(data) {
                        return onUpdateSettingData("font_color", data);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScaleSeletor, {
                visible: isOpenScaleSelector,
                value: scale,
                onClose: function() {
                    return setIsOpenScaleSelector(false);
                },
                onSelect: function(val) {
                    return onUpdateSettingData("scale", val);
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/ButtonSetting/components/DetailButtonSetting/index.tsx





function DetailButtonSetting(props) {
    var value1 = props.value, onUpdate = props.onUpdate, buttonSettingData = props.buttonSettingData;
    var font_size = value1.font_size, line_height = value1.line_height, font_weight = value1.font_weight, type1 = value1.type;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var _enable_border = buttonSettingData.enable_border, enable_border = _enable_border === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.ENABLE_BORDER */.Xe.ENABLE_BORDER : _enable_border, _border_color = buttonSettingData.border_color, border_color = _border_color === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.BORDER_COLOR */.Xe.BORDER_COLOR : _border_color, _background_color = buttonSettingData.background_color, background_color = _background_color === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.BACKGROUND_COLOR */.Xe.BACKGROUND_COLOR : _background_color, _text_color = buttonSettingData.text_color, text_color = _text_color === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.TEXT_COLOR */.Xe.TEXT_COLOR : _text_color, _border_width = buttonSettingData.border_width, border_width = _border_width === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.BORDER_WIDTH */.Xe.BORDER_WIDTH : _border_width, _radius_type = buttonSettingData.radius_type, radius_type = _radius_type === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.RADIUS_TYPE */.Xe.RADIUS_TYPE : _radius_type, _radius_value = buttonSettingData.radius_value, radius_value = _radius_value === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.RADIUS_VALUE */.Xe.RADIUS_VALUE : _radius_value, _shadow_type = buttonSettingData.shadow_type, shadow_type1 = _shadow_type === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.SHADOW_TYPE */.Xe.SHADOW_TYPE : _shadow_type, _shadow_color = buttonSettingData.shadow_color, shadow_color = _shadow_color === void 0 ? shadow_type1 === configs_const/* BUTTON_SETTING_SHADOW_STYLE.SOFT_SHADOW */.r8.SOFT_SHADOW ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.SOFT_SHADOW_COLOR */.Xe.SOFT_SHADOW_COLOR : configs_const/* BUTTON_SETTING_DEFAULT_VALUE.HARD_SHADOW_COLOR */.Xe.HARD_SHADOW_COLOR : _shadow_color;
    var borderRadiusValue = (0,react.useMemo)(function() {
        var value = "0px";
        if (radius_type === "rounded") {
            value = "4px";
        } else if (radius_type === "custom") {
            value = "".concat(radius_value, "px");
        }
        return value;
    }, [
        radius_type,
        radius_value
    ]);
    var styleBorder = enable_border === true ? {
        borderWidth: border_width + "px",
        borderStyle: radius_type,
        borderColor: border_color
    } : {
        border: "none"
    };
    var getClassByTypeButton = function(type) {
        switch(type){
            case "big":
                return "large";
            case "small":
                return "small";
            case "mini":
                return "mini";
            default:
                return "middle";
        }
    };
    var styleShadow = function(shadow_type) {
        var styles = {};
        switch(shadow_type){
            case configs_const/* BUTTON_SETTING_SHADOW_STYLE.NO_SHADOW */.r8.NO_SHADOW:
                styles = {
                    boxShadow: "none"
                };
                break;
            case configs_const/* BUTTON_SETTING_SHADOW_STYLE.SOFT_SHADOW */.r8.SOFT_SHADOW:
                styles = {
                    boxShadow: "0px 5px 12px ".concat(shadow_color)
                };
                break;
            case configs_const/* BUTTON_SETTING_SHADOW_STYLE.HARD_SHADOW */.r8.HARD_SHADOW:
                styles = {
                    boxShadow: "5px 5px 0px ".concat(shadow_color)
                };
                break;
            default:
                styles = {
                    boxShadow: "none"
                };
        }
        return styles;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-base mb-4",
                        children: t("ss_builder_button_font_size")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                        onChange: function(val) {
                            return onUpdate("font_size", parseInt(val.toString()));
                        },
                        value: font_size,
                        marks: {
                            13: 13,
                            14: 14,
                            15: 15,
                            16: 16,
                            17: 17,
                            18: 18,
                            19: 19,
                            20: 20,
                            21: 21,
                            22: 22,
                            23: 23,
                            24: 24
                        },
                        ticks: true,
                        min: 13,
                        max: 24,
                        step: 1
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-base mb-4",
                        children: t("ss_builder_button_line_height")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                        onChange: function(val) {
                            return onUpdate("line_height", parseFloat(val.toString()));
                        },
                        value: line_height,
                        marks: {
                            1.0: 1.0,
                            1.1: 1.1,
                            1.2: 1.2,
                            1.3: 1.3,
                            1.4: 1.4,
                            1.5: 1.5,
                            1.6: 1.6,
                            1.7: 1.7,
                            1.8: 1.8,
                            1.9: 1.9,
                            2.0: 2.0
                        },
                        ticks: true,
                        min: 1.0,
                        max: 2.0,
                        step: 0.1
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-base mb-4",
                        children: t("ss_builder_button_font_weight")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                        onChange: function(val) {
                            return onUpdate("font_weight", parseInt(val.toString()));
                        },
                        value: font_weight,
                        marks: {
                            400: t("ss_builder_medium"),
                            500: "",
                            600: "",
                            700: "",
                            800: "",
                            900: t("ss_builder_bold")
                        },
                        // ticks={true}
                        min: 400,
                        max: 900,
                        step: 100
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/ButtonSetting/index.tsx
function ButtonSetting_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ButtonSetting_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ButtonSetting_arrayLikeToArray(arr);
}
function ButtonSetting_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ButtonSetting_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ButtonSetting_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ButtonSetting_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ButtonSetting_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ButtonSetting_toConsumableArray(arr) {
    return ButtonSetting_arrayWithoutHoles(arr) || ButtonSetting_iterableToArray(arr) || ButtonSetting_unsupportedIterableToArray(arr) || ButtonSetting_nonIterableSpread();
}
function ButtonSetting_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ButtonSetting_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ButtonSetting_arrayLikeToArray(o, minLen);
}






















var defaultBigButtonSetting = {
    font_size: configs_const/* BIG_BUTTON_SETTING_DEFAULT_VALUE.FONT_SIZE */.tQ.FONT_SIZE,
    line_height: configs_const/* BIG_BUTTON_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.tQ.LINE_HEIGHT,
    font_weight: configs_const/* BIG_BUTTON_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.tQ.FONT_WEIGHT,
    type: "big"
};
var defaultMediumButtonSetting = {
    font_size: configs_const/* MEDIUM_BUTTON_SETTING_DEFAULT_VALUE.FONT_SIZE */.h3.FONT_SIZE,
    line_height: configs_const/* MEDIUM_BUTTON_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.h3.LINE_HEIGHT,
    font_weight: configs_const/* MEDIUM_BUTTON_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.h3.FONT_WEIGHT,
    type: "medium"
};
var defaultSmallButtonSetting = {
    font_size: configs_const/* SMALL_BUTTON_SETTING_DEFAULT_VALUE.FONT_SIZE */.s2.FONT_SIZE,
    line_height: configs_const/* SMALL_BUTTON_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.s2.LINE_HEIGHT,
    font_weight: configs_const/* SMALL_BUTTON_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.s2.FONT_WEIGHT,
    type: "small"
};
// const RADIUS_STYLE_SQUARE = "square";
// const RADIUS_STYLE_ROUNDED = "circle";
// const RADIUS_STYLE_CUSTOM = "custom";
var masks = {
    0: 0,
    2: "",
    4: "",
    6: "",
    8: "",
    10: "",
    12: "",
    14: "",
    16: "",
    18: "",
    20: "",
    22: "",
    24: "",
    26: "",
    28: "",
    30: "",
    32: "",
    34: "",
    36: "",
    38: "",
    40: "",
    42: "",
    44: "",
    46: "",
    48: 48
};
var defaultButtonSettingData = {
    enable_border: configs_const/* BUTTON_SETTING_DEFAULT_VALUE.ENABLE_BORDER */.Xe.ENABLE_BORDER,
    border_color: configs_const/* BUTTON_SETTING_DEFAULT_VALUE.BORDER_COLOR */.Xe.BORDER_COLOR,
    background_color: configs_const/* BUTTON_SETTING_DEFAULT_VALUE.BACKGROUND_COLOR */.Xe.BACKGROUND_COLOR,
    text_color: configs_const/* BUTTON_SETTING_DEFAULT_VALUE.TEXT_COLOR */.Xe.TEXT_COLOR,
    border_width: configs_const/* BUTTON_SETTING_DEFAULT_VALUE.BORDER_WIDTH */.Xe.BORDER_WIDTH,
    radius_type: configs_const/* BUTTON_SETTING_DEFAULT_VALUE.RADIUS_TYPE */.Xe.RADIUS_TYPE,
    radius_value: configs_const/* BUTTON_SETTING_DEFAULT_VALUE.RADIUS_VALUE */.Xe.RADIUS_VALUE,
    big_button_setting: defaultBigButtonSetting,
    medium_button_setting: defaultMediumButtonSetting,
    small_button_setting: defaultSmallButtonSetting,
    button_bg_color: {},
    button_border_color: {}
};
var COLOR_LENGTH_DEFAULT = 9;
function ButtonSetting(props) {
    var backToAllSetting = props.backToAllSetting, type = props.type;
    var buttonSettingDataState = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref, ref10;
        return state === null || state === void 0 ? void 0 : (ref = state.siteSettings) === null || ref === void 0 ? void 0 : (ref10 = ref.display_setting) === null || ref10 === void 0 ? void 0 : ref10.button_setting;
    });
    var ref11 = (0,react.useState)(buttonSettingDataState !== null && buttonSettingDataState !== void 0 ? buttonSettingDataState : defaultButtonSettingData), buttonSettingData = ref11[0], setButtonSettingData = ref11[1];
    var ref1 = (0,react.useState)(false), isOpenBorderColorPicker = ref1[0], setIsOpenBorderColorPicker = ref1[1];
    var ref2 = (0,react.useState)(false), isOpenShadowColorPicker = ref2[0], setIsOpenShadowColorPicker = ref2[1];
    var ref3 = (0,react.useState)(false), isOpenBackgroundColorPicker = ref3[0], setIsOpenBackgroundColorPicker = ref3[1];
    var ref4 = (0,react.useState)(false), isOpenTextColorPicker = ref4[0], setIsOpenTextColorPicker = ref4[1];
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var hasChange = (0,setting_hooks/* useHasChange */.wJ)([
        buttonSettingData
    ]);
    var onCancel = (0,setting_hooks/* useOnCancel */.RI)(hasChange, backToAllSetting, type);
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var SuccessToast = (0,toast/* useToast */.p)().SuccessToast;
    var _enable_border = buttonSettingData.enable_border, enable_border = _enable_border === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.ENABLE_BORDER */.Xe.ENABLE_BORDER : _enable_border, _border_color = buttonSettingData.border_color, border_color = _border_color === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.BORDER_COLOR */.Xe.BORDER_COLOR : _border_color, _background_color = buttonSettingData.background_color, background_color = _background_color === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.BACKGROUND_COLOR */.Xe.BACKGROUND_COLOR : _background_color, _text_color = buttonSettingData.text_color, text_color = _text_color === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.TEXT_COLOR */.Xe.TEXT_COLOR : _text_color, _border_width = buttonSettingData.border_width, border_width = _border_width === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.BORDER_WIDTH */.Xe.BORDER_WIDTH : _border_width, _radius_type = buttonSettingData.radius_type, radius_type1 = _radius_type === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.RADIUS_VALUE */.Xe.RADIUS_VALUE : _radius_type, _radius_value = buttonSettingData.radius_value, radius_value = _radius_value === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.RADIUS_VALUE */.Xe.RADIUS_VALUE : _radius_value, _big_button_setting = buttonSettingData.big_button_setting, big_button_setting = _big_button_setting === void 0 ? defaultBigButtonSetting : _big_button_setting, _medium_button_setting = buttonSettingData.medium_button_setting, medium_button_setting = _medium_button_setting === void 0 ? defaultMediumButtonSetting : _medium_button_setting, _small_button_setting = buttonSettingData.small_button_setting, small_button_setting = _small_button_setting === void 0 ? defaultSmallButtonSetting : _small_button_setting, _button_bg_color = buttonSettingData.button_bg_color, button_bg_color = _button_bg_color === void 0 ? {} : _button_bg_color, _button_border_color = buttonSettingData.button_border_color, button_border_color = _button_border_color === void 0 ? {} : _button_border_color, _shadow_type = buttonSettingData.shadow_type, shadow_type1 = _shadow_type === void 0 ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.SHADOW_TYPE */.Xe.SHADOW_TYPE : _shadow_type, _shadow_color = buttonSettingData.shadow_color, shadow_color = _shadow_color === void 0 ? shadow_type1 === configs_const/* BUTTON_SETTING_SHADOW_STYLE.SOFT_SHADOW */.r8.SOFT_SHADOW ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.SOFT_SHADOW_COLOR */.Xe.SOFT_SHADOW_COLOR : configs_const/* BUTTON_SETTING_DEFAULT_VALUE.HARD_SHADOW_COLOR */.Xe.HARD_SHADOW_COLOR : _shadow_color;
    var new_big_button_setting = ButtonSetting_objectSpread({
        type: defaultBigButtonSetting.type
    }, big_button_setting);
    var new_medium_button_setting = ButtonSetting_objectSpread({
        type: defaultMediumButtonSetting.type
    }, medium_button_setting);
    var new_small_button_setting = ButtonSetting_objectSpread({
        type: defaultSmallButtonSetting.type
    }, small_button_setting);
    var ref5 = new_medium_button_setting || defaultMediumButtonSetting, font_size = ref5.font_size, line_height = ref5.line_height, font_weight = ref5.font_weight;
    var onUpdateButtonSettingData = function(key, value) {
        setButtonSettingData(function(state) {
            return ButtonSetting_objectSpread({}, state, ButtonSetting_defineProperty({}, key, value));
        });
    };
    var updateButtonSetting = function(buttonKey, key, value) {
        setButtonSettingData(function(state) {
            return ButtonSetting_objectSpread({}, state, ButtonSetting_defineProperty({}, buttonKey, ButtonSetting_objectSpread({}, state[buttonKey], ButtonSetting_defineProperty({}, key, value))));
        });
    };
    //generate background color
    var button_bg_color_default = background_color !== null && background_color !== void 0 ? background_color : defaultButtonSettingData.background_color;
    var opacityColor = button_bg_color_default.length == COLOR_LENGTH_DEFAULT ? button_bg_color_default.slice(-2) : "";
    var parseColorValues = generateColor/* parseColorValues */.Yu(button_bg_color_default);
    var ref6;
    var calculateShades = generateColor/* calculateShades */.ZN((ref6 = parseColorValues[0]) !== null && ref6 !== void 0 ? ref6 : button_bg_color_default.replace("#", ""));
    var ref7;
    var calculateTints = generateColor/* calculateTints */.SC((ref7 = parseColorValues[0]) !== null && ref7 !== void 0 ? ref7 : button_bg_color_default.replace("#", ""));
    var calculateShadesAndTints = ButtonSetting_toConsumableArray(calculateTints.reverse()).concat(ButtonSetting_toConsumableArray(calculateShades));
    var button_bg_color_setting = (0,react.useMemo)(function() {
        var buttonColorObj = {};
        calculateShadesAndTints.forEach(function(ele, index) {
            buttonColorObj["button-bg-color-".concat(index + 1)] = ele + opacityColor;
        });
        return buttonColorObj;
    }, [
        calculateShadesAndTints
    ]);
    //generate button color
    var button_border_color_default = border_color !== null && border_color !== void 0 ? border_color : defaultButtonSettingData.border_color;
    var opacityBorderColor = button_border_color_default.length == COLOR_LENGTH_DEFAULT ? button_border_color_default.slice(-2) : "";
    var parseColorValuesBorder = generateColor/* parseColorValues */.Yu(button_border_color_default);
    var ref8;
    var calculateShadesBorder = generateColor/* calculateShades */.ZN((ref8 = parseColorValuesBorder[0]) !== null && ref8 !== void 0 ? ref8 : button_border_color_default.replace("#", ""));
    var ref9;
    var calculateTintsBorder = generateColor/* calculateTints */.SC((ref9 = parseColorValuesBorder[0]) !== null && ref9 !== void 0 ? ref9 : button_border_color_default.replace("#", ""));
    var calculateShadesAndTintsBorder = ButtonSetting_toConsumableArray(calculateTintsBorder.reverse()).concat(ButtonSetting_toConsumableArray(calculateShadesBorder));
    var button_border_color_setting = (0,react.useMemo)(function() {
        var buttonBorderColorObj = {};
        calculateShadesAndTintsBorder.forEach(function(ele, index) {
            buttonBorderColorObj["button-border-color-".concat(index + 1)] = ele + opacityBorderColor;
        });
        return buttonBorderColorObj;
    }, [
        calculateShadesAndTintsBorder
    ]);
    var onSave = function() {
        dispatch(saveButtonThemeSetting({
            enable_border: enable_border !== null && enable_border !== void 0 ? enable_border : defaultButtonSettingData.enable_border,
            border_color: border_color !== null && border_color !== void 0 ? border_color : defaultButtonSettingData.border_color,
            background_color: background_color !== null && background_color !== void 0 ? background_color : defaultButtonSettingData.background_color,
            text_color: text_color !== null && text_color !== void 0 ? text_color : defaultButtonSettingData.text_color,
            border_width: border_width !== null && border_width !== void 0 ? border_width : defaultButtonSettingData.border_width,
            radius_type: radius_type1 !== null && radius_type1 !== void 0 ? radius_type1 : defaultButtonSettingData.radius_type,
            radius_value: radius_value !== null && radius_value !== void 0 ? radius_value : defaultButtonSettingData.radius_value,
            big_button_setting: new_big_button_setting !== null && new_big_button_setting !== void 0 ? new_big_button_setting : defaultButtonSettingData.big_button_setting,
            medium_button_setting: new_medium_button_setting !== null && new_medium_button_setting !== void 0 ? new_medium_button_setting : defaultButtonSettingData.medium_button_setting,
            small_button_setting: new_small_button_setting !== null && new_small_button_setting !== void 0 ? new_small_button_setting : defaultButtonSettingData.small_button_setting,
            button_bg_color: button_bg_color_setting,
            button_border_color: button_border_color_setting,
            shadow_type: shadow_type1 !== null && shadow_type1 !== void 0 ? shadow_type1 : defaultButtonSettingData.shadow_type,
            shadow_color: shadow_color !== null && shadow_color !== void 0 ? shadow_color : defaultButtonSettingData.shadow_color
        }));
        backToAllSetting();
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.THEME_SETTINGS */.Bt.THEME_SETTINGS, "ThemeSettings_".concat((0,lib/* handleCapitalizeFirstLetter */.Tz)(type), "_").concat(ga_events/* LABEL_CONFIG.EDIT */.tW.EDIT), ga_events/* LABEL_CONFIG.EDIT */.tW.EDIT, (0,lib/* handleCapitalizeFirstLetter */.Tz)(type));
        SuccessToast(t("ss_builder_save_succesfully_label"));
    };
    var noShadowIcon = function(radius_type) {
        var iconElement = null;
        switch(radius_type){
            case configs_const/* BUTTON_SETTING_RADIUS_STYLE.SQUARE */.OX.SQUARE:
                iconElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NoShadowSquareIcon */.mB, {
                    className: "m-auto"
                });
                break;
            case configs_const/* BUTTON_SETTING_RADIUS_STYLE.ROUNDED */.OX.ROUNDED:
                iconElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NoShadowRoundedIcon */.ak, {
                    className: "m-auto"
                });
                break;
            case configs_const/* BUTTON_SETTING_RADIUS_STYLE.CUSTOM */.OX.CUSTOM:
                iconElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NoShadowCustomIcon */.H, {
                    className: "m-auto"
                });
                break;
            default:
                iconElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NoShadowSquareIcon */.mB, {
                    className: "m-auto"
                });
        }
        return iconElement;
    };
    var softShadowIcon = function(radius_type) {
        var iconElement = null;
        switch(radius_type){
            case configs_const/* BUTTON_SETTING_RADIUS_STYLE.SQUARE */.OX.SQUARE:
                iconElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SoftShadowSquareIcon */.TV, {
                    className: "m-auto"
                });
                break;
            case configs_const/* BUTTON_SETTING_RADIUS_STYLE.ROUNDED */.OX.ROUNDED:
                iconElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SoftShadowRoundedIcon */.qK, {
                    className: "m-auto"
                });
                break;
            case configs_const/* BUTTON_SETTING_RADIUS_STYLE.CUSTOM */.OX.CUSTOM:
                iconElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SoftShadowCustomIcon */.T8, {
                    className: "m-auto"
                });
                break;
            default:
                iconElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* SoftShadowSquareIcon */.TV, {
                    className: "m-auto"
                });
        }
        return iconElement;
    };
    var hardShadowIcon = function(radius_type) {
        var iconElement = null;
        switch(radius_type){
            case configs_const/* BUTTON_SETTING_RADIUS_STYLE.SQUARE */.OX.SQUARE:
                iconElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* HardShadowSquareIcon */.y1, {
                    className: "m-auto"
                });
                break;
            case configs_const/* BUTTON_SETTING_RADIUS_STYLE.ROUNDED */.OX.ROUNDED:
                iconElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* HardShadowRoundedIcon */.O$, {
                    className: "m-auto"
                });
                break;
            case configs_const/* BUTTON_SETTING_RADIUS_STYLE.CUSTOM */.OX.CUSTOM:
                iconElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* HardShadowCustomIcon */.KE, {
                    className: "m-auto"
                });
                break;
            default:
                iconElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* HardShadowSquareIcon */.y1, {
                    className: "m-auto"
                });
        }
        return iconElement;
    };
    var borderRadiusValue = (0,react.useMemo)(function() {
        var value = "0px";
        if (radius_type1 === "rounded") {
            value = "4px";
        } else if (radius_type1 === "custom") {
            value = "".concat(radius_value, "px");
        }
        return value;
    }, [
        radius_type1,
        radius_value
    ]);
    var styleBorder = enable_border === true ? {
        borderWidth: border_width + "px",
        borderStyle: "".concat(radius_type1),
        borderColor: border_color
    } : {
        border: "none"
    };
    var styleShadow = function(shadow_type) {
        var styles = {};
        switch(shadow_type){
            case configs_const/* BUTTON_SETTING_SHADOW_STYLE.NO_SHADOW */.r8.NO_SHADOW:
                styles = {
                    boxShadow: "none"
                };
                break;
            case configs_const/* BUTTON_SETTING_SHADOW_STYLE.SOFT_SHADOW */.r8.SOFT_SHADOW:
                styles = {
                    boxShadow: "0px 5px 12px ".concat(shadow_color)
                };
                break;
            case configs_const/* BUTTON_SETTING_SHADOW_STYLE.HARD_SHADOW */.r8.HARD_SHADOW:
                styles = {
                    boxShadow: "5px 5px 0px ".concat(shadow_color)
                };
                break;
            default:
                styles = {
                    boxShadow: "none"
                };
        }
        return styles;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full pb-14",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingHeader/* default */.Z, {
                        title: t("ss_builder_button_setting_title"),
                        Icon: Icons/* ButtonIcon */.Ei
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                        style: {
                            margin: "0"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "preview-button-block mb-[13px] bg-white sticky z-[999] top-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " py-3 px-4 w-full h-full preview-general-block text-center flex justify-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full h-full flex justify-center py-3 rounded",
                                style: {
                                    border: "1px solid #EEEEEE",
                                    backgroundColor: "#FAFAFA"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                    color: "primary",
                                    className: classnames_default()("flex items-center adm-button adm-button-primary adm-button-shape-default gap-2"),
                                    size: "middle",
                                    style: ButtonSetting_objectSpread({
                                        backgroundColor: background_color,
                                        color: text_color,
                                        fontSize: font_size,
                                        lineHeight: line_height,
                                        fontWeight: font_weight,
                                        borderRadius: borderRadiusValue
                                    }, styleBorder, styleShadow(shadow_type1)),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SettingIcon */.qY, {
                                            width: font_size,
                                            height: font_size,
                                            fillColor: text_color
                                        }),
                                        t("ss_builder_button_title")
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Collapse */.UO, {
                        defaultActiveKey: [
                            "general",
                            "big_button",
                            "medium_button",
                            "small_button", 
                        ],
                        accordion: false,
                        arrow: function(active) {
                            return active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DropDownIcon1 */.yu, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DropDownIcon2 */.oS, {});
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Collapse.Panel */.UO.Panel, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mr-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconGeneral */.k9, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("ss_builder_theme_button_setting_general")
                                            })
                                        ]
                                    })
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_enable_button_border")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                                                defaultChecked: enable_border,
                                                uncheckedText: t("ss_builder_off"),
                                                checkedText: t("ss_builder_on"),
                                                onChange: function(value) {
                                                    return onUpdateButtonSettingData("enable_border", value);
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex mb-3",
                                        children: [
                                            enable_border && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mr-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayColor/* default */.Z, {
                                                            backgroundColor: border_color,
                                                            onClickOpenColorPicker: setIsOpenBorderColorPicker
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-sm mb-4 text-black mt-3",
                                                            children: t("ss_builder_button_border_color")
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mr-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayColor/* default */.Z, {
                                                            backgroundColor: background_color,
                                                            onClickOpenColorPicker: setIsOpenBackgroundColorPicker
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-sm mb-4 text-black mt-3",
                                                            children: t("ss_builder_button_background_color")
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mr-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayColor/* default */.Z, {
                                                            backgroundColor: text_color,
                                                            onClickOpenColorPicker: setIsOpenTextColorPicker
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-sm mb-4 text-black mt-3",
                                                            children: t("ss_builder_button_text_color")
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    enable_border && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-base mb-4",
                                                        children: t("ss_builder_button_border_width")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                                                        onChange: function(val) {
                                                            return onUpdateButtonSettingData("border_width", parseInt(val.toString()));
                                                        },
                                                        marks: {
                                                            1: 1,
                                                            2: 2,
                                                            3: 3,
                                                            4: 4,
                                                            5: 5,
                                                            6: 6
                                                        },
                                                        min: 1,
                                                        max: 6,
                                                        step: 1,
                                                        value: border_width
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-base mb-1",
                                        children: t("ss_builder_border_radius_style")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                        className: "mb-3",
                                        columns: 3,
                                        onChange: function(val) {
                                            if (val.length) {
                                                var ref;
                                                onUpdateButtonSettingData("radius_type", (ref = val[0]) !== null && ref !== void 0 ? ref : configs_const/* BUTTON_SETTING_RADIUS_STYLE.SQUARE */.OX.SQUARE);
                                            }
                                        },
                                        options: [
                                            {
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NoShadowSquareIcon */.mB, {
                                                    className: "m-auto"
                                                }),
                                                description: t("ss_builder_square"),
                                                value: configs_const/* BUTTON_SETTING_RADIUS_STYLE.SQUARE */.OX.SQUARE
                                            },
                                            {
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NoShadowRoundedIcon */.ak, {
                                                    className: "m-auto"
                                                }),
                                                description: t("ss_builder_rounded"),
                                                value: configs_const/* BUTTON_SETTING_RADIUS_STYLE.ROUNDED */.OX.ROUNDED
                                            },
                                            {
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* NoShadowCustomIcon */.H, {
                                                    className: "m-auto"
                                                }),
                                                description: t("ss_builder_custom"),
                                                value: configs_const/* BUTTON_SETTING_RADIUS_STYLE.CUSTOM */.OX.CUSTOM
                                            }, 
                                        ],
                                        value: [
                                            radius_type1
                                        ],
                                        style: {
                                            "--checked-color": "#fff"
                                        }
                                    }),
                                    radius_type1 == configs_const/* BUTTON_SETTING_RADIUS_STYLE.CUSTOM */.OX.CUSTOM && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                                style: {
                                                    marginTop: "24px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-base mb-2 flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: t("ss_builder_border_radius_label")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "primary-color text-sm",
                                                        children: [
                                                            radius_value,
                                                            " px"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                                                onChange: function(val) {
                                                    return onUpdateButtonSettingData("radius_value", parseInt(val.toString()));
                                                },
                                                marks: masks,
                                                min: 0,
                                                step: 2,
                                                max: 48,
                                                popover: true,
                                                defaultValue: radius_value
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                        style: {
                                            marginTop: "24px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-base mb-1",
                                        children: t("ss_builder_theme_setting_shadow")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                        className: "mb-3",
                                        columns: 3,
                                        onChange: function(val) {
                                            if (val.length) {
                                                var ref;
                                                onUpdateButtonSettingData("shadow_type", (ref = val[0]) !== null && ref !== void 0 ? ref : configs_const/* BUTTON_SETTING_SHADOW_STYLE.NO_SHADOW */.r8.NO_SHADOW);
                                            }
                                        },
                                        options: [
                                            {
                                                label: noShadowIcon(radius_type1),
                                                description: t("ss_builder_theme_setting_no_shadow"),
                                                value: configs_const/* BUTTON_SETTING_SHADOW_STYLE.NO_SHADOW */.r8.NO_SHADOW
                                            },
                                            {
                                                label: softShadowIcon(radius_type1),
                                                description: t("ss_builder_theme_setting_soft_shadow"),
                                                value: configs_const/* BUTTON_SETTING_SHADOW_STYLE.SOFT_SHADOW */.r8.SOFT_SHADOW
                                            },
                                            {
                                                label: hardShadowIcon(radius_type1),
                                                description: t("ss_builder_theme_setting_hard_shadow"),
                                                value: configs_const/* BUTTON_SETTING_SHADOW_STYLE.HARD_SHADOW */.r8.HARD_SHADOW
                                            }, 
                                        ],
                                        value: [
                                            shadow_type1
                                        ],
                                        style: {
                                            "--checked-color": "#fff"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                        style: {
                                            marginTop: "24px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-base mb-1",
                                        children: t("ss_builder_theme_setting_shadow_color")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayColor/* default */.Z, {
                                        backgroundColor: shadow_color,
                                        onClickOpenColorPicker: setIsOpenShadowColorPicker
                                    })
                                ]
                            }, "general"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Collapse.Panel */.UO.Panel, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mr-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ButtonIcon */.Ei, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("ss_builder_theme_setting_text")
                                            })
                                        ]
                                    })
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailButtonSetting, {
                                    value: new_medium_button_setting !== null && new_medium_button_setting !== void 0 ? new_medium_button_setting : defaultMediumButtonSetting,
                                    onUpdate: function(key, value) {
                                        updateButtonSetting("medium_button_setting", key, value);
                                    },
                                    buttonSettingData: buttonSettingData !== null && buttonSettingData !== void 0 ? buttonSettingData : {}
                                })
                            }, "medium_button")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            onClick: onCancel,
                            className: "adm-button adm-button-default adm-button-shape-default w-full",
                            children: t("ss_builder_close_panel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            color: "primary",
                            disabled: !hasChange,
                            className: "adm-button adm-button-primary adm-button-shape-default w-full",
                            onClick: function() {
                                onSave();
                            },
                            children: t("ss_builder_save")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenBorderColorPicker,
                onMaskClick: function() {
                    return setIsOpenBorderColorPicker(false);
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return setIsOpenBorderColorPicker(false);
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPickerV2 */._, {
                    defaultColor: border_color,
                    onCancel: function() {
                        setIsOpenBorderColorPicker(false);
                    },
                    onColorSelected: function(value) {
                        return onUpdateButtonSettingData("border_color", value);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenBackgroundColorPicker,
                onMaskClick: function() {
                    return setIsOpenBackgroundColorPicker(false);
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return setIsOpenBackgroundColorPicker(false);
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPickerV2 */._, {
                    defaultColor: background_color,
                    onCancel: function() {
                        setIsOpenBackgroundColorPicker(false);
                    },
                    onColorSelected: function(value) {
                        return onUpdateButtonSettingData("background_color", value);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenTextColorPicker,
                onMaskClick: function() {
                    return setIsOpenTextColorPicker(false);
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return setIsOpenTextColorPicker(false);
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPickerV2 */._, {
                    defaultColor: text_color,
                    onCancel: function() {
                        setIsOpenTextColorPicker(false);
                    },
                    onColorSelected: function(value) {
                        return onUpdateButtonSettingData("text_color", value);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenShadowColorPicker,
                onMaskClick: function() {
                    return setIsOpenShadowColorPicker(false);
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return setIsOpenShadowColorPicker(false);
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPickerV2 */._, {
                    defaultColor: shadow_color,
                    onCancel: function() {
                        setIsOpenShadowColorPicker(false);
                    },
                    onColorSelected: function(value) {
                        return onUpdateButtonSettingData("shadow_color", value);
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/ParagraphSetting/components/Preview/index.tsx
function components_Preview_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function components_Preview_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            components_Preview_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







function components_Preview_Preview(param) {
    var paragraphSettingData = param.paragraphSettingData, background = param.background, blockSetting = param.blockSetting;
    var BACKGROUND_TYPE_IMAGE = "image";
    var BACKGROUND_TYPE_SOLID = "solid";
    var BACKGROUND_TYPE_GRADENT = "gradient";
    var BACKGROUND_TYPE_COLOR = "color";
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var isFontLoading = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref;
        return (state === null || state === void 0 ? void 0 : (ref = state.externalState) === null || ref === void 0 ? void 0 : ref.is_font_loading) || false;
    });
    var ref7 = paragraphSettingData || {}, _font_family_preview = ref7.font_family_preview, font_family_preview = _font_family_preview === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_FAMILY */.no.FONT_FAMILY : _font_family_preview, _font_color = ref7.font_color, font_color = _font_color === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_COLOR */.no.FONT_COLOR : _font_color, _scale = ref7.scale, scale = _scale === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_SCALE */.no.FONT_SCALE : _scale, _font_size = ref7.font_size, font_size = _font_size === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_SIZE */.no.FONT_SIZE : _font_size, _font_weight = ref7.font_weight, font_weight = _font_weight === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.no.FONT_WEIGHT : _font_weight, _line_height = ref7.line_height, line_height = _line_height === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.no.LINE_HEIGHT : _line_height, _using_font_custom = ref7.using_font_custom, using_font_custom = _using_font_custom === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.USING_FONT_CUSTOM */.no.USING_FONT_CUSTOM : _using_font_custom, _font_family_custom = ref7.font_family_custom, font_family_custom = _font_family_custom === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_FAMILY_CUSTOM */.no.FONT_FAMILY_CUSTOM : _font_family_custom;
    var lead1 = font_size * scale * scale;
    var lead2 = font_size * scale;
    var body = font_size;
    var small = font_size / scale;
    var fontSizeArr = [
        lead1,
        lead2,
        body,
        small
    ];
    var titleParagrah = function(index) {
        switch(index){
            case 1:
                return "Lead 2";
            case 2:
                return "Body";
            case 3:
                return "Small";
            default:
                return "Lead 1";
        }
    };
    var ref1 = background || {}, type = ref1.type, color = ref1.color, gradient = ref1.gradient, image = ref1.image, enable_overlay = ref1.enable_overlay, overlay_color = ref1.overlay_color, tmp = ref1.blur, blurBackgroundSetting = tmp === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.BLUR */.Vw.BLUR : tmp;
    var ref2 = blockSetting || {}, block_style = ref2.block_style, block_background = ref2.block_background, block_border = ref2.block_border, block_shadow = ref2.block_shadow;
    var ref3 = block_style || {}, _radius_type = ref3.radius_type, radius_type = _radius_type === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_STYLE */.eJ.BLOCK_STYLE : _radius_type, _radius_value = ref3.radius_value, radius_value = _radius_value === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_RADIUS */.eJ.BORDER_RADIUS : _radius_value, _inner_space = ref3.inner_space, inner_space = _inner_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE */.eJ.INNER_SPACE : _inner_space, _inner_space_number = ref3.inner_space_number, inner_space_number = _inner_space_number === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */.eJ.INNER_SPACE_NUMBER : _inner_space_number, _outside_space = ref3.outside_space, outside_space = _outside_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE */.eJ.OUTSIDE_SPACE : _outside_space;
    var ref4 = block_background || {}, tmp1 = ref4.color, blockBackgroundColor = tmp1 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_COLOR */.eJ.BACKGROUND_COLOR : tmp1, _blur = ref4.blur, blur = _blur === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_BLUR */.eJ.BACKGROUND_BLUR : _blur;
    var ref5 = block_border || {}, tmp2 = ref5.enable, borderEnable = tmp2 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_ENABLE */.eJ.BORDER_ENABLE : tmp2, _border_width = ref5.border_width, border_width = _border_width === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_WIDTH */.eJ.BORDER_WIDTH : _border_width, tmp3 = ref5.color, borderColor = tmp3 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_COLOR */.eJ.BORDER_COLOR : tmp3, tmp4 = ref5.type, borderType = tmp4 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_STYLE */.eJ.BORDER_STYLE : tmp4;
    var ref6 = block_shadow || {}, tmp5 = ref6.enable, shadowEnable = tmp5 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.SHADOW_ENABLE */.eJ.SHADOW_ENABLE : tmp5, tmp6 = ref6.color, shadowColor = tmp6 === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.SHADOW_COLOR */.eJ.SHADOW_COLOR : tmp6;
    var boxShadowStyle = shadowEnable === true ? {
        boxShadow: "0px 4px 4px " + shadowColor
    } : {};
    var borderRadiusValue = (0,react.useMemo)(function() {
        var value = "0px";
        if (radius_type === "rounded") {
            value = "8px";
        } else if (radius_type === "custom") {
            value = "".concat(radius_value, "px");
        }
        return value;
    }, [
        radius_type,
        radius_value
    ]);
    var styleBorder = borderEnable === true ? {
        borderWidth: border_width + "px",
        borderStyle: borderType,
        borderColor: borderColor
    } : {
        border: "none"
    };
    var styleBackgroundImage = type === BACKGROUND_TYPE_IMAGE ? {
        backgroundPosition: "center center",
        filter: "blur(".concat(blurBackgroundSetting, "px) "),
        WebkitFilter: "blur(".concat(blurBackgroundSetting, "px) "),
        width: "calc(100% + ".concat(blurBackgroundSetting * 2, "px) "),
        height: "calc(100% + ".concat(blurBackgroundSetting * 2, "px) "),
        transform: "translate(-".concat(blurBackgroundSetting, "px, -").concat(blurBackgroundSetting, "px)")
    } : "";
    var checkStyleBackgroundImage = function() {
        switch(type){
            case BACKGROUND_TYPE_IMAGE:
                return 'url("'.concat(image, '")');
            case BACKGROUND_TYPE_GRADENT:
                return gradient;
            default:
                return "";
        }
    };
    var innerSpaceNumber = typeof inner_space_number === "number" ? "".concat(inner_space_number, "px") : inner_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */.eJ.INNER_SPACE_NUMBER, "px") : 0;
    var styleOutsideSpace = outside_space ? {
        marginLeft: "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px"),
        marginRight: "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px"),
        width: "calc(100% - ".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER * 2, "px) ")
    } : "";
    var fontLinkArr = (0,react.useMemo)(function() {
        return configs_const/* FONT_OPTIONS.filter */.qD.filter(function(x) {
            return (x === null || x === void 0 ? void 0 : x.value) !== font_family_preview;
        });
    }, [
        font_family_preview
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: fontLinkArr === null || fontLinkArr === void 0 ? void 0 : fontLinkArr.map(function(font) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            href: "".concat(configs_const/* GG_FONT_URI */.s0, "?family=").concat(font.value.replace(/\s+/g, "+")),
                            rel: "stylesheet"
                        })
                    }, font.value);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-2 bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-3 mt-1 pt-4 pb-4 w-full h-full relative overflow-hidden",
                    children: [
                        type === BACKGROUND_TYPE_IMAGE && enable_overlay === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute top-0 left-[50%] translate-x-[-50%] block w-full h-full z-[1]",
                            style: {
                                backgroundColor: overlay_color
                            }
                        }) : "",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute top-0 left-0 w-full h-full bg-cover bg-no-repeat object-cover",
                            style: components_Preview_objectSpread({
                                backgroundColor: type === BACKGROUND_TYPE_SOLID || type === BACKGROUND_TYPE_COLOR ? color : "",
                                backgroundImage: "".concat(checkStyleBackgroundImage()),
                                borderBottom: "1px solid var(--adm-color-border)"
                            }, styleBackgroundImage)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative z-[3]",
                            style: components_Preview_objectSpread({}, styleOutsideSpace, {
                                opacity: isFontLoading ? 0 : ""
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pt-3 pb-3",
                                style: components_Preview_objectSpread({
                                    backgroundColor: blockBackgroundColor,
                                    borderRadius: borderRadiusValue,
                                    backdropFilter: "blur(".concat(blur, "px) "),
                                    WebkitBackdropFilter: "blur(".concat(blur, "px) "),
                                    paddingLeft: innerSpaceNumber,
                                    paddingRight: innerSpaceNumber
                                }, styleBorder, boxShadowStyle),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-1 preview-text-block ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pr-3 grid overflow-hidden",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: " table w-full overflow-hidden",
                                            children: fontSizeArr && fontSizeArr.map(function(ele, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    className: "table-row item-preview-text",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "ml-3 w-[50px] pr-2 table-cell align-middle whitespace-nowrap",
                                                            style: {
                                                                color: font_color,
                                                                opacity: 0.8
                                                            },
                                                            children: "".concat(titleParagrah(index))
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "table-cell whitespace-nowrap py-2 scale-preview-text align-middle",
                                                            style: {
                                                                color: font_color,
                                                                fontSize: ele,
                                                                lineHeight: line_height,
                                                                fontWeight: font_weight,
                                                                fontFamily: font_family_preview
                                                            },
                                                            children: t("ss_builder_deep_blue_sky")
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    })
                                })
                            })
                        }),
                        isFontLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SpinLoading */.wW, {
                            color: "".concat(font_color),
                            style: {
                                "--size": "48px"
                            },
                            className: "absolute left-[50%] translate-x-[-50%] top-[50%] translate-y-[-50%] z-[3]"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/ParagraphSetting/index.tsx
function ParagraphSetting_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ParagraphSetting_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ParagraphSetting_arrayLikeToArray(arr);
}
function ParagraphSetting_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ParagraphSetting_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ParagraphSetting_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ParagraphSetting_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ParagraphSetting_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ParagraphSetting_toConsumableArray(arr) {
    return ParagraphSetting_arrayWithoutHoles(arr) || ParagraphSetting_iterableToArray(arr) || ParagraphSetting_unsupportedIterableToArray(arr) || ParagraphSetting_nonIterableSpread();
}
function ParagraphSetting_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ParagraphSetting_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ParagraphSetting_arrayLikeToArray(o, minLen);
}





























function ParagraphSetting(props) {
    var ref12, ref1, ref2;
    var backToAllSetting = props.backToAllSetting, type = props.type;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var SuccessToast = (0,toast/* useToast */.p)().SuccessToast;
    var ref3;
    var defaultSiteSetting = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref;
        return (ref3 = state === null || state === void 0 ? void 0 : (ref = state.siteSettings) === null || ref === void 0 ? void 0 : ref.display_setting) !== null && ref3 !== void 0 ? ref3 : {};
    });
    var ref4;
    var defaultParagraphSetting = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref, ref13;
        return (ref4 = state === null || state === void 0 ? void 0 : (ref = state.siteSettings) === null || ref === void 0 ? void 0 : (ref13 = ref.display_setting) === null || ref13 === void 0 ? void 0 : ref13.paragraph_setting) !== null && ref4 !== void 0 ? ref4 : {};
    });
    var isValidFont = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref;
        return (state === null || state === void 0 ? void 0 : (ref = state.externalState) === null || ref === void 0 ? void 0 : ref.is_valid_font) || false;
    });
    var isFontLoading = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref;
        return (state === null || state === void 0 ? void 0 : (ref = state.externalState) === null || ref === void 0 ? void 0 : ref.is_font_loading) || false;
    });
    var ref5 = (0,react.useState)(defaultParagraphSetting), paragraphSettingData = ref5[0], setParagraphSettingData = ref5[1];
    var fontWeightAvailable = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.externalState.font_weight_available;
    });
    var _font_family = paragraphSettingData.font_family, font_family = _font_family === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_FAMILY */.no.FONT_FAMILY : _font_family, _font_color = paragraphSettingData.font_color, font_color = _font_color === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_COLOR */.no.FONT_COLOR : _font_color, _scale = paragraphSettingData.scale, scale = _scale === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_SCALE */.no.FONT_SCALE : _scale, _font_size = paragraphSettingData.font_size, font_size = _font_size === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_SIZE */.no.FONT_SIZE : _font_size, _font_weight = paragraphSettingData.font_weight, font_weight = _font_weight === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.no.FONT_WEIGHT : _font_weight, _line_height = paragraphSettingData.line_height, line_height = _line_height === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.no.LINE_HEIGHT : _line_height, _using_font_custom = paragraphSettingData.using_font_custom, using_font_custom = _using_font_custom === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.USING_FONT_CUSTOM */.no.USING_FONT_CUSTOM : _using_font_custom, _font_family_custom = paragraphSettingData.font_family_custom, font_family_custom = _font_family_custom === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_FAMILY_CUSTOM */.no.FONT_FAMILY_CUSTOM : _font_family_custom;
    var debounceValueFontCustom = (0,esm/* useDebounce */.Nr)(using_font_custom === configs_const/* FONT_GOOGLE */.O ? startCase_default()((ref12 = font_family_custom === null || font_family_custom === void 0 ? void 0 : font_family_custom.toString()) === null || ref12 === void 0 ? void 0 : ref12.trim()) : startCase_default()((ref1 = font_family === null || font_family === void 0 ? void 0 : font_family.toString()) === null || ref1 === void 0 ? void 0 : ref1.trim()), 500);
    (0,react.useEffect)(function() {
        if (debounceValueFontCustom) {
            dispatch((0,externalStateSlice/* setFontLoading */.ZR)(true));
        }
    }, [
        debounceValueFontCustom
    ]);
    var ref6 = (0,react.useState)(false), isOpenFontOption = ref6[0], setIsOpenFontOption = ref6[1];
    var ref7 = (0,react.useState)(false), isOpenTextColorPicker = ref7[0], setIsOpenTextColorPicker = ref7[1];
    var ref8 = (0,react.useState)(false), isOpenScaleSelector = ref8[0], setIsOpenScaleSelector = ref8[1];
    var ref9 = (0,react.useState)(false), hasHandler = ref9[0], setHasHandler = ref9[1];
    (0,react.useEffect)(function() {
        if (!isFontLoading) {
            setHasHandler(false);
        }
    }, [
        isFontLoading
    ]);
    var hasChange = (0,setting_hooks/* useHasChange */.wJ)([
        paragraphSettingData
    ]);
    var isDisabledBtnSave = (0,react.useMemo)(function() {
        if (using_font_custom === configs_const/* FONT_AVAILABLE */.QD) {
            return !hasChange;
        }
        return !hasChange || !(font_family_custom === null || font_family_custom === void 0 ? void 0 : font_family_custom.trim()) || !isValidFont || isFontLoading || hasHandler;
    }, [
        hasChange,
        font_family_custom === null || font_family_custom === void 0 ? void 0 : font_family_custom.trim(),
        isValidFont,
        isFontLoading,
        hasHandler, 
    ]);
    var handleBackToSetting = function() {
        dispatch((0,externalStateSlice/* setDataFont */.AQ)({
            title: "",
            paragraph: ""
        }));
        backToAllSetting();
    };
    var onCancel = (0,setting_hooks/* useOnCancel */.RI)(hasChange, handleBackToSetting, type);
    var fontFamilyTitle = (0,react.useMemo)(function() {
        var selectedOne = configs_const/* FONT_OPTIONS.find */.qD.find(function(item) {
            return item.value == font_family;
        });
        var ref;
        return (ref = selectedOne === null || selectedOne === void 0 ? void 0 : selectedOne.label) !== null && ref !== void 0 ? ref : font_family;
    }, [
        font_family
    ]);
    //generate Heading color
    var COLOR_LENGTH_DEFAULT = 9;
    var FONT_SETTING_OPTIONS = [
        {
            label: t("ss_builder_paragraph_setting_font_available"),
            value: configs_const/* FONT_AVAILABLE */.QD
        },
        {
            label: t("ss_builder_paragraph_setting_font_custom"),
            value: configs_const/* FONT_GOOGLE */.O
        }, 
    ];
    var opacityTextColor = font_color.length == COLOR_LENGTH_DEFAULT ? font_color.slice(-2) : "";
    var parseColorValuesText = generateColor/* parseColorValues */.Yu(font_color);
    var ref10;
    var calculateShadesText = generateColor/* calculateShades */.ZN((ref10 = parseColorValuesText[0]) !== null && ref10 !== void 0 ? ref10 : font_color.replace("#", ""));
    var ref11;
    var calculateTintsText = generateColor/* calculateTints */.SC((ref11 = parseColorValuesText[0]) !== null && ref11 !== void 0 ? ref11 : font_color.replace("#", ""));
    var calculateShadesAndTintsText = ParagraphSetting_toConsumableArray(calculateTintsText.reverse()).concat(ParagraphSetting_toConsumableArray(calculateShadesText));
    var textColorGenerate = (0,react.useMemo)(function() {
        var textColorObj = {};
        calculateShadesAndTintsText.forEach(function(ele, index) {
            textColorObj["text-color-".concat(index + 1)] = ele + opacityTextColor;
        });
        return textColorObj;
    }, [
        calculateShadesAndTintsText
    ]);
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var onUpdateSettingData = function(key, value) {
        setParagraphSettingData(function(state) {
            return ParagraphSetting_objectSpread({}, state, ParagraphSetting_defineProperty({}, key, value));
        });
    };
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var onSave = function() {
        var ref;
        dispatch(saveThemeParagraphSetting(ParagraphSetting_objectSpread({}, paragraphSettingData, {
            font_family_custom: startCase_default()(paragraphSettingData === null || paragraphSettingData === void 0 ? void 0 : (ref = paragraphSettingData.font_family_custom) === null || ref === void 0 ? void 0 : ref.trim()) || configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_FAMILY_CUSTOM */.no.FONT_FAMILY_CUSTOM,
            font_weight: (paragraphSettingData === null || paragraphSettingData === void 0 ? void 0 : paragraphSettingData.font_weight) || fontWeightAvailable[0],
            is_new: true
        }), textColorGenerate));
        dispatch((0,externalStateSlice/* setDataFont */.AQ)({
            title: "",
            paragraph: ""
        }));
        backToAllSetting();
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.THEME_SETTINGS */.Bt.THEME_SETTINGS, "ThemeSettings_".concat((0,lib/* handleCapitalizeFirstLetter */.Tz)(type), "_").concat(ga_events/* LABEL_CONFIG.EDIT */.tW.EDIT), ga_events/* LABEL_CONFIG.EDIT */.tW.EDIT, (0,lib/* handleCapitalizeFirstLetter */.Tz)(type));
        SuccessToast(t("ss_builder_save_succesfully_label"));
    };
    var goToGGFont = function() {
        window.open("https://fonts.google.com/", "_blank");
    };
    var handleChangeFontGG = function(val) {
        onUpdateSettingData("font_family_custom", val);
        setHasHandler(true);
    };
    var marksFontWeight = (0,react.useMemo)(function() {
        if (fontWeightAvailable === null || fontWeightAvailable === void 0 ? void 0 : fontWeightAvailable.length) {
            var fisrtValue = fontWeightAvailable[0] || 400;
            var lastValue = fontWeightAvailable[(fontWeightAvailable === null || fontWeightAvailable === void 0 ? void 0 : fontWeightAvailable.length) - 1] || 900;
            return fontWeightAvailable === null || fontWeightAvailable === void 0 ? void 0 : fontWeightAvailable.reduce(function(a, b) {
                if (b === fisrtValue) {
                    return ParagraphSetting_objectSpread({}, a, ParagraphSetting_defineProperty({}, b, t("ss_builder_medium")));
                }
                if (b === lastValue) {
                    return ParagraphSetting_objectSpread({}, a, ParagraphSetting_defineProperty({}, b, t("ss_builder_bold")));
                }
                return ParagraphSetting_objectSpread({}, a, ParagraphSetting_defineProperty({}, b, ""));
            }, {});
        }
        return {
            400: t("ss_builder_medium")
        };
    }, [
        fontWeightAvailable
    ]);
    (0,react.useEffect)(function() {
        if (debounceValueFontCustom) {
            dispatch((0,externalStateSlice/* setDataFont */.AQ)({
                title: "",
                paragraph: debounceValueFontCustom
            }));
        }
    }, [
        debounceValueFontCustom
    ]);
    var fontWeightval = (0,react.useMemo)(function() {
        if (fontWeightAvailable === null || fontWeightAvailable === void 0 ? void 0 : fontWeightAvailable.includes(font_weight)) {
            return font_weight;
        } else return fontWeightAvailable[0];
    }, [
        fontWeightAvailable,
        font_weight
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full pb-14",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingHeader/* default */.Z, {
                        title: t("ss_builder_paragraph_setting_title"),
                        Icon: Icons/* ParagraphIcon */.lp
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sticky z-[999] top-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Preview_Preview, {
                            paragraphSettingData: ParagraphSetting_objectSpread({}, paragraphSettingData, {
                                font_weight: fontWeightval,
                                font_family_preview: debounceValueFontCustom
                            }),
                            background: (defaultSiteSetting === null || defaultSiteSetting === void 0 ? void 0 : defaultSiteSetting.background) || {},
                            blockSetting: (defaultSiteSetting === null || defaultSiteSetting === void 0 ? void 0 : defaultSiteSetting.block_setting) || {}
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Collapse */.UO, {
                        defaultActiveKey: [
                            "style",
                            "font"
                        ],
                        accordion: false,
                        arrow: function(active) {
                            return active ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DropDownIcon1 */.yu, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DropDownIcon2 */.oS, {});
                        },
                        className: classnames_default()((styele_module_default()).customCollapse),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Collapse.Panel */.UO.Panel, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mr-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* StyleIcon */.qG, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("ss_builder_theme_setting_block_style")
                                            })
                                        ]
                                    })
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-base mb-1",
                                        children: t("ss_builder_paragraph_setting_option")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                        options: FONT_SETTING_OPTIONS,
                                        columns: 2,
                                        onChange: function(val) {
                                            return onUpdateSettingData("using_font_custom", val[0]);
                                        },
                                        value: [
                                            using_font_custom
                                        ],
                                        style: {
                                            "--border": "solid transparent 1px",
                                            "--checked-border": "solid var(--adm-color-primary) 1px",
                                            "--checked-color": "#FFFFFF"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                        className: "!my-3"
                                    }),
                                    using_font_custom === configs_const/* FONT_AVAILABLE */.QD ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_setting_text_font")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-[100%] p-3 bg-[#F5F5F5] rounded border-0 text-[#333333] text-[13px] leading-[17px] flex flex-row justify-between items-center mb-3 cursor-pointer",
                                                onClick: function() {
                                                    return setIsOpenFontOption(true);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            fontFamily: font_family
                                                        },
                                                        children: fontFamilyTitle
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DownIcon */.KL, {
                                                        className: "w-[9px] h-[9px]"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-base mb-4",
                                                        children: t("ss_builder_popular_font_families")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonFontSelector, {
                                                        selectedValue: font_family,
                                                        onSelect: function(val) {
                                                            return onUpdateSettingData("font_family", val);
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex justify-between text-base",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: t("ss_builder_enter_font_name")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex gap-2 py-[3px] cursor-pointer",
                                                        onClick: goToGGFont,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FontGoogle, {
                                                                className: "my-auto"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "text-[#333]",
                                                                children: t("ss_builder_google_font")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* RightArrowIcon */.AD, {
                                                                width: 13,
                                                                height: 13,
                                                                className: "my-auto"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Input */.II, {
                                                value: font_family_custom,
                                                onChange: function(value) {
                                                    return handleChangeFontGG(value);
                                                },
                                                placeholder: t("ss_bp_enter_font_name")
                                            }),
                                            !isValidFont && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[13px] leading-[17px] text-[#FF3141]",
                                                children: t("ss_builder_font_name_not_exist")
                                            }),
                                            (font_family_custom === null || font_family_custom === void 0 ? void 0 : font_family_custom.trim()) && isValidFont && /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                                width: 24,
                                                height: 24,
                                                className: "absolute right-[16px] bottom-[14px] p-1",
                                                fillColor: "#00B578"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {
                                                className: "!my-3"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_title_color")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayColor/* default */.Z, {
                                                backgroundColor: font_color || "black",
                                                onClickOpenColorPicker: setIsOpenTextColorPicker
                                            })
                                        ]
                                    })
                                ]
                            }, "style"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Collapse.Panel */.UO.Panel, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "mr-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* TIcon */.Fv, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("ss_builder_theme_setting_font_title")
                                            })
                                        ]
                                    })
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_setting_text_size")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                                                onChange: function(val) {
                                                    return onUpdateSettingData("font_size", parseInt(val.toString()));
                                                },
                                                ticks: true,
                                                marks: {
                                                    13: 13,
                                                    14: 14,
                                                    15: 15,
                                                    16: 16,
                                                    17: 17,
                                                    18: 18,
                                                    19: 19,
                                                    20: 20
                                                },
                                                min: 13,
                                                step: 1,
                                                max: 20,
                                                value: font_size
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_setting_text_scale")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-[100%] p-3 bg-[#F5F5F5] rounded border-0 text-[#333333] text-[13px] leading-[17px] flex flex-row justify-between items-center mb-3 cursor-pointer",
                                                onClick: function() {
                                                    return setIsOpenScaleSelector(true);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: (ref2 = SCALE_OPTIONS[0].find(function(item) {
                                                            return item.value == scale;
                                                        })) === null || ref2 === void 0 ? void 0 : ref2.label
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DownIcon */.KL, {
                                                        className: "w-[9px] h-[9px]"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_setting_font_weight")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                                                onChange: function(val) {
                                                    return onUpdateSettingData("font_weight", parseInt(val.toString()));
                                                },
                                                ticks: true,
                                                marks: marksFontWeight,
                                                min: fontWeightAvailable[0] || 400,
                                                max: fontWeightAvailable[(fontWeightAvailable === null || fontWeightAvailable === void 0 ? void 0 : fontWeightAvailable.length) - 1] || 900,
                                                value: fontWeightval || 400,
                                                popover: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-base mb-4",
                                                children: t("ss_builder_setting_line_height")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                                                onChange: function(val) {
                                                    return onUpdateSettingData("line_height", parseFloat(val.toString()));
                                                },
                                                ticks: true,
                                                marks: {
                                                    1: 1,
                                                    1.1: 1.1,
                                                    1.2: 1.2,
                                                    1.3: 1.3,
                                                    1.4: 1.4,
                                                    1.5: 1.5,
                                                    1.6: 1.6,
                                                    1.7: 1.7,
                                                    1.8: 1.8,
                                                    1.9: 1.9,
                                                    2: 2
                                                },
                                                min: 1,
                                                step: 0.1,
                                                max: 2,
                                                value: line_height
                                            })
                                        ]
                                    })
                                ]
                            }, "font")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            onClick: onCancel,
                            className: "adm-button adm-button-default adm-button-shape-default w-full",
                            children: t("ss_builder_close_panel")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/2 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            color: "primary",
                            disabled: isDisabledBtnSave,
                            className: "adm-button adm-button-primary adm-button-shape-default w-full",
                            onClick: function() {
                                return onSave();
                            },
                            children: t("ss_builder_save")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenFontOption,
                onMaskClick: function() {
                    return setIsOpenFontOption(false);
                },
                title: t("ss_builder_font_option_panel_title"),
                onClose: function() {
                    return setIsOpenFontOption(false);
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FontOptionV2, {
                    selectedValue: font_family,
                    onSelectFont: function(val) {
                        return onUpdateSettingData("font_family", val);
                    },
                    callbackCancelFontOption: function() {
                        return setIsOpenFontOption(false);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenTextColorPicker,
                onMaskClick: function() {
                    return setIsOpenTextColorPicker(false);
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return setIsOpenTextColorPicker(false);
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPickerV2 */._, {
                    defaultColor: font_color,
                    onCancel: function() {
                        setIsOpenTextColorPicker(false);
                    },
                    onColorSelected: function(data) {
                        return onUpdateSettingData("font_color", data);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScaleSeletor, {
                visible: isOpenScaleSelector,
                value: scale,
                onClose: function() {
                    return setIsOpenScaleSelector(false);
                },
                onSelect: function(val) {
                    return onUpdateSettingData("scale", val);
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/setting/components/body/component/ThemeSetting/index.tsx
function ThemeSetting_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
















var LIST_SETTING = {
    GENERAL: "general",
    BLOCK: "block",
    HEADING: "heading",
    BUTTON: "button",
    PARAGRAPH: "paragraph"
};
var _obj;
var SETTING_MAPPING = (_obj = {}, ThemeSetting_defineProperty(_obj, LIST_SETTING.GENERAL, ThemeSetting_GeneralSetting), ThemeSetting_defineProperty(_obj, LIST_SETTING.BLOCK, BlockSetting/* default */.Z), ThemeSetting_defineProperty(_obj, LIST_SETTING.HEADING, TitleSetting), ThemeSetting_defineProperty(_obj, LIST_SETTING.BUTTON, ButtonSetting), ThemeSetting_defineProperty(_obj, LIST_SETTING.PARAGRAPH, ParagraphSetting), _obj);
var Setting = function(props) {
    var type = props.type, backToAllSetting = props.backToAllSetting, visible = props.visible;
    var Renderer = SETTING_MAPPING[type];
    return Renderer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
        visible: visible,
        onMaskClick: backToAllSetting,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Renderer, {
            backToAllSetting: backToAllSetting,
            type: type
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var ThemeSetting = function(props) {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(null), settingType = ref[0], setSettingType = ref[1];
    var ref1 = (0,react.useState)(false), visible = ref1[0], setVisible = ref1[1];
    var listSettingArr = [
        {
            type: LIST_SETTING.GENERAL,
            icon: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* GeneralIcon */.dy, {
                    className: "m-auto"
                });
            },
            title: "ss_builder_theme_setting_general"
        },
        {
            type: LIST_SETTING.BLOCK,
            icon: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* BlockIcon */.wD, {
                    className: "m-auto"
                });
            },
            title: "ss_builde_theme_setting_block"
        },
        {
            type: LIST_SETTING.HEADING,
            icon: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* HeaderIconV2 */._N, {
                    className: "m-auto"
                });
            },
            title: "ss_builder_theme_setting_title"
        },
        {
            type: LIST_SETTING.PARAGRAPH,
            icon: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* TextIcon */.VL, {
                    className: "m-auto"
                });
            },
            title: "ss_builder_theme_setting_paragraph"
        },
        {
            type: LIST_SETTING.BUTTON,
            icon: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ButtonIconV2 */.NX, {
                    className: "m-auto"
                });
            },
            title: "ss_builder_theme_setting_button"
        }, 
    ];
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var handleSelectItem = function(type) {
        setSettingType(type);
        if (type === LIST_SETTING.HEADING || type === LIST_SETTING.BLOCK || type === LIST_SETTING.BUTTON || type === LIST_SETTING.GENERAL || type === LIST_SETTING.PARAGRAPH) {
            setVisible(true);
        } else setVisible(false);
        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.THEME_SETTINGS */.Bt.THEME_SETTINGS, "ThemeSettings_".concat((0,lib/* handleCapitalizeFirstLetter */.Tz)(type), "_").concat(ga_events/* LABEL_CONFIG.CLICK_ON */.tW.CLICK_ON), ga_events/* LABEL_CONFIG.CLICK_ON */.tW.CLICK_ON, (0,lib/* handleCapitalizeFirstLetter */.Tz)(type));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("pb-3 bg-[#fff] rounded-[4px] mb-3", SETTING_TOUR_CLASS_NAME.STEP_2),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    fontStyle: "normal",
                    fontWeight: "400",
                    fontSize: "16px",
                    lineHeight: "130%",
                    padding: "12px 12px 16px 12px",
                    color: "#666666"
                },
                children: t("ss_builder_setup_theme_setting")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "gap-4 flex",
                style: {
                    display: "grid",
                    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                    gap: "10px",
                    padding: "0px 12px",
                    alignItems: "center"
                },
                children: listSettingArr === null || listSettingArr === void 0 ? void 0 : listSettingArr.map(function(ele, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeSetting_Item, {
                            Icon: ele.icon,
                            title: ele.title,
                            onClick: function() {
                                return handleSelectItem(ele.type);
                            }
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Setting, {
                type: settingType,
                backToAllSetting: function() {
                    return setVisible(false);
                },
                visible: visible
            })
        ]
    });
};
/* harmony default export */ var component_ThemeSetting = (ThemeSetting);

;// CONCATENATED MODULE: ./src/features/share/components/RatingStarComponent/index.tsx
function RatingStarComponent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function RatingStarComponent_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                RatingStarComponent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                RatingStarComponent_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}











var RATING_STAR = {
    STAR_1: 1,
    STAR_2: 2,
    STAR_3: 3,
    STAR_4: 4,
    STAR_5: 5
};
var RATING_DESCRIPTION = {
    CATEGORY_1: "unsatisfactory",
    CATEGORY_2: "need_improvement",
    CATEGORY_3: "not_bad",
    CATEGORY_4: "satisfactory",
    CATEGORY_5: "good"
};
var RATING_CATEGORY = {
    CATEGORY_1: "user_interface",
    CATEGORY_2: "loading_time",
    CATEGORY_3: "user_experience",
    CATEGORY_4: "support",
    CATEGORY_5: "other"
};
var DESCRIPTION_MAXIMUM = 500;
var RatingStarComponent = function(param) {
    var _ratingDefault = param.ratingDefault, ratingDefault = _ratingDefault === void 0 ? null : _ratingDefault, _isAuto = param.isAuto, isAuto = _isAuto === void 0 ? false : _isAuto, onClose = param.onClose;
    var ref, ref1, ref2, ref3;
    var userAgent = window.navigator.userAgent;
    var user = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.user;
    });
    var userId = user === null || user === void 0 ? void 0 : (ref = user.kol) === null || ref === void 0 ? void 0 : ref._id;
    var country = user === null || user === void 0 ? void 0 : (ref1 = user.kol) === null || ref1 === void 0 ? void 0 : ref1.country;
    var username = user === null || user === void 0 ? void 0 : (ref2 = user.kol) === null || ref2 === void 0 ? void 0 : ref2.username;
    var domain = user === null || user === void 0 ? void 0 : (ref3 = user.kol) === null || ref3 === void 0 ? void 0 : ref3.domain;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref4 = (0,react.useState)(null), titleStar = ref4[0], setTitleStar = ref4[1];
    var ref5 = (0,react.useState)(null), descriptionStar = ref5[0], setDescriptionStar = ref5[1];
    var ref6 = (0,react.useState)(ratingDefault), rating = ref6[0], setRating = ref6[1];
    var ref7 = (0,react.useState)([]), category = ref7[0], setCategory = ref7[1];
    var ref8 = (0,react.useState)(""), valueDescription = ref8[0], setValueDescription = ref8[1];
    var ref9 = (0,react.useState)(true), isDisableBtn = ref9[0], setIsDisableBtn = ref9[1];
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var ref10 = (0,react.useState)(false), isPendingRating = ref10[0], setIsPendingRating = ref10[1];
    var getTitleStar = function(star) {
        switch(star){
            case RATING_STAR.STAR_1:
                return t("ss_builder_block_rating_star_1");
                break;
            case RATING_STAR.STAR_2:
                return t("ss_builder_block_rating_star_2");
                break;
            case RATING_STAR.STAR_3:
                return t("ss_builder_block_rating_star_3");
                break;
            case RATING_STAR.STAR_4:
                return t("ss_builder_block_rating_star_4");
                break;
            case RATING_STAR.STAR_5:
                return t("ss_builder_block_rating_star_5");
                break;
            default:
                return t("ss_builder_block_rating_star_5");
                break;
        }
    };
    var getDescriptionStar = function(star) {
        switch(star){
            case RATING_STAR.STAR_1:
                return t("ss_builder_block_rating_description_star_1");
                break;
            case RATING_STAR.STAR_2:
                return t("ss_builder_block_rating_description_star_2");
                break;
            case RATING_STAR.STAR_3:
                return t("ss_builder_block_rating_description_star_3");
                break;
            case RATING_STAR.STAR_4:
                return t("ss_builder_block_rating_description_star_4");
                break;
            case RATING_STAR.STAR_5:
                return t("ss_builder_block_rating_description_star_5");
                break;
            default:
                return t("ss_builder_block_rating_description_star_5");
                break;
        }
    };
    var handleTitleStar = function(star) {
        setTitleStar(getTitleStar(star));
    };
    var handleDescriptioStar = function(star) {
        setDescriptionStar(getDescriptionStar(star));
    };
    var handleRatingStar = function(value) {
        if (value > 0) {
            setRating(value);
            handleTitleStar(value);
            handleDescriptioStar(value);
            setIsDisableBtn(false);
        }
    };
    var handleSetCategory = function(arr) {
        if (arr && arr.length) {
            setCategory(arr);
        }
    };
    var handleClose = function() {
        if (isAuto) {
            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.ASK_TO_REVIEW */.Bt.ASK_TO_REVIEW, ga_events/* EVENT_CONFIG.ASK_TO_REVIEW_CLOSE_REVIEW_FORM */.f1.ASK_TO_REVIEW_CLOSE_REVIEW_FORM, "", ga_events/* ACTION_CONFIG.CLOSE_REVIEW_FORM */.AN.CLOSE_REVIEW_FORM);
        } else {
            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.CREATOR_SEND_REVIEW */.Bt.CREATOR_SEND_REVIEW, ga_events/* EVENT_CONFIG.CREATOR_SEND_REVIEW_CLOSE_REVIEW_FORM */.f1.CREATOR_SEND_REVIEW_CLOSE_REVIEW_FORM, "", ga_events/* ACTION_CONFIG.CLOSE_REVIEW_FORM */.AN.CLOSE_REVIEW_FORM);
        }
        onClose();
    };
    var handleDescriptionCategory = function(star) {
        switch(star){
            case RATING_STAR.STAR_1:
                return RATING_DESCRIPTION.CATEGORY_1;
                break;
            case RATING_STAR.STAR_2:
                return RATING_DESCRIPTION.CATEGORY_2;
                break;
            case RATING_STAR.STAR_3:
                return RATING_DESCRIPTION.CATEGORY_3;
                break;
            case RATING_STAR.STAR_4:
                return RATING_DESCRIPTION.CATEGORY_4;
                break;
            case RATING_STAR.STAR_5:
                return RATING_DESCRIPTION.CATEGORY_5;
                break;
            default:
                return RATING_DESCRIPTION.CATEGORY_5;
                break;
        }
    };
    var handleSubmitRatingStar = function() {
        var _ref = RatingStarComponent_asyncToGenerator(runtime_default().mark(function _callee() {
            var dataRequest, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataRequest = {
                            user_id: userId,
                            username: username,
                            domain: domain,
                            country: country,
                            user_agent: userAgent,
                            rating_star: rating,
                            rating_description: handleDescriptionCategory(rating),
                            description: valueDescription,
                            rating_category: category.toString()
                        };
                        ;
                        _ctx.prev = 2;
                        handlePendingRating(true);
                        _ctx.next = 6;
                        return (0,api/* sendRating */.$h)(dataRequest);
                    case 6:
                        response = _ctx.sent;
                        if (isAuto) {
                            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.ASK_TO_REVIEW */.Bt.ASK_TO_REVIEW, ga_events/* EVENT_CONFIG.ASK_TO_REVIEW_SUBMIT_REVIEW */.f1.ASK_TO_REVIEW_SUBMIT_REVIEW, "", ga_events/* ACTION_CONFIG.SUBMIT_REVIEW_FORM */.AN.SUBMIT_REVIEW_FORM);
                        } else {
                            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.CREATOR_SEND_REVIEW */.Bt.CREATOR_SEND_REVIEW, ga_events/* EVENT_CONFIG.CREATOR_SEND_REVIEW_SUBMIT_REVIEW */.f1.CREATOR_SEND_REVIEW_SUBMIT_REVIEW, "", ga_events/* ACTION_CONFIG.SUBMIT_REVIEW_FORM */.AN.SUBMIT_REVIEW_FORM);
                        }
                        _ctx.next = 13;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](2);
                        console.log(_ctx.t0);
                    case 13:
                        handlePendingRating(false);
                        if (response.success) {
                            es/* Toast.show */.FN.show({
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                    className: "text-center inline-block w-[30px] h-[30px]",
                                    fillColor: "#00B578"
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: t("ss_builder_block_rating_toast_success_rating")
                                })
                            });
                            handleClose();
                        }
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    10
                ]
            ]);
        }));
        return function handleSubmitRatingStar() {
            return _ref.apply(this, arguments);
        };
    }();
    var options = [
        {
            label: t("ss_builder_block_rating_answer_1"),
            value: RATING_CATEGORY.CATEGORY_1
        },
        {
            label: t("ss_builder_block_rating_answer_2"),
            value: RATING_CATEGORY.CATEGORY_2
        },
        {
            label: t("ss_builder_block_rating_answer_3"),
            value: RATING_CATEGORY.CATEGORY_3
        },
        {
            label: t("ss_builder_block_rating_answer_4"),
            value: RATING_CATEGORY.CATEGORY_4
        },
        {
            label: t("ss_builder_block_rating_answer_5"),
            value: RATING_CATEGORY.CATEGORY_5
        }, 
    ];
    var handleChangeBlockDescription = function(val) {
        if ((val === null || val === void 0 ? void 0 : val.length) <= DESCRIPTION_MAXIMUM) {
            setValueDescription(val);
        }
    };
    var handlePendingRating = function(value) {
        setIsPendingRating(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "rating-popup-content h-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-h-full overflow-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "rating-star form-item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Rate */.j8, {
                                className: "w-full",
                                onChange: function(val) {
                                    return handleRatingStar(val);
                                },
                                value: rating,
                                character: /*#__PURE__*/ (0,jsx_runtime.jsx)(line_icon/* StarFillIcon */.qN, {
                                    width: 30,
                                    height: 30,
                                    fillColor: "var(--adm-color-light)"
                                }),
                                style: {
                                    "--inactive-color": "var(--adm-color-light)",
                                    "--active-color": "#ffd21e"
                                }
                            }),
                            titleStar && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title-star",
                                children: titleStar
                            })
                        ]
                    }),
                    rating && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "category mt-3 form-item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-[#666] text-[15px] leading-[1.5] mb-1",
                                children: descriptionStar
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                className: "selector-category-star",
                                options: options,
                                multiple: true,
                                onChange: function(arr, extend) {
                                    return handleSetCategory(arr);
                                },
                                style: {
                                    "--border-radius": "4px",
                                    "--checked-color": "#fff",
                                    "--padding": "8px 16px"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "input-text-box form-item",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "pt-3 px-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-[15px] leading-[1.5] text-[#666666] mb-1",
                                    children: t("ss_builder_block_rating_content_rating")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* TextArea */.Kx, {
                                    placeholder: t("ss_builder_block_rating_content_rating_placeholder"),
                                    onChange: handleChangeBlockDescription,
                                    value: valueDescription,
                                    maxLength: DESCRIPTION_MAXIMUM,
                                    rows: 5
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-[#999999] text-[13px] leading-[17px] w-full text-right",
                                    children: "".concat(valueDescription ? valueDescription.length : 0, "/").concat(DESCRIPTION_MAXIMUM)
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonConfirmPopup/* default */.Z, {
                onConfirm: rating ? handleSubmitRatingStar : function() {},
                isDisable: rating && !isPendingRating ? false : true,
                title: t("ss_builder_block_rating_button_submit_rating")
            })
        ]
    });
};
/* harmony default export */ var components_RatingStarComponent = (RatingStarComponent);

;// CONCATENATED MODULE: ./src/features/setting/components/body/component/RatingStar/index.tsx










var RatingStar = function() {
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var isMarginSettingTour = (dynamicConfig === null || dynamicConfig === void 0 ? void 0 : dynamicConfig.isMarginSettingTour) || false;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(false), isOpenPopupRating = ref[0], setIsOpenPopupRating = ref[1];
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var handleOpenPopupRating = function(value) {
        setIsOpenPopupRating(value);
        if (value) {
            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.SETTINGS */.Bt.SETTINGS, ga_events/* EVENT_CONFIG.CLICK_REVIEW_BUTTON */.f1.CLICK_REVIEW_BUTTON, "", ga_events/* ACTION_CONFIG.CLICK_REVIEW_BUTTON */.AN.CLICK_REVIEW_BUTTON);
        } else {
            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.CREATOR_SEND_REVIEW */.Bt.CREATOR_SEND_REVIEW, ga_events/* EVENT_CONFIG.CREATOR_SEND_REVIEW_CLOSE_REVIEW_FORM */.f1.CREATOR_SEND_REVIEW_CLOSE_REVIEW_FORM, "", ga_events/* ACTION_CONFIG.CLOSE_REVIEW_FORM */.AN.CLOSE_REVIEW_FORM);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("p-3 bg-[#fff] rounded-[4px]", isMarginSettingTour ? "mb-[300px]" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-2 text-[15.6px] leading-[130%]",
                children: t("ss_builder_block_rating_title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[#8C8C8C] text-[12px] leading-[16px] mb-4",
                children: t("ss_builder_block_rating_description")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                    className: "btn-flex",
                    onClick: function() {
                        return handleOpenPopupRating(true);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(line_icon/* StarIcon */.r7, {
                            width: 17,
                            height: 17
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[17px] leading-[1.4]",
                            children: t("ss_builder_block_rating_button_title_open_popup")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenPopupRating,
                onMaskClick: function() {
                    return handleOpenPopupRating(false);
                },
                title: t("ss_builder_block_rating_title"),
                onClose: function() {
                    return handleOpenPopupRating(false);
                },
                classNameBody: "max-h-[60vh] h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RatingStarComponent, {
                    onClose: function() {
                        return handleOpenPopupRating(false);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var component_RatingStar = (RatingStar);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/features/setting/components/body/component/JoinCampaign/Reject/index.tsx








function RejectAccess(props) {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var router = (0,next_router.useRouter)();
    var customerToken = js_cookie/* default.get */.Z.get(system/* KEY_TOKEN */.JE);
    var login = function() {
        router.push(pages/* AUTH_PAGE.login */._L.login);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center justify-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: "https://i.ecomobi.com/ssp/brand-rating/noAccessAllow.jpg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "mt-2 text-[15.6px] font-normal",
                children: t("ss_brand_cpc_no_access_allow")
            }),
            !customerToken ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                    color: "primary",
                    fill: "solid",
                    size: "middle",
                    className: "w-fit",
                    onClick: login,
                    children: t("login")
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/setting/components/body/component/JoinCampaign/Details/index.tsx
function Details_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Details_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Details_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Details_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


















function DetailsCampaign(props) {
    var details = props.details, setShowDetails = props.setShowDetails, setShowUploadImage = props.setShowUploadImage;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var profile = (0,react_redux_es/* useSelector */.v9)(userSlice/* selectProfile */.tM);
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var customerToken = js_cookie/* default.get */.Z.get(system/* KEY_TOKEN */.JE);
    var ref = (0,react.useState)(false), showReject = ref[0], setShowReject = ref[1];
    var titleCss = "font-normal text-[15.6px] text-[#333333]";
    var contentCss = "font-normal text-[13px] text-[#8C8C8C]";
    var buttonCss = "adm-button adm-button-shape-default w-full  w-1/2 text-center";
    var handleJoin = function() {
        var _ref = Details_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,api/* updateCampaignStatus */.pw)({
                            cpc_campaign_id: details.id
                        }).then(function() {
                            es/* Toast.show */.FN.show({
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                    className: "text-center inline-block w-[36px] h-[36px]",
                                    fillColor: "#00B578"
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: t("ss_brand_cpc_join_successfully_label")
                                })
                            });
                            setTimeout(function() {
                                setShowDetails(false);
                                setShowUploadImage(true);
                            }, 1500);
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleJoin() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!details || !customerToken) setShowReject(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full h-full pb-[69px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-3 px-3 bg-white pb-2 flex",
                        style: {
                            boxShadow: "inset 0px -1px 0px #EEEEEE"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "m-auto text-center items-center text-lg font-normal flex",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconDocument */.sz, {
                                    className: "inline-block mr-2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "max-h-[28px] max-w-[300px] block whitespace-nowrap overflow-hidden text-ellipsis line-clamp-1",
                                    children: [
                                        t("ss_brand_cpc_campaign_title"),
                                        " ",
                                        details.title
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-3 flex flex-col gap-3 bg-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: details.creator_banner_image,
                                className: "rounded-lg",
                                style: {
                                    aspectRatio: "3/2"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: titleCss,
                                        children: t("ss_brand_cpc_bonus")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "bg-[#FFCCC7] text-[#EE3244] text-[13px] font-medium rounded px-2 py-1 w-fit",
                                        children: [
                                            (0,lib/* formatNumberToCurrency */.vx)(details.bonus),
                                            " ",
                                            configs_const/* countryCurrencyMap */.f8[passioPageProfile.country]
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: titleCss,
                                        children: t("ss_brand_cpc_notice")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: contentCss,
                                        children: t("ss_brand_cpc_notice_content")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: titleCss,
                                        children: t("ss_brand_cpc_description")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: contentCss,
                                        children: (0,lib/* htmlDecode */.l_)(details.description)
                                    })
                                ]
                            }),
                            details.creator_start_date || details.creator_end_date ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: titleCss,
                                        children: details.creator_start_date && details.creator_end_date ? t("ss_brand_cpc_time") : details.creator_start_date && !details.creator_end_date ? t("ss_brand_cpc_time_start") : t("ss_brand_cpc_time_end")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: contentCss,
                                        children: details.creator_start_date && details.creator_end_date ? "".concat(moment_default()(details.creator_start_date).format("DD/MM/YYYY"), " - ").concat(moment_default()(details.creator_end_date).format("DD/MM/YYYY")) : details.creator_start_date && !details.creator_end_date ? moment_default()(details.creator_start_date).format("DD/MM/YYYY") : moment_default()(details.creator_end_date).format("DD/MM/YYYY")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: titleCss,
                                        children: t("ss_brand_cpc_requirement")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: contentCss,
                                        children: (0,lib/* htmlDecode */.l_)(details.requirement)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                        className: "".concat(buttonCss, " adm-button-default"),
                        onClick: function() {
                            return setShowDetails(false);
                        },
                        children: t("ss_builder_close_panel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                        color: "primary",
                        className: "".concat(buttonCss, " adm-button-primary"),
                        onClick: handleJoin,
                        children: t("ss_brand_cpc_join")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: showReject,
                onMaskClick: function() {
                    return setShowReject(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RejectAccess, {
                    visible: showReject,
                    setShowUploadImage: setShowReject,
                    details: details
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/features/share/components/UploadImage/index.tsx
var UploadImage = __webpack_require__(94261);
;// CONCATENATED MODULE: ./src/features/setting/components/body/component/JoinCampaign/UploadImage/index.tsx
function UploadImage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function UploadImage_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                UploadImage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                UploadImage_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}










function UploadTestImage(props) {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var details = props.details, setShowUploadImage = props.setShowUploadImage;
    var ref = (0,react.useState)((details === null || details === void 0 ? void 0 : details.acceptance_image) || ""), valueUrlImage = ref[0], setValueUrlImage = ref[1];
    var ref1 = (0,react.useState)([]), uploadedImageArr = ref1[0], setUploadedImageArr = ref1[1];
    var ref2 = (0,react.useState)(""), errorImage = ref2[0], setErrorImage = ref2[1];
    var ref3 = (0,react.useState)(false), isButton = ref3[0], setIsButton = ref3[1];
    var contentCss = "text-[15px] font-normal text-[#666666]";
    var buttonCss = "adm-button adm-button-shape-default w-full w-1/2 text-center";
    var handleSave = function() {
        var _ref = UploadImage_asyncToGenerator(runtime_default().mark(function _callee() {
            var imageUpload, formData, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (valueUrlImage) {
                            _ctx.next = 4;
                            break;
                        }
                        setErrorImage(t("ss_builder_upload_file_format_invalid_content"));
                        setIsButton(true);
                        return _ctx.abrupt("return");
                    case 4:
                        imageUpload = uploadedImageArr && uploadedImageArr[uploadedImageArr.length - 1];
                        formData = new FormData();
                        if (imageUpload) formData.append("acceptance_image", imageUpload === null || imageUpload === void 0 ? void 0 : imageUpload.file);
                        formData.append("cpc_campaign_id", details.id);
                        _ctx.next = 10;
                        return (0,api/* updateCampaignImage */.ow)(formData);
                    case 10:
                        res = _ctx.sent;
                        if (res) {
                            es/* Toast.show */.FN.show({
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CheckCircleIcon */.rE, {
                                    className: "text-center inline-block w-[36px] h-[36px]",
                                    fillColor: "#00B578"
                                }),
                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center",
                                    children: t("ss_brand_cpc_upload_image_successfully")
                                })
                            });
                            setTimeout(function() {
                                setShowUploadImage(false);
                            }, 1500);
                        }
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSave() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (errorImage) {
            setUploadedImageArr([]);
            setValueUrlImage("");
        }
    }, [
        errorImage
    ]);
    var handleImageUrl = function(data) {
        var imgFileItems = data && data[data.length - 1];
        if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidFormat) {
            setErrorImage(t("ss_builder_upload_file_format_invalid_content"));
        } else if (imgFileItems === null || imgFileItems === void 0 ? void 0 : imgFileItems.isValidSize) {
            setErrorImage(t("ss_builder_upload_file_size_invalid_content"));
        } else {
            setUploadedImageArr(data);
            setValueUrlImage(imgFileItems.url);
            setIsButton(true);
            setErrorImage("");
        }
    };
    var handleDownloadBarCode = function() {
        var _ref = UploadImage_asyncToGenerator(runtime_default().mark(function _callee() {
            var res, data, url, a;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetch("https://ga.passio.eco/api/v1/affiliate/media-file?tk=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJmaWxlIjoiaW1hZ2VzL2NvbW1vbi9mXzIwMjMwNDEyMTEzNDEwMTY2MTMxMDAucG5nIiwiZXh0IjoicG5nIiwidHlwZSI6ImltYWdlIn0.VfCq2uV1TaeZ8WmpwyLB2ReW9IO0wCwFQmbwCBeIh9I");
                    case 2:
                        res = _ctx.sent;
                        _ctx.next = 5;
                        return res.blob();
                    case 5:
                        data = _ctx.sent;
                        url = window.URL.createObjectURL(data);
                        a = document.createElement("a");
                        a.href = url;
                        a.download = Date.now() + "-file.png";
                        a.click();
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDownloadBarCode() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDownloadDantri = function() {
        var _ref = UploadImage_asyncToGenerator(runtime_default().mark(function _callee() {
            var res, data, url, a;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetch("https://icdn.dantri.com.vn/thumb_w/1020/2023/05/31/luc-luong-than-nga-tai-donbass-don-them-hai-tieu-doan-tiep-viendocx-1663383975320-1668568569427-1673146469826-1676283542589-1685517987879.jpeg");
                    case 2:
                        res = _ctx.sent;
                        _ctx.next = 5;
                        return res.blob();
                    case 5:
                        data = _ctx.sent;
                        url = window.URL.createObjectURL(data);
                        a = document.createElement("a");
                        a.href = url;
                        a.download = Date.now() + "-file.png";
                        a.click();
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDownloadDantri() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDownload = function() {
        var _ref = UploadImage_asyncToGenerator(runtime_default().mark(function _callee() {
            var res, data, url, a;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetch(details.creator_banner_image);
                    case 2:
                        res = _ctx.sent;
                        _ctx.next = 5;
                        return res.blob();
                    case 5:
                        data = _ctx.sent;
                        url = window.URL.createObjectURL(data);
                        a = document.createElement("a");
                        a.href = url;
                        a.download = Date.now() + "-file.png";
                        a.click();
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        // saveAs(url, `banner-title.png`)
        }));
        return function handleDownload() {
            return _ref.apply(this, arguments);
        };
    }();
    var toDataURL = function(url) {
        return fetch(url).then(function(response) {
            return response.blob();
        }).then(function(blob) {
            return URL.createObjectURL(blob);
        });
    };
    var dateTime = function() {
        if (details.creator_start_date && details.creator_end_date) {
            return "".concat(moment_default()(details === null || details === void 0 ? void 0 : details.creator_start_date).format("DD/MM/YYYY"), " - ").concat(moment_default()(details === null || details === void 0 ? void 0 : details.creator_end_date).format("DD/MM/YYYY"));
        }
        if (details.creator_start_date && !details.creator_end_date) {
            return "".concat(t("ss_brand_cpc_from"), " ").concat(moment_default()(details === null || details === void 0 ? void 0 : details.creator_start_date).format("DD/MM/YYYY"));
        }
        if (!details.creator_start_date && details.creator_end_date) {
            return "".concat(t("ss_brand_cpc_to"), " ").concat(moment_default()(details === null || details === void 0 ? void 0 : details.creator_end_date).format("DD/MM/YYYY"));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full h-full pb-[69px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-3 px-3 bg-white pb-2 flex",
                        style: {
                            boxShadow: "inset 0px -1px 0px #EEEEEE"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "m-auto text-center items-center text-lg font-normal",
                            children: t("ss_brand_cpc_upload_image_title")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-3 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-1 px-4 py-3 bg-white",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-0.5 relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute top-0 text-[15px] leading-6",
                                                style: {
                                                    left: "-0.6em",
                                                    color: "var(--adm-color-danger)"
                                                },
                                                children: "*"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(contentCss),
                                                children: t("ss_brand_cpc_step_1")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat(contentCss),
                                                children: [
                                                    t("ss_brand_cpc_step_1_note"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    dateTime()
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: details.creator_banner_image,
                                        style: {
                                            aspectRatio: "3/2"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                            color: "primary",
                                            fill: "solid",
                                            size: "middle",
                                            className: "w-full",
                                            onClick: handleDownload,
                                            children: t("ss_brand_cpc_download")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-1 px-4 py-3 bg-white",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col gap-0.5 relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute top-0 text-[15px] leading-6",
                                                style: {
                                                    left: "-0.6em",
                                                    color: "var(--adm-color-danger)"
                                                },
                                                children: "*"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(contentCss),
                                                children: t("ss_brand_cpc_step_2")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(contentCss),
                                                children: t("ss_brand_cpc_step_2_note")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage/* default */.Z, {
                                        isUseBorderErr: errorImage.length > 0,
                                        valueUrlImage: valueUrlImage,
                                        imageRatio: "3/2",
                                        error: errorImage.length > 0,
                                        textHelper: t("ss_tod_setting_cover_image_helper")
                                    }),
                                    errorImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row gap-1 items-center mt-1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                                                fillColor: "#FF3141",
                                                className: "w-4 h-4"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-[#FF3141] text-[13px]",
                                                children: errorImage
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                                            onChange: handleImageUrl,
                                            upload: function(file) {
                                                return (0,lib/* mockUpload */.Hq)(file, 514, 980);
                                            },
                                            className: "grow",
                                            value: uploadedImageArr,
                                            disableUpload: details.join_status === 2,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                                color: "primary",
                                                fill: "solid",
                                                size: "middle",
                                                className: "w-full",
                                                disabled: details.join_status === 2,
                                                children: t("ss_brand_cpc_upload_image_button")
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-width-content-class fixed bottom-0 p-2 flex w-full justify-between gap-2 z-[10] bg-[#FFFFFF]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                        className: "".concat(buttonCss, " adm-button-default"),
                        onClick: function() {
                            return setShowUploadImage(false);
                        },
                        children: t("ss_builder_close_panel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                        disabled: !isButton,
                        color: "primary",
                        className: "".concat(buttonCss, " adm-button-primary"),
                        onClick: handleSave,
                        children: t("ss_builder_save")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/setting/components/body/component/JoinCampaign/index.tsx
function JoinCampaign_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function JoinCampaign_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                JoinCampaign_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                JoinCampaign_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}









function JoinCampaign(props) {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(), details = ref[0], setDetails = ref[1];
    var ref1 = (0,react.useState)(false), showDetails = ref1[0], setShowDetails = ref1[1];
    var ref2 = (0,react.useState)(false), showUploadImage = ref2[0], setShowUploadImage = ref2[1];
    var getWebsiteConfig = function() {
        var _ref = JoinCampaign_asyncToGenerator(runtime_default().mark(function _callee() {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        response = null;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,api/* getListCampaign */["do"])();
                    case 4:
                        response = _ctx.sent;
                        setDetails(response[0]);
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        console.log(_ctx.t0);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function getWebsiteConfig() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getWebsiteConfig();
    }, []);
    (0,react.useEffect)(function() {
        getWebsiteConfig();
    }, [
        showUploadImage
    ]);
    var handleButton = function() {
        if ((details === null || details === void 0 ? void 0 : details.join_status) == 0) setShowDetails(true);
        else setShowUploadImage(true);
    };
    if (!details || !Object.keys(details).length) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-3 bg-[#fff] rounded flex flex-col gap-4 mb-3",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "font-normal text-[15.6px] text-[#333333]",
                        children: [
                            t("ss_brand_cpc_text_title"),
                            " ",
                            details === null || details === void 0 ? void 0 : details.title
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "font-normal text-[12px] text-[#8C8C8C]",
                        children: [
                            details === null || details === void 0 ? void 0 : details.title,
                            " ",
                            t("ss_brand_cpc_text_content")
                        ]
                    }),
                    (details === null || details === void 0 ? void 0 : details.join_status) == 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-2 py-1 rounded bg-[#FFCCC7] w-fit text-[#F5222D] text-[10.8px] font-normal",
                        children: t("ss_brand_cpc_reject")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                    (details === null || details === void 0 ? void 0 : details.join_status) == 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "px-2 py-1 rounded bg-[#00B578] w-fit text-[#FFFFFF] text-[10.8px] font-normal",
                        children: t("ss_brand_cpc_success")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            }),
            (details === null || details === void 0 ? void 0 : details.join_status) != 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                color: "primary",
                fill: "solid",
                size: "middle",
                className: "w-fit",
                onClick: handleButton,
                children: (details === null || details === void 0 ? void 0 : details.join_status) == 0 ? t("ss_brand_cpc_join_now") : (details === null || details === void 0 ? void 0 : details.join_status) == 2 ? "" : t("ss_brand_cpc_upload_image")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: showDetails,
                onMaskClick: function() {
                    return setShowDetails(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsCampaign, {
                    visible: showDetails,
                    setShowDetails: setShowDetails,
                    setShowUploadImage: setShowUploadImage,
                    details: details
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: showUploadImage,
                onMaskClick: function() {
                    return setShowUploadImage(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadTestImage, {
                    visible: showUploadImage,
                    setShowUploadImage: setShowUploadImage,
                    details: details
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/setting/components/body/index.tsx






var BodySetting = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinCampaign, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_ThemeSetting, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_SiteSetting, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(component_RatingStar, {})
        ]
    });
};
/* harmony default export */ var body = (BodySetting);

;// CONCATENATED MODULE: ./src/features/setting/hooks/useGetWebsiteConfig.ts
function useGetWebsiteConfig_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useGetWebsiteConfig_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useGetWebsiteConfig_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useGetWebsiteConfig_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}








var useGetWebsiteConfig = function() {
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var user_id = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref, ref1;
        return state === null || state === void 0 ? void 0 : (ref = state.user) === null || ref === void 0 ? void 0 : (ref1 = ref.kol) === null || ref1 === void 0 ? void 0 : ref1._id;
    });
    var passioPageProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var creatorType = passioPageProfile === null || passioPageProfile === void 0 ? void 0 : passioPageProfile.creator_type;
    (0,react.useEffect)(function() {
        var getWebsiteConfig = function() {
            var _ref = useGetWebsiteConfig_asyncToGenerator(runtime_default().mark(function _callee() {
                var response, data, ref, favicon, meta_title, ref2, meta_description;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            response = null;
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return (0,api/* requestGetSiteSetting */.s2)(user_id);
                        case 4:
                            response = _ctx.sent;
                            _ctx.next = 10;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](1);
                            console.log(_ctx.t0);
                        case 10:
                            if (response) {
                                data = response === null || response === void 0 ? void 0 : response.data;
                                if (data) {
                                    ;
                                    favicon = creatorType === store_interface/* CREATOR_TYPE_ENUM.FOURTEEN */.sG.FOURTEEN && ((data === null || data === void 0 ? void 0 : data.favicon) === configs_const/* OLD_PASSIO_DEFAULT_ICON */.Vm || (data === null || data === void 0 ? void 0 : data.favicon) === configs_const/* PASSIO_DEFAULT_ICON */.wO) ? configs_const/* CREATOR_FOURTEEN_DEFAULT_ICON */.kH : (ref = data === null || data === void 0 ? void 0 : data.favicon) !== null && ref !== void 0 ? ref : configs_const/* PASSIO_DEFAULT_ICON */.wO;
                                    meta_title = (data === null || data === void 0 ? void 0 : data.meta_title) || "";
                                    ;
                                    meta_description = (ref2 = data === null || data === void 0 ? void 0 : data.meta_description) !== null && ref2 !== void 0 ? ref2 : t("ss_builder_default_meta_description");
                                    dispatch((0,websiteConfigSlice/* setWebsiteConfig */.me)({
                                        data: {
                                            id: data === null || data === void 0 ? void 0 : data.id,
                                            favicon: favicon,
                                            meta_title: meta_title,
                                            meta_description: meta_description,
                                            site_title: data === null || data === void 0 ? void 0 : data.site_title
                                        }
                                    }));
                                }
                            }
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        7
                    ]
                ]);
            }));
            return function getWebsiteConfig() {
                return _ref.apply(this, arguments);
            };
        }();
        getWebsiteConfig();
    }, [
        user_id
    ]);
    return null;
};
/* harmony default export */ var hooks_useGetWebsiteConfig = (useGetWebsiteConfig);

;// CONCATENATED MODULE: ./src/features/setting/components/index.tsx





var components_Setting = function() {
    hooks_useGetWebsiteConfig();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-width-content-class theme-setting-class m-auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(heading, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "wrapper-setting",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(body, {})
                })
            ]
        })
    });
};
/* harmony default export */ var setting_components = (components_Setting);

;// CONCATENATED MODULE: ./src/features/share/components/theme-style/background.tsx


var BackgroundTypeEnum;
(function(BackgroundTypeEnum) {
    BackgroundTypeEnum["SOLID"] = "solid";
    BackgroundTypeEnum["GRADIENT"] = "gradient";
    BackgroundTypeEnum["IMAGE"] = "image";
})(BackgroundTypeEnum || (BackgroundTypeEnum = {}));
var BackgroundStyle = function(param) {
    var backgroundSetting = param.backgroundSetting;
    (0,react.useEffect)(function() {
        var ref = backgroundSetting || {}, color = ref.color, gradient = ref.gradient, image = ref.image, type = ref.type, blur = ref.blur, overlay_color = ref.overlay_color;
        //Background solid color
        if (type === "solid") {
            document.documentElement.style.setProperty("--background-color", color !== null && color !== void 0 ? color : configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_SOLID */.Vw.COLOR_SOLID);
            document.documentElement.style.setProperty("--background-image", "none");
        }
        //Background gradient color
        if (type === "gradient") {
            document.documentElement.style.setProperty("--background-image", gradient !== null && gradient !== void 0 ? gradient : "linear-gradient(".concat(configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_GRADIENT_DIRECTION */.Vw.COLOR_GRADIENT_DIRECTION, ", ").concat(configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_GRADIENT_GENERATOR_FIRST_COLOR */.Vw.COLOR_GRADIENT_GENERATOR_FIRST_COLOR, ", ").concat(configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_GRADIENT_GENERATOR_SECOND_COLOR */.Vw.COLOR_GRADIENT_GENERATOR_SECOND_COLOR, ")"));
            document.documentElement.style.setProperty("--background-color", "none");
        }
        //Background image
        if (image && type === "image") {
            document.documentElement.style.setProperty("--background-image", "url('".concat(image, "')"));
            document.documentElement.style.setProperty("--background-color", "none");
        }
        //Background blur
        document.documentElement.style.setProperty("--background-blur", blur && typeof blur === "number" ? "".concat(blur, "px") : "".concat(configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.BLUR */.Vw.BLUR, "px"));
        //Background overlay color
        document.documentElement.style.setProperty("--background-overlay-color", overlay_color || configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.OVERLAY_COLOR */.Vw.OVERLAY_COLOR);
    }, [
        backgroundSetting
    ]);
    return null;
};
/* harmony default export */ var background = (BackgroundStyle);

;// CONCATENATED MODULE: ./src/features/share/components/theme-style/block.tsx


var BlockRadiusTypeEnum;
(function(BlockRadiusTypeEnum) {
    BlockRadiusTypeEnum["SQUARE"] = "square";
    BlockRadiusTypeEnum["ROUNDED"] = "rounded";
    BlockRadiusTypeEnum["CUSTOM"] = "custom";
})(BlockRadiusTypeEnum || (BlockRadiusTypeEnum = {}));
var BlockStyle = function(param) {
    var blockSetting = param.blockSetting;
    (0,react.useEffect)(function() {
        var ref = blockSetting || {}, block_style = ref.block_style, block_background = ref.block_background, block_border = ref.block_border, block_shadow = ref.block_shadow;
        var ref1 = block_style || {}, radius_type = ref1.radius_type, radius_value = ref1.radius_value, inner_space = ref1.inner_space, inner_space_number = ref1.inner_space_number, outside_space = ref1.outside_space;
        var ref2 = block_background || {}, tmp = ref2.color, backgroundColor = tmp === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_COLOR */.eJ.BACKGROUND_COLOR : tmp, blur = ref2.blur;
        var block_tab_background = backgroundColor ? "".concat(backgroundColor.toString().substring(0, 7), "ff") : configs_const/* BLOCK_SETTING_DEFAULT_VALUE.TAB_BACKGROUND_COLOR */.eJ.TAB_BACKGROUND_COLOR;
        var block_background_drag_drop = backgroundColor ? "".concat(backgroundColor.toString().substring(0, 7), "BF") : configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_COLOR */.eJ.BACKGROUND_COLOR;
        var ref3 = block_border || {}, enableBorder = ref3.enable, borderColor = ref3.color, typeBorder = ref3.type, border_width = ref3.border_width;
        var ref4 = block_shadow || {}, enableShadow = ref4.enable, shadowColor = ref4.color;
        //Block border radius
        if (radius_type && radius_type === "square") {
            document.documentElement.style.setProperty("--block-border-radius", "0px");
        }
        if (radius_type && radius_type === "rounded") {
            document.documentElement.style.setProperty("--block-border-radius", "8px");
        }
        if (radius_type && radius_type === "custom") {
            document.documentElement.style.setProperty("--block-border-radius", radius_value && typeof radius_value === "number" ? "".concat(radius_value, "px") : "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE */.eJ, "px"));
        }
        //Block inner space
        if (typeof inner_space_number === "number") {
            document.documentElement.style.setProperty("--block-inner-space", "".concat(inner_space_number, "px"));
        } else {
            if (typeof inner_space === "boolean") {
                document.documentElement.style.setProperty("--block-inner-space", inner_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */.eJ.INNER_SPACE_NUMBER, "px") : "0px");
            } else {
                document.documentElement.style.setProperty("--block-inner-space", "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */.eJ.INNER_SPACE_NUMBER, "px"));
            }
        }
        if (outside_space || typeof outside_space === "undefined") {
            document.documentElement.style.setProperty("--block-outside-space", "12px");
        } else {
            document.documentElement.style.setProperty("--block-outside-space", "0px");
        }
        //Block background color
        document.documentElement.style.setProperty("--block-background-color", backgroundColor);
        //Block Tab background color
        document.documentElement.style.setProperty("--block-tab-background-color", block_tab_background);
        //background color when drag drop
        document.documentElement.style.setProperty("--block-background-color-drag-drop", block_background_drag_drop);
        //Block background blur
        document.documentElement.style.setProperty("--block-background-blur", blur && typeof blur === "number" ? "".concat(blur, "px") : "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_BLUR */.eJ.BACKGROUND_BLUR, "px"));
        // Block border
        if (enableBorder) {
            //Block border color
            document.documentElement.style.setProperty("--block-border-color", borderColor !== null && borderColor !== void 0 ? borderColor : configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_COLOR */.eJ.BORDER_COLOR);
            //Block border width
            document.documentElement.style.setProperty("--block-border-width", border_width && typeof border_width === "number" ? "".concat(border_width, "px") : "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_WIDTH */.eJ.BORDER_WIDTH, "px"));
            //Block border style
            document.documentElement.style.setProperty("--block-border-style", typeBorder !== null && typeBorder !== void 0 ? typeBorder : configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_STYLE */.eJ.BORDER_STYLE);
        } else {
            document.documentElement.style.setProperty("--block-border-width", "0px");
        }
        if (enableShadow) {
            //Block shadow
            document.documentElement.style.setProperty("--block-box-shadow", shadowColor ? "0px 4px 4px ".concat(shadowColor) : "0px 4px 4px ".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.SHADOW_COLOR */.eJ.SHADOW_COLOR));
        } else {
            document.documentElement.style.setProperty("--block-box-shadow", "none");
        }
        // First we get the viewport height and multiply it by 1% to get a value for a vh unit
        var vh1 = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty("--vh", "".concat(vh1, "px"));
        // We listen to the resize event
        window.addEventListener("resize", function() {
            // We execute the same script as before
            var vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
        });
    }, [
        blockSetting
    ]);
    return null;
};
/* harmony default export */ var block = (BlockStyle);

;// CONCATENATED MODULE: ./src/features/share/components/theme-style/button.tsx


var ButtonRadiusTypeEnum;
(function(ButtonRadiusTypeEnum) {
    ButtonRadiusTypeEnum["SQUARE"] = "square";
    ButtonRadiusTypeEnum["ROUNDED"] = "rounded";
    ButtonRadiusTypeEnum["CUSTOM"] = "custom";
})(ButtonRadiusTypeEnum || (ButtonRadiusTypeEnum = {}));
var ButtonStyle = function(param) {
    var buttonSetting = param.buttonSetting;
    (0,react.useEffect)(function() {
        var ref = buttonSetting || {}, border_color = ref.border_color, background_color = ref.background_color, border_width = ref.border_width, text_color = ref.text_color, radius_type = ref.radius_type, radius_value = ref.radius_value, enable_border = ref.enable_border, _shadow_type = ref.shadow_type, shadow_type = _shadow_type === void 0 ? configs_const/* BUTTON_SETTING_SHADOW_STYLE.NO_SHADOW */.r8.NO_SHADOW : _shadow_type, shadow_color = ref.shadow_color;
        var bigButtonSetting = buttonSetting === null || buttonSetting === void 0 ? void 0 : buttonSetting.big_button_setting;
        var mediumButtonSetting = buttonSetting === null || buttonSetting === void 0 ? void 0 : buttonSetting.medium_button_setting;
        var smallButtonSetting = buttonSetting === null || buttonSetting === void 0 ? void 0 : buttonSetting.small_button_setting;
        var newShadowColor = shadow_color !== null && shadow_color !== void 0 ? shadow_color : shadow_type === configs_const/* BUTTON_SETTING_SHADOW_STYLE.SOFT_SHADOW */.r8.SOFT_SHADOW ? configs_const/* BUTTON_SETTING_DEFAULT_VALUE.SOFT_SHADOW_COLOR */.Xe.SOFT_SHADOW_COLOR : configs_const/* BUTTON_SETTING_DEFAULT_VALUE.HARD_SHADOW_COLOR */.Xe.HARD_SHADOW_COLOR;
        var ref1 = mediumButtonSetting || {}, medium_button_font_size = ref1.font_size, medium_button_line_height = ref1.line_height, medium_button_font_weight = ref1.font_weight;
        if (enable_border) {
            //Button border color
            document.documentElement.style.setProperty("--button-border-color", border_color !== null && border_color !== void 0 ? border_color : configs_const/* BUTTON_SETTING_DEFAULT_VALUE.BORDER_COLOR */.Xe.BORDER_COLOR);
            //Button border width
            if (typeof border_width === "number") {
                document.documentElement.style.setProperty("--button-border-width", border_width && typeof border_width === "number" ? "".concat(border_width, "px") : "".concat(configs_const/* BUTTON_SETTING_DEFAULT_VALUE.BORDER_WIDTH */.Xe.BORDER_WIDTH, "px"));
            }
        } else {
            document.documentElement.style.setProperty("--button-border-width", "0px");
        }
        //Button background color
        document.documentElement.style.setProperty("--button-background-color", background_color !== null && background_color !== void 0 ? background_color : configs_const/* BUTTON_SETTING_DEFAULT_VALUE.BACKGROUND_COLOR */.Xe.BACKGROUND_COLOR);
        //Button text color
        document.documentElement.style.setProperty("--button-text-color", text_color !== null && text_color !== void 0 ? text_color : configs_const/* BUTTON_SETTING_DEFAULT_VALUE.TEXT_COLOR */.Xe.TEXT_COLOR);
        //Button radius
        if (radius_type) {
            if (radius_type === "square") {
                document.documentElement.style.setProperty("--button-border-radius", "0px");
            }
            if (radius_type === "rounded") {
                document.documentElement.style.setProperty("--button-border-radius", "8px");
            }
            if (radius_type === "custom") {
                document.documentElement.style.setProperty("--button-border-radius", typeof radius_value === "number" ? "".concat(radius_value, "px") : "".concat(configs_const/* BUTTON_SETTING_DEFAULT_VALUE.RADIUS_VALUE */.Xe.RADIUS_VALUE, "px"));
            }
        }
        // Big button
        //Big button font size
        document.documentElement.style.setProperty("--large-button-font-size", medium_button_font_size && typeof medium_button_font_size === "number" ? "".concat(medium_button_font_size + 1, "px") : "".concat(configs_const/* MEDIUM_BUTTON_SETTING_DEFAULT_VALUE.FONT_SIZE */.h3.FONT_SIZE, "px"));
        //Big button font weight
        document.documentElement.style.setProperty("--large-button-font-weight", medium_button_font_weight !== null && medium_button_font_weight !== void 0 ? medium_button_font_weight : configs_const/* MEDIUM_BUTTON_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.h3.FONT_WEIGHT);
        //Big button line height
        document.documentElement.style.setProperty("--large-button-line-height", medium_button_line_height !== null && medium_button_line_height !== void 0 ? medium_button_line_height : configs_const/* MEDIUM_BUTTON_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.h3.LINE_HEIGHT);
        //Medium button
        //Medium button font size
        document.documentElement.style.setProperty("--middle-button-font-size", medium_button_font_size && typeof medium_button_font_size === "number" ? "".concat(medium_button_font_size, "px") : "".concat(configs_const/* MEDIUM_BUTTON_SETTING_DEFAULT_VALUE.FONT_SIZE */.h3.FONT_SIZE, "px"));
        //Medium button font weight
        document.documentElement.style.setProperty("--middle-button-font-weight", medium_button_font_weight !== null && medium_button_font_weight !== void 0 ? medium_button_font_weight : configs_const/* MEDIUM_BUTTON_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.h3.FONT_WEIGHT);
        //Medium button line height
        document.documentElement.style.setProperty("--middle-button-line-height", medium_button_line_height !== null && medium_button_line_height !== void 0 ? medium_button_line_height : configs_const/* MEDIUM_BUTTON_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.h3.LINE_HEIGHT);
        //Small button
        //Small button font size
        document.documentElement.style.setProperty("--small-button-font-size", medium_button_font_size && typeof medium_button_font_size === "number" ? "".concat(medium_button_font_size - 2, "px") : "".concat(configs_const/* MEDIUM_BUTTON_SETTING_DEFAULT_VALUE.FONT_SIZE */.h3.FONT_SIZE));
        //Small button font weight
        document.documentElement.style.setProperty("--small-button-font-weight", medium_button_font_weight !== null && medium_button_font_weight !== void 0 ? medium_button_font_weight : configs_const/* MEDIUM_BUTTON_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.h3.FONT_WEIGHT);
        //Small button line height
        document.documentElement.style.setProperty("--small-button-line-height", medium_button_line_height !== null && medium_button_line_height !== void 0 ? medium_button_line_height : configs_const/* MEDIUM_BUTTON_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.h3.LINE_HEIGHT);
        //Button shadow
        if (shadow_type) {
            if (shadow_type === configs_const/* BUTTON_SETTING_SHADOW_STYLE.NO_SHADOW */.r8.NO_SHADOW) {
                document.documentElement.style.setProperty("--button-box-shadow", "none");
            }
            if (shadow_type === configs_const/* BUTTON_SETTING_SHADOW_STYLE.SOFT_SHADOW */.r8.SOFT_SHADOW) {
                document.documentElement.style.setProperty("--button-box-shadow", "0px 5px 12px ".concat(newShadowColor));
            }
            if (shadow_type === configs_const/* BUTTON_SETTING_SHADOW_STYLE.HARD_SHADOW */.r8.HARD_SHADOW) {
                document.documentElement.style.setProperty("--button-box-shadow", "5px 5px 0px ".concat(newShadowColor));
            }
        }
        document.documentElement.style.setProperty("--button-box-soft-shadow", "0px 5px 12px  ".concat(shadow_color !== null && shadow_color !== void 0 ? shadow_color : configs_const/* BUTTON_SETTING_DEFAULT_VALUE.SOFT_SHADOW_COLOR */.Xe.SOFT_SHADOW_COLOR));
        document.documentElement.style.setProperty("--button-box-hard-shadow", "4px 5px 0px ".concat(shadow_color !== null && shadow_color !== void 0 ? shadow_color : configs_const/* BUTTON_SETTING_DEFAULT_VALUE.HARD_SHADOW_COLOR */.Xe.HARD_SHADOW_COLOR));
    }, [
        buttonSetting
    ]);
    return null;
};
/* harmony default export */ var theme_style_button = (ButtonStyle);

;// CONCATENATED MODULE: ./src/features/share/components/theme-style/generator.tsx


var GeneratorStyle = function(param) {
    var generatorSetting = param.generatorSetting;
    var ref = generatorSetting || {}, primary_color = ref.primary_color, secondary_color = ref.secondary_color;
    (0,react.useEffect)(function() {
        var designElement = document.querySelector(".design-class");
        var tabMenuPortalElement = document.querySelector("#tabMenuDesignPortal");
        // const designContentPortalElement = document.querySelector(
        //   "#myDesignContentPortal"
        // ) as HTMLElement;
        //Primary color
        designElement === null || designElement === void 0 ? void 0 : designElement.style.setProperty("--adm-color-primary", primary_color !== null && primary_color !== void 0 ? primary_color : configs_const/* GENERAL_SETTING_DEFAULT_VALUE.PRIMARY_COLOR */.yv.PRIMARY_COLOR);
        tabMenuPortalElement === null || tabMenuPortalElement === void 0 ? void 0 : tabMenuPortalElement.style.setProperty("--adm-color-primary", primary_color !== null && primary_color !== void 0 ? primary_color : configs_const/* GENERAL_SETTING_DEFAULT_VALUE.PRIMARY_COLOR */.yv.PRIMARY_COLOR);
        // designContentPortalElement.style.setProperty(
        //   "--adm-color-primary",
        //   primary_color ?? GENERAL_SETTING_DEFAULT_VALUE.PRIMARY_COLOR
        // );
        //Secondary color
        document.documentElement.style.setProperty("--secondary-color", secondary_color !== null && secondary_color !== void 0 ? secondary_color : configs_const/* GENERAL_SETTING_DEFAULT_VALUE.SECONDARY_COLOR */.yv.SECONDARY_COLOR);
    }, [
        primary_color,
        secondary_color
    ]);
    return null;
};
/* harmony default export */ var generator = (GeneratorStyle);

;// CONCATENATED MODULE: ./src/features/share/components/theme-style/paragraph.tsx


var ParagraphStyle = function(param) {
    var paragraphSetting = param.paragraphSetting;
    (0,react.useEffect)(function() {
        var ref = paragraphSetting || {}, fontFamily = ref.font_family, paragraphColor = ref.font_color, paragraphFontSize = ref.font_size, paragraphScale = ref.scale, paragraphFontWeight = ref.font_weight, paragraphLineHeight = ref.line_height, usingFontCustom = ref.using_font_custom, fontFamilyCustom = ref.font_family_custom;
        //Paragraph font family
        var paragraphFontFamily;
        if (!!usingFontCustom && usingFontCustom === configs_const/* FONT_GOOGLE */.O) {
            paragraphFontFamily = (fontFamilyCustom === null || fontFamilyCustom === void 0 ? void 0 : fontFamilyCustom.toString().trim()) || configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_FAMILY_CUSTOM */.no.FONT_FAMILY_CUSTOM;
        } else {
            paragraphFontFamily = fontFamily || configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_FAMILY */.no.FONT_FAMILY;
        }
        document.documentElement.style.setProperty("--paragraph-font-family", paragraphFontFamily !== null && paragraphFontFamily !== void 0 ? paragraphFontFamily : configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_FAMILY */.no.FONT_FAMILY);
        //Paragraph font color
        document.documentElement.style.setProperty("--paragraph-font-color", paragraphColor !== null && paragraphColor !== void 0 ? paragraphColor : configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_COLOR */.no.FONT_COLOR);
        //Paragraph font size
        document.documentElement.style.setProperty("--paragraph-font-size", paragraphFontSize && typeof paragraphFontSize === "number" ? "".concat(paragraphFontSize, "px") : "".concat(configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_SIZE */.no.FONT_SIZE, "px"));
        //Paragraph font weight
        document.documentElement.style.setProperty("--paragraph-font-weight", paragraphFontWeight !== null && paragraphFontWeight !== void 0 ? paragraphFontWeight : configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.no.FONT_WEIGHT);
        //Paragraph line height
        document.documentElement.style.setProperty("--paragraph-line-height", paragraphLineHeight !== null && paragraphLineHeight !== void 0 ? paragraphLineHeight : configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.no.LINE_HEIGHT);
        //Paragraph font scale
        document.documentElement.style.setProperty("--paragraph-font-ratio", paragraphScale !== null && paragraphScale !== void 0 ? paragraphScale : configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_SCALE */.no.FONT_SCALE);
    }, [
        paragraphSetting
    ]);
    return null;
};
/* harmony default export */ var paragraph = (ParagraphStyle);

;// CONCATENATED MODULE: ./src/features/share/components/theme-style/title.tsx


var TitleStyle = function(param) {
    var titleSetting = param.titleSetting;
    (0,react.useEffect)(function() {
        var ref = titleSetting || {}, fontFamily = ref.font_family, titleColor = ref.font_color, titleFontSize = ref.font_size, titleScale = ref.scale, titleFontWeight = ref.font_weight, titleLineHeight = ref.line_height, usingFontCustom = ref.using_font_custom, fontFamilyCustom = ref.font_family_custom;
        //Title font family
        var titleFontFamily;
        if (!!usingFontCustom && usingFontCustom === configs_const/* FONT_GOOGLE */.O) {
            var ref1;
            titleFontFamily = ((ref1 = fontFamilyCustom === null || fontFamilyCustom === void 0 ? void 0 : fontFamilyCustom.toString()) === null || ref1 === void 0 ? void 0 : ref1.trim()) || configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_FAMILY_CUSTOM */.lI.FONT_FAMILY_CUSTOM;
        } else {
            titleFontFamily = fontFamily || configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_FAMILY */.lI.FONT_FAMILY;
        }
        document.documentElement.style.setProperty("--heading-font-family", titleFontFamily !== null && titleFontFamily !== void 0 ? titleFontFamily : configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_FAMILY */.lI.FONT_FAMILY);
        //Title color
        document.documentElement.style.setProperty("--heading-font-color", titleColor !== null && titleColor !== void 0 ? titleColor : configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_COLOR */.lI.FONT_COLOR);
        //Title font size
        document.documentElement.style.setProperty("--heading-font-size", titleFontSize && typeof titleFontSize === "number" ? "".concat(titleFontSize, "px") : "".concat(configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_SIZE */.lI.FONT_SIZE, "px"));
        //Title font weight
        document.documentElement.style.setProperty("--heading-font-weight", titleFontWeight !== null && titleFontWeight !== void 0 ? titleFontWeight : configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.lI.FONT_WEIGHT);
        //Title line height
        document.documentElement.style.setProperty("--heading-line-height", titleLineHeight !== null && titleLineHeight !== void 0 ? titleLineHeight : configs_const/* TITLE_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.lI.LINE_HEIGHT);
        //Title font scale
        document.documentElement.style.setProperty("--heading-font-ratio", titleScale !== null && titleScale !== void 0 ? titleScale : configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_SCALE */.lI.FONT_SCALE);
    }, [
        titleSetting
    ]);
    return null;
};
/* harmony default export */ var title = (TitleStyle);

;// CONCATENATED MODULE: ./src/features/share/components/theme-style/index.tsx








// const enum BackgroundTypeEnum {
//   COLOR = "color",
//   GRADIENT = "gradient",
//   IMAGE = "image",
// }
function ThemeStyle(param) {
    var displaySetting = param.displaySetting;
    var primary_color = displaySetting.primary_color, secondary_color = displaySetting.secondary_color, backgroundSetting = displaySetting.background, block_setting = displaySetting.block_setting, title_setting = displaySetting.title_setting, button_setting = displaySetting.button_setting, paragraph_setting = displaySetting.paragraph_setting;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(generator, {
                generatorSetting: {
                    primary_color: primary_color,
                    secondary_color: secondary_color
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(background, {
                backgroundSetting: backgroundSetting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(block, {
                blockSetting: block_setting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(title, {
                titleSetting: title_setting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph, {
                paragraphSetting: paragraph_setting
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(theme_style_button, {
                buttonSetting: button_setting
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/share/components/generate-color/button.tsx

var ButtonBgColor = function(param) {
    var buttonSetting = param.buttonSetting;
    (0,react.useEffect)(function() {
        if (buttonSetting) {
            var _button_bg_color = buttonSetting.button_bg_color, button_bg_color = _button_bg_color === void 0 ? {} : _button_bg_color, _button_border_color = buttonSetting.button_border_color, button_border_color = _button_border_color === void 0 ? {} : _button_border_color;
            for(var i = 1; i <= 10; i++){
                if (button_bg_color["button-bg-color-".concat(i)]) {
                    document.documentElement.style.setProperty("--button-bg-color-".concat(i), button_bg_color["button-bg-color-".concat(i)]);
                }
                if (button_border_color["button-border-color-".concat(i)]) {
                    document.documentElement.style.setProperty("--button-border-color-".concat(i), button_border_color["button-border-color-".concat(i)]);
                }
            }
        }
    }, [
        buttonSetting
    ]);
    return null;
};
/* harmony default export */ var generate_color_button = (ButtonBgColor);

;// CONCATENATED MODULE: ./src/features/share/components/generate-color/generator.tsx

var GenerateColor = function(param) {
    var generatorSetting = param.generatorSetting;
    var primary_color_generate = generatorSetting.primary_color_generate, secondary_color_generate = generatorSetting.secondary_color_generate;
    (0,react.useEffect)(function() {
        for(var i = 1; i <= 10; i++){
            if (primary_color_generate["primary-".concat(i)]) {
                document.documentElement.style.setProperty("--primary-color-".concat(i), primary_color_generate["primary-".concat(i)]);
            }
            if (secondary_color_generate["secondary-".concat(i)]) {
                document.documentElement.style.setProperty("--secondary-".concat(i), secondary_color_generate["secondary-".concat(i)]);
            }
        }
    }, [
        primary_color_generate,
        secondary_color_generate
    ]);
    return null;
};
/* harmony default export */ var generate_color_generator = (GenerateColor);

;// CONCATENATED MODULE: ./src/features/share/components/generate-color/text.tsx

var TextColor = function(param) {
    var textColorGenerate = param.textColorGenerate;
    (0,react.useEffect)(function() {
        if (textColorGenerate) {
            for(var i = 1; i <= 10; i++){
                if (textColorGenerate["text-color-".concat(i)]) {
                    document.documentElement.style.setProperty("--text-color-".concat(i), textColorGenerate["text-color-".concat(i)]);
                }
            }
        }
    }, [
        textColorGenerate
    ]);
    return null;
};
/* harmony default export */ var generate_color_text = (TextColor);

;// CONCATENATED MODULE: ./src/features/share/components/generate-color/heading.tsx

var HeadingColor = function(param) {
    var headingColorGenerate = param.headingColorGenerate;
    (0,react.useEffect)(function() {
        if (headingColorGenerate) {
            for(var i = 1; i <= 10; i++){
                if (headingColorGenerate["heading-color-".concat(i)]) {
                    document.documentElement.style.setProperty("--heading-color-".concat(i), headingColorGenerate["heading-color-".concat(i)]);
                }
            }
        }
    }, [
        headingColorGenerate
    ]);
    return null;
};
/* harmony default export */ var generate_color_heading = (HeadingColor);

;// CONCATENATED MODULE: ./src/features/share/components/generate-color/index.tsx






// const enum BackgroundTypeEnum {
//   COLOR = "color",
//   GRADIENT = "gradient",
//   IMAGE = "image",
// }
function generate_color_GenerateColor(param) {
    var displaySetting = param.displaySetting;
    var _primary_color_generate = displaySetting.primary_color_generate, primary_color_generate = _primary_color_generate === void 0 ? {} : _primary_color_generate, _secondary_color_generate = displaySetting.secondary_color_generate, secondary_color_generate = _secondary_color_generate === void 0 ? {} : _secondary_color_generate, _heading_color_generate = displaySetting.heading_color_generate, heading_color_generate = _heading_color_generate === void 0 ? {} : _heading_color_generate, _button_setting = displaySetting.button_setting, button_setting = _button_setting === void 0 ? {} : _button_setting, _text_color_generate = displaySetting.text_color_generate, text_color_generate = _text_color_generate === void 0 ? {} : _text_color_generate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(generate_color_generator, {
                generatorSetting: {
                    primary_color_generate: primary_color_generate,
                    secondary_color_generate: secondary_color_generate
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(generate_color_heading, {
                headingColorGenerate: heading_color_generate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(generate_color_text, {
                textColorGenerate: text_color_generate
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(generate_color_button, {
                buttonSetting: button_setting
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/BackgroundSetting/components/ImageUploader/index.tsx






function ImageUploader(props) {
    var defaultImage = props.defaultImage, onChangeImage = props.onChangeImage;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(defaultImage), image = ref[0], setImage = ref[1];
    (0,react.useEffect)(function() {
        setImage(defaultImage);
    }, [
        defaultImage
    ]);
    var ref1 = (0,react.useState)(false), isValidFileFormat = ref1[0], setIsValidFileFormat = ref1[1];
    var ref2 = (0,react.useState)(false), isValidFileSize = ref2[0], setIsValidFileSize = ref2[1];
    var onUploadImage = function(data) {
        var uploadedImage = data[data.length - 1];
        if (uploadedImage === null || uploadedImage === void 0 ? void 0 : uploadedImage.isValidFormat) {
            setIsValidFileFormat(true);
            setIsValidFileSize(false);
        } else if (uploadedImage === null || uploadedImage === void 0 ? void 0 : uploadedImage.isValidSize) {
            setIsValidFileFormat(false);
            setIsValidFileSize(true);
        } else {
            setImage(uploadedImage.url);
            onChangeImage(uploadedImage);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-base mb-1",
                children: t("ss_builder_theme_setting_background_image_preview_label")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-[120px_auto] gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Image */.Ee, {
                        src: image || "https://i.ecomobi.com/ssp/passio-page/image-default.png",
                        // width={120}
                        // height={120}
                        fit: "cover",
                        style: {
                            borderRadius: "8px",
                            width: "120px",
                            height: "120px",
                            objectFit: "cover"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "leading-4",
                                children: t("ss_builder_theme_setting_background_content")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex gap-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* ImageUploader */.wA, {
                                    onChange: onUploadImage,
                                    upload: function(file) {
                                        return (0,lib/* mockUpload */.Hq)(file, 2000, 2000);
                                    },
                                    className: "flex-grow",
                                    // value={uploadedImageArr}
                                    // disableUpload={isDisableUploadBtn}
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                                        color: "primary",
                                        fill: "solid",
                                        size: "middle",
                                        className: "w-full",
                                        children: t("ss_builder_upload_button_label")
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            isValidFileFormat && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row gap-1 items-center mt-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                        fillColor: "#FF3141",
                        className: "w-4 h-4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[#FF3141]",
                        children: t("ss_builder_upload_file_format_invalid_content")
                    })
                ]
            }),
            isValidFileSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row gap-1 items-center mt-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationTriangleIcon */.Lm, {
                        fillColor: "#FF3141",
                        className: "w-4 h-4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[#FF3141]",
                        children: t("ss_builder_upload_file_size_invalid_content")
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/GradientColor/index.tsx
function GradientColor_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function GradientColor_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function GradientColor_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function GradientColor_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function GradientColor_slicedToArray(arr, i) {
    return GradientColor_arrayWithHoles(arr) || GradientColor_iterableToArrayLimit(arr, i) || GradientColor_unsupportedIterableToArray(arr, i) || GradientColor_nonIterableRest();
}
function GradientColor_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return GradientColor_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return GradientColor_arrayLikeToArray(o, minLen);
}














var getTwoDifferentColors = function() {
    var firstColor = (0,lib/* getRandomColor */.mr)();
    var secondColor = (0,lib/* getRandomColor */.mr)(firstColor);
    return [
        firstColor,
        secondColor
    ];
};
var GradientColor = function() {
    var directionButtonOptions = [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowUpLeft */.$o, {
                className: "align-middle inline-block"
            }),
            value: "to top left"
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowUp */.a2, {
                className: "align-middle inline-block"
            }),
            value: "to top"
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowUpRight */.Gu, {
                className: "align-middle inline-block"
            }),
            value: "to top right"
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowLeft */.Xd, {
                className: "align-middle inline-block"
            }),
            value: "to left"
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: ""
            }),
            value: "circle",
            disabled: true
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowRight */.ol, {
                className: "align-middle inline-block"
            }),
            value: "to right"
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowDownLeft */.l2, {
                className: "align-middle inline-block"
            }),
            value: "to bottom left"
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowDown */.K5, {
                className: "align-middle inline-block"
            }),
            value: "to bottom"
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowDownRight */.NC, {
                className: "align-middle inline-block"
            }),
            value: "to bottom right"
        }, 
    ];
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    // const regex = new RegExp(/#[a-zA-Z0-9\#!]+/g);
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var displaySettings = siteSettings && Object.values(siteSettings).length > 0 && siteSettings.display_setting;
    var meta_data = displaySettings.meta_data;
    var ref10;
    var background = (ref10 = displaySettings === null || displaySettings === void 0 ? void 0 : displaySettings.background) !== null && ref10 !== void 0 ? ref10 : {};
    var gradient = background === null || background === void 0 ? void 0 : background.gradient;
    var arrColorDefault = meta_data && meta_data.colors && meta_data.colors.length > 0 ? meta_data.colors : [
        configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_GRADIENT_GENERATOR_FIRST_COLOR */.Vw.COLOR_GRADIENT_GENERATOR_FIRST_COLOR,
        configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_GRADIENT_GENERATOR_SECOND_COLOR */.Vw.COLOR_GRADIENT_GENERATOR_SECOND_COLOR, 
    ];
    var intensityDefault = meta_data && meta_data.intensity || configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_GRADIENT_INTENSITY */.Vw.COLOR_GRADIENT_INTENSITY;
    var directionDefault = meta_data && meta_data.direction || configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_GRADIENT_DIRECTION */.Vw.COLOR_GRADIENT_DIRECTION;
    var ref1 = (0,react.useState)(arrColorDefault || getTwoDifferentColors), colors1 = ref1[0], setColors = ref1[1];
    var ref2 = (0,react.useState)(intensityDefault), intensity = ref2[0], setIntensity = ref2[1];
    var ref3 = (0,react.useState)(directionDefault), direction = ref3[0], setDirection = ref3[1];
    var ref4 = (0,react.useState)(false), isShowIntensityChange = ref4[0], setIsShowIntensityChange = ref4[1];
    var ref5 = (0,react.useState)(null), actionKey1 = ref5[0], setActionKey = ref5[1];
    var ref6 = (0,react.useState)(null), indexColor1 = ref6[0], setIndexColor = ref6[1];
    var ref7 = (0,react.useState)(false), isOpenFirstColorPicker = ref7[0], setIsOpenFirstColorPicker = ref7[1];
    var ref8 = (0,react.useState)(false), isOpenSecondColorPicker = ref8[0], setIsOpenSecondColorPicker = ref8[1];
    var ref9 = (0,react.useState)(gradient || "white"), gradientBackground = ref9[0], setGradientBackGround = ref9[1];
    var firstColorRandom = (0,react.useRef)(colors1[0]);
    var secondColorRandom = (0,react.useRef)(colors1[1]);
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var handleRandomise = function() {
        var ref = GradientColor_slicedToArray(getTwoDifferentColors(), 2), firstColor = ref[0], secondColor = ref[1];
        firstColorRandom.current = firstColor;
        secondColorRandom.current = secondColor;
        setColors([
            (0,lib/* getHexColor */.Xv)(firstColor, intensity),
            (0,lib/* getHexColor */.Xv)(secondColor, intensity), 
        ]);
        setIsShowIntensityChange(true);
    };
    var handleIntensityChange = function(value) {
        setColors([
            (0,lib/* getHexColor */.Xv)(firstColorRandom.current, value),
            (0,lib/* getHexColor */.Xv)(secondColorRandom.current, value), 
        ]);
        setIntensity(value);
    };
    (0,react.useEffect)(function() {
        // const [firstColor, secondColor] = colors;
        var linearBackground = "linear-gradient(".concat(direction !== null && direction !== void 0 ? direction : "circle", ", ").concat((0,lib/* getHexColor */.Xv)(firstColorRandom.current, intensity), ", ").concat((0,lib/* getHexColor */.Xv)(secondColorRandom.current, intensity), ")");
        if (direction == undefined) {
            linearBackground = "radial-gradient(".concat((0,lib/* getHexColor */.Xv)(firstColorRandom.current, intensity), ", ").concat((0,lib/* getHexColor */.Xv)(secondColorRandom.current, intensity), ")");
        }
        setGradientBackGround(linearBackground);
    }, [
        firstColorRandom.current,
        secondColorRandom.current,
        intensity,
        direction, 
    ]);
    (0,react.useEffect)(function() {
        dispatch((0,siteSettingSlice/* setDisplaySetting */.H9)({
            data: {
                meta_data: {
                    colors: colors1,
                    direction: direction,
                    intensity: intensity
                }
            }
        }));
    }, [
        colors1,
        direction,
        intensity
    ]);
    (0,react.useEffect)(function() {
        var subscription = rxjs/* dataService.getObservable */.c.getObservable().subscribe(function(data) {
            if (data) {
                var selectedBackgroundGradientColor = data.selectedBackgroundGradientColor;
                var indexColor = data.indexColor;
                if (selectedBackgroundGradientColor && indexColor !== undefined) {
                    setIsShowIntensityChange(false);
                    setColors(function(colors) {
                        return colors.map(function(item, index) {
                            if (index === indexColor) {
                                return selectedBackgroundGradientColor;
                            }
                            return item;
                        });
                    });
                    if (indexColor === 0) {
                        firstColorRandom.current = selectedBackgroundGradientColor;
                    }
                    if (indexColor === 1) {
                        secondColorRandom.current = selectedBackgroundGradientColor;
                    }
                }
            }
        });
        return function() {
            return subscription.unsubscribe();
        };
    }, []);
    (0,react.useEffect)(function() {
        dispatch((0,dynamicSlice/* setParamsThemeSetting */._7)({
            data: {
                gradientColor: gradientBackground
            }
        }));
    }, [
        gradientBackground
    ]);
    var handleOpenColorPicker = function(data) {
        var actionKey = data.actionKey, indexColor = data.indexColor;
        setIndexColor(indexColor);
        setActionKey(actionKey);
        if (indexColor === 0) {
            setIsOpenFirstColorPicker(true);
        }
        if (indexColor === 1) {
            setIsOpenSecondColorPicker(true);
        }
    };
    var handleSetDirectionKey = function(value) {
        if (value.length > 0) {
            setDirection(value[0]);
        }
    };
    var handleCloseFirstColorPicker = function() {
        setIsOpenFirstColorPicker(false);
    };
    var handleCloseSecondColorPicker = function() {
        setIsOpenSecondColorPicker(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col mx-auto w-full mt-4",
                style: {
                    maxWidth: "80ch"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Button */.zx, {
                                className: "py-2 px-6 mb-4 d-flex gap-2 items-center w-full justify-center",
                                onClick: handleRandomise,
                                color: "primary",
                                fill: "solid",
                                size: "middle",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* RandomizeIcon */.u4, {
                                        className: "h-4 inline-block ml-2"
                                    }),
                                    " ",
                                    t("ss_builder_randomize")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-base mb-1 mb-[10px] mt-5",
                                        children: t("ss_builder_theme_setting_select_gradient_color_label")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-row gap-5",
                                        children: colors1 && colors1.map(function(ele, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col text-center items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-12 h-12 rounded-[50%] cursor-pointer relative overflow-hidden",
                                                        style: {
                                                            backgroundColor: (0,lib/* getGlobalColor */.mg)(ele.includes("#") ? ele : (0,lib/* colorNameToHex */.tB)(ele))
                                                        },
                                                        onClick: function() {
                                                            return handleOpenColorPicker({
                                                                actionKey: "SELECT_BACKGROUND_GRADIENT_COLOR",
                                                                indexColor: index
                                                            });
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                (0,lib/* getOpacityFromHex */.eq)(ele.includes("#") ? ele : (0,lib/* colorNameToHex */.tB)(ele)) !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "w-[50%] h-[100%] absolute right-0 top-0",
                                                                    style: {
                                                                        background: "repeat #fff url(https://image.passio.eco/page-builder/page-builder/background-default/checkerboard-v2.png) "
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "w-[50%] h-[100%] absolute right-0 top-0",
                                                                    style: {
                                                                        backgroundColor: ele.includes("#") ? ele : (0,lib/* colorNameToHex */.tB)(ele)
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "w-[100%] h-[100%] absolute left-0 top-0 rounded-[50%]",
                                                                    style: {
                                                                        outline: "rgba(0, 0, 0, 0.2) solid 1px",
                                                                        outlineOffset: "-1px"
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "text-center",
                                                        children: [
                                                            t("ss_builder_theme_setting_gadient_color"),
                                                            " ",
                                                            "".concat(index + 1)
                                                        ]
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }),
                            isShowIntensityChange && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-base mb-1 mt-5 mb-5",
                                        children: t("ss_builder_theme_setting_intensity_color_label")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                                        step: 100,
                                        min: 100,
                                        max: 900,
                                        ticks: true,
                                        onChange: handleIntensityChange,
                                        value: intensity
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base mb-1 mt-5 mb-4",
                                children: t("ss_builder_theme_setting_gradient_color_direction_label")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                    columns: 3,
                                    options: directionButtonOptions,
                                    onChange: handleSetDirectionKey,
                                    value: [
                                        direction
                                    ],
                                    style: {
                                        "--border": "solid transparent 1px",
                                        "--checked-border": "solid var(--adm-color-primary) 1px"
                                    }
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenFirstColorPicker,
                onMaskClick: function() {
                    return handleCloseFirstColorPicker();
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return handleCloseFirstColorPicker();
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* default */.Z, {
                    callbackCancelColorPicker: handleCloseFirstColorPicker,
                    indexColor: indexColor1,
                    actionKey: actionKey1,
                    defaultColor: colors1[0]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenSecondColorPicker,
                onMaskClick: function() {
                    return handleCloseSecondColorPicker();
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return handleCloseSecondColorPicker();
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* default */.Z, {
                    callbackCancelColorPicker: handleCloseSecondColorPicker,
                    indexColor: indexColor1,
                    actionKey: actionKey1,
                    defaultColor: colors1[1]
                })
            })
        ]
    });
};
/* harmony default export */ var ThemeSetting_GradientColor = (GradientColor);

// EXTERNAL MODULE: ./src/features/setting/helper/index.ts
var setting_helper = __webpack_require__(92407);
;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/BackgroundSetting/components/Preview/index.tsx
function BackgroundSetting_components_Preview_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BackgroundSetting_components_Preview_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BackgroundSetting_components_Preview_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





function BackgroundSetting_components_Preview_Preview(param) {
    var defaultValue = param.defaultValue, backgroundSettingData = param.backgroundSettingData, dynamicConfig = param.dynamicConfig;
    var BACKGROUND_TYPE_IMAGE = "image";
    var BACKGROUND_TYPE_SOLID = "solid";
    var BACKGROUND_TYPE_GRADENT = "gradient";
    var BACKGROUND_TYPE_COLOR = "color";
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var ref = (siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.display_setting) || {}, background = ref.background, paragraph_setting = ref.paragraph_setting, title_setting = ref.title_setting;
    var ref1 = title_setting !== null && title_setting !== void 0 ? title_setting : {}, tmp = ref1.font_family, font_family_title = tmp === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_FAMILY */.lI.FONT_FAMILY : tmp, tmp1 = ref1.font_color, font_color_title = tmp1 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_COLOR */.lI.FONT_COLOR : tmp1, tmp2 = ref1.scale, scale_title = tmp2 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_SCALE */.lI.FONT_SCALE : tmp2, tmp3 = ref1.font_size, font_size_title = tmp3 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_SIZE */.lI.FONT_SIZE : tmp3, tmp4 = ref1.font_weight, font_weight_title = tmp4 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.lI.FONT_WEIGHT : tmp4, tmp5 = ref1.line_height, line_height_title = tmp5 === void 0 ? configs_const/* TITLE_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.lI.LINE_HEIGHT : tmp5;
    var ref2 = paragraph_setting !== null && paragraph_setting !== void 0 ? paragraph_setting : {}, tmp6 = ref2.font_family, font_family_paragraph = tmp6 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_FAMILY */.no.FONT_FAMILY : tmp6, tmp7 = ref2.font_color, font_color_paragraph = tmp7 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_COLOR */.no.FONT_COLOR : tmp7, tmp8 = ref2.scale, scale_paragraph = tmp8 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_SCALE */.no.FONT_SCALE : tmp8, tmp9 = ref2.font_size, font_size_paragraph = tmp9 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_SIZE */.no.FONT_SIZE : tmp9, tmp10 = ref2.font_weight, font_weight_paragraph = tmp10 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.no.FONT_WEIGHT : tmp10, tmp11 = ref2.line_height, line_height_paragraph = tmp11 === void 0 ? configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.LINE_HEIGHT */.no.LINE_HEIGHT : tmp11;
    var backgroundSetting = backgroundSettingData !== null && backgroundSettingData !== void 0 ? backgroundSettingData : background;
    var ref3 = backgroundSetting || {}, _type = ref3.type, type = _type === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.BACKGROUND_TYPE */.Vw.BACKGROUND_TYPE : _type, _color = ref3.color, color = _color === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_SOLID */.Vw.COLOR_SOLID : _color, gradient = ref3.gradient, _image = ref3.image, image = _image === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.IMAGE */.Vw.IMAGE : _image, tmp12 = ref3.blur, blurBackgroundSetting = tmp12 === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.BLUR */.Vw.BLUR : tmp12, _enable_overlay = ref3.enable_overlay, enable_overlay = _enable_overlay === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.OVERLAY_ENABLE */.Vw.OVERLAY_ENABLE : _enable_overlay, _overlay_color = ref3.overlay_color, overlay_color = _overlay_color === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.OVERLAY_COLOR */.Vw.OVERLAY_COLOR : _overlay_color;
    var gradientColor = dynamicConfig.themeSettings.gradientColor || {};
    var ref4 = defaultValue || {}, block_style = ref4.block_style, block_background = ref4.block_background, block_border = ref4.block_border, block_shadow = ref4.block_shadow;
    var ref5 = block_style || {}, _radius_type = ref5.radius_type, radius_type = _radius_type === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_STYLE */.eJ.BLOCK_STYLE : _radius_type, _radius_value = ref5.radius_value, radius_value = _radius_value === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_RADIUS */.eJ.BORDER_RADIUS : _radius_value, _inner_space = ref5.inner_space, inner_space = _inner_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE */.eJ.INNER_SPACE : _inner_space, _inner_space_number = ref5.inner_space_number, inner_space_number = _inner_space_number === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */.eJ.INNER_SPACE_NUMBER : _inner_space_number, _block_space = ref5.block_space, block_space = _block_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_SPACE */.eJ.BLOCK_SPACE : _block_space, _outside_space = ref5.outside_space, outside_space = _outside_space === void 0 ? configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE */.eJ.OUTSIDE_SPACE : _outside_space;
    var ref6 = block_background || {}, blockBackgroundColor = ref6.color, blur = ref6.blur;
    var borderEnable = block_border.enable, border_width = block_border.border_width, borderColor = block_border.color, borderType = block_border.type;
    var shadowEnable = block_shadow.enable, shadowColor = block_shadow.color;
    var font_size_title_block = font_size_title * scale_title * scale_title * scale_title;
    var boxShadowStyle = shadowEnable === true ? {
        boxShadow: "0px 4px 4px " + shadowColor
    } : {};
    var borderRadiusValue = (0,react.useMemo)(function() {
        var value = "0px";
        if (radius_type === "rounded") {
            value = "8px";
        } else if (radius_type === "custom") {
            value = "".concat(radius_value, "px");
        }
        return value;
    }, [
        radius_type,
        radius_value
    ]);
    var styleBorder = borderEnable === true ? {
        borderWidth: border_width + "px",
        borderStyle: borderType,
        borderColor: borderColor
    } : {
        border: "none"
    };
    var styleBackgroundImage = type === BACKGROUND_TYPE_IMAGE ? {
        filter: "blur(".concat(blurBackgroundSetting, "px) "),
        WebkitFilter: "blur(".concat(blurBackgroundSetting, "px) "),
        backgroundPosition: "center center",
        width: "calc(100% + ".concat(blurBackgroundSetting * 2, "px) "),
        height: "calc(100% + ".concat(blurBackgroundSetting * 2, "px) "),
        transform: "translate(-".concat(blurBackgroundSetting, "px, -").concat(blurBackgroundSetting, "px)")
    } : "";
    var checkStyleBackgroundImage = function() {
        switch(type){
            case BACKGROUND_TYPE_IMAGE:
                return 'url("'.concat(image, '")');
            case BACKGROUND_TYPE_GRADENT:
                return gradientColor;
            default:
                return "";
        }
    };
    var innerSpaceNumber = typeof inner_space_number === "number" ? "".concat(inner_space_number, "px") : inner_space ? "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE_NUMBER */.eJ.INNER_SPACE_NUMBER, "px") : 0;
    var styleOutsideSpace = outside_space ? {
        marginLeft: "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px"),
        marginRight: "".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER, "px"),
        width: "calc(100% - ".concat(configs_const/* BLOCK_SETTING_DEFAULT_VALUE.OUTSIDE_SPACE_NUMBER */.eJ.OUTSIDE_SPACE_NUMBER * 2, "px) ")
    } : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: " bg-white mb-2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-3 pt-4 pb-4 w-full h-full relative overflow-hidden",
                children: [
                    type === BACKGROUND_TYPE_IMAGE && enable_overlay === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-[50%] translate-x-[-50%] block w-full h-full z-[1]",
                        style: {
                            backgroundColor: overlay_color
                        }
                    }) : "",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 left-0 w-full h-full bg-cover bg-no-repeat object-cover",
                        style: BackgroundSetting_components_Preview_objectSpread({
                            backgroundColor: type === BACKGROUND_TYPE_SOLID || type === BACKGROUND_TYPE_COLOR ? color : "",
                            backgroundImage: "".concat(checkStyleBackgroundImage()),
                            borderBottom: "1px solid var(--adm-color-border)"
                        }, styleBackgroundImage)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-[3]",
                        style: BackgroundSetting_components_Preview_objectSpread({}, styleOutsideSpace),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pt-3 pb-3",
                                style: BackgroundSetting_components_Preview_objectSpread({
                                    backgroundColor: blockBackgroundColor,
                                    borderRadius: borderRadiusValue,
                                    backdropFilter: "blur(".concat(blur, "px) "),
                                    WebkitBackdropFilter: "blur(".concat(blur, "px) "),
                                    paddingLeft: innerSpaceNumber,
                                    paddingRight: innerSpaceNumber
                                }, styleBorder, boxShadowStyle),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-titleFontSize",
                                        style: {
                                            color: font_color_title,
                                            fontSize: font_size_title_block,
                                            lineHeight: line_height_title,
                                            fontWeight: font_weight_title,
                                            fontFamily: font_family_title
                                        },
                                        children: t("ss_builder_1st_block_preview_sample_title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "content-block-preview",
                                        style: {
                                            color: font_color_paragraph,
                                            fontSize: font_size_paragraph,
                                            lineHeight: line_height_paragraph,
                                            fontWeight: font_weight_paragraph,
                                            fontFamily: font_family_paragraph
                                        },
                                        children: t("ss_builder_1st_block_preview_sample_description")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    height: "".concat(block_space, "px")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pt-3 pb-3",
                                style: BackgroundSetting_components_Preview_objectSpread({
                                    backgroundColor: blockBackgroundColor,
                                    borderRadius: borderRadiusValue,
                                    backdropFilter: "blur(".concat(blur, "px) "),
                                    WebkitBackdropFilter: "blur(".concat(blur, "px) "),
                                    paddingLeft: innerSpaceNumber,
                                    paddingRight: innerSpaceNumber
                                }, styleBorder, boxShadowStyle),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "text-titleFontSize",
                                        style: {
                                            color: font_color_title,
                                            fontSize: font_size_title_block,
                                            lineHeight: line_height_title,
                                            fontWeight: font_weight_title,
                                            fontFamily: font_family_title
                                        },
                                        children: t("ss_builder_2st_block_preview_sample_title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "content-block-preview",
                                        style: {
                                            color: font_color_paragraph,
                                            fontSize: font_size_paragraph,
                                            lineHeight: line_height_paragraph,
                                            fontWeight: font_weight_paragraph,
                                            fontFamily: font_family_paragraph
                                        },
                                        children: t("ss_builder_2st_block_preview_sample_description")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/BackgroundSetting/components/BackgroundTourOpening/BackgroundTour/const.ts
var BACKGROUND_TOUR_CLASS_NAME = {
    STEP_1: "background-tour-step-1",
    STEP_2: "background-tour-step-2"
};
var const_STEP_INDEX = {
    STEP_1: 0,
    STEP_2: 1
};
var const_steps = [
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/background-tour/product-tour-for-background-tep-1.gif",
        title_key: "ss_builder_background_tour_title_step_1",
        intro_key: "ss_builder_background_tour_content_step_1",
        element_class: BACKGROUND_TOUR_CLASS_NAME.STEP_1,
        tooltip_class: "show-label-text",
        position: "bottom-middle-aligned"
    },
    {
        image_header: "https://image.passio.eco/page-builder/page-builder/background-tour/product-tour-for-background-tep-2.gif",
        title_key: "ss_builder_background_tour_title_step_2",
        intro_key: "ss_builder_background_tour_content_step_2",
        element_class: BACKGROUND_TOUR_CLASS_NAME.STEP_2,
        tooltip_class: "show-label-text product-tour-custom",
        position: "bottom"
    }, 
];

;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/BackgroundSetting/components/BackgroundTourOpening/BackgroundTour/index.tsx
function BackgroundTour_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function BackgroundTour_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                BackgroundTour_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                BackgroundTour_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}










var BackgroundTour = function(props) {
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var handleHideSettingTour = props.handleHideSettingTour;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var productTourRef = (0,react.useRef)(null);
    var setRef = function(ref) {
        productTourRef.current = ref;
    };
    var stepsDefault = const_steps.map(function(ele) {
        return {
            title: '<div class="wrapper-image">' + product_tour_icon/* placeHolderImageIcon */.GT + '\n        <img class="img-product-tour" src='.concat(ele.image_header, ' /> </div>\n        <div class="title">').concat(t(ele.title_key), "<div/>"),
            element: ele.using_selector ? document.querySelector(".".concat(ele.element_class)) : ".".concat(ele.element_class),
            intro: "<div> ".concat(t(ele.intro_key), "<div/>"),
            tooltipClass: "tooltip-product-tour ".concat(ele.tooltip_class),
            position: (ele === null || ele === void 0 ? void 0 : ele.position) || "auto"
        };
    });
    var onExit = function() {
        handleHideSettingTour();
    };
    var onBeforeExit = function(stepIndex) {
        if (stepIndex === setting_tour_config_STEP_INDEX.STEP_2) {
            dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
                data: {
                    isMarginBackground: false
                }
            }));
        }
    };
    var onChangeProductTour = function() {
        var _ref = BackgroundTour_asyncToGenerator(runtime_default().mark(function _callee(nextStepIndex, nextElement) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
                            data: {
                                isMarginBackground: nextStepIndex === setting_tour_config_STEP_INDEX.STEP_2
                            }
                        }));
                        if (nextStepIndex === setting_tour_config_STEP_INDEX.STEP_2) {
                            window.scrollTo(0, document.body.scrollHeight);
                        } else {
                            window.scrollTo({
                                top: 0
                            });
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onChangeProductTour(nextStepIndex, nextElement) {
            return _ref.apply(this, arguments);
        };
    }();
    var onCompleteProductTour = function() {};
    var onBeforeChange = function() {
        var _ref = BackgroundTour_asyncToGenerator(runtime_default().mark(function _callee(nextStepIndex, nextElement) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onBeforeChange(nextStepIndex, nextElement) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTourComponent/* default */.Z, {
        steps: stepsDefault,
        onExit: onExit,
        onBeforeExit: onBeforeExit,
        onChange: onChangeProductTour,
        onComplete: onCompleteProductTour,
        onBeforeChange: onBeforeChange,
        setRef: setRef
    });
};
/* harmony default export */ var BackgroundTourOpening_BackgroundTour = (BackgroundTour);

;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/BackgroundSetting/components/BackgroundTourOpening/index.tsx
function BackgroundTourOpening_throw(e) {
    throw e;
}






var BackgroundTourOpening = function(param) {
    var param = param !== null ? param : BackgroundTourOpening_throw(new TypeError("Cannot destructure undefined"));
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(false), isOpenBackgroundTour = ref[0], setIsOpenBackgroundTour = ref[1];
    var popoverRef = (0,react.useRef)(null);
    var popoverManualRef = (0,react.useRef)(null);
    var handleHidePopoverManual = function() {
        popoverManualRef.current.hide();
    };
    var handleHideSettingTour = function() {
        setIsOpenBackgroundTour(false);
    };
    var contentPopoverManual = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-[320px] max-w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[32px] h-[32px] absolute p-1 right-2 top-2 cursor-pointer z-[3]",
                    onClick: function() {
                        return handleHidePopoverManual();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ClosePopupIconV2 */.gz, {
                        fillColor: "#fff"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "https://image.passio.eco/page-builder/page-builder/background-tour/product-tour-for-background-tep-0.gif",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "p-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb-2 text-lg leading-[25px] font-bold",
                            children: t("ss_builder_background_popover_manual_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-[15px] font-normal leading-[140%] text-textColorDefault mb-5",
                            children: t("ss_builder_background_popover_manual_content")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Button */.zx, {
                            color: "primary",
                            size: "middle",
                            fill: "solid",
                            onClick: function() {
                                handleHidePopoverManual();
                                setIsOpenBackgroundTour(true);
                            },
                            block: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "flex items-center w-full justify-center gap-2 text-[17px]",
                                children: [
                                    t("ss_builder_popover_manual_button"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowRightIcon */.LZ, {
                                        fillColor: "#fff"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "user-manual",
                ref: popoverRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Popover */.J2, {
                    className: "popover-user-manual",
                    content: contentPopoverManual(),
                    placement: "bottom-end",
                    trigger: "click",
                    stopPropagation: [
                        "click"
                    ],
                    getContainer: function() {
                        return popoverRef.current;
                    },
                    ref: popoverManualRef,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* QuestionIcon */.UO, {
                            width: 20,
                            height: 20,
                            className: "cursor-pointer"
                        })
                    })
                })
            }),
            isOpenBackgroundTour && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundTourOpening_BackgroundTour, {
                handleHideSettingTour: handleHideSettingTour
            })
        ]
    });
};
/* harmony default export */ var components_BackgroundTourOpening = (BackgroundTourOpening);

// EXTERNAL MODULE: ./src/features/setting/components/ThemeSetting/BackgroundSetting/style.module.scss
var BackgroundSetting_style_module = __webpack_require__(37583);
var BackgroundSetting_style_module_default = /*#__PURE__*/__webpack_require__.n(BackgroundSetting_style_module);
;// CONCATENATED MODULE: ./src/features/setting/components/ThemeSetting/BackgroundSetting/index.tsx
function BackgroundSetting_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BackgroundSetting_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BackgroundSetting_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






















var BACKGROUND_TYPE_IMAGE = "image";
var BACKGROUND_TYPE_SOLID = "solid";
var BACKGROUND_TYPE_GRADENT = "gradient";
var BACKGROUND_OPTION_COLOR = "color";
var BACKGROUND_OPTION_IMAGE = "image";
var COLOR_TYPE_SOLID = "solid";
var COLOR_TYPE_GRADIENT = "gradient";
var getBackgroundSettingOptions = function(t) {
    return [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ImageIcon */.XB, {
                width: "27",
                height: "27",
                className: "align-middle inline-block mb-2"
            }),
            value: BACKGROUND_OPTION_IMAGE,
            description: t("ss_builder_theme_setting_background_image_selector_label")
        },
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ColorIcon */.LR, {
                width: "27",
                height: "27",
                className: "align-middle inline-block mb-2"
            }),
            value: BACKGROUND_OPTION_COLOR,
            description: t("ss_builder_theme_setting_background_color_selector_label")
        }, 
    ];
};
var defaultBackgroundSetting = {
    type: "solid",
    color: "#FFFFFF",
    gradient: null,
    image: null
};
var defaultSettingState = {
    block_style: {
        radius_type: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BLOCK_STYLE */.eJ.BLOCK_STYLE,
        radius_value: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_RADIUS */.eJ.BORDER_RADIUS,
        inner_space: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.INNER_SPACE */.eJ.INNER_SPACE
    },
    block_background: {
        color: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_COLOR */.eJ.BACKGROUND_COLOR,
        blur: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BACKGROUND_BLUR */.eJ.BACKGROUND_BLUR,
        meta: {}
    },
    block_border: {
        enable: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_ENABLE */.eJ.BORDER_ENABLE,
        color: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_COLOR */.eJ.BORDER_COLOR,
        color_meta: {},
        type: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_STYLE */.eJ.BORDER_STYLE,
        border_width: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.BORDER_WIDTH */.eJ.BORDER_WIDTH
    },
    block_shadow: {
        enable: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.SHADOW_ENABLE */.eJ.SHADOW_ENABLE,
        color: configs_const/* BLOCK_SETTING_DEFAULT_VALUE.SHADOW_COLOR */.eJ.SHADOW_COLOR,
        color_meta: {}
    }
};
/** @todo Optimize việc gradient picker bị dính vào redux */ function BackgroundSetting(props) {
    var backToAllSetting = props.backToAllSetting, activeIndex = props.activeIndex;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref8 = (0,react.useState)(false), isOpenColorPicker = ref8[0], setIsOpenColorPicker = ref8[1];
    var ref1 = (0,react.useState)(false), isOpenHoverColorPicker = ref1[0], setIsOpenHoverColorPicker = ref1[1];
    var defaultBackgroundSetting1 = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings.display_setting.background;
    });
    var backgroundMeta = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings.display_setting.meta_data;
    });
    var blockSetting = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref, ref7;
        return state === null || state === void 0 ? void 0 : (ref = state.siteSettings) === null || ref === void 0 ? void 0 : (ref7 = ref.display_setting) === null || ref7 === void 0 ? void 0 : ref7.block_setting;
    });
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var colorSettingOptions = [
        {
            label: t("ss_builder_solid"),
            value: COLOR_TYPE_SOLID
        },
        {
            label: t("ss_builder_gradient"),
            value: COLOR_TYPE_GRADIENT
        }, 
    ];
    var ref2 = (0,react.useState)(BackgroundSetting_objectSpread({}, defaultBackgroundSetting1, {
        meta: backgroundMeta
    })), backgroundSettingData = ref2[0], setBackgroundSettingData = ref2[1];
    var ref3 = backgroundSettingData !== null && backgroundSettingData !== void 0 ? backgroundSettingData : {}, _type = ref3.type, type = _type === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.BACKGROUND_TYPE */.Vw.BACKGROUND_TYPE : _type, _image = ref3.image, image1 = _image === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.IMAGE */.Vw.IMAGE : _image, _color = ref3.color, color1 = _color === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_SOLID */.Vw.COLOR_SOLID : _color, _overlay_color = ref3.overlay_color, overlay_color = _overlay_color === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.OVERLAY_COLOR */.Vw.OVERLAY_COLOR : _overlay_color, _enable_overlay = ref3.enable_overlay, enable_overlay = _enable_overlay === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.OVERLAY_ENABLE */.Vw.OVERLAY_ENABLE : _enable_overlay, _blur = ref3.blur, blur = _blur === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.BLUR */.Vw.BLUR : _blur, _color_type = ref3.color_type, color_type = _color_type === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.BACKGROUND_TYPE */.Vw.BACKGROUND_TYPE : _color_type;
    var ref4 = (0,react.useState)(type === BACKGROUND_TYPE_IMAGE ? BACKGROUND_OPTION_IMAGE : BACKGROUND_OPTION_COLOR), backgroundOption = ref4[0], setBackgroundOption = ref4[1];
    var ref5 = (0,react.useState)(color_type), colorType = ref5[0], setColorType = ref5[1];
    var isMarginBackground = (dynamicConfig === null || dynamicConfig === void 0 ? void 0 : dynamicConfig.isMarginBackground) || false;
    (0,react.useEffect)(function() {
        setBackgroundOption(type === BACKGROUND_TYPE_IMAGE ? BACKGROUND_OPTION_IMAGE : BACKGROUND_OPTION_COLOR);
    // setColorType(
    //   type == COLOR_TYPE_GRADIENT ? COLOR_TYPE_GRADIENT : COLOR_TYPE_SOLID
    // );
    }, [
        type
    ]);
    var backgroundSettingOptions = getBackgroundSettingOptions(t);
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var onChangeBackgroundType = function(val) {
        if (val.length > 0) {
            setBackgroundOption(val[0]);
            var colorTypeSetting = val[0] === BACKGROUND_OPTION_COLOR ? colorType : val[0];
            setBackgroundSettingData(function(state) {
                return BackgroundSetting_objectSpread({}, state, {
                    type: colorTypeSetting
                });
            });
        }
    };
    var onChangeColorType = function(val) {
        if (val.length > 0) {
            setColorType(val[0]);
            setBackgroundSettingData(function(state) {
                return BackgroundSetting_objectSpread({}, state, {
                    type: val[0]
                });
            });
        } else {
            setColorType(COLOR_TYPE_SOLID);
            setBackgroundSettingData(function(state) {
                return BackgroundSetting_objectSpread({}, state, {
                    type: val[COLOR_TYPE_SOLID]
                });
            });
        }
    };
    var onChangeColor = function(data) {
        var newColorState = {
            color: data
        };
        setBackgroundSettingData(function(state) {
            return BackgroundSetting_objectSpread({}, state, newColorState);
        });
    };
    var onUploadImage = function(image) {
        var ref;
        setBackgroundSettingData(function(state) {
            return BackgroundSetting_objectSpread({}, state, {
                base64_image: (ref = image === null || image === void 0 ? void 0 : image.dataBase64) !== null && ref !== void 0 ? ref : null,
                image: image === null || image === void 0 ? void 0 : image.url,
                image_name: image.fileName
            });
        });
    };
    var onChangeBackgroundSettingState = function(key, value) {
        setBackgroundSettingData(function(state) {
            return BackgroundSetting_objectSpread({}, state, BackgroundSetting_defineProperty({}, key, value));
        });
    };
    var lastestData = (0,esm/* useDebounce */.Nr)(backgroundSettingData, 100);
    var onSave = (0,react.useCallback)(function() {
        var savedData = {
            type: backgroundOption == BACKGROUND_OPTION_IMAGE ? BACKGROUND_TYPE_IMAGE : colorType,
            color: color1,
            gradient: dynamicConfig.themeSettings.gradientColor,
            image: lastestData.image,
            base64_image: lastestData.base64_image,
            image_name: lastestData.image_name,
            blur: lastestData.blur,
            enable_overlay: lastestData.enable_overlay,
            overlay_color: lastestData.overlay_color,
            color_type: colorType
        };
        dispatch(saveBackgroundSetting(savedData, backgroundMeta));
        backToAllSetting();
    }, [
        backgroundOption,
        colorType,
        color1,
        dynamicConfig,
        lastestData
    ]);
    var ref6 = (0,react.useState)(blockSetting !== null && blockSetting !== void 0 ? blockSetting : defaultSettingState), blockSettingData = ref6[0], setBlockSettingData = ref6[1];
    (0,react.useEffect)(function() {
        if (JSON.stringify(backgroundSettingData) !== JSON.stringify(BackgroundSetting_objectSpread({}, defaultBackgroundSetting1, {
            meta: backgroundMeta
        })) && activeIndex === 1) {
            onSave();
        }
    }, [
        backgroundOption,
        dynamicConfig.themeSettings.gradientColor,
        color1,
        colorType,
        lastestData.image,
        lastestData.image_name,
        lastestData.enable_overlay,
        lastestData.overlay_color,
        lastestData.blur,
        activeIndex, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-width-content-class m-auto h-full relative",
        style: {
            marginBottom: isMarginBackground ? "300px" : ""
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full pb-10 h-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-width-content-class sticky top-0 z-[999] w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingHeader/* default */.Z, {
                                title: t("ss_builder_background_setting_title"),
                                Icon: Icons/* BackgroundIcon */.AZ,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BackgroundTourOpening, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundSetting_components_Preview_Preview, {
                                defaultValue: blockSettingData !== null && blockSettingData !== void 0 ? blockSettingData : {},
                                backgroundSettingData: backgroundSettingData !== null && backgroundSettingData !== void 0 ? backgroundSettingData : {},
                                dynamicConfig: dynamicConfig !== null && dynamicConfig !== void 0 ? dynamicConfig : {}
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Collapse */.UO, {
                        defaultActiveKey: "style",
                        accordion: true,
                        className: (BackgroundSetting_style_module_default()).backgroundStyleCollapse,
                        arrow: null,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Collapse.Panel */.UO.Panel, {
                            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "mr-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* StyleIcon */.qG, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t("ss_builder_theme_setting_block_style")
                                        })
                                    ]
                                })
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "background-tour-step-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                        columns: 2,
                                        options: backgroundSettingOptions,
                                        onChange: onChangeBackgroundType,
                                        value: [
                                            backgroundOption
                                        ],
                                        style: {
                                            "--border": "solid transparent 1px",
                                            "--checked-border": "solid var(--adm-color-primary) 1px"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                backgroundOption == BACKGROUND_OPTION_IMAGE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageUploader, {
                                            defaultImage: image1,
                                            onChangeImage: onUploadImage
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "text-base mb-4 flex justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: t("ss_builder_background_opacity")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "primary-color text-sm",
                                                            children: [
                                                                blur !== null && blur !== void 0 ? blur : 0,
                                                                " px"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Slider */.iR, {
                                                    onChange: function(val) {
                                                        onChangeBackgroundSettingState("blur", parseInt(val.toString()));
                                                    // _.debounce(onChangeBackgroundSettingState("blur",parseInt(val.toString())),5000)
                                                    },
                                                    // ticks={true}
                                                    marks: setting_helper/* blurMarksBackgroundImage */.q,
                                                    min: 0,
                                                    step: 1,
                                                    max: 30,
                                                    defaultValue: blur,
                                                    popover: true
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-base mb-4",
                                                    children: t("ss_builder_background_enable_overlay")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Switch */.rs, {
                                                    defaultChecked: enable_overlay,
                                                    uncheckedText: t("ss_builder_off"),
                                                    checkedText: t("ss_builder_on"),
                                                    onChange: function(val) {
                                                        return onChangeBackgroundSettingState("enable_overlay", val);
                                                    }
                                                })
                                            ]
                                        }),
                                        enable_overlay && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Divider */.iz, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "text-base mb-4",
                                                            children: t("ss_builder_background_overlay_color")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayColor/* default */.Z, {
                                                            backgroundColor: overlay_color || "black",
                                                            onClickOpenColorPicker: setIsOpenHoverColorPicker
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                backgroundOption == BACKGROUND_OPTION_COLOR && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-base mb-1 mb-[10px]",
                                            children: t("ss_builder_theme_setting_select_background_color_label")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Selector */.Qf, {
                                                style: {
                                                    // "--border-radius": "100px",
                                                    "--border": "solid transparent 1px",
                                                    "--checked-border": "solid var(--adm-color-primary) 1px",
                                                    "--padding": "8px 24px",
                                                    // "--color": "#000",
                                                    "--text-color": "#333"
                                                },
                                                options: colorSettingOptions,
                                                value: [
                                                    colorType
                                                ],
                                                columns: 2,
                                                onChange: onChangeColorType
                                            })
                                        }),
                                        colorType === "solid" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-base mb-1 mt-7 mb-3",
                                                    children: t("ss_builder_theme_setting_select_solid_color_label")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayColor/* default */.Z, {
                                                    backgroundColor: color1 || "#f5f5f5",
                                                    onClickOpenColorPicker: setIsOpenColorPicker
                                                })
                                            ]
                                        }),
                                        colorType === "gradient" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeSetting_GradientColor, {})
                                    ]
                                })
                            ]
                        }, "style")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenColorPicker,
                onMaskClick: function() {
                    return setIsOpenColorPicker(false);
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return setIsOpenColorPicker(false);
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPickerV2 */._, {
                    defaultColor: color1,
                    onColorSelected: onChangeColor,
                    onCancel: function() {
                        return setIsOpenColorPicker(false);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenHoverColorPicker,
                onMaskClick: function() {
                    return setIsOpenHoverColorPicker(false);
                },
                title: t("ss_builder_color_picker_panel_title"),
                onClose: function() {
                    return setIsOpenHoverColorPicker(false);
                },
                classNameBody: "h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPickerV2 */._, {
                    defaultColor: overlay_color,
                    onColorSelected: function(color) {
                        return onChangeBackgroundSettingState("overlay_color", color);
                    },
                    onCancel: function() {
                        return setIsOpenHoverColorPicker(false);
                    }
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/share/components/RatingStarAutoComponent/index.tsx







var RatingStarAutoComponent_RATING_STAR = {
    STAR_1: 1,
    STAR_2: 2,
    STAR_3: 3,
    STAR_4: 4,
    STAR_5: 5
};
var RatingStarAutoComponent_RATING_CATEGORY = {
    CATEGORY_1: "unsatisfactory",
    CATEGORY_2: "need_improvement",
    CATEGORY_3: "not_bad",
    CATEGORY_4: "satisfactory",
    CATEGORY_5: "good"
};
var RatingStarAutoComponent_DESCRIPTION_MAXIMUM = 500;
var RatingStarAutoComponent = function(param) {
    var onClose = param.onClose;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(null), rating = ref[0], setRating = ref[1];
    var ref1 = (0,react.useState)(false), isOpenPopupRating = ref1[0], setIsOpenPopupRating = ref1[1];
    var handleRatingStar = function(value) {
        if (value > 0) {
            setRating(value);
            handleOpenPopupRating(true);
        }
    };
    var handleClose = function() {
        onClose();
    };
    var handleOpenPopupRating = function(value) {
        if (!value) {
            handleClose();
        } else {
            setIsOpenPopupRating(value);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "popup-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rating-popup-content h-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-h-full overflow-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "rating-star form-item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Rate */.j8, {
                                className: "w-full",
                                onChange: function(val) {
                                    return handleRatingStar(val);
                                },
                                character: /*#__PURE__*/ (0,jsx_runtime.jsx)(line_icon/* StarFillIcon */.qN, {
                                    width: 30,
                                    height: 30,
                                    fillColor: "var(--adm-color-light)"
                                }),
                                style: {
                                    "--inactive-color": "var(--adm-color-light)",
                                    "--active-color": "#ffd21e"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title-star",
                                children: t("ss_builder_block_rating_description_auto_show")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenPopupRating,
                onMaskClick: function() {},
                title: t("ss_builder_block_rating_title"),
                onClose: function() {
                    return handleOpenPopupRating(false);
                },
                classNameBody: "max-h-[60vh] h-[60vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RatingStarComponent, {
                    isAuto: true,
                    ratingDefault: rating,
                    onClose: function() {
                        return handleOpenPopupRating(false);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var components_RatingStarAutoComponent = (RatingStarAutoComponent);

// EXTERNAL MODULE: ./src/features/main/store/passioPageProfileSlice.ts
var passioPageProfileSlice = __webpack_require__(69067);
// EXTERNAL MODULE: ./src/features/share/icons/block-icons.tsx
var block_icons = __webpack_require__(65679);
// EXTERNAL MODULE: ./src/features/block/block-editor/DigitalProduct/constants/index.tsx
var constants = __webpack_require__(53443);
;// CONCATENATED MODULE: ./src/features/share/components/ManagementService/index.tsx
function ManagementService_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ManagementService_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ManagementService_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ManagementService_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}















var ManagementServiceComponent = function(param) {
    var onClose = param.onClose;
    var ref, ref1;
    var url_Iframe = "https://dev.account.passio.eco/";
    var user = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.user;
    });
    var userId1 = user === null || user === void 0 ? void 0 : (ref = user.kol) === null || ref === void 0 ? void 0 : ref._id;
    var country = user === null || user === void 0 ? void 0 : (ref1 = user.kol) === null || ref1 === void 0 ? void 0 : ref1.country;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ref2 = (0,react.useState)(false), isOpenPopupIframe = ref2[0], setOpenPopupIframe = ref2[1];
    var ref3 = (0,react.useState)(false), isUpdated = ref3[0], setIsUpdated = ref3[1];
    var dispatch = (0,react_redux_es/* useDispatch */.I0)();
    var handleSetIsUpdated = function(value) {
        setIsUpdated(value);
    };
    var handleFetchSiteSetting = function() {
        var _ref = ManagementService_asyncToGenerator(runtime_default().mark(function _callee(userId) {
            var responseSite, payloadPosition, responseSiteClone;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        responseSite = null;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,api/* fetchSiteSetting */.Dx)(userId);
                    case 4:
                        responseSite = _ctx.sent;
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](1);
                        console.log(_ctx.t0);
                    case 10:
                        if (responseSite === null || responseSite === void 0 ? void 0 : responseSite.positions) {
                            payloadPosition = responseSite.positions;
                            responseSiteClone = cloneDeep_default()(responseSite);
                            if (responseSiteClone) delete responseSiteClone.positions;
                            console.log("payloadPosition", payloadPosition);
                            dispatch((0,positionsSlice/* setPosition */.wq)({
                                positions: payloadPosition
                            }));
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    7
                ]
            ]);
        }));
        return function handleFetchSiteSetting(userId) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOpenPopupIfame = function(value) {
        setOpenPopupIframe(value);
        var iframe = document.getElementById("select-list-iframe");
        console.log("iframe", iframe);
        if (!iframe) {
            return;
        }
        iframe.contentWindow.postMessage({
            key: constants/* IFRAME_ACTION.LIST_DATA */.Jf.LIST_DATA,
            data: ""
        }, "*");
    };
    var handleMessage = function(event) {
        switch(event.data.key){
            case constants/* IFRAME_ACTION.CLOSE_IFRAME */.Jf.CLOSE_IFRAME:
                handleSetIsUpdated(true);
                handleOpenPopupIfame(false);
                break;
            case constants/* IFRAME_ACTION.RECIVED_DATA */.Jf.RECIVED_DATA:
            case constants/* IFRAME_ACTION.FETCH_DATA */.Jf.FETCH_DATA:
                handleSetIsUpdated(true);
                break;
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener("message", handleMessage, false);
        return function() {
            return window.removeEventListener("message", handleMessage);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (isUpdated) {
            handleFetchSiteSetting(userId1);
        }
    }, [
        isUpdated,
        userId1
    ]);
    if (country === configs_const/* COUNTRY_TH */.Un) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "popup-auto rating-popup-content",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List */.aV, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* List.Item */.aV.Item, {
                    prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(block_icons/* DigitalProducticonV2 */.Nv, {
                        className: "rounded-lg",
                        width: 32,
                        height: 32
                    }),
                    onClick: function() {
                        return handleOpenPopupIfame(true);
                    },
                    arrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(line_icon/* AngelRightIcon */.Zi, {}),
                    description: t("ss_builder_management_digital_product_description"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-[17px]",
                        children: t("ss_builder_management_digital_product_title")
                    })
                })
            }),
            isOpenPopupIframe && /*#__PURE__*/ (0,jsx_runtime.jsx)(full_screen_popup/* default */.Z, {
                visible: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full fixed min-h-screen top-0 left-0",
                    style: {
                        zIndex: 999999
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        id: "select-list-iframe",
                        src: "".concat(url_Iframe, "kol/digital-product/iframe?isIframe=true&isSetting=true"),
                        className: "min-h-screen w-full"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ManagementService = (ManagementServiceComponent);

;// CONCATENATED MODULE: ./src/features/main/pages/main.tsx
function main_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function main_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                main_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                main_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function main_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function main_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            main_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

































var TabsElement = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("min-w-[45px] ", props === null || props === void 0 ? void 0 : props.className),
        children: [
            props.children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[11px] text-[#999999]",
                style: {
                    marginBottom: "0px"
                },
                children: props.title
            })
        ]
    });
};
var main = function() {
    var ref11;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var country = (0,react_redux_es/* useSelector */.v9)(function(state) {
        var ref, ref10;
        return state === null || state === void 0 ? void 0 : (ref = state.user) === null || ref === void 0 ? void 0 : (ref10 = ref.kol) === null || ref10 === void 0 ? void 0 : ref10.country;
    });
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var ErrorModal = (0,modal/* useModal */.dd)().ErrorModal;
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var isOpenFloatingPanel = dynamicConfig && dynamicConfig.isOpenFloatingPanel;
    var isErrorNetwork = dynamicConfig && dynamicConfig.isErrorNetwork;
    var display_setting = siteSettings && siteSettings.display_setting;
    var is_open_popup_rating = siteSettings && (siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.is_open_popup_rating);
    var ref1 = (display_setting === null || display_setting === void 0 ? void 0 : display_setting.background) || {}, enable_overlay = ref1.enable_overlay, overlay_color = ref1.overlay_color, type = ref1.type, tmp = ref1.blur, blurBackgroundSetting = tmp === void 0 ? configs_const/* BACKGROUND_SETTING_DEFAULT_VALUE.BLUR */.Vw.BLUR : tmp;
    var user = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.user;
    });
    var userId = user && (user === null || user === void 0 ? void 0 : user.kol) && (user === null || user === void 0 ? void 0 : (ref11 = user.kol) === null || ref11 === void 0 ? void 0 : ref11._id);
    var alertError = function() {
        var onClose = function() {
            window.location.reload();
        };
        ErrorModal({
            title: t("ss_builder_error_network_title"),
            description: t("ss_builder_error_network_content"),
            confirmText: t("ss_builder_reload_label"),
            onClose: onClose
        });
    };
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = main_asyncToGenerator(runtime_default().mark(function _callee() {
                var passioPageProfile;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return (0,api/* fetchPassioPageProfile */.Qi)(userId);
                        case 2:
                            passioPageProfile = _ctx.sent;
                            ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile, ga_events/* CATEGORY_CONFIG.BUILDER_ACCESS */.Bt.BUILDER_ACCESS, "BuilderAccess_SessionStart", "", ga_events/* ACTION_CONFIG.SESSION_START */.AN.SESSION_START);
                            dispatch((0,passioPageProfileSlice/* setPassioPageProfile */.gA)({
                                data: passioPageProfile
                            }));
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (userId) {
            fetchData();
        }
    }, [
        userId
    ]);
    (0,react.useEffect)(function() {
        var checkDataCreator = function() {
            var _ref = main_asyncToGenerator(runtime_default().mark(function _callee() {
                var creatorProfile;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return (0,api/* fetchCreatorProfile */.H$)();
                        case 2:
                            creatorProfile = _ctx.sent;
                            if (!creatorProfile) {
                                alertError();
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function checkDataCreator() {
                return _ref.apply(this, arguments);
            };
        }();
        if (userId) {
            checkDataCreator();
        }
    }, [
        userId
    ]);
    var passioPageProfile1 = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.passioPageProfile;
    });
    var swiperRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(configs_const/* TAB_BAR_INDEX.DESIGN */.F.DESIGN), activeIndex = ref2[0], setActiveIndex = ref2[1];
    var ref3 = (0,react.useState)(false), isOpenFloatingAddBlock = ref3[0], setOpenFloatingAddBlock = ref3[1];
    var ref4 = (0,react.useState)(false), isPublishSuccess = ref4[0], setIsPublishSuccess = ref4[1];
    var ref5 = (0,react.useState)(isOpenFloatingAddBlock), isOpenPositionSelectedList = ref5[0], setIsOpenPositionSelectedList = ref5[1];
    var ref6 = (0,react.useState)(false), isOpenAddBlockFloatingPanel = ref6[0], setIsOpenAddBlockFloatingPanel = ref6[1];
    var ref7 = (0,react.useState)(false), isOpenPopupRating = ref7[0], setIsOpenPopupRating = ref7[1];
    var ref8 = (0,react.useState)(false), isLoginEnoughTime = ref8[0], setIsLoginEnoughTime = ref8[1];
    var ref9 = (0,react.useState)(false), isOpenPopupManagementService = ref9[0], setIsOpenPopupManagementService = ref9[1];
    var styleBackgroundImage = type === configs_const/* THEME_SETTING_BACKGROUND_TYPE.IMAGE */.tn.IMAGE ? {
        backgroundPosition: "center center",
        filter: "blur(".concat(blurBackgroundSetting, "px) "),
        WebkitFilter: "blur(".concat(blurBackgroundSetting, "px) "),
        width: "calc(100% + ".concat(blurBackgroundSetting * 2, "px) "),
        height: "calc(100% + ".concat(blurBackgroundSetting * 2, "px) "),
        transform: "translate(-".concat(blurBackgroundSetting, "px, -").concat(blurBackgroundSetting, "px)")
    } : "";
    (0,react.useEffect)(function() {
        if (isErrorNetwork) {
            es/* Modal.alert */.u_.alert({
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* InformationIcon */.Yk, {
                    className: "w-11 h-11",
                    fillColor: "#FF8F1F",
                    onClick: function() {}
                }),
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col text-center items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-lg font-bold leading-[25px]",
                            children: t("ss_builder_error_network_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: t("ss_builder_error_network_content")
                        })
                    ]
                }),
                confirmText: t("ss_builder_error_network_confirm_btn_label"),
                onConfirm: function() {
                    dispatch((0,dynamicSlice/* setDynamicParams */.B9)({
                        data: {
                            isErrorNetwork: false
                        }
                    }));
                    return;
                }
            });
        }
    }, [
        isErrorNetwork
    ]);
    var getTabItems = function(indexKey) {
        var items = [
            {
                key: "design",
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsElement, {
                    title: t("ss_builder_design_label"),
                    className: product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_1 */.uN.STEP_1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* DesignIcon */.UF, {
                        fillColor: indexKey === configs_const/* TAB_BAR_INDEX.DESIGN */.F.DESIGN ? "#EE3244" : undefined,
                        className: "m-auto"
                    })
                })
            },
            {
                key: "background",
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsElement, {
                    title: t("ss_builder_theme_setting_background"),
                    className: product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_14 */.uN.STEP_14,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BackgroundIcon */.AZ, {
                        fillColor: indexKey === configs_const/* TAB_BAR_INDEX.BACKGROUND */.F.BACKGROUND ? "#EE3244" : undefined,
                        className: "m-auto"
                    })
                })
            },
            {
                key: "theme-store",
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsElement, {
                    title: t("ss_builder_theme_store_label"),
                    className: product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_15 */.uN.STEP_15,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ThemeStoreIcon */.X0, {
                        fillColor: indexKey === configs_const/* TAB_BAR_INDEX.TEMPLATE */.F.TEMPLATE ? "#EE3244" : undefined,
                        className: "m-auto"
                    })
                })
            },
            {
                key: "setting",
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsElement, {
                    title: t("ss_builder_settings_label"),
                    className: product_tour_config/* PRODUCT_TOUR_CLASS_NAME.STEP_16 */.uN.STEP_16,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* SettingIcon */.qY, {
                        fillColor: indexKey === configs_const/* TAB_BAR_INDEX.SETTING */.F.SETTING ? "#EE3244" : undefined,
                        className: "m-auto"
                    })
                })
            }, 
        ];
        if (country !== configs_const/* COUNTRY_TH */.Un) {
            items.push({
                key: "management",
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsElement, {
                    title: t("ss_builder_management_label"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(line_icon/* ManagementIcon */.IS, {
                        fillColor: indexKey === configs_const/* TAB_BAR_INDEX.MANAGEMENT */.F.MANAGEMENT ? "#EE3244" : undefined,
                        className: "m-auto"
                    })
                })
            });
        }
        return items;
    };
    (0,react.useEffect)(function() {
        var isMounted = true;
        if (isMounted && userId) dispatch((0,thunk/* getSite */.NP)());
        return function() {
            isMounted = false;
        };
    }, [
        userId
    ]);
    (0,react.useEffect)(function() {
        var subscription = rxjs/* dataService.getObservable */.c.getObservable().subscribe(function(data) {
            if (data) {
                data.indexDesign !== undefined && handleSwitchTab(data.indexDesign);
            }
        });
        return function() {
            return subscription.unsubscribe();
        };
    }, []);
    var tabItems = getTabItems(activeIndex);
    var handleCallback = function(data) {
        dispatch((0,dynamicSlice/* setParamsBlock */.wT)({
            data: {
                positionSlug: data.positionSlug,
                listBlocksData: data.listBlocksData,
                tabUid: data.activeKeyTab
            }
        }));
    };
    var handleSwitchTab = function(index) {
        var ref;
        setActiveIndex(index);
        (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.swipeTo(index);
    };
    var handleRedirectTabs = function() {
        handleSwitchTab(0);
    };
    var handleCloseFloatingAddBlock = function() {
        setIsOpenAddBlockFloatingPanel(false);
        setIsOpenPositionSelectedList(false);
        setOpenFloatingAddBlock(true);
    };
    var handleOpenFloatingAddBlock = function() {
        setOpenFloatingAddBlock(true);
    };
    var callBackCloseFloating = function() {
        // dispatch(
        //   setDynamicParams({ data: { isOpenFloatingPanel: !isOpenFloatingPanel } })
        // );
        setOpenFloatingAddBlock(false);
    };
    (0,react.useEffect)(function() {
        var timeOut;
        timeOut = setTimeout(function() {
            handleLoginEnoughTime(true);
        }, 30000);
        return function() {
            clearTimeout(timeOut);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (is_open_popup_rating && activeIndex === configs_const/* TAB_BAR_INDEX.DESIGN */.F.DESIGN && isLoginEnoughTime) {
            handleOpenPopupRating(true);
        }
    }, [
        is_open_popup_rating,
        isLoginEnoughTime,
        activeIndex
    ]);
    var tabContentRender = function() {
        var element = null;
        switch(activeIndex){
            case configs_const/* TAB_BAR_INDEX.DESIGN */.F.DESIGN:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(components, {
                    callbackShowResultPublish: function(data) {
                        return setIsPublishSuccess(data);
                    },
                    activeIndex: activeIndex,
                    handleRedirectTabs: handleRedirectTabs,
                    isOpenFloatingAddBlock: isOpenFloatingAddBlock,
                    callBackCloseFloating: callBackCloseFloating,
                    setIsOpenPositionSelectedList: setIsOpenPositionSelectedList,
                    setIsOpenAddBlockFloatingPanel: setIsOpenAddBlockFloatingPanel,
                    isOpenPositionSelectedList: isOpenPositionSelectedList,
                    isOpenAddBlockFloatingPanel: isOpenAddBlockFloatingPanel
                });
                break;
            case configs_const/* TAB_BAR_INDEX.BACKGROUND */.F.BACKGROUND:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundSetting, {
                    backToAllSetting: function() {
                        return null;
                    },
                    activeIndex: activeIndex
                });
                break;
            case configs_const/* TAB_BAR_INDEX.TEMPLATE */.F.TEMPLATE:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeTemplateHandler_ThemeTemplateStore, {
                    handleRedirectTabs: handleRedirectTabs,
                    siteSettings: siteSettings,
                    user: user,
                    activeIndex: activeIndex
                });
                break;
            case configs_const/* TAB_BAR_INDEX.SETTING */.F.SETTING:
                element = /*#__PURE__*/ (0,jsx_runtime.jsx)(setting_components, {});
                break;
        }
        return element;
    };
    var fetchSiteInfo = function() {
        var _ref = main_asyncToGenerator(runtime_default().mark(function _callee() {
            var newSiteSettings;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        newSiteSettings = main_objectSpread({}, siteSettings, {
                            is_open_popup_rating: false
                        });
                        dispatch((0,siteSettingSlice/* setSiteInfo */.cP)({
                            sites: newSiteSettings
                        }));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchSiteInfo() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNoNeedToRating = function() {
        var _ref = main_asyncToGenerator(runtime_default().mark(function _callee() {
            var dataRequest, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataRequest = {
                            user_id: userId,
                            is_need_to_rating: false
                        };
                        ;
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,api/* sendRequestNoNeedToRating */.hQ)(dataRequest);
                    case 5:
                        response = _ctx.sent;
                        ga_events/* default.submitEventV2 */.ZP.submitEventV2(passioPageProfile1, ga_events/* CATEGORY_CONFIG.CREATOR_SEND_REVIEW */.Bt.CREATOR_SEND_REVIEW, ga_events/* EVENT_CONFIG.CREATOR_SEND_REVIEW_CLOSE_REVIEW_FORM */.f1.CREATOR_SEND_REVIEW_CLOSE_REVIEW_FORM, "", ga_events/* ACTION_CONFIG.CLOSE_REVIEW_FORM */.AN.CLOSE_REVIEW_FORM);
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](2);
                        console.log(_ctx.t0);
                    case 12:
                        if (response.success) {
                            fetchSiteInfo();
                        }
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    9
                ]
            ]);
        }));
        return function handleNoNeedToRating() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOpenPopupRating = function(value) {
        setIsOpenPopupRating(value);
        if (!value) {
            handleNoNeedToRating();
        }
    };
    var handleOpenPopupManagementService = function(value) {
        setIsOpenPopupManagementService(value);
    };
    var handleLoginEnoughTime = function(value) {
        setIsLoginEnoughTime(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileLayout, {
                children: [
                    tabContentRender(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            position: "fixed",
                            bottom: "0",
                            width: "inherit",
                            backgroundColor: "#FFFFFF",
                            borderTop: "1px solid #EEEEEE",
                            zIndex: 998,
                            left: "50%",
                            transform: "translateX(-50%)",
                            display: isOpenFloatingPanel ? "none" : ""
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Tabs */.mQ, {
                            activeKey: tabItems[activeIndex] && tabItems[activeIndex].key,
                            onChange: function(key) {
                                var index = tabItems.findIndex(function(item) {
                                    return (item === null || item === void 0 ? void 0 : item.key) === key;
                                });
                                if (key != configs_const/* TAB_BAR_KEY.MANAGEMENT */.kW.MANAGEMENT) {
                                    handleSwitchTab(index);
                                    setActiveIndex(index);
                                } else {
                                    handleOpenPopupManagementService(true);
                                }
                            },
                            style: {
                                "--active-line-color": "#FFFFFF",
                                margin: "auto"
                            },
                            className: "tab-bar-footer max-width-content-layout",
                            children: tabItems.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Tabs.Tab */.mQ.Tab, {
                                    title: item.title,
                                    className: "text-[#999999] text-center"
                                }, item.key);
                            })
                        })
                    }),
                    isPublishSuccess && // <FullScreenPopup
                    //   visible={isPublishSuccess}
                    //   onMaskClick={() => setIsPublishSuccess(false)}
                    // >
                    //   <ResultPublishComponent
                    //     callbackClosePublishResult={() => setIsPublishSuccess(false)}
                    //   />
                    // </FullScreenPopup>
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(portal/* default */.Z, {
                        elementId: "modalPortal",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Modal */.u_, {
                            visible: isPublishSuccess,
                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultPublish, {
                                callbackClosePublishResult: function() {
                                    return setIsPublishSuccess(false);
                                }
                            }),
                            closeOnAction: true,
                            closeOnMaskClick: true,
                            onClose: function() {
                                setIsPublishSuccess(false);
                            },
                            className: "modal-publish-success"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockEditV2/* default */.Z, {
                        handleRedirectTabs: handleRedirectTabs,
                        handleCloseFloatingAddBlock: handleCloseFloatingAddBlock,
                        handleOpenFloatingAddBlock: handleOpenFloatingAddBlock
                    }),
                    activeIndex === configs_const/* TAB_BAR_INDEX.DESIGN */.F.DESIGN && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(portal/* default */.Z, {
                                elementId: "myBackgroundViewPortal",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            position: "fixed",
                                            width: "100%",
                                            height: "100%",
                                            top: "0px",
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            overflow: "hidden",
                                            paddingBottom: "65px",
                                            paddingTop: "48px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full h-full background-image background-color",
                                            style: main_objectSpread({
                                                backgroundRepeat: "no-repeat",
                                                backgroundSize: "cover",
                                                objectFit: "cover"
                                            }, styleBackgroundImage)
                                        })
                                    }),
                                    type === configs_const/* THEME_SETTING_BACKGROUND_TYPE.IMAGE */.tn.IMAGE && enable_overlay && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-0 left-[50%] translate-x-[-50%] block w-full h-full z-[2]",
                                        style: {
                                            backgroundColor: overlay_color
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "tabBarHeaderPortal",
                                style: {
                                    display: tabItems[activeIndex] && tabItems[activeIndex].key !== "design" ? "none" : ""
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "tabMenuDesignPortal",
                                className: "design-class",
                                style: {
                                    display: tabItems[activeIndex] && tabItems[activeIndex].key !== "design" ? "none" : ""
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeStyle, {
                                displaySetting: display_setting
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "themeTemplateHandlerPortal"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(generate_color_GenerateColor, {
                        displaySetting: display_setting
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "newBlockPortal",
                        className: "",
                        style: {
                            display: tabItems[activeIndex] && tabItems[activeIndex].key !== "design" ? "none" : ""
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "modalPortal",
                        className: "relative z-[9999]"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenPopupRating,
                onMaskClick: function() {},
                title: t("ss_builder_block_rating_title"),
                onClose: function() {
                    return handleOpenPopupRating(false);
                },
                classNameBody: "max-h-[60vh] h-[30vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RatingStarAutoComponent, {
                    onClose: function() {
                        return handleOpenPopupRating(false);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupComponent/* default */.Z, {
                visible: isOpenPopupManagementService,
                onMaskClick: function() {},
                title: t("ss_builder_popup_management_title"),
                onClose: function() {
                    return handleOpenPopupManagementService(false);
                },
                classNameBody: "h-[40vh] popup-hard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ManagementService, {
                    onClose: function() {
                        return handleOpenPopupManagementService(false);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var pages_main = (/*#__PURE__*/react.memo(main));

// EXTERNAL MODULE: ./src/features/share/configs/country-config.ts
var country_config = __webpack_require__(80188);
;// CONCATENATED MODULE: ./src/features/share/hooks/useGetFontValue.ts
function useGetFontValue_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useGetFontValue_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useGetFontValue_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function useGetFontValue_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useGetFontValue_slicedToArray(arr, i) {
    return useGetFontValue_arrayWithHoles(arr) || useGetFontValue_iterableToArrayLimit(arr, i) || useGetFontValue_unsupportedIterableToArray(arr, i) || useGetFontValue_nonIterableRest();
}
function useGetFontValue_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return useGetFontValue_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return useGetFontValue_arrayLikeToArray(o, minLen);
}



var useGetFontValue = function(paragraphSetting, titleSetting) {
    //Thực hiện xóa link font nếu có bất kì link nào tồn tại trong Head
    (0,react.useEffect)(function() {
        var existingLinks = document.querySelectorAll('link[href^="'.concat(configs_const/* GG_FONT_URI */.s0, '?family="]'));
        existingLinks.forEach(function(link) {
            return link.parentNode.removeChild(link);
        });
    }, [
        paragraphSetting,
        titleSetting
    ]);
    //Tạo link font mới
    var fontValue = (0,react.useMemo)(function() {
        // paragraph
        var paragraph_using_font_custom = (paragraphSetting === null || paragraphSetting === void 0 ? void 0 : paragraphSetting.using_font_custom) || configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.USING_FONT_CUSTOM */.no.USING_FONT_CUSTOM;
        var paragraph_font_family_custom = (paragraphSetting === null || paragraphSetting === void 0 ? void 0 : paragraphSetting.font_family_custom) || configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_FAMILY_CUSTOM */.no.FONT_FAMILY_CUSTOM;
        var paragraph_font_family = (paragraphSetting === null || paragraphSetting === void 0 ? void 0 : paragraphSetting.font_family) || configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_FAMILY */.no.FONT_FAMILY;
        var paragraphFontFamily = (paragraph_using_font_custom === configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.USING_FONT_CUSTOM */.no.USING_FONT_CUSTOM ? startCase_default()(paragraph_font_family) : startCase_default()(paragraph_font_family_custom.toString().trim())).replace(/\s+/g, "+");
        var paragraphWeight = (paragraphSetting === null || paragraphSetting === void 0 ? void 0 : paragraphSetting.font_weight) || configs_const/* PARAGRAPH_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.no.FONT_WEIGHT;
        var isNewParagraph = (paragraphSetting === null || paragraphSetting === void 0 ? void 0 : paragraphSetting.is_new) || false;
        //title
        var title_using_font_custom = (titleSetting === null || titleSetting === void 0 ? void 0 : titleSetting.using_font_custom) || configs_const/* TITLE_SETTING_DEFAULT_VALUE.USING_FONT_CUSTOM */.lI.USING_FONT_CUSTOM;
        var title_font_family_custom = (titleSetting === null || titleSetting === void 0 ? void 0 : titleSetting.font_family_custom) || configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_FAMILY_CUSTOM */.lI.FONT_FAMILY_CUSTOM;
        var title_font_family = (titleSetting === null || titleSetting === void 0 ? void 0 : titleSetting.font_family) || configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_FAMILY */.lI.FONT_FAMILY;
        var titleFontFamily = (title_using_font_custom === configs_const/* TITLE_SETTING_DEFAULT_VALUE.USING_FONT_CUSTOM */.lI.USING_FONT_CUSTOM ? startCase_default()(title_font_family) : startCase_default()(title_font_family_custom.toString().trim())).replace(/\s+/g, "+");
        var titleWeight = (titleSetting === null || titleSetting === void 0 ? void 0 : titleSetting.font_weight) || configs_const/* TITLE_SETTING_DEFAULT_VALUE.FONT_WEIGHT */.lI.FONT_WEIGHT;
        var isNewTitle = (titleSetting === null || titleSetting === void 0 ? void 0 : titleSetting.is_new) || false;
        var titleFont = isNewTitle ? "".concat(titleFontFamily, ":").concat(titleWeight) : titleFontFamily;
        var paragraphFont = isNewParagraph ? "".concat(paragraphFontFamily, ":").concat(paragraphWeight) : paragraphFontFamily;
        var value = "".concat(titleFont, "|").concat(paragraphFont);
        if (titleFontFamily === paragraphFontFamily) {
            if (Number(paragraphWeight) === Number(titleWeight)) {
                value = titleFont;
            } else {
                var firstWeight = Number(titleWeight);
                var secondWeight = Number(paragraphWeight);
                var ref = useGetFontValue_slicedToArray(firstWeight > secondWeight ? [
                    titleWeight,
                    paragraphWeight
                ] : [
                    paragraphWeight,
                    titleWeight
                ], 2), fontFirst = ref[0], fontSecond = ref[1];
                value = "".concat(titleFontFamily, ":").concat(fontFirst, ",").concat(fontSecond);
            }
        }
        return value;
    }, [
        paragraphSetting,
        titleSetting
    ]);
    return {
        fontValue: fontValue
    };
};

;// CONCATENATED MODULE: ./src/pages/index.tsx
function pages_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function pages_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                pages_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                pages_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



















var Pages = function(props) {
    var ref3, ref1;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    var dispatch = (0,hooks/* useAppDispatch */.TL)();
    var router = (0,next_router.useRouter)();
    var fromQuery = router.query.from;
    var fromCookies = js_cookie/* default.get */.Z.get("from");
    var from = fromCookies || fromQuery;
    var creatorProfile = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.creatorProfile;
    });
    var userId = creatorProfile === null || creatorProfile === void 0 ? void 0 : creatorProfile.user_id;
    var dynamicConfig = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.dynamicConfig;
    });
    var finishOnboard = creatorProfile === null || creatorProfile === void 0 ? void 0 : creatorProfile.finish_onboard;
    var siteSettings = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.siteSettings;
    });
    var paragraphSetting = siteSettings === null || siteSettings === void 0 ? void 0 : (ref3 = siteSettings.display_setting) === null || ref3 === void 0 ? void 0 : ref3.paragraph_setting;
    var titleSetting = siteSettings === null || siteSettings === void 0 ? void 0 : (ref1 = siteSettings.display_setting) === null || ref1 === void 0 ? void 0 : ref1.title_setting;
    var fontValue = useGetFontValue(paragraphSetting, titleSetting).fontValue;
    var dataFont = (0,hooks/* useAppSelector */.CG)(function(state) {
        var ref;
        return (ref = state.externalState) === null || ref === void 0 ? void 0 : ref.data_font;
    });
    var fontWeightAvailable = (0,hooks/* useAppSelector */.CG)(function(state) {
        return state.externalState.font_weight_available;
    });
    var ref2 = dataFont || {}, title = ref2.title, paragraph = ref2.paragraph;
    var previewFontParagraphSrc = (0,react.useMemo)(function() {
        return paragraph ? "".concat(configs_const/* GG_FONT_URI */.s0, "?family=").concat(paragraph.replace(/\s+/g, "+"), ":").concat(fontWeightAvailable === null || fontWeightAvailable === void 0 ? void 0 : fontWeightAvailable.join(",")) : null;
    }, [
        fontWeightAvailable,
        paragraph
    ]);
    var previewFontTitleSrc = (0,react.useMemo)(function() {
        return title ? "".concat(configs_const/* GG_FONT_URI */.s0, "?family=").concat(title.replace(/\s+/g, "+"), ":").concat(fontWeightAvailable === null || fontWeightAvailable === void 0 ? void 0 : fontWeightAvailable.join(",")) : null;
    }, [
        fontWeightAvailable,
        title
    ]);
    (0,react.useEffect)(function() {
        if (fontWeightAvailable) dispatch((0,externalStateSlice/* setFontLoading */.ZR)(false));
    }, [
        fontWeightAvailable
    ]);
    var isShowDesignFontLink = !previewFontParagraphSrc && !previewFontTitleSrc;
    (0,react.useEffect)(function() {
        if (finishOnboard !== store_interface/* FINISH_ONBOARD_ENUM.TRUE */.s2.TRUE && finishOnboard != configs_const/* INITIAL_ONBOARDING */.hB) {
            var onboardingUrl = from ? "".concat(pages/* ONBOARDING_PAGE.onboarding */.p5.onboarding, "?from=").concat(from) : pages/* ONBOARDING_PAGE.onboarding */.p5.onboarding;
            router.push(onboardingUrl);
        }
    }, [
        finishOnboard,
        from
    ]);
    var handleRequestLogin = function() {
        var _ref = pages_asyncToGenerator(runtime_default().mark(function _callee() {
            var dataRequest;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataRequest = {
                            user_id: userId
                        };
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,api/* sendRequestLogin */.w)(dataRequest);
                    case 4:
                        _ctx.next = 9;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](1);
                        console.log(_ctx.t0);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    6
                ]
            ]);
        }));
        return function handleRequestLogin() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var isLogin = js_cookie/* default.get */.Z.get(configs_const/* KEY_IS_LOGIN */.Ep);
        if (userId && isLogin != userId) {
            handleRequestLogin();
            var expiresDate = new Date(Date.now() + 10 * 60 * 1000);
            js_cookie/* default.set */.Z.set(configs_const/* KEY_IS_LOGIN */.Ep, userId, {
                expires: expiresDate
            });
        }
    }, [
        userId
    ]);
    (0,react.useEffect)(function() {
        var isError = dynamicConfig === null || dynamicConfig === void 0 ? void 0 : dynamicConfig.isError;
        if (isError) {
            es/* Dialog.alert */.Vq.alert({
                header: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ExclamationTriangleIcon */.LP, {
                    width: 48,
                    height: 48,
                    fillColor: "var(--adm-color-warning)"
                }),
                confirmText: t("ss_builder_dialog_error_confirm_text"),
                title: t("ss_builder_dialog_error_title"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center",
                    children: t("ss_builder_dialog_error_content")
                }),
                onConfirm: function() {
                    window.location.reload();
                }
            });
        }
    }, [
        dynamicConfig
    ]);
    var titlePage = "".concat(t("ss_builder_title_page_builder"), " - ").concat(country_config/* COUNTRY_CONFIG */.Q[props === null || props === void 0 ? void 0 : props.country] || country_config/* COUNTRY_CONFIG.OTHER */.Q.OTHER);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: titlePage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: t("ss_builder_description_page_builder")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/x-icon",
                        href: "https://i.ecomobi.com/128x128/ssp/passio-page/passio.png"
                    }),
                    !!previewFontParagraphSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: previewFontParagraphSrc,
                        rel: "stylesheet"
                    }),
                    !!previewFontTitleSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: previewFontTitleSrc,
                        rel: "stylesheet"
                    }),
                    isShowDesignFontLink && fontValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "".concat(configs_const/* GG_FONT_URI */.s0, "?family=").concat(fontValue),
                        rel: "stylesheet"
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "minimum-scale=1, initial-scale=1, user-scalable=0, width=device-width, shrink-to-fit=no, maximum-scale=1.0, viewport-fit=cover"
                    }, "meta_viewport")
                ]
            }),
            finishOnboard !== store_interface/* FINISH_ONBOARD_ENUM.TRUE */.s2.TRUE ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-white h-screen w-screen flex flex-wrap justify-center items-center content-center gap-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* SpinLoading */.wW, {
                            color: "primary",
                            style: {
                                "--size": "32px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logged/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_main, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "product-tour-skip-button-id"
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var src_pages = (Pages);


/***/ }),

/***/ 52706:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"notShowing":"style_notShowing__WSrjo","showing":"style_showing__9bSXC"};

/***/ }),

/***/ 37583:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"backgroundStyleCollapse":"style_backgroundStyleCollapse__Ou4zu"};

/***/ }),

/***/ 28917:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customCollapse":"styele_customCollapse__G3Ov_"};

/***/ }),

/***/ 35157:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"labelSettingBox":"heading_labelSettingBox__yg7UR","crown":"heading_crown__lDhsb","btnTextSpan":"heading_btnTextSpan__mauCe","domain":"heading_domain__nA9Rx","headerRight":"heading_headerRight__ICKFR","btnEditDomain":"heading_btnEditDomain__d_8MY","wrapperPremium":"heading_wrapperPremium___HXK1","itemSwiperPremium":"heading_itemSwiperPremium__YMauJ","titleItem":"heading_titleItem__OYoNE","descriptionItem":"heading_descriptionItem__KOdFH","icon":"heading_icon__wsnhj","btnUpgradeBox":"heading_btnUpgradeBox__S5G1k","btnUpgrade":"heading_btnUpgrade__1cuMy","introItem":"heading_introItem__87a9C","action":"heading_action__mPl_v","actionItem":"heading_actionItem__9rvzG","textAction":"heading_textAction__5aUA8"};

/***/ }),

/***/ 57488:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mobileContainer":"style_mobileContainer__T0R2h","mobileContent":"style_mobileContent__WvY_6","backgroundOverlayColor":"style_backgroundOverlayColor__YMnKZ"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [885,779,286,551,240,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);